/* eslint-disable prettier/prettier */

import { tokens } from '@/locales/tokens/index'

export const de = {
  [tokens.common.welcome]: 'Willkommen',
  [tokens.common.welcomeLogin]: 'Herzlich willkommen bei',
  [tokens.common.welcomeLoginText]:
    'Nabu ist der Zoll-Copilot, mit dem Sie auf Ihre Zollformalitäten und Daten zugreifen, diese verwalten und effizient ausführen können.',
  [tokens.common.nabuLogo]: 'Nabu-Logo',
  [tokens.common.login]: 'Einloggen',
  [tokens.common.clear]: 'Zurücksetzen',
  [tokens.common.theActionWasSuccessful]: 'Die Massenaktion war erfolgreich',
  [tokens.common.createdAt]: 'Erstellt am',
  [tokens.common.created]: 'Erstellt',
  [tokens.common.updatedAt]: 'Aktualisiert am',
  [tokens.common.notes]: 'Vermerke',
  [tokens.common.loginError]:
    'Hoppla, es scheint, dass die von Ihnen eingegebene E-Mail-Adresse oder das Passwort falsch ist. Bitte überprüfen Sie es noch einmal und versuchen Sie es erneut.',
  [tokens.common.unknownError]: 'Unbekannter Fehler',
  [tokens.common.clientOrganization]: 'Organisation des Kunden',
  [tokens.common.emailSendError]:
    'Hoppla, es scheint, dass der E-Mail-Versand fehlgeschlagen ist. Bitte versuchen Sie es erneut.',
  [tokens.common.returnToLoginPage]: 'Zurück zur Login-Seite',
  [tokens.common.logout]: 'Logout',
  [tokens.common.impersonatingAs]: 'Angemeldet als <bold>{{name}}</bold>',
  [tokens.common.stopImpersonation]: 'Sitzung beenden',
  [tokens.common.impersonationTimeLeft]: 'noch {{minutes}} Min.',
  [tokens.common.impersonationExpired]: 'Die „Anmelden als“-Sitzung ist abgelaufen.',
  [tokens.common.impersonationClosed]: 'Die „Anmelden als“-Sitzung wurde beendet.',
  [tokens.common.impersonationOpening]: 'Sitzung wird geöffnet…',
  [tokens.common.impersonationLinkInvalid]:
    'Dieser Link ist abgelaufen oder wurde bereits verwendet. Starten Sie „Anmelden als“ erneut in der Konsole.',
  [tokens.common.smartPreparationAnnouncement]:
    'Die <bold>intelligente Vorbereitung</bold> kommt zu Nabu: weniger manuelle Eingaben, mehr Zeit für das Wesentliche.',
  [tokens.common.smartPreparationBadge]: 'Neu',
  [tokens.common.smartPreparationTry]: 'Ausprobieren',
  [tokens.common.smartPreparationLearnMore]: 'Mehr erfahren',
  [tokens.common.search]: 'Suche',
  [tokens.common.unknownUser]: 'Unbekannter Benutzer',
  [tokens.common.noItemFound]: 'Keine Einträge gefunden',
  [tokens.common.noAccount]: 'Du hast noch kein Konto? ',
  [tokens.common.needAccountHelp]:
    'Wenn Sie Probleme haben, sich anzumelden, oder wenn Sie ein neues Konto erstellen möchten:',
  [tokens.common.questionForgotPassword]: 'Passwort vergessen ?',
  [tokens.common.forgotPassword]: 'Passwort vergessen',
  [tokens.common.selectAGroup]: 'Wählen Sie eine Agentur',
  [tokens.common.selectAConfiguration]: 'Einstellungen neu laden',
  [tokens.common.enterNewPassword]: 'Legen Sie ein neues Passwort fest.',
  [tokens.common.passwordConfirmation]: 'Das Kennwort bestätigen',
  [tokens.common.anErrorOccurred]: 'Ein Fehler ist aufgetreten',
  [tokens.common.currentOwner]: 'Aktueller Besitzer',
  [tokens.common.currentGroup]: 'Aktuelle Agentur',
  [tokens.common.forgotPasswordText]:
    'Geben Sie die E-Mail-Adresse mit Ihrem Konto verbunden.',
  [tokens.common.oldPasswordRequired]: 'Altes Passwort ist erforderlich',
  [tokens.common.newPasswordRequired]: 'Neues Passwort ist erforderlich',
  [tokens.common.warningRulesForNewPassword]:
    'Das Passwort muss mindestens einen Kleinbuchstaben, einen Großbuchstaben, eine Zahl, ein Sonderzeichen (@, $,!, %, *,?, &) enthalten und zwischen 8 und 16 Zeichen lang sein.',
  [tokens.common.emailSent]: 'Ein E-Mail wurde gesendet',
  [tokens.common.passwordResetEmailConfirmTitle]:
    'Passwort-Reset-E-Mail gesendet.',
  [tokens.common.passwordResetEmailConfirmDescription]:
    'Wenn für diese Adresse ein Konto existiert, erhalten Sie eine E-Mail mit einem Link zum Zurücksetzen Ihres Passworts. Bitte überprüfe deinen Spam-Ordner.',
  [tokens.common.passwordChangedSuccessTitle]: 'Passwort zurückgesetzt',
  [tokens.common.passwordChangedSuccessDescription]:
    'Sie konnen sich mit Ihrem neuen Passwort anmelden.',
  [tokens.common.recoveryLinkInvalidTitle]: 'Dieser Link ist nicht mehr gültig',
  [tokens.common.recoveryLinkInvalidDescription]:
    'Er ist abgelaufen, wurde bereits verwendet oder durch eine neuere E-Mail ersetzt: Nur der zuletzt erhaltene Link funktioniert.',
  [tokens.common.requestNewLink]: 'Neuen Link anfordern',
  [tokens.common.exportTypeRequired]: 'Ein Exporttyp ist erforderlich',
  [tokens.common.exportTypeUnknown]: 'Exporttyp unbekannt',
  [tokens.common.updateDeclarationOwner]: 'Deklarationsbesitzer aktualisieren',
  [tokens.common.changeOwnerForCurrentDeclaration]:
    'Besitzer für die aktuelle Deklaration ändern',
  [tokens.common.declarationOwner]: 'Deklarationseigentümer',
  [tokens.common.contactUs]: 'Kontaktieren Sie uns',
  [tokens.common.yes]: 'Ja',
  [tokens.common.confirm]: 'Bestätigen',
  [tokens.common.import]: 'Importieren',
  [tokens.common.export]: 'Exportieren',
  [tokens.common.transit]: 'Durchfahrt',
  [tokens.common.noOptions]: 'Keine Optionen',
  [tokens.common.validate]: 'Bestätigen',
  [tokens.common.delete]: 'Löschen',
  [tokens.common.cancel]: 'Abbrechen',
  [tokens.common.selectUser]: 'Benutzer auswählen',
  [tokens.common.errorRenameModelName]:
    'Der Modellname konnte nicht umbenannt werden',
  [tokens.common.continue]: 'Weiter',
  [tokens.common.next]: 'Nächste',
  [tokens.common.back]: 'Zurück',
  [tokens.common.close]: 'Schließen',
  [tokens.common.create]: 'Erstellen',
  [tokens.common.upload]: 'Datei Hochladen',
  [tokens.common.sentDocuments]: 'Gesendete Anmeldungen',
  [tokens.common.sentFolders]: 'Anmeldungen gesendet',
  [tokens.common.tableConsolidated]: 'Konsolidierte Tabelle',
  [tokens.common.tableNotConsolidated]: 'Nicht konsolidierte Tabelle',
  [tokens.common.numberofLinesSent]: 'Gesamtzahl der gesendeten Zeilen:',
  [tokens.common.send]: 'Senden',
  [tokens.common.add]: 'Hinzufügen',
  [tokens.common.languageChanged]: 'Sprache geändert',
  [tokens.common.manager]: 'Verantwortlicher',
  [tokens.common.guest]: 'Band',
  [tokens.common.admin]: 'Administrator',
  [tokens.common.user]: 'Benutzer',
  [tokens.common.superadmin]: 'Nabu-Personal',
  [tokens.common.mail]: 'E-Mail',
  [tokens.common.email]: 'Mail',
  [tokens.common.mailHook]: 'E-Mail-Haken',
  [tokens.common.regenerateMailHook]: 'E-Mail-Haken neu generieren',
  [tokens.common.mailHookDescription]:
    'Nabu-E-Mail-Adresse, die mit dem Trainerordner-Posteingang Ihres Teams verbunden ist',
  [tokens.common.copy]: 'Abschrift',
  [tokens.common.holdToConfirmNudge]: 'Gedrückt halten',
  [tokens.common.holdToConfirmHint]:
    'Halten Sie die Schaltfläche oder die Leer- bzw. Eingabetaste etwa eine Sekunde lang gedrückt, um zu bestätigen.',
  [tokens.common.confirmed]: 'Bestätigt',
  [tokens.common.copied]: 'Kopiert',
  [tokens.common.copyFailed]: 'Fehlgeschlagen',
  [tokens.common.role]: 'Rolle',
  [tokens.common.date]: 'Datum',
  [tokens.common.name]: 'Benennung',
  [tokens.common.member]: 'Mitglied',
  [tokens.common.members]: 'Mitglieder',
  [tokens.common.administrator]: 'Administrator',
  [tokens.common.administrators]: 'Admins',
  [tokens.common.sendInvite]: 'Eine Einladung senden',
  [tokens.common.inviteMember]: 'Laden Sie ein Mitglied ein!',
  [tokens.common.inviteMembers]: 'Mitglieder einladen',
  [tokens.common.inviteAdministrator]: 'Einen Administrator einladen',
  [tokens.common.inviteAdministrators]: 'Administratoren einladen',
  [tokens.common.inviteSomeAdministrators]:
    'Laden Sie einige Administratoren ein',
  [tokens.common.atLeastOneInvitedPeople]: 'Mindestens eine Person einladen',
  [tokens.common.maxOneInvitedPeople]: 'Maximal einen Administrator einladen',
  [tokens.common.sendInvitation]: 'Einladung senden',
  [tokens.common.deleteInvitation]: 'Einladung löschen',
  [tokens.common.socialName]: 'Firmenname',
  [tokens.common.registrationNumber]: 'Registernummer',
  [tokens.common.country]: 'Land',
  [tokens.common.organization]: 'Organisation',
  [tokens.common.organizationAndEstablishments]: 'Organisation & Etablierung',
  [tokens.common.somethingWentWrong]: 'Etwas ist schief gelaufen ...',
  [tokens.common.general]: 'Allgemeines',
  [tokens.common.lastName]: 'Nachname',
  [tokens.common.firstName]: 'Vorname',
  [tokens.common.function]: 'Rolle',
  [tokens.common.preferences]: 'Einstellungen',
  [tokens.common.password]: 'Passwort',
  [tokens.common.position]: 'Position',
  [tokens.common.language]: 'Sprache',
  [tokens.common.help]: 'Hilfe',
  [tokens.common.helpAndSupport]: 'Hilfe & Support',
  [tokens.common.supportChat]: 'Mit dem Support chatten',
  [tokens.common.supportChatUnread]: 'Ungelesene Nachrichten: {{count}}',
  [tokens.common.supportChatMoveHint]: 'Ziehen oder Pfeiltasten zum Verschieben',
  [tokens.common.active]: 'Aktiv',
  [tokens.common.group]: 'Agentur',
  [tokens.common.groups]: 'Agenturen',
  [tokens.common.groupSettings]: 'Agentureinstellungen',
  [tokens.common.selectGroup]: 'Wählen Sie eine Agentur',
  [tokens.common.userSettings]: 'Benutzer-Einstellungen',
  [tokens.common.collaborators]: 'Mitarbeiterin',
  [tokens.common.update]: 'Aktualisierung',
  [tokens.common.actions]: 'Aktionen',
  [tokens.common.parameters]: 'Parameter',
  [tokens.common.external]: 'External',
  [tokens.common.required]: 'erforderlich',
  [tokens.common.validEmail]: 'Muss eine gültige E-Mail sein',
  [tokens.common.emailRequired]: 'E-Mail-Adresse ist erforderlich',
  [tokens.common.passwordRequired]: 'Passwort ist erforderlich',
  [tokens.common.matchPasswordsRequired]:
    'Die Passwörter müssen übereinstimmen',
  [tokens.common.passwordRuleLowercase]: 'Mindestens ein Kleinbuchstabe',
  [tokens.common.passwordRuleUppercase]: 'mindestens ein Großbuchstabe',
  [tokens.common.passwordRuleDigit]: 'Mindestens eine Zahl',
  [tokens.common.passwordRuleSpecial]:
    'Mindestens ein Sonderzeichen (@, $, !, %, *, ?, &)',
  [tokens.common.passwordRuleLength]: 'Zwischen 8 und 16 Zeichen',
  [tokens.common.passwordConfirmationRequired]:
    'Bitte bestätigen Sie Ihr Passwort',
  [tokens.common.firstNameRequired]: 'Vorname ist erforderlich',
  [tokens.common.lastNameRequired]: 'Nachname ist erforderlich',
  [tokens.common.roleRequired]: 'Es muss eine Rolle eingegeben werden.',
  [tokens.common.languageRequired]: 'Sprache ist erforderlich',
  [tokens.common.organizationRequired]: 'Organisation erforderlich',
  [tokens.common.groupRequired]: 'Agentur ist erforderlich',
  [tokens.common.socialNameRequired]: 'Sozialer Name ist erforderlich',
  [tokens.common.registrationNumberRequired]:
    'Registrierungsnummer ist erforderlich',
  [tokens.common.countryRequired]: 'Land ist erforderlich',
  [tokens.common.affiliatedGroup]:
    'Wählen Sie die Agenturen aus, mit denen Sie sich verbinden möchten',
  [tokens.common.share]: 'Freigeben',
  [tokens.common.step]: 'Schritt',
  [tokens.common.none]: 'keine',
  [tokens.common.registeredCustomsRepresentative]:
    'Eingetragener Zollvertreter',
  [tokens.common.customsManager]: 'Zollverwalter',
  [tokens.common.customsTeamManager]: 'Teamleiter Zoll',
  [tokens.common.informationSystemsManager]: 'Manager für Informationssysteme',
  [tokens.common.nabuAdministrator]: 'Nabu-Administrator',
  [tokens.common.french]: 'Französisch',
  [tokens.common.english]: 'Englisch',
  [tokens.common.german]: 'Deutsch',
  [tokens.common.administrator]: 'Administrator',
  [tokens.common.basicInformation]: 'Basisinformationen',
  [tokens.common.personalInformation]: 'Angaben zur Person',
  [tokens.common.companyInformation]: 'Impressum',
  [tokens.common.organizationAndGroups]: 'Organisation und Agenturen',
  [tokens.common.establishmentsAndGroups]: 'Betriebe & Agenturen',
  [tokens.common.settings]: 'Einstellungen',
  [tokens.common.save]: 'Speichern',
  [tokens.common.saving]: 'Wird gespeichert…',
  [tokens.common.saved]: 'Gespeichert',
  [tokens.common.changePassword]: 'Passwort ändern',
  [tokens.common.oldPassword]: 'Altes Passwort',
  [tokens.common.newPassword]: 'Neues Passwort',
  [tokens.common.passwordChangeSuccess]: 'Passwortänderung erfolgreich',
  [tokens.common.passwordChangeError]:
    'Beim Ändern Ihres Passworts ist ein Fehler aufgetreten.',
  [tokens.common.fileName]: 'Erklärungsbezeichung',
  [tokens.common.generalInformation]: 'Allgemeine Informationen',
  [tokens.common.offices]: 'I.12.',
  [tokens.common.edit]: 'Bearbeiten',
  [tokens.common.accessInformations]: 'Zugangsinformationen',
  [tokens.common.deleteAccount]: 'Account löschen',
  [tokens.common.deleteAccountWarning]:
    'Das Löschen Ihres Kontos und aller Ihrer Daten ist irreversibel.',
  [tokens.common.name]: 'Benennung',
  [tokens.common.client]: 'Auftraggeber:Innen',
  [tokens.common.date]: 'Datum',
  [tokens.common.status]: 'Status',
  [tokens.common.actions]: 'Aktionen',
  [tokens.common.option10]: '10',
  [tokens.common.option20]: '20',
  [tokens.common.option50]: '50',
  [tokens.common.searchByCaseName]: 'Nach Fallnamen suchen',
  [tokens.common.all]: 'Alle',
  [tokens.common.pending]: 'Ausstehend',
  [tokens.common.from]: 'Von',
  [tokens.common.to]: 'Herrn',
  [tokens.common.view]: 'Ansehen',
  [tokens.common.folder]: 'Anmeldung',
  [tokens.common.customDeclaration]: 'Verzollungs Deklaration',
  [tokens.common.billOfLading]: 'Frachtbrief',
  [tokens.common.exported]: 'Exportiert',
  [tokens.common.toTreat]: 'Zielprozess',
  [tokens.common.archived]: 'Archiviert',
  [tokens.common.inProgress]: 'In Bearbeitung',
  [tokens.common.category]: 'Kategorie',
  [tokens.common.searchByName]: 'Nach einer Anmeldung suchen',
  [tokens.common.layerName]: 'Modellname',
  [tokens.common.modelName]: 'Kundenmodell',
  [tokens.common.modelSearchPlaceholder]: 'Nach einem Modell suchen',
  [tokens.common.modelTabName]: 'Modellname',
  [tokens.common.modelTabType]: 'Modelltyp',
  [tokens.common.declarationType]: 'Deklarationsart',
  [tokens.common.flowTabExporter]: 'Sender',
  [tokens.common.flowTabCreatedBy]: 'Erstellt von',
  [tokens.common.flowTabDate]: 'Erstellungsdatum',
  [tokens.common.modelDeleteOneTitle]: 'Ein Modell löschen',
  [tokens.common.modelDeleteOneText]: 'Möchtest du das löschen?',
  [tokens.common.modelDeleteMultipleTitle]: 'Löschen mehrerer Modelle',
  [tokens.common.modelDeleteMultipleText]:
    'Bist du sicher, dass du sie löschen willst?',
  [tokens.common.modelHasBeenDeleted]: 'Das Modell wurde gelöscht',
  [tokens.common.modelHasNotBeenDeleted]: 'Das Modell wurde nicht gelöscht',
  [tokens.common.teamName]: 'Teamname',
  [tokens.common.office]: 'im Büro',
  [tokens.common.loggedIn]:
    'Willkommen zurück! Sie haben sich erfolgreich angemeldet.',
  [tokens.common.permissionError]:
    'Du verfügst nicht über die notwendige Berechtigung, diese Seite anzusehen.',
  [tokens.common.permissionAndAccess]: 'Typ der Zugangsberechtigung',
  [tokens.common.fieldNotFound]: 'Feld nicht gefunden',
  [tokens.common.failToSave]: 'Speichern fehlgeschlagen',
  [tokens.common.team]: 'Team',
  [tokens.common.profil]: 'Profil',
  [tokens.common.security]: 'Sicherheit',
  [tokens.common.metrics]: 'Wirtschaftlichkeitskontrolle',
  [tokens.common.copiedToClipBoard]: 'In Zwischenablage kopiert',
  [tokens.common.setup]: 'Konfiguration',
  [tokens.common.setups]: 'Konfigurationen',
  [tokens.common.addSetup]: 'Konfiguration erstellen',
  [tokens.common.noSetup]: 'Keine Konfiguration vorhanden!',
  [tokens.common.noOptionAvailable]: 'Keine Option verfuegbar',
  [tokens.common.noSetupGroup]:
    'Keine Konfiguration für diese Agentur verfügbar',
  [tokens.common.editSetup]: 'Konfiguration bearbeiten',
  [tokens.common.createSetup]: 'Konfiguration erstellen',
  [tokens.common.download]: 'Herunterladen',
  [tokens.common.file]: 'Datei',
  [tokens.common.files]: 'Dateien',
  [tokens.common.punctualCustomer]: 'Pünktlicher Kunde',
  [tokens.common.regularCustomer]: 'Regelmäßiger Kunde',
  [tokens.common.creationOfNewFolder]: 'Erstellung einer neuen Anmeldung',
  [tokens.common.folderCreationInProgress]: 'Vorgang wird erstellt',
  [tokens.common.emailFrom]: 'Gesendet von',
  [tokens.common.workInProgress]: 'Ausstehende Erklärungen',
  [tokens.common.document]: 'Deklaration',
  [tokens.common.classification]: 'Klassifikation',
  [tokens.common.model]: 'Modell',
  [tokens.common.models]: 'Modelle',
  [tokens.common.information]: 'Informationen',
  [tokens.common.exportConfiguration]: 'Konfiguration',
  [tokens.common.userSettings]: 'Benutzer-Einstellungen',
  [tokens.common.confirmationRequired]: 'Bestätigung erforderlich',
  [tokens.common.rowsPerPage]: 'Zeilen pro Seite',
  [tokens.common.displayedRows]: '{{from}}-{{to}} von {{count}}',
  [tokens.common.details]: 'Details',
  [tokens.common.declaration]: 'Deklaration',
  [tokens.common.backToHome]: 'Zurück zur Startseite',
  [tokens.common.message401]: 'genehmigungspflichtige Einladung',
  [tokens.common.message404]:
    '404: Die von Ihnen gesuchte Seite ist nicht hier',
  [tokens.common.message500]: '500 Interner Serverfehler',
  [tokens.common.titleErrorPage]: 'Unbekannter Fehler',
  [tokens.common.messageErrorPage]:
    'Es ist ein unerwarteter Fehler aufgetreten. Bitte versuche es erneut.',
  [tokens.common.key]: 'Kennungl',
  [tokens.common.configurations]: 'Konfigurationen',
  [tokens.common.configuration]: 'Konfiguration',
  [tokens.common.userSettingsNoParameter]: 'Keine Parameter vorhanden',
  [tokens.common.commonError]: 'Es ist ein Fehler aufgetreten',
  [tokens.common.author]: 'Vorgeschlagen von',
  [tokens.common.noFiles]: 'Keine Dateien verfügbar.',
  [tokens.common.notification]: 'Meldung',
  [tokens.common.createdBy]: 'Erstellt von',
  [tokens.common.sendBy]: 'Gesendet von',
  [tokens.common.updateSucceeded]: 'Aktualisierung gelungen',
  [tokens.common.updateFailed]: 'Update fehlgeschlagen',
  [tokens.common.filesDropInputWrongFormat]: 'Nicht unterstützter Dateityp',
  [tokens.common.hintMessageFirstText]: 'Gebrauch',
  [tokens.common.hintMessageSecondText]: 'Freier Platz',
  [tokens.common.hintMessageThirdText]: 'Schlüsselwort hinzufügen',
  [tokens.common.hintMessageFourthText]:
    'um nach einer genauen Phrase zu suchen.',
  [tokens.common.thisActionCannotBeUndone]:
    'Diese Aktion kann nicht rückgängig gemacht werden.',
  [tokens.common.remove]: 'Entlassen',
  [tokens.common.unknown]: 'Unbekannt',
  [tokens.common.selectAction]: 'Aktion auswählen',
  [tokens.common.deselect]: 'Abwählen',
  [tokens.common.expandAll]: 'Alle aufklappen',
  [tokens.common.collapseAll]: 'Alle ausblenden',
  [tokens.common.validated]: 'Geprüft',
  [tokens.common.week]: 'Woche',
  [tokens.common.month]: 'Monat',
  [tokens.common.seeDetails]: 'Details anzeigen',
  [tokens.common.hideDetails]: 'Details ausblenden',
  [tokens.common.start]: 'Start',
  [tokens.common.end]: '-End.',
  [tokens.common.clearAll]: 'Alle löschen',
  [tokens.common.noCustomersSelected]: 'Keine Kunden ausgewählt',
  [tokens.common.aboutThisDeclaration]: 'Über diese Erklärung',
  [tokens.common.preparationInProgress]: 'in Vorbereitung',
  [tokens.common.processingTimeline]: 'Verarbeitungsverlauf',
  [tokens.common.invoiceDate]: 'Rechnungs-Datum',
  [tokens.common.articles]: 'Artikel',
  [tokens.common.commodityCodesFilled]: 'Warennummern ausgefüllt',
  [tokens.common.mode]: 'Betriebsmodus',
  [tokens.common.delivered]: 'Übermittelt',
  [tokens.common.lastModified]: 'Zuletzt geändert',
  [tokens.common.lastModifiedAt]: 'Zuletzt geändert am',
  [tokens.common.tags]: 'Schlagwörter',
  [tokens.common.type]: 'Typ',
  [tokens.common.downloadArchive]: 'Laden Sie das Archiv herunter',
  [tokens.common.downloadValueDetail]: 'Laden Sie das Wertdetail herunter',
  [tokens.common.viewDetail]: 'Details ansehen',
  [tokens.common.show]: 'Anzeigen',
  [tokens.common.hide]: 'Ausblenden',
  [tokens.common.noteSucccessfullySaved]: 'Erfolgreich gespeichert',
  [tokens.common.errorOccuredWhileSavingNote]:
    'Beim Speichern des Formulars ist ein Fehler aufgetreten.',
  [tokens.common.ctrlClickToOpenInNewTab]:
    'Strg/Cmd + Klick zum Öffnen in einem neuen Tab',
  [tokens.common.offline]:
    'Ihre Netzwerkverbindung scheint unterbrochen zu sein. Bitte überprüfen Sie Ihren Internetzugang und versuchen Sie es erneut.',
  [tokens.common.online]: 'Ihr Netzwerk ist wiederhergestellt!',
  [tokens.common.maintenanceTitle]: 'Geplante Wartung',
  [tokens.common.maintenanceUntil]: 'Nabu wird bis {{date}} um {{time}} Uhr gewartet.',
  [tokens.common.maintenanceNoEnd]: 'Nabu ist wegen Wartungsarbeiten vorübergehend nicht verfügbar.',
  [tokens.common.maintenanceSessionKept]:
    'Ihre Sitzung bleibt erhalten. Sie müssen die Seite nicht neu laden: Nabu öffnet sich von selbst wieder, sobald die Wartung beendet ist.',
  [tokens.common.newVersionAvailableMessage]:
    'Eine neue Version ist verfügbar. Aktualisieren Sie die Seite, um sie zu verwenden.',
  [tokens.common.refreshPageForNewVersion]: 'Aktualisieren',
  [tokens.common.noTags]: 'Nessun tag',
  [tokens.common.declarant]: 'Die Erklärung abgebende Person',
  [tokens.common.editComment]: 'Kommentar bearbeiten',
  [tokens.common.deleteComment]: 'Kommentar löschen',
  [tokens.common.addAComment]: 'Schreibe einen Kommentar...',
  [tokens.common.areYouSureYouWantToDeleteThisComment]:
    'Sind Sie sicher, dass Sie diesen Kommentar löschen wollen?',
  [tokens.common.urgent]: 'Dringlich',
  [tokens.common.sendUrgent]: 'Dringend senden',
  [tokens.common.putFileErrorStatus]: 'Anmeldung in den Fehlerstatus versetzen',
  [tokens.common.subscribers]: 'Abonnenten',
  [tokens.common.typeAnEmailAndPressEnter]:
    'Geben Sie eine E-Mail ein und drücken Sie die Eingabetaste',
  [tokens.common.autoMode]: 'Automatik',
  [tokens.common.darkMode]: 'Dunkelmodus',
  [tokens.common.lightMode]: 'Heller Modus',
  [tokens.common.theme]: 'Theme',
  [tokens.common.themePressToCycle]:
    'Drücken Sie, um zum nächsten Theme-Modus zu wechseln.',
  [tokens.events.declarationReceivedBy]:
    'Antrag auf Erklärung erhalten von {{source}}',
  [tokens.events.creationAndExtractionOfDeclaration]:
    'Erstellung und Extraktion der Erklärung {{reference}}',
  [tokens.events.missingDataIdentified]: 'Fehlende Daten identifiziert',
  [tokens.events.missingDataAddedFromDataLibrary]:
    'Fehlende Daten aus der Datenbibliothek hinzugefügt',
  [tokens.events.informationRequested]: 'Erbetene Informationen',
  [tokens.events.informationReceived]: 'Erhaltene Informationen',
  [tokens.events.declarationValidationsCompleted]:
    'Deklarationsvalidierungen abgeschlossen',
  [tokens.events.declarationFinalized]: 'Erklärung {{reference}} abgeschlossen',
  [tokens.events.declarationFinalizedBy]:
    'Erklärung {{reference}} abgeschlossen von {{accountName}}',
  [tokens.events.declarationSent]:
    'Erklärung {{reference}} gesendet an {{clientDestinationName}}',
  [tokens.events.processingStopped]: 'Verarbeitung gestoppt',

  [tokens.batchImportHistory.historyDrawerTitle]: 'Verlauf der Erklärung',
  [tokens.batchImportHistory.historyOpenTooltip]:
    'Verlauf der Erklärung anzeigen',
  [tokens.batchImportHistory.historySearchPlaceholder]: 'Im Verlauf suchen…',
  [tokens.batchImportHistory.historySearchEmpty]:
    'Keine Ergebnisse für diese Suche',
  [tokens.batchImportHistory.historyEmpty]: 'Keine Verlaufseinträge',
  [tokens.batchImportHistory.historyLoadError]:
    'Verlauf konnte nicht geladen werden',
  [tokens.batchImportHistory.historyRetry]: 'Erneut versuchen',
  [tokens.batchImportHistory.historyExpand]: 'Details anzeigen',
  [tokens.batchImportHistory.historyCollapse]: 'Details ausblenden',
  [tokens.batchImportHistory.historyActorSystem]: 'System',
  [tokens.batchImportHistory.historyActorUnknownUser]: 'Benutzer',
  [tokens.batchImportHistory.historyFieldsCount]: '{{count}} Feld',
  [tokens.batchImportHistory.historyFieldsCount_other]: '{{count}} Felder',
  [tokens.batchImportHistory.historyReplacedFields]: 'Ersetzte Felder',
  [tokens.batchImportHistory.historyEmptyValue]: 'leer',
  [tokens.batchImportHistory.historyRowSuffix]: ' (Zeile {{row}})',
  [tokens.batchImportHistory.historyActionDeclarationModified]:
    'Erklärung geändert',
  [tokens.batchImportHistory.historyActionDeclarationCreated]:
    'Erklärung erstellt',
  [tokens.batchImportHistory.historyActionDeclarationSent]:
    'Erklärung gesendet',
  [tokens.batchImportHistory.historyActionAutomationRun]:
    'Tabellenautomatisierung gestartet',
  [tokens.batchImportHistory.historyActionExtractionRerun]:
    'Extraktion erneut gestartet',
  [tokens.batchImportHistory.historyActionClassificationRerun]:
    'Klassifizierung erneut gestartet',
  [tokens.batchImportHistory.historyActionMerge]:
    'Zusammenführung durchgeführt',
  [tokens.batchImportHistory.historyActionMergeColumnsTitle]:
    'Spalten zusammengeführt',
  [tokens.batchImportHistory.historyActionMergeBatchImportsTitle]:
    'Anmeldungen zusammengeführt',
  [tokens.batchImportHistory.historyActionMarkedError]:
    'Anmeldung als fehlerhaft markiert',
  [tokens.batchImportHistory.historyActionTagAdded]: 'Tag hinzugefügt',
  [tokens.batchImportHistory.historyActionClientChanged]: 'Kunde geändert',
  [tokens.batchImportHistory.historyActionRowDeleted]: 'Artikelzeile gelöscht',
  [tokens.batchImportHistory.historyActionFileAdded]: 'Datei hinzugefügt',
  [tokens.batchImportHistory.historyFilesCount]: '{{count}} Datei',
  [tokens.batchImportHistory.historyFilesCount_other]: '{{count}} Dateien',
  [tokens.batchImportHistory.historyDeletedRowValues]: 'Inhalt der Zeile',
  [tokens.batchImportHistory.historyRowLabel]: 'Zeile {{row}}',
  [tokens.batchImportHistory.historyDocumentsCount]: '{{count}} Dokument',
  [tokens.batchImportHistory.historyDocumentsCount_other]:
    '{{count}} Dokumente',
  [tokens.batchImportHistory.historyMergeColumns]:
    '{{count}} Spalte zusammengeführt',
  [tokens.batchImportHistory.historyMergeColumns_other]:
    '{{count}} Spalten zusammengeführt',
  [tokens.batchImportHistory.historyMergeBatchImports]:
    '{{count}} Anmeldungen zusammengeführt',
  [tokens.batchImportHistory.historyMergeBatchImports_other]:
    '{{count}} Anmeldungen zusammengeführt',
  [tokens.batchImportHistory.historyMarkedErrorManual]:
    'Manuell als fehlerhaft markiert',
  [tokens.batchImportHistory.historyMarkedErrorUploadFailed]:
    'Dokumenten-Upload fehlgeschlagen',
  [tokens.batchImportHistory.historyMarkedErrorMissingSuffix]: 'fehlend',
  [tokens.batchImportHistory.historyFilterAll]: 'Alle',
  [tokens.batchImportHistory.historyFilterCorrections]: 'Korrekturen',
  [tokens.batchImportHistory.historyUndoCorrection]:
    'Diese Korrektur rückgängig machen',
  [tokens.batchImportHistory.historyRedoCorrection]: 'Wiederherstellen',
  [tokens.batchImportHistory.historyRevertedAt]: 'rückgängig um {{time}}',
  [tokens.batchImportHistory.historyCorrectionSet]: 'Wert korrigiert',
  [tokens.batchImportHistory.historyCorrectionClear]: 'Wert gelöscht',
  [tokens.batchImportHistory.historyCorrectionValidate]:
    'Erklärung validiert',
  [tokens.batchImportHistory.historyCorrectionReviewConfirmed]:
    'Prüfung bestätigt',
  [tokens.batchImportHistory.historyCorrectionReviewReopened]:
    'Punkt wieder geöffnet',
  [tokens.batchImportHistory.historyCorrectionAddTuple]: 'Vorkommen hinzugefügt',
  [tokens.batchImportHistory.historyCorrectionRemoveTuple]:
    'Vorkommen entfernt',
  [tokens.batchImportHistory.historyCorrectionClearColumn]:
    'Spalte geleert',
  [tokens.batchImportHistory.historyCorrectionSetColumn]: 'Spalte befüllt',
  [tokens.batchImportHistory.historyCorrectionAddLine]: 'Artikel hinzugefügt',
  [tokens.batchImportHistory.historyCorrectionRemoveLine]:
    'Artikel entfernt',
  [tokens.batchImportHistory.historyCorrectionUnvalidate]: 'Überarbeitung geöffnet',
  [tokens.batchImportHistory.historyCorrectionAbandonRevision]:
    'Überarbeitung verworfen: zurück zur übermittelten Version',

  [tokens.configuration.configurationNameWarning]:
    'Name der Konfiguration ist erforderlich',
  [tokens.configuration.addAField]: 'Feld hinzufügen ',
  [tokens.configuration.typeTransportWarning]:
    'Art des Exports ist erforderlich',
  [tokens.configuration.nameTransportWarning]:
    'Name der Software ist erforderlich',
  [tokens.configuration.addressTransportWarning]:
    'URL- oder FTP-Adresse ist erforderlich',
  [tokens.configuration.portTransportWarning]: 'Port ist erforderlich',
  [tokens.configuration.emailAuthenticationTransportWarning]:
    'E-Mail zur Authentifizierung ist erforderlich',
  [tokens.configuration.passwordAuthenticationTransportWarning]:
    'Passwort ist erforderlich',
  [tokens.configuration.configurationSaved]: 'Konfiguration gespeichert',
  [tokens.configuration.configurationName]: 'Bezeichnung',
  [tokens.configuration.softwareName]: 'Softwarename',
  [tokens.configuration.typeTransport]: 'Verkehrszweig',
  [tokens.configuration.addressTransport]: 'API-URL oder SFTP',
  [tokens.configuration.portTransport]: 'Port',
  [tokens.configuration.emailAuthenticationTransport]: 'Mail',
  [tokens.configuration.passwordAuthenticationTransport]: 'Passwort',
  [tokens.configuration.pleaseChooseAGroupAndAConfiguration]:
    'Bitte wählen Sie eine Agentur und Konfiguration',
  [tokens.configuration.pleaseChooseAConfiguration]:
    'Bitte wählen Sie eine Konfiguration',
  [tokens.configuration.noSettingsFoundForConfiguration]:
    'Keine Einstellungen für die ausgewählte Konfiguration gefunden',
  [tokens.configuration.noSettingsAvailableForConfiguration]:
    'Keine Einstellungen für die ausgewählte Konfiguration verfügbar',
  [tokens.configuration.availableSettingKeys]: 'Verfügbare Einstelltasten',
  [tokens.configuration.youHaveUnsavedConfigurationChanges]:
    'Sie haben ungespeicherte Änderungen',
  [tokens.configuration.cannotRemoveLastTupleItem]:
    'Mindestens ein Element muss beibehalten werden.',
  [tokens.upload.dropText]: 'Dateien hierher ziehen',
  [tokens.upload.declarationType]: 'Art der Anmeldung',
  [tokens.upload.exportService]: 'Zollsoftware',
  [tokens.upload.model]: 'Modell',
  [tokens.upload.emailHookText]: 'Du sendest Deine Unterlagen an...',
  [tokens.upload.atLeastOneFileRequired]:
    'es ist mindestens eine Datei erforderlich',
  [tokens.upload.warningOnNumberFilesMinimum]:
    'es ist mindestens eine Datei erforderlich',
  [tokens.upload.warningOnNumberFilesMaximum]:
    'Es wird nur eine Datei erwartet',
  [tokens.upload.requiredFiles]: 'Dateien sind erforderlich',
  [tokens.upload.requiredCustomerType]: 'Kundentyp ist erforderlich',
  [tokens.upload.requiredRecordName]: 'Deklarationsname ist erforderlich',
  [tokens.upload.warningOnRecordNameLength]:
    'Der Datensatzname darf höchstens 255 Zeichen lang sein',
  [tokens.upload.requiredExportConfiguration]:
    'Deklarationssoftware erforderlich',
  [tokens.upload.requiredDeclarationType]: 'Art der Erklärung erforderlich',
  [tokens.upload.requiredModelConfiguration]: 'Modell erforderlich',
  [tokens.upload.requiredGroup]: 'Agentur ist erforderlich',
  [tokens.upload.noModelFound]: 'Kein Modell gefunden',
  [tokens.upload.modelWarning]:
    'Warnung: Das Ändern des Modells kann dazu führen, dass einige vorhandene Daten in Ihrer Anmeldung überschrieben werden.',
  [tokens.upload.agenticLabel]: 'Agentic',
  [tokens.upload.nfRequired]: 'PFLICHT',
  [tokens.upload.wizardStepFilesLabel]: 'Dateien',
  [tokens.upload.wizardStepFilesSubtitle]:
    'Legen Sie die zu verarbeitenden Dokumente ab.',
  [tokens.upload.wizardStepFolderLabel]: 'Vorgang',
  [tokens.upload.wizardStepFolderSubtitle]:
    'Name, Zuordnung, Kunde und Tags.',
  [tokens.upload.wizardPreparationSectionTitle]: 'Vorbereitung',
  [tokens.upload.wizardPreparationModeStandardTitle]: 'Klassische Vorbereitung',
  [tokens.upload.wizardPreparationModeStandardDescription]:
    'Algorithmische Dokumentenlesung. Felder werden vorausgefüllt, Sie bestätigen jeden Schritt.',
  [tokens.upload.wizardPreparationModeIntelligentTitle]: 'Intelligente Vorbereitung',
  [tokens.upload.wizardPreparationModeIntelligentDescription]:
    'Nabu bereitet Ihren Vorgang vor: organisiert, vervollständigt, behebt Anomalien und legt Ihnen das Ergebnis vor.',
  [tokens.upload.wizardPreparationModeNewBadge]: 'Neu',
  [tokens.upload.wizardFilesStepGuidance]:
    'Schnellerstellung, oder „Optionen“, um den Vorgang zu benennen und zuzuordnen.',
  [tokens.upload.wizardFilesStepGuidanceClassic]:
    'Weiter zu den Optionen, um den Vorgang auszufüllen.',
  [tokens.upload.wizardStepCounter]: 'Schritt {{step}} von {{total}}',
  [tokens.upload.wizardCompleteRequiredFields]:
    'Vervollständigen Sie die markierten Felder.',
  [tokens.upload.wizardAddAtLeastOneFile]:
    'Fügen Sie mindestens eine Datei hinzu, um fortzufahren.',
  [tokens.upload.wizardSubmitting]:
    'Dateien werden gesendet, schließen Sie dieses Fenster nicht.',
  [tokens.upload.wizardCreating]: 'Wird erstellt…',
  [tokens.upload.wizardDropTitle]: 'Ziehen Sie Ihre Dateien hierher',
  [tokens.upload.wizardDropTitleActive]: 'Zum Hinzufügen ablegen',
  [tokens.upload.wizardDropSubtitle]:
    'oder klicken Sie zum Durchsuchen · PDF, Bilder, XLSX · max. 20 MB',
  [tokens.upload.wizardAddFiles]: 'Dateien hinzufügen',
  [tokens.upload.wizardRemoveFile]: 'Diese Datei aus dem Vorgang entfernen',
  [tokens.upload.wizardFilesCount]: '{{count}} Datei',
  [tokens.upload.wizardFilesCount_other]: '{{count}} Dateien',
  [tokens.upload.wizardFolderNamePlaceholder]:
    'Z. B. Sammelsendung Delmas 88431',
  [tokens.upload.wizardFolderNameSuggested]:
    'Aus dem Namen der ersten Datei vorausgefüllt, bearbeitbar.',
  [tokens.upload.wizardAgencyLabel]: 'Agentur / Team',
  [tokens.upload.wizardAgencyHint]:
    'Organisation oder Agentur: bestimmt verfügbare Deklarationstypen und Modelle. Bei intelligenter Vorbereitung die Agentur, die Sie am häufigsten für Ihre Vorgänge nutzen. Sonst Ihre Organisation.',
  [tokens.upload.wizardAgencyOrganizationBadge]: 'Organisation',
  [tokens.upload.wizardAgencyClearToOrganization]: 'Zur Organisation zurück',
  [tokens.upload.wizardNoAgencyOption]: 'Keine Agentur verfügbar',
  [tokens.upload.wizardTypePlaceholder]: 'Typ wählen',
  [tokens.upload.wizardTypePrefilledHint]: 'Vorausgefüllt, bearbeitbar.',
  [tokens.upload.wizardTypeTooltip]:
    'Ohne Auswahl wird die Richtung (Import/Export) automatisch aus den Dokumenten erkannt. Später über das Badge unter dem Vorgangstitel änderbar.',
  [tokens.upload.wizardChooseGroupFirst]: 'Wählen Sie zuerst eine Agentur.',
  [tokens.upload.wizardWorkflowLabel]: 'Modell',
  [tokens.upload.wizardWorkflowHint]: 'Vorgefertigte Konfiguration.',
  [tokens.upload.wizardWorkflowTooltip]:
    'Füllt wiederkehrende Felder bereits bei der Erstellung voraus. Aus Dokumenten extrahierte Werte werden nicht überschrieben.',
  [tokens.upload.wizardWorkflowPlaceholder]: 'Kein Modell',
  [tokens.upload.wizardNoWorkflowForCombination]:
    'Kein Modell für diese Kombination. Manuelle Bearbeitung.',
  [tokens.upload.wizardClientHint]: 'Name oder Referenz.',
  [tokens.upload.wizardClientSearchPlaceholder]: 'Kunde suchen',
  [tokens.upload.wizardNoClientOption]: 'Kein Kunde',
  [tokens.upload.wizardNoClientFound]: 'Kein Kunde gefunden',
  [tokens.upload.wizardNoWorkflowFound]: 'Kein Modell gefunden',
  [tokens.upload.wizardOptionsLoading]: 'Wird geladen…',
  [tokens.upload.wizardTagsHint]: 'Um den Vorgang in den Filtern wiederzufinden.',
  [tokens.upload.wizardTagsPlaceholder]: 'Tags hinzufügen',
  [tokens.upload.wizardOptionsButton]: 'Optionen',
  [tokens.upload.wizardQuickCreateButton]: 'Schnellerstellung',
  [tokens.upload.wizardQuickCreateButtonInAgency]:
    'Schnellerstellung in {{agency}}',
  [tokens.upload.wizardQuickCreateTooltip]:
    'Erstellt den Vorgang sofort in {{agency}}.',
  [tokens.upload.wizardCreateFolderButton]: 'Vorgang erstellen',
  [tokens.documents.collaborators]: 'Mitwirkende',
  [tokens.documents.statusExported]: 'Gesendet',
  [tokens.documents.createNewFlowFromThisDeclaration]:
    'Erstellen Sie einen neuen Workflow aus dieser Erklärung',
  [tokens.documents.statusToRead]: 'Zum Lesen',
  [tokens.documents.statusToTreat]: 'Zielprozess',
  [tokens.documents.statusToSend]: 'Zu senden',
  [tokens.documents.statusError]: 'Error',
  [tokens.documents.statusAbandoned]: 'Verfallen',
  [tokens.documents.statusExportFailed]: 'Versand fehlgeschlagen',
  [tokens.documents.batchImportErrorTitle]: 'Anmeldung mit Fehler',
  [tokens.documents.batchImportAbandonedTitle]: 'Verfallene Anmeldung',
  [tokens.documents.batchImportAbandonedWhatToDo]:
    'Falls die Anmeldung noch erforderlich ist, legen Sie sie mit denselben Dateien erneut an.',
  [tokens.documents.batchImportErrorReasonProcessingTimeout]:
    'Die automatische Verarbeitung wurde nicht innerhalb von 15 Minuten abgeschlossen.',
  [tokens.documents.batchImportErrorReasonWorkflowLost]: 'Die Verarbeitung wurde vor dem Abschluss unterbrochen.',
  [tokens.documents.batchImportErrorReasonWorkflowStuck]: 'Die Verarbeitung ist blockiert.',
  [tokens.documents.batchImportErrorReasonFilesTimeout]: 'Innerhalb der vorgesehenen Zeit wurde keine Datei empfangen.',
  [tokens.documents.batchImportErrorReasonHumanTimeout]:
    'Die Anmeldung wartete auf eine Aktion und die Frist ist abgelaufen.',
  [tokens.documents.batchImportErrorReasonNoUsableDocument]:
    'In der Anmeldung wurde kein verwertbares Dokument gefunden.',
  [tokens.documents.batchImportErrorReasonStepFailed]:
    'Ein Verarbeitungsschritt ist fehlgeschlagen.',
  [tokens.documents.batchImportErrorReasonNoTypedDocument]:
    'Keines der Dokumente wurde erkannt. Der Vorgang kann nicht automatisch verarbeitet werden.',
  [tokens.documents.batchImportErrorReasonNoGroupConfiguration]:
    'Für diese Gruppe ist keine Konfiguration verfügbar. Wenden Sie sich an Ihren Administrator.',
  [tokens.documents.batchImportErrorReasonBlockingDiagnostic]:
    'Ein Dokument verhindert die Erstellung der Anmeldung.',
  [tokens.documents.batchImportErrorReasonEmptyDeclaration]:
    'In den Dokumenten wurden keine verwertbaren Daten zum Ausfüllen der Anmeldung gefunden. Der Vorgang kann nicht automatisch verarbeitet werden.',
  [tokens.documents.batchImportErrorReasonRepeatedBlock]:
    'Dasselbe Problem ist nach dem erneuten Start wieder aufgetreten. Wenden Sie sich an den Support.',
  [tokens.documents.batchImportErrorReasonUnknown]: 'Die Verarbeitung wurde nicht abgeschlossen.',
  [tokens.documents.batchImportErrorStoppedAt]:
    'Um {{time}} im Schritt {{step}} gestoppt.',
  [tokens.documents.batchImportErrorStoppedAtStep]:
    'Im Schritt {{step}} gestoppt.',
  [tokens.documents.batchImportErrorStoppedAtTime]:
    'Um {{time}} gestoppt.',
  [tokens.documents.batchImportErrorEarlierStepsSucceeded]:
    'Die vorherigen Schritte waren erfolgreich.',
  [tokens.documents.batchImportErrorStepAwaitingUploads]: 'Empfang',
  [tokens.documents.batchImportErrorStepFileProcessing]: 'Dokumentenauswertung',
  [tokens.documents.batchImportErrorStepExtraction]: 'Extraktion',
  [tokens.documents.batchImportErrorStepMapping]: 'Aufbereitung',
  [tokens.documents.batchImportErrorWhatToDo]: 'Was nun?',
  [tokens.documents.batchImportErrorWhatToDoFilesMissing]:
    'Für diese Anmeldung ist keine Datei eingegangen. Legen Sie es erneut an und fügen Sie die Dokumente bei.',
  [tokens.documents.batchImportErrorContactSupport]:
    'Wenden Sie sich an den Support und geben Sie die obenstehende Referenz an.',
  [tokens.documents.batchImportErrorContactButton]: 'Kontakt aufnehmen',
  [tokens.documents.batchImportErrorSupportMessage]:
    'Hallo, meine Anmeldung wurde mit einem Fehler gestoppt und ich möchte sie fortsetzen lassen.',
  [tokens.documents.batchImportErrorRecreate]:
    'Sie können die Anmeldung auch mit denselben Dateien neu anlegen.',
  [tokens.documents.batchImportErrorRetryButton]: 'Erneut starten',
  [tokens.documents.batchImportErrorRetryFailed]:
    'Der erneute Start ist fehlgeschlagen. Versuchen Sie es erneut oder wenden Sie sich an den Support.',
  [tokens.documents.batchImportErrorNotified]: 'Unser technisches Team wurde benachrichtigt.',
  [tokens.documents.statusSent]: 'Gesendet',
  [tokens.documents.visualizeDocuments]: 'Dokumente anzeigen',
  [tokens.documents.downloadDeclarationXML]:
    'Erklärung im XML-Format herunterladen',
  [tokens.documents.downloadDetailValue]: 'Laden Sie die Wertdetails herunter',
  [tokens.documents.downloadOrginalDocuments]:
    'Laden Sie die Originaldokumente herunter',
  [tokens.documents.declarationExportNotFound]:
    'Der Erklärungsexport konnte nicht gefunden werden.',
  [tokens.documents.valueDetailExportNotFound]:
    'Das Wertdetail ist für diese Erklärung nicht verfügbar.',
  [tokens.documents.typeDocument]: 'Dokumenttyp',
  [tokens.documents.nameDocument]: 'Name des Dokuments',
  [tokens.documents.statusExtraction]: 'Absaugung',
  [tokens.documents.statusInProgress]: 'In Bearbeitung',
  [tokens.documents.statusArchived]: 'Archiviert',
  [tokens.documents.statusUploaded]:
    'Die hochgeladene Datei ist nur zum Teil angekommen.',
  [tokens.documents.statusUnknown]: 'Unbekannt',
  [tokens.documents.removeRecordTitle]: 'Datensatz löschen',
  [tokens.documents.removeRecordsTitle]: 'Einige Datensätze löschen',
  [tokens.documents.removeRecordText]:
    'Möchten Sie {{count}} Anmeldung wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
  [tokens.documents.removeRecordsText]:
    'Möchten Sie {{count}} Anmeldungen wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
  [tokens.documents.removePendingRecordTitle]:
    'Eine ausstehende Erklärung löschen',
  [tokens.documents.removePendingRecordsTitle]:
    'Löschen Sie einige ausstehende Erklärungen',
  [tokens.documents.removePendingRecordText]:
    'Möchten Sie diese ausstehende Erklärung wirklich löschen?',
  [tokens.documents.removePendingRecordsText]:
    'Möchten Sie diese ausstehenden Erklärungen wirklich löschen?',
  [tokens.documents.documentHasBeenDeleted]: 'Erklärung wurde gelöscht',
  [tokens.documents.documentHasBeenDeleted_other]:
    'Erklärungen wurden gelöscht',
  [tokens.documents.documentHasNotBeenDeleted]:
    'Erklärung wurde nicht gelöscht',
  [tokens.documents.documentHasNotBeenDeleted_other]:
    'Erklärungen wurden nicht gelöscht',
  [tokens.documents.documentHasBeenUpdated]: 'Erklärung wurde aktualisiert',
  [tokens.documents.noDocumentFound]: 'Keine Erklärungen gefunden',
  [tokens.documents.starting]: 'Wird gestartet',
  [tokens.documents.bulkSelectedCount]: 'Anmeldung ausgewählt',
  [tokens.documents.bulkSelectedCount_other]: 'Anmeldungen ausgewählt',
  [tokens.documents.bulkDuplicate]: 'Duplizieren',
  [tokens.documents.bulkApplyTag]: 'Tag anwenden',
  [tokens.documents.bulkDownloadDocuments]: 'Dokumente herunterladen',
  [tokens.documents.bulkDelete]: 'Löschen',
  [tokens.documents.foldersDuplicated]: '{{count}} Anmeldung dupliziert',
  [tokens.documents.foldersDuplicated_other]: '{{count}} Anmeldungen dupliziert',
  [tokens.documents.foldersNotDuplicated]:
    'Die Anmeldung konnte nicht dupliziert werden',
  [tokens.documents.foldersNotDuplicated_other]:
    'Die Anmeldungen konnten nicht dupliziert werden',
  [tokens.documents.tagsAppliedToFolders]:
    'Tags wurden auf {{count}} Anmeldung angewendet',
  [tokens.documents.tagsAppliedToFolders_other]:
    'Tags wurden auf {{count}} Anmeldungen angewendet',
  [tokens.documents.bulkDownloadStarted]: 'Download gestartet',
  [tokens.documents.bulkDownloadError]:
    'Die ausgewählten Dokumente konnten nicht heruntergeladen werden',
  [tokens.documents.bulkDownloadOutputFiles]: 'Ausgabedateien herunterladen',
  [tokens.documents.bulkDownloadOutputFilesPartial]:
    '{{count}} Anmeldung ohne erzeugte Ausgabedatei wurde übersprungen',
  [tokens.documents.bulkDownloadOutputFilesPartial_other]:
    '{{count}} Anmeldungen ohne erzeugte Ausgabedatei wurden übersprungen',
  [tokens.documents.bulkDownloadOutputFilesNone]:
    'Keine der ausgewählten Anmeldungen hat eine erzeugte Ausgabedatei',
  [tokens.documents.bulkDownloadOutputFilesError]:
    'Die Ausgabedateien der ausgewählten Anmeldungen konnten nicht heruntergeladen werden',
  [tokens.documents.attachmentCount]: '{{count}} Anh.',
  [tokens.documents.revisionInProgress]: 'In Überarbeitung',
  [tokens.export.confirmExportTitle]: 'Bestätigen Sie den Export',
  [tokens.export.confirmExportText]:
    'Möchten Sie diesen Datensatz wirklich entfernen?',
  [tokens.export.confirmExport]: 'Senden',
  [tokens.export.successToExport]: 'Der Datensatz wurde erfolgreich gesendet',
  [tokens.export.notExtracted]: 'Nicht extrahiert',
  [tokens.teams.teamName]: 'Der Name des Teams.',
  [tokens.teams.removeFromGroup]: 'Aus Agentur entfernen',
  [tokens.teams.youHaveNoTeam]: 'Sie haben kein Team',
  [tokens.teams.createATeam]: 'Team erstellen',
  [tokens.teams.noRole]: 'Kein Status',
  [tokens.nav.account]: 'Einstellungen',
  [tokens.nav.settings]: 'Einstellungen',
  [tokens.nav.managementConsole]: 'Verwaltungskonsole',
  [tokens.nav.analytics]: 'Analysen',
  [tokens.nav.auth]: 'Authorization',
  [tokens.nav.browse]: 'Durchsuchen',
  [tokens.nav.contact]: 'Kontakt',
  [tokens.nav.create]: 'Erstellen',
  [tokens.nav.customers]: 'Kunden',
  [tokens.nav.dashboard]: 'Dashboard',
  [tokens.nav.gobackToDeclaration]: 'Zurück zu den aktuellen Deklarationen',
  [tokens.nav.backoffice]: 'Backoffice',
  [tokens.nav.database]: 'Datenbank',
  [tokens.nav.customerFlow]: 'Datenzentren',
  [tokens.nav.customer]: 'Kunde',
  [tokens.nav.data]: 'Daten',
  [tokens.nav.models]: 'Modelle',
  [tokens.nav.referentials]: 'Referenzdaten',
  [tokens.nav.automation]: 'Automatisierung',
  [tokens.nav.workflows]: 'Workflows',
  [tokens.nav.details]: 'Details',
  [tokens.nav.edit]: 'Bearbeiten',
  [tokens.nav.error]: 'Fehler',
  [tokens.nav.feed]: 'Feed',
  [tokens.nav.fileManager]: 'Dateimanager',
  [tokens.nav.forgotPassword]: 'Passwort vergessen',
  [tokens.nav.list]: 'Liste',
  [tokens.nav.login]: 'Login',
  [tokens.nav.mcpConsent]: 'MCP-Autorisierung',
  [tokens.nav.impersonate]: 'Anmelden als',
  [tokens.nav.mail]: 'Mail',
  [tokens.nav.management]: 'Verwaltung',
  [tokens.nav.orderList]: 'Aufträge',
  [tokens.nav.overview]: 'Überblick',
  [tokens.nav.organizations]: 'Organisationen',
  [tokens.nav.pages]: 'Seiten',
  [tokens.nav.postCreate]: 'Beitrag erstellen',
  [tokens.nav.postDetails]: 'Beitrag Details',
  [tokens.nav.postList]: 'Beitrags Liste',
  [tokens.nav.pricing]: 'Preis',
  [tokens.nav.productList]: 'Produkte',
  [tokens.nav.fieldList]: 'Anmeldung',
  [tokens.nav.fieldToRead]: 'Zum Lesen',
  [tokens.nav.fieldToManage]: 'Gehen Sie auf',
  [tokens.nav.pendingField]: 'Ausstehend',
  [tokens.nav.fieldExported]: 'Gesendet',
  [tokens.nav.fieldDeleted]: 'Gelöscht',
  [tokens.nav.pendingDocuments]: 'Anhaengige Anmeldungen',
  [tokens.nav.sentDocuments]: 'Gesendete Anmeldungen',
  [tokens.nav.removedDocuments]: 'Entfernte Anmeldungen',
  [tokens.nav.profile]: 'Profil',
  [tokens.nav.register]: 'Registrierung',
  [tokens.nav.resetPassword]: 'Passwort zurücksetzen',
  [tokens.nav.connectors]: 'Anschlüsse???',
  [tokens.nav.users]: 'Benutzer',
  [tokens.nav.expandSideNav]: 'Navigation ausklappen',
  [tokens.nav.collapseSideNav]: 'Navigation einklappen',
  [tokens.nav.accountMenuTooltip]: 'Einstellungsmenü',
  [tokens.activity.lastActivity]: 'Letzte Aktivität',
  [tokens.activity.subTitleLastActivity]:
    'Basierend auf dem ausgewählten Zeitraum',
  [tokens.activity.seeSentDocuments]: 'Gesendete Anmeldungen ansehen',
  [tokens.activity.seeDocumentsToManage]: 'Siehe Erklärungen',
  [tokens.activity.seeDocuments]: 'Siehe Erklärungen',
  [tokens.activity.exportedDocuments]: 'Gesendete Erklärungen',
  [tokens.dashboard.all]: 'Alle',
  [tokens.dashboard.pending]: 'Ausstehend',
  [tokens.dashboard.toBeProcessed]: 'Zu Verarbeiten',
  [tokens.dashboard.inProgress]: 'In Bearbeitung',
  [tokens.dashboard.completed]: 'erledigt',
  [tokens.dashboard.error]: 'Fehler',
  [tokens.dashboard.abandoned]: 'Verfallen',
  [tokens.dashboard.canceled]: 'Abgebrochen',
  [tokens.dashboard.rejected]: 'Abgelehnt',
  [tokens.dashboard.returned]: 'Zurückgegeben',
  [tokens.dashboard.uploading]: 'Hochladen läuft',
  [tokens.dashboard.extracting]: 'Extrahieren',
  [tokens.dashboard.batchImport]: 'Erklärungen',
  [tokens.dashboard.pendingRecords]: 'Ausstehende Erklärungen',
  [tokens.dashboard.recordsToManage]: 'Zu verwaltende Dokumente',
  [tokens.dashboard.exportedRecords]: 'Gesendete Erklärungen',
  [tokens.dashboard.seeRecords]: 'Aufzeichnungen ansehen',
  [tokens.dashboard.seeExportedRecords]: 'Gesendete Datensätze anzeigen',
  [tokens.dashboard.createOrganization]: 'Eine Organisation erstellen',
  [tokens.dashboard.organizationCreated]:
    'Die Organisation wurde erfolgreich etabliert',
  [tokens.dashboard.createOffice]: 'Ein Büro erstellen',
  [tokens.dashboard.officeCreated]: 'Das Büro wurde erfolgreich eingerichtet',
  [tokens.dashboard.officeDeleted]: 'Das Büro wurde erfolgreich gelöscht',
  [tokens.dashboard.userCreated]: 'Der Benutzer ~0~ wurde angelegt.',
  [tokens.dashboard.deleteOrganization]: 'Organisation löschen',
  [tokens.dashboard.deleteUser]: 'Benutzer entfernen',
  [tokens.dashboard.userUpdated]: 'Der Benutzer wurde erfolgreich geändert',
  [tokens.dashboard.organizationAndGroups]: 'Organisation und Agenturen',
  [tokens.dashboard.selectGroups]: 'Agenturen für Affiliate auswählen',
  [tokens.dashboard.inviteCollaborators]: 'Beteiligte einladen',
  [tokens.dashboard.externalCollaborator]: 'Externer Mitarbeiter',
  [tokens.dashboard.removeCollaborator]: 'Mitwirkenden entfernen',
  [tokens.dashboard.removeOrganizationTitle]: 'Eine Organisation löschen',
  [tokens.dashboard.removeOrganizationText]: 'Wirklich löschen?',
  [tokens.dashboard.removeUserTitle]: 'Einen Benutzer löschen',
  [tokens.dashboard.removeUserText]:
    'Möchten Sie wirklich diesen Benutzer löschen?',
  [tokens.dashboard.sendInvitationEmailTitle]: 'Eine Einladung senden',
  [tokens.dashboard.sendInvitationEmailText]:
    'Sind Sie sicher, dass Sie diesem Benutzer eine Einladung senden möchten?',
  [tokens.dashboard.manageDocuments]: 'Erklärung verwalten',
  [tokens.dashboard.dropFilesHere]: 'Dateien hierher ziehen',
  [tokens.dashboard.useNewFolderButton]:
    'oder verwenden Sie die Schaltfläche "Neue Anmeldung"',
  [tokens.dashboard.newFolderButton]: 'Neue Anmeldung',
  [tokens.dashboard.folderInformation]: 'Angaben zur Erklärung',
  [tokens.dashboard.folderName]: 'Folder Name',
  [tokens.dashboard.customer]: 'Kunde',
  [tokens.dashboard.exportService]: 'Zollsoftware',
  [tokens.dashboard.typeDeclarationService]: 'Art der Anmeldung',
  [tokens.dashboard.addNewCustomer]: 'Einen neuen Kunden hinzufügen.',
  [tokens.dashboard.customerName]: 'Name Kunde',
  [tokens.dashboard.createNewCustomer]: 'Neuen Kunden anlegen',
  [tokens.dashboard.punctualCustomer]: 'Pünktlicher Kunde',
  [tokens.dashboard.regularCustomer]: 'Regelmäßiger Kunde',
  [tokens.dashboard.theEmailWasCopiedToYourClipboard]:
    'Die E-Mail wurde in Ihre Zwischenablage kopiert !',
  [tokens.dashboard.fastTrackFirstText]: 'Schneller Check-in',
  [tokens.dashboard.fastTrackSecondText]:
    '(überspringen Sie den Klassifizierungsschritt, wenn Ihr einziges Dokument eine Rechnung oder ein Exportbegleitdokument ist)',
  [tokens.dashboard.fastTrackTooltipText]: 'Wählen Sie einen Deklarationstyp',
  [tokens.dashboard.isCurrentlyInAnErrorState]:
    'befindet sich derzeit in einem Fehlerzustand',
  [tokens.dashboard.declarationInErrorState]: 'Deklaration im Fehlerzustand',
  [tokens.dashboard.itsLastReportedStateWas]:
    'Der letzte gemeldete Zustand war',
  [tokens.dashboard.ourTechnicalTeamHasBeenNotified]:
    'Unser technisches Team wurde benachrichtigt',
  [tokens.dashboard.pleaseContactCustomerServiceForFurtherInformation]:
    'Weitere Informationen erhalten Sie von unserem Kundendienst.',
  [tokens.dashboard.created]: 'Erstellt',
  [tokens.dashboard.clientOrganization]: 'Organisation des Kunden',
  [tokens.dashboard.reference]: 'Aktenzeichen:',
  [tokens.dashboard.customerReference]: 'Referenzkunde',
  [tokens.dashboard.noReference]: 'Kein Aktenzeichen',
  [tokens.dashboard.type]: 'Typ',
  [tokens.dashboard.timing]: 'Timing',
  [tokens.dashboard.clientName]: 'Auftraggeber:Innen',
  [tokens.dashboard.status]: 'Status',
  [tokens.dashboard.noDeclarationsFound]: 'Keine Erklärungen gefunden',
  [tokens.dashboard.searchForADeclaration]: 'Suche nach einer Erklärung',
  [tokens.dashboard.searchNameMaxLengthHint]:
    'Die Suche ist auf {{max}} Zeichen beschränkt.',
  [tokens.dashboard.tracking]: 'Nachverfolgung',
  [tokens.dashboard.pastDue]: 'Überfällig',
  [tokens.dashboard.importer]: 'Einführer',
  [tokens.dashboard.exporter]: 'Ausführer',
  [tokens.dashboard.noExporterIndicated]: 'Kein Exporteur',
  [tokens.dashboard.noImporterIndicated]: 'Kein Importeur',
  [tokens.dashboard.emailSender]: 'Absender',
  [tokens.dashboard.emailSubject]: 'Betreff der E-Mail',
  [tokens.dashboard.emailSendingDate]: 'Versanddatum',
  [tokens.dashboard.details]: 'Details',
  [tokens.dashboard.viewDetails]: 'Details anzeigen',
  [tokens.dashboard.openInfoPanel]: 'Info Panel',
  [tokens.dashboard.tags]: 'Schlagwörter',
  [tokens.dashboard.tag]: 'Tag',
  [tokens.dashboard.noTags]: 'Nessun tag',
  [tokens.dashboard.addTag]: 'Tag hinzufügen',
  [tokens.dashboard.createTag]: 'Tag erstellen',
  [tokens.dashboard.tagName]: 'Name des Tags',
  [tokens.dashboard.source]: 'Quelle',
  [tokens.dashboard.description]: 'Beschreibung',
  [tokens.dashboard.group]: 'Agentur',
  [tokens.dashboard.declarant]: 'Die Erklärung abgebende Person',
  [tokens.dashboard.filter]: 'Filter',
  [tokens.dashboard.clearAll]: 'Alle löschen',
  [tokens.dashboard.addFilter]: 'Filter hinzufügen',
  [tokens.dashboard.allFilterActive]: 'Alle Filter aktiv',
  [tokens.dashboard.allTypes]: 'Typen: alle',
  [tokens.dashboard.user]: 'Benutzer',
  [tokens.dashboard.sendDate]: 'Versandatum',
  [tokens.dashboard.apply]: 'Anwenden',
  [tokens.dashboard.search]: 'Suche',
  [tokens.dashboard.noResults]: 'Keine Ergebnisse gefunden',
  [tokens.dashboard.lastDay]: 'Vor 1 Tag',
  [tokens.dashboard.last3Days]: '3 Tage',
  [tokens.dashboard.lastWeek]: 'Vor 1 Woche',
  [tokens.dashboard.lastMonth]: 'Vor einem Monat',
  [tokens.dashboard.last3Months]: 'Vor 3 Monaten',
  [tokens.dashboard.lastYear]: 'Vor 1 Jahr',
  [tokens.dashboard.customDateRange]: 'Persönlicher Datumsbereich',
  [tokens.dashboard.saveFilter]: 'Filter speichern',
  [tokens.dashboard.customizeView]: 'Ansicht anpassen',
  [tokens.dashboard.customizeViewTitle]: 'Ansicht anpassen',
  [tokens.dashboard.customizeViewSubtitle]: 'Ziehen zum Sortieren, umschalten zum Anzeigen',
  [tokens.dashboard.columnRequired]: 'Pflicht',
  [tokens.dashboard.visibleColumnsCount]: '{{count}} Spalten angezeigt',
  [tokens.dashboard.sortAscending]: 'Aufsteigend sortieren',
  [tokens.dashboard.sortDescending]: 'Absteigend sortieren',
  [tokens.dashboard.savedFilters]: 'Gespeicherte Filter',
  [tokens.dashboard.filterName]: 'Filtername',
  [tokens.dashboard.noSavedFilters]: 'Keine gespeicherten Filter',
  [tokens.dashboard.noSavedSearches]: 'Keine gespeicherten Suchen',
  [tokens.dashboard.unknown]: 'Unbekannt',
  [tokens.dashboard.from]: 'Von',
  [tokens.dashboard.to]: 'Bis',

  [tokens.dashboardV2.kicker]: 'Startseite · {{date}}',
  [tokens.dashboardV2.greeting]: 'Hallo {{name}}',
  [tokens.dashboardV2.searchPlaceholder]: 'Vorgang suchen',
  [tokens.dashboardV2.searchNoResults]: 'Kein Vorgang für „{{query}}"',
  [tokens.dashboardV2.searchLoading]: 'Wird geladen…',
  [tokens.dashboardV2.exportTitle]:
    'Alle Daten des Dashboards exportieren (CSV)',
  [tokens.dashboardV2.customizeStart]: 'Anordnung der Blöcke anpassen',
  [tokens.dashboardV2.customizeStop]: 'Anpassung beenden',

  [tokens.dashboardV2.kpiToProcessLabel]: 'Zu bearbeiten',
  [tokens.dashboardV2.kpiToProcessSub]: 'Vorgänge warten auf eine Aktion',
  [tokens.dashboardV2.kpiErrorLabel]: 'Fehlerhaft',
  [tokens.dashboardV2.kpiSentLabel]: 'Diesen Monat gesendet',
  [tokens.dashboardV2.kpiSentSub]: 'vs. gleicher Zeitraum Vormonat',
  [tokens.dashboardV2.kpiSentPrevious]:
    '{{period}}: {{formattedCount}} Vorgang gesendet.',
  [tokens.dashboardV2.kpiSentPrevious_other]:
    '{{period}}: {{formattedCount}} Vorgänge gesendet.',
  [tokens.dashboardV2.kpiSentPreviousNone]:
    '{{period}}: keine Vorgänge gesendet.',
  [tokens.dashboardV2.kpiSentFewer]: 'Also {{diff}} weniger ({{pct}}).',
  [tokens.dashboardV2.kpiSentMore]: 'Also {{diff}} mehr ({{pct}}).',
  [tokens.dashboardV2.kpiSentSame]: 'Genauso viele wie diesen Monat.',
  [tokens.dashboardV2.seeDossiers]: 'Vorgänge ansehen',

  [tokens.dashboardV2.activityTitle]: 'Letzte Aktivitäten',
  [tokens.dashboardV2.activitySubtitle]: 'Ihre letzten 10 Vorgänge',
  [tokens.dashboardV2.seeAll]: 'Alle ansehen',
  [tokens.dashboardV2.filterAll]: 'Alle',
  [tokens.dashboardV2.filterToProcess]: 'Zu bearbeiten',
  [tokens.dashboardV2.filterSent]: 'Gesendet',
  [tokens.dashboardV2.filterError]: 'Fehlerhaft',
  [tokens.dashboardV2.colName]: 'Vorgangsname',
  [tokens.dashboardV2.colType]: 'Typ',
  [tokens.dashboardV2.colStatus]: 'Status',
  [tokens.dashboardV2.colDate]: 'Datum',
  [tokens.dashboardV2.emptyCategory]: 'Kein Vorgang in dieser Kategorie',
  [tokens.dashboardV2.staleTooltip]: 'Wartet seit {{duration}}',
  [tokens.dashboardV2.staleBadgeMinutes]: '+{{count}} Min',
  [tokens.dashboardV2.staleBadgeHours]: '+{{count}} Std',
  [tokens.dashboardV2.staleBadgeDays]: '+{{count}} T',
  [tokens.dashboardV2.staleBadgeWeeks]: '+{{count}} Wo',
  [tokens.dashboardV2.staleBadgeMonths]: '+{{count}} Mon',

  [tokens.dashboardV2.aiTitle]: 'Was die KI für Sie erledigt hat',
  [tokens.dashboardV2.aiSubtitle]: 'Diesen Monat',
  [tokens.dashboardV2.aiHeadlineSuffix]: 'KI-Aktionen durchgeführt',
  [tokens.dashboardV2.aiHeadlineSub]: 'von {{count}} Anmeldungen',
  [tokens.dashboardV2.aiCreditsFooter]: '{{count}} Credits verbraucht',
  [tokens.dashboardV2.aiEmptyTitle]: 'Keine Automatisierung konfiguriert',
  [tokens.dashboardV2.aiEmptyBody]:
    'Richten Sie eine Automatisierung ein, um Ihre Artikelzeilen anhand Ihrer Lieferantendateien vorauszufüllen.',
  [tokens.dashboardV2.aiEmptyCta]: 'Automatisierung erstellen',
  [tokens.dashboardV2.aiRowPrefilled]: 'Vorausgefüllte Artikelzeilen',
  [tokens.dashboardV2.aiRowPrefilledMeta]:
    'von {{total}} · {{corrected}} manuell korrigiert',
  [tokens.dashboardV2.aiRowAnomalies]: 'Automatisch erkannte Anomalien',
  [tokens.dashboardV2.aiRowAnomaliesMeta]:
    'davon {{blocking}} blockierende Abweichungen',
  [tokens.dashboardV2.aiRowSuggestions]: 'Akzeptierte Vorschläge',
  [tokens.dashboardV2.aiRowSuggestionsMeta]:
    'von {{total}} vorgeschlagen · {{pct}} %',
  [tokens.dashboardV2.aiRowFields]: 'Aus Dokumenten ausgefüllte Felder',
  [tokens.dashboardV2.aiRowFieldsMeta]: '{{count}} Dokumente extrahiert',

  [tokens.dashboardV2.teamTitle]: 'Team-Aktivität',
  [tokens.dashboardV2.teamSubtitle]:
    'Agentur {{agency}} · {{count}} Sachbearbeiter · {{processed}} Vorgänge {{period}} bearbeitet',
  [tokens.dashboardV2.teamSubtitleStats]:
    '· {{count}} Sachbearbeiter · {{processed}} Vorgänge {{period}} bearbeitet',
  [tokens.dashboardV2.teamRangeWeek]: 'Diese Woche',
  [tokens.dashboardV2.teamRangeMonth]: 'Diesen Monat',
  [tokens.dashboardV2.teamLateBadge]: '{{count}} im Verzug',
  [tokens.dashboardV2.teamOverloadBadge]: '{{count}} überlastet',
  [tokens.dashboardV2.teamAgencySelect]: 'Agentur',
  [tokens.dashboardV2.teamEmpty]: 'Keine Sachbearbeiter in dieser Agentur.',
  [tokens.dashboardV2.teamError]: 'Team-Aktivität konnte nicht geladen werden.',
  [tokens.dashboardV2.teamUnknownMember]: 'Ohne Namen',
  [tokens.dashboardV2.colDeclarant]: 'Sachbearbeiter',
  [tokens.dashboardV2.colProcessed]: 'Bearbeitet',
  [tokens.dashboardV2.colInProgress]: 'In Bearbeitung',
  [tokens.dashboardV2.colLate]: 'Verzug',
  [tokens.dashboardV2.colRate]: 'Takt / Tag',
  [tokens.dashboardV2.colLoad]: 'Auslastung',
  [tokens.dashboardV2.lateTooltip]:
    'Ein verspäteter Vorgang ist ein nicht gesendeter Vorgang, der vor mehr als vier Stunden erstellt wurde.',
  [tokens.dashboardV2.rateTooltip]:
    'Durchschnittlich bearbeitete Vorgänge pro Werktag. Ziel: {{target}} pro Sachbearbeiter. Er misst das Bearbeitungstempo.',
  [tokens.dashboardV2.loadTooltip]:
    'Laufende Vorgänge im Verhältnis zu einer Kapazität von {{capacity}}. Über 100 % betreut der Sachbearbeiter mehr Vorgänge, als er ordentlich verfolgen kann, und ist überlastet.',

  [tokens.dashboardV2.fluxTitle]: 'Volumen & Warenverkehr',
  [tokens.dashboardV2.fluxSubtitle]:
    '12 rollierende Monate · Aufschlüsselung Import / Export / Transit',
  [tokens.dashboardV2.fluxEmpty]: 'Kein Volumen in den letzten 12 Monaten.',
  [tokens.dashboardV2.fluxError]: 'Volumen nach Warenverkehr konnte nicht geladen werden.',
  [tokens.dashboardV2.fluxMonthlyLabel]: 'Monatliche Entwicklung',
  [tokens.dashboardV2.fluxAllFlows]: 'Alle Warenverkehre',
  [tokens.dashboardV2.fluxBreakdownLabel]: 'Aufteilung über 12 Monate',
  [tokens.dashboardV2.fluxTotalLabel]: 'Gesamt',
  [tokens.dashboardV2.fluxTotalUnit]: 'Anmeldungen',
  [tokens.dashboardV2.fluxTooltipDeclarations]: 'Anmeldungen:',
  [tokens.dashboardV2.typeImport]: 'Import',
  [tokens.dashboardV2.typeExport]: 'Export',
  [tokens.dashboardV2.typeTransit]: 'Transit',

  [tokens.dashboardV2.cplxTitle]: 'Leistung nach Komplexität',
  [tokens.dashboardV2.cplxSubtitle]:
    'Benchmark {{base}} s + {{perLine}} s / Zeile',
  [tokens.dashboardV2.cplxTierSmall]: 'Klein',
  [tokens.dashboardV2.cplxTierMedium]: 'Mittel',
  [tokens.dashboardV2.cplxTierLarge]: 'Groß',
  [tokens.dashboardV2.cplxColDossiers]: 'Vorgänge',
  [tokens.dashboardV2.cplxColBenchmark]: 'Benchmark',
  [tokens.dashboardV2.cplxColMeasured]: 'Nabu gemessen',
  [tokens.dashboardV2.cplxColGain]: 'Gewinn',
  [tokens.dashboardV2.cplxMeasuredSub]: '{{sampled}}/{{total}} gemessen',
  [tokens.dashboardV2.cplxAvgTimeLabel]: 'Durchschnittliche Zeit pro Vorgang',
  [tokens.dashboardV2.cplxLegendBenchmark]: 'Benchmark',
  [tokens.dashboardV2.cplxLegendMeasured]: 'Nabu gemessen',
  [tokens.dashboardV2.cplxTooltipBenchmark]: 'Benchmark {{lines}} Zeilen:',
  [tokens.dashboardV2.cplxTooltipMeasured]: 'Nabu:',

  [tokens.dashboardV2.editBannerText]:
    'Ziehen Sie einen Block auf den Rand eines anderen, um sich die Zeile zu teilen (bis zu 3), oder zwischen zwei Zeilen, um ihn zu isolieren. Das Auge blendet einen Block aus.',
  [tokens.dashboardV2.resetCta]: 'Zurücksetzen',
  [tokens.dashboardV2.doneCta]: 'Fertig',
  [tokens.dashboardV2.newRowLabel]: 'Neue Zeile',
  [tokens.dashboardV2.dropNewRowBottom]:
    'Hier ablegen für eine neue Zeile unten',
  [tokens.dashboardV2.hideBlock]: 'Diesen Block ausblenden',
  [tokens.dashboardV2.showBlock]: 'Diesen Block anzeigen',
  [tokens.dashboardV2.dragHandleTitle]: 'Ziehen, um diesen Block zu verschieben',

  [tokens.dashboardV2.sectionKpi]: 'Kennzahlen des Tages',
  [tokens.dashboardV2.sectionActivity]: 'Letzte Aktivitäten',
  [tokens.dashboardV2.sectionAi]: 'Was die KI für Sie erledigt hat',
  [tokens.dashboardV2.sectionTeam]: 'Team-Aktivität',
  [tokens.dashboardV2.sectionFlux]: 'Volumen & Warenverkehr',
  [tokens.dashboardV2.sectionComplexity]: 'Leistung nach Komplexität',
  [tokens.backoffice.createUser]: 'Benutzer erstellen',
  [tokens.backoffice.deleteUser]: 'Der Benutzer wurde erfolgreich gelöscht',
  [tokens.backoffice.successSendEmailMessage]:
    'Einladungs-E-Mail erfolgreich gesendet',
  [tokens.backoffice.users]: 'Benutzer',
  [tokens.backoffice.importLayer]: 'Ebene importieren',
  [tokens.backoffice.chooseLayerName]: 'Wählen Sie einen Ebenennamen',
  [tokens.backoffice.selectDocumentType]: 'Dokumenttyp',
  [tokens.backoffice.onlyFirstPage]: 'Es wird nur die erste Seite verwendet.',
  [tokens.backoffice.acceptedFormats]: 'Akzeptierte Formate',
  [tokens.backoffice.maxSize]: 'Maximale Größe',
  [tokens.backoffice.exportConfig]: 'Konfiguration exportieren',
  [tokens.backoffice.layerNameIsRequired]: 'Modellname ist erforderlich',
  [tokens.backoffice.documentTypeIsRequired]: 'Dokumentart ist ein Pflichtfeld',
  [tokens.backoffice.exportConfigurationIsRequired]:
    'Dabei wird keine Konfiguration benötigt.',
  [tokens.backoffice.deleteOrganization]: 'Organisation erfolgreich geloescht',
  [tokens.organizations.organizationsTitle]: 'Organisationen',
  [tokens.organizations.organizationTitle]: 'Organisation',

  [tokens.declarationProgress.title]: 'Nabu bereitet Ihren Vorgang vor',
  [tokens.declarationProgress.subtitleReady]:
    'Sie können die Anmeldung vervollständigen, sobald sie bereit ist.',
  [tokens.declarationProgress.subtitleWaitingHuman]:
    'Ein Schritt wartet auf Ihre Eingabe.',
  [tokens.declarationProgress.groupDocuments]: 'Ihre Unterlagen',
  [tokens.declarationProgress.groupData]: 'Datenlesung',
  [tokens.declarationProgress.groupDeclaration]: 'Ihre Anmeldung',
  [tokens.declarationProgress.stateDone]: 'Abgeschlossen',
  [tokens.declarationProgress.stateRunning]: 'In Bearbeitung…',
  [tokens.declarationProgress.stateBlocked]: 'Wartet auf Sie',
  [tokens.declarationProgress.statePending]: 'Ausstehend…',
  [tokens.declarationProgress.stepAwaitingUploadsLabel]: 'Dateien empfangen',
  [tokens.declarationProgress.stepAwaitingUploadsHint]:
    'Upload und Entpacken laufen…',
  [tokens.declarationProgress.stepFileProcessingLabel]: 'Seiten lesen',
  [tokens.declarationProgress.stepFileProcessingHint]:
    'Entzerrung, OCR und Dokumentenerkennung…',
  [tokens.declarationProgress.stepAwaitingClassificationLabel]:
    'Dokumenttyp je Datei',
  [tokens.declarationProgress.stepAwaitingClassificationHint]:
    'Ein Dokument wartet auf die Klassifizierung.',
  [tokens.declarationProgress.stepExtractionLabel]: 'Datenextraktion',
  [tokens.declarationProgress.stepExtractionHint]:
    'Unterlagen lesen und untereinander abgleichen…',
  [tokens.declarationProgress.stepAwaitingReviewLabel]: 'Dokumentprüfung',
  [tokens.declarationProgress.stepAwaitingReviewHint]:
    'Eine Lesung wurde als unzuverlässig eingestuft und braucht eine Prüfung.',
  [tokens.declarationProgress.stepAwaitingConfigurationLabel]:
    'Anmeldungstyp',
  [tokens.declarationProgress.stepAwaitingConfigurationHint]:
    'Der Vorgang wartet auf seine Konfiguration.',
  [tokens.declarationProgress.stepMappingLabel]: 'Anmeldung erzeugen',
  [tokens.declarationProgress.stepMappingHint]:
    'Ableitungen, Referenzdaten und Formularausfüllung…',
  [tokens.declarationProgress.stepInstructionRoutineLabel]: 'Anweisungen werden angewendet',
  [tokens.declarationProgress.stepInstructionRoutineHint]:
    'Der Nabu-Assistent wendet Ihre automatischen Anweisungen auf die Anmeldung an…',
  [tokens.declarationProgress.stepAwaitingDeclarationLabel]:
    'Anmeldung bereit',
  [tokens.declarationProgress.stepAwaitingDeclarationHint]:
    'Bereit zur Vervollständigung.',
  [tokens.declarationProgress.resumeTitle]: 'Anmeldungstyp wählen',
  [tokens.declarationProgress.resumeHint]:
    'Nabu konnte den Anmeldungstyp dieses Vorgangs nicht ableiten. Wählen Sie ihn, um die Erzeugung fortzusetzen.',
  [tokens.declarationProgress.resumeAction]: 'Anmeldung erstellen',
  [tokens.declarationProgress.resumeError]: 'Die Fortsetzung ist fehlgeschlagen.',
  [tokens.declarationProgress.detailFiles]: 'Empfangene Dateien: {{count}}',
  [tokens.declarationProgress.stepAssemblyLabel]: 'Zusammenführung der Daten',
  [tokens.declarationProgress.stepAssemblyHint]: 'Abgleich der Unterlagen nach dem gewählten Typ…',
  [tokens.declarationProgress.detailAssembly]: 'Sendungen: {{count}} · Referenz: {{backbone}}',
  [tokens.declarationProgress.detailAssemblyPlanner]: 'von Nabu entschieden (Konfidenz {{confidence}} %)',
  [tokens.declarationProgress.detailPages]: 'Gelesene Seiten: {{processed}} / {{total}}',
  [tokens.declarationProgress.detailDocuments]: '{{count}} Dokumente: {{types}}',
  [tokens.declarationProgress.detailRead]: 'Gelesene Unterlagen: {{read}} / {{total}}',
  [tokens.declarationProgress.detailBlocked]: 'Zu prüfen: {{document}} ({{reason}})',
  [tokens.declarationProgress.detailChosenAutomatically]: 'aus den Unterlagen abgeleitet',
  [tokens.declarationProgress.detailParties]: 'Verkäufer: {{sellers}} · Käufer: {{buyers}}',
  [tokens.declarationProgress.decType_import]: 'Einfuhr',
  [tokens.declarationProgress.decType_export]: 'Ausfuhr',
  [tokens.declarationProgress.decType_ens]: 'Sicherheit (ENS)',
  [tokens.declarationProgress.decType_transit]: 'Versand',

  [tokens.declarationValidationProgress.sectionRequired]: 'Pflichtfelder',
  [tokens.declarationValidationProgress.sectionBlocking]: 'Blockierende Prüfungen',

  [tokens.tariffClassification.statusValid]: 'Gültig',
  [tokens.tariffClassification.statusIncomplete]: 'Unvollständig',
  [tokens.tariffClassification.statusUnknown]: 'Unbekannt',
  [tokens.tariffClassification.statusMissing]: 'Einzureihen',
  [tokens.tariffClassification.authorAuto]: 'Auto',
  [tokens.tariffClassification.received]: 'erhalten {{code}}',
  [tokens.tariffClassification.unknownHint]: 'Nicht in der Nomenklatur',
  [tokens.tariffClassification.missingHint]: 'Kein Code erhalten',
  [tokens.tariffClassification.residual]: 'Restposition',
  [tokens.tariffClassification.apply]: '{{code}} anwenden',
  [tokens.tariffClassification.cancel]: 'Abbrechen',
  [tokens.tariffClassification.close]: 'Schließen',
  [tokens.tariffClassification.productName]: 'Tarifill',
  [tokens.tariffClassification.colArticles]: 'Positionen',
  [tokens.tariffClassification.bannerTitle]: '{{count}} Codes mit der Unterposition „andere“ ergänzen',
  [tokens.tariffClassification.bannerTitle_one]: '1 Code mit der Unterposition „andere“ ergänzen',
  [tokens.tariffClassification.bannerBody]: 'Zulässige Kapitel: {{chapters}} (Demoliste).',
  [tokens.tariffClassification.preview]: 'Prüfen und ergänzen',
  [tokens.tariffClassification.dialogTitle]: '{{count}} Codes zu „andere“ ergänzen',
  [tokens.tariffClassification.dialogTitle_one]: '1 Code zu „andere“ ergänzen',
  [tokens.tariffClassification.dialogIntro]: 'Jeder erhaltene Code wird zur Restposition „andere“ unter seinem Präfix ergänzt. Prüfen Sie die Bezeichnung vor der Bestätigung.',
  [tokens.tariffClassification.colReceived]: 'Erhalten',
  [tokens.tariffClassification.colCompleted]: 'Nach Ergänzung angemeldet',
  [tokens.tariffClassification.colLabel]: 'Bezeichnung',
  [tokens.tariffClassification.skippedOutOfScope]: '{{count}} Codes außerhalb der zulässigen Kapitel wählen Sie selbst.',
  [tokens.tariffClassification.skippedOutOfScope_one]: '1 Code außerhalb der zulässigen Kapitel wählen Sie selbst.',
  [tokens.tariffClassification.skippedAmbiguous]: '{{count}} Codes ohne eindeutige Restposition wählen Sie selbst.',
  [tokens.tariffClassification.skippedAmbiguous_one]: '1 Code ohne eindeutige Restposition wählen Sie selbst.',
  [tokens.tariffClassification.autoNote]: 'Die Codes bleiben mit ihrem erhaltenen Code als „Auto“ markiert und können rückgängig gemacht werden.',
  [tokens.tariffClassification.confirm]: '{{count}} Codes ergänzen',
  [tokens.tariffClassification.confirm_one]: '1 Code ergänzen',
  [tokens.tariffClassification.done]: '{{count}} Codes zu „andere“ ergänzt',
  [tokens.tariffClassification.done_one]: '1 Code zu „andere“ ergänzt',
  [tokens.tariffClassification.undo]: 'Rückgängig',
  [tokens.tariffClassification.reasonAuto]: 'Tarifill: zu „andere“ ergänzt',
  [tokens.tariffClassification.reasonUser]: 'Tarifill: Code gewählt',
  [tokens.tariffClassification.reasonUndo]: 'Tarifill: zurück zum erhaltenen Code',
  [tokens.tariffClassification.tourStepIntroTitle]: 'Tarifill, die Zolltarifierung',
  [tokens.tariffClassification.tourStepIntroBody]: 'Tarifill hilft Ihnen, für jeden Artikel einen vollständigen, gültigen Warencode anzumelden. Docken Sie das Fenster links oder rechts an oder lassen Sie es über dem Raster schweben. Folgen Sie dem Beispiel Schritt für Schritt an Ihrem Vorgang.',
  [tokens.tariffClassification.tourStepPreviewTitle]: 'Auf einmal zu „andere“ ergänzen',
  [tokens.tariffClassification.tourStepPreviewBody]: 'Dieser Kasten erscheint, wenn unvollständige Codes zu ihrer Restposition „andere“ ergänzt werden können, in den für Ihre Organisation zulässigen Kapiteln (geringes Risiko: Mechanik, Kunststoffe…).',
  [tokens.tariffClassification.tourStepPreviewButtonTitle]: 'Prüfen und ergänzen',
  [tokens.tariffClassification.tourStepPreviewButtonBody]: 'Nichts ändert sich ohne Ihre Zustimmung: Die Vorschau zeigt jede Ergänzung, bevor sie angewendet wird. Öffnen wir sie.',
  [tokens.tariffClassification.tourStepPreviewTitleTitle]: 'Die Vorschau',
  [tokens.tariffClassification.tourStepPreviewTitleBody]: 'Wie viele Codes ergänzt werden und in welchen zulässigen Kapiteln.',
  [tokens.tariffClassification.tourStepPreviewTableTitle]: 'Eine Zeile je erhaltenem Code',
  [tokens.tariffClassification.tourStepPreviewTableBody]: '„Erhalten“: der Code wie eingegangen. „Nach Ergänzung angemeldet“: der 10-stellige Code. „Bezeichnung“: was er umfasst. „Positionen“: wie viele Positionen ihn tragen.',
  [tokens.tariffClassification.tourStepPreviewCheckboxTitle]: 'Einen Code auslassen',
  [tokens.tariffClassification.tourStepPreviewCheckboxBody]: 'Entfernen Sie den Haken einer Zeile, um sie auszulassen: Sie wird nicht ergänzt und bleibt offen.',
  [tokens.tariffClassification.tourStepPreviewCompletedTitle]: 'Die ergänzten Ziffern',
  [tokens.tariffClassification.tourStepPreviewCompletedBody]: 'Die von Tarifill ergänzten Ziffern sind hervorgehoben: Sie sehen auf einen Blick, was sich ändert.',
  [tokens.tariffClassification.tourStepPreviewLabelTitle]: 'Bezeichnung prüfen',
  [tokens.tariffClassification.tourStepPreviewLabelBody]: 'Die Bezeichnung des Codes und sein Pfad in der Nomenklatur: Lesen Sie sie vor der Bestätigung.',
  [tokens.tariffClassification.tourStepPreviewSkippedTitle]: 'Was bei Ihnen bleibt',
  [tokens.tariffClassification.tourStepPreviewSkippedBody]: 'Codes außerhalb der zulässigen Kapitel oder ohne eindeutige Restposition werden nicht ergänzt: Sie bleiben unter „Zu bearbeiten“ zu Ihrer Wahl.',
  [tokens.tariffClassification.tourStepPreviewAutoTitle]: 'Immer nachvollziehbar',
  [tokens.tariffClassification.tourStepPreviewAutoBody]: 'Ergänzte Codes sind im Raster mit ✦ und unter Korrigiert als „Auto“ markiert, mit dem erhaltenen Code. Sie können sie rückgängig machen, solange die Anmeldung nicht gesendet ist.',
  [tokens.tariffClassification.tourStepPreviewConfirmTitle]: 'Bestätigen',
  [tokens.tariffClassification.tourStepPreviewConfirmBody]: 'Ein Klick ergänzt alle markierten Codes in einem Schritt, sichtbar im Verlauf. Danach bietet eine Meldung „Rückgängig“ an.',
  [tokens.tariffClassification.tourStepCardTitle]: 'Ein Artikel, eine Karte',
  [tokens.tariffClassification.tourStepCardBody]: 'Bezeichnung, erhaltener Code und Status. Geöffnet zeigt die Karte, was existiert und was fehlt. Hier ein Artikel Ihres Vorgangs mit mehreren Fortsetzungen.',
  [tokens.tariffClassification.tourStepFiltersTitle]: 'Einen Artikel finden',
  [tokens.tariffClassification.tourStepFiltersBody]: 'Suchen Sie nach Artikelnummer, Code oder Wörtern der Bezeichnung, filtern Sie nach Status oder Kapitel. Zu bearbeitende Artikel zuerst, in Gruppen zu 20.',
  [tokens.tariffClassification.tourStepReviewTitle]: 'Serienweise bearbeiten',
  [tokens.tariffClassification.tourStepReviewBody]: 'Bei großen Vorgängen die zu vervollständigenden Artikel nach Code und Produkt gruppiert, per Tastatur: 1 bis 9 wendet eine Fortsetzung an und geht weiter, ← → wechselt die Gruppe, Esc führt zur Liste zurück.',
  [tokens.tariffClassification.tourStepDirectoryTargetTitle]: 'Für wen wir suchen',
  [tokens.tariffClassification.tourStepDirectoryTargetBody]: 'Der Artikel, auf den der gewählte Code angewendet wird.',
  [tokens.tariffClassification.tourStepDirectorySearchTitle]: 'Suchen',
  [tokens.tariffClassification.tourStepDirectorySearchBody]: 'Ziffern („7318 15“) oder Wortanfänge („Stahlschraube“), ohne Rücksicht auf Akzente. Die Codes des Vorgangs zuerst.',
  [tokens.tariffClassification.tourStepDirectoryScopeTitle]: 'Die ganze Nomenklatur oder unsere Artikel',
  [tokens.tariffClassification.tourStepDirectoryScopeBody]: '„Ganze Nomenklatur“, um Codes zu suchen oder zu durchsuchen; „Unsere Artikel“, um die Codes des Vorgangs gruppiert zu sehen.',
  [tokens.tariffClassification.tourStepGridTitle]: 'In der Tabelle',
  [tokens.tariffClassification.tourStepGridBody]: 'In der Code-Zelle zeigt ein Symbol, was zu tun ist: ⚠ unvollständiger Code, ⊘ in der Nomenklatur unbekannt, ○ kein Code, ✦ von einer Maschine angenommener Code, zu prüfen (von der intelligenten Vorbereitung abgeleitet oder von Tarifill ergänzt). Beim Überfahren, was zu tun ist. Ein Klick in die Zelle öffnet Tarifill.',
  [tokens.tariffClassification.tourStepHelpTitle]: 'Diese Tour erneut ansehen',
  [tokens.tariffClassification.tourStepHelpBody]: 'Dieser Knopf startet die Tour jederzeit erneut.',
  [tokens.tariffClassification.clearSearch]: 'Suche löschen',
  [tokens.tariffClassification.openTaric]: 'In TARIC ansehen',
  [tokens.tariffClassification.openTaricTooltip]: 'TARIC-Blatt zu {{code}} (Europäische Kommission): seine EU-Maßnahmen für den Ursprung der Position',
  [tokens.tariffClassification.openRitaTooltip]: 'RITA (douane.gouv.fr) öffnet sich mit {{code}} vorausgefüllt: Starten Sie die Suche, um auch die nationalen Maßnahmen zu sehen',
  [tokens.tariffClassification.incompleteTooltip]: 'Unvollständiger Warencode: Für einen anmeldbaren 10-stelligen Code fehlen {{count}} Ziffern. Klicken Sie, um in Tarifill die richtige Unterposition zu wählen.',
  [tokens.tariffClassification.incompleteTooltip_one]: 'Unvollständiger Warencode: Für einen anmeldbaren 10-stelligen Code fehlt 1 Ziffer. Klicken Sie, um in Tarifill die richtige Unterposition zu wählen.',
  [tokens.tariffClassification.incompleteCount]: '{{count}} unvollständige Codes',
  [tokens.tariffClassification.incompleteCount_one]: '1 unvollständiger Code',
  [tokens.tariffClassification.openInOtherWindow]: 'In einem anderen Fenster öffnen',
  [tokens.tariffClassification.openedInOtherWindow]: 'Tarifill ist in einem anderen Fenster geöffnet: Ein Klick in die Code-Zelle öffnet die Position dort.',
  [tokens.tariffClassification.otherWindowDisabled]: 'Tarifill ist für Ihr Konto nicht aktiviert.',
  [tokens.tariffClassification.measureStateConditional]: 'Bedingt',
  [tokens.tariffClassification.measureStateInapplicable]: 'Nicht anwendbar',
  [tokens.tariffClassification.browsePosition]: '{{position}} von {{count}}',
  [tokens.tariffClassification.browsePrevious]: 'Vorherige Position (↑)',
  [tokens.tariffClassification.browseNext]: 'Nächste Position (↓)',
  [tokens.tariffClassification.toCheck]: 'Zu prüfen',
  [tokens.tariffClassification.completedByTarifill]: 'Von Tarifill mit der Unterposition „andere“ ergänzt',
  [tokens.tariffClassification.receivedShort]: 'erhalten',
  [tokens.tariffClassification.noDesignation]: 'Ohne Bezeichnung',
  [tokens.tariffClassification.directoryLink]: 'Verzeichnis',
  [tokens.tariffClassification.treeLoading]: 'Kapitel wird geladen…',
  [tokens.tariffClassification.treeFailed]: 'Das Kapitel konnte nicht geladen werden.',
  [tokens.tariffClassification.tourStepDirectoryTreeTitle]: 'Der Baum',
  [tokens.tariffClassification.tourStepDirectoryTreeBody]: 'Ohne Suche die Nomenklatur wie in RITA, geöffnet auf dem Code des Artikels: anmeldbare Codes in Grün und ein Zähler der Artikel des Vorgangs unter jeder Ebene. Code wählen, dann „Anwenden“.',
  [tokens.tariffClassification.measuresDemoNote]: 'Fiktive Maßnahmen, Abgaben und RITA-Daten in der von TEC-1834 vorgesehenen Form: das Backend stellt sie noch nicht bereit.',
  [tokens.tariffClassification.groupSplit]: 'Gleicher erhaltener Code für {{count}} verschiedene Produkte: getrennt einreihen.',
  [tokens.tariffClassification.moreDesignations]: '+{{count}} weitere',
  [tokens.tariffClassification.reviewStart]: 'Nacheinander bearbeiten',
  [tokens.tariffClassification.reviewPosition]: 'Gruppe {{position}} von {{count}}',
  [tokens.tariffClassification.reviewDone]: 'Alle Gruppen der Auswahl sind bearbeitet.',
  [tokens.tariffClassification.reviewProgress]: '{{done}} von {{total}} bearbeitet',
  [tokens.tariffClassification.reviewExit]: 'Bearbeitung beenden',
  [tokens.tariffClassification.reviewPrevious]: 'Zurück',
  [tokens.tariffClassification.reviewSkip]: 'Überspringen',
  [tokens.tariffClassification.reviewHintPick]: 'Code übernehmen',
  [tokens.tariffClassification.reviewHintMove]: 'Gruppe wechseln',
  [tokens.tariffClassification.keyEscape]: 'Esc',
  [tokens.tariffClassification.filterChapter]: 'Kapitel',
  [tokens.tariffClassification.filterAllChapters]: 'Alle Kapitel',
  [tokens.tariffClassification.chapterOption]: 'Kapitel {{chapter}} · {{count}} Pos.',
  [tokens.tariffClassification.showNext]: '{{count}} weitere anzeigen ({{remaining}} übrig)',
  [tokens.tariffClassification.levelChapter]: 'Kapitel',
  [tokens.tariffClassification.levelHeading]: 'Position',
  [tokens.tariffClassification.levelSubheading]: 'HS-Unterposition',
  [tokens.tariffClassification.levelCn]: 'Kombinierte Nomenklatur',
  [tokens.tariffClassification.levelTaric]: 'TARIC',
  [tokens.tariffClassification.askAssistant]: 'Den Assistenten fragen',
  [tokens.tariffClassification.openRita]: 'In RITA ansehen',
  [tokens.tariffClassification.assistantPromptReceived]: 'Hilf mir, {{count}} mit dem Code {{code}} erhaltene Positionen einzureihen.',
  [tokens.tariffClassification.assistantPromptReceived_one]: 'Hilf mir, eine mit dem Code {{code}} erhaltene Position einzureihen.',
  [tokens.tariffClassification.assistantPromptMissing]: 'Hilf mir, {{count}} ohne Code erhaltene Positionen einzureihen.',
  [tokens.tariffClassification.assistantPromptMissing_one]: 'Hilf mir, eine ohne Code erhaltene Position einzureihen.',
  [tokens.tariffClassification.assistantPromptDesignations]: 'Bezeichnungen: {{list}}.',
  [tokens.tariffClassification.assistantPromptOrigin]: 'Ursprung: {{origin}}.',
  [tokens.tariffClassification.assistantPromptBranches]: 'Mögliche Unterpositionen in der Nomenklatur: {{list}}.',
  [tokens.tariffClassification.assistantPromptAsk]: 'Schlage den wahrscheinlichsten 10-stelligen Warencode vor, erkläre deine Begründung und sag mir, was ich vor der Anmeldung prüfen muss.',
  [tokens.tariffClassification.missingDigits]: '{{count}} Ziffern fehlen',
  [tokens.tariffClassification.missingDigits_one]: '1 Ziffer fehlt',
  [tokens.tariffClassification.notInNomenclature]: 'nicht in der Nomenklatur',
  [tokens.tariffClassification.pickCandidate]: 'Wählen Sie den Code, er gilt für die {{count}} Positionen',
  [tokens.tariffClassification.pickCandidate_one]: 'Wählen Sie den Code der Position',
  [tokens.tariffClassification.help]: 'So funktioniert es',
  [tokens.tariffClassification.tourTitle]: 'Tarifill entdecken',
  [tokens.tariffClassification.openTarifill]: 'Die Zolltarifeinreihung des Vorgangs: Tarifill erkennt unvollständige oder unbekannte Warencodes, schlägt Unterpositionen der Nomenklatur vor und protokolliert jede Korrektur.',
  [tokens.tariffClassification.groupArticles]: '{{count}} Positionen',
  [tokens.tariffClassification.groupArticles_one]: '1 Position',
  [tokens.tariffClassification.noCode]: 'Kein Code',
  [tokens.tariffClassification.searchInDirectory]: 'Im Verzeichnis suchen',
  [tokens.tariffClassification.directoryPlaceholder]: 'Beliebiger Code oder Stichwort',
  [tokens.tariffClassification.directoryScopeAll]: 'Die gesamte Nomenklatur',
  [tokens.tariffClassification.directoryExtend]: 'Auch in den anderen Kapiteln suchen',
  [tokens.tariffClassification.directoryNoResult]: 'Kein Code passt.',
  [tokens.tariffClassification.directoryResults]: '{{count}} Ergebnisse',
  [tokens.tariffClassification.directoryResults_one]: '1 Ergebnis',
  [tokens.tariffClassification.determinedDerived]: 'Abgeleitet',
  [tokens.tariffClassification.determinedMasterData]: 'Stammdaten',
  [tokens.tariffClassification.determinedDefault]: 'Regel',
  [tokens.tariffClassification.determinationTitle]: 'Von Nabu bestimmt',
  [tokens.tariffClassification.determinationDerived]: 'Dieser Code steht so nicht in den Unterlagen: Nabu hat ihn abgeleitet.',
  [tokens.tariffClassification.determinationMasterData]: 'Aus den Kundenstammdaten {{name}} übernommen.',
  [tokens.tariffClassification.determinationMasterDataUnnamed]: 'Aus den Kundenstammdaten übernommen.',
  [tokens.tariffClassification.determinationDefault]: 'Durch eine Regel gesetzt, da die Unterlagen keinen Code enthalten.',
  [tokens.tariffClassification.stateReady]: 'Bereit',
  [tokens.tariffClassification.statePartial]: 'Zu vervollständigen',
  [tokens.tariffClassification.stateUnknown]: 'Nicht gefunden',
  [tokens.tariffClassification.filterAll]: 'Alle',
  [tokens.tariffClassification.filterPartial]: 'Zu vervollständigen',
  [tokens.tariffClassification.filterReady]: 'Bereit',
  [tokens.tariffClassification.filterUnknown]: 'Nicht gefunden',
  [tokens.tariffClassification.readyArticles]: 'Artikel bereit',
  [tokens.tariffClassification.readyArticles_one]: 'Artikel bereit',
  [tokens.tariffClassification.listSearchPlaceholder]: 'Artikel, Code oder Bezeichnung',
  [tokens.tariffClassification.listEmpty]: 'Kein Artikel entspricht.',
  [tokens.tariffClassification.articleNumber]: 'Artikel {{index}}',
  [tokens.tariffClassification.articleShort]: 'Nr. {{index}}',
  [tokens.tariffClassification.receivedCode]: 'Erhaltener Code',
  [tokens.tariffClassification.noCodeShort]: 'keiner',
  [tokens.tariffClassification.originShort]: 'Ursprung {{origin}}',
  [tokens.tariffClassification.partialIntro]: '{{prefix}} existiert. Die letzte Ebene fehlt: {{count}} mögliche Fortsetzungen.',
  [tokens.tariffClassification.partialIntro_one]: '{{prefix}} existiert. Die letzte Ebene fehlt: nur eine Fortsetzung ist möglich.',
  [tokens.tariffClassification.partialPrefixOf]: '{{prefix}} (erhaltener Code {{received}})',
  [tokens.tariffClassification.unknownIntro]: 'Keine Ebene von {{code}} existiert in der Nomenklatur. Suchen Sie den richtigen Code im Verzeichnis.',
  [tokens.tariffClassification.missingIntro]: 'Dieser Artikel hat keinen Code. Suchen Sie ihn im Verzeichnis.',
  [tokens.tariffClassification.nextLevels]: '{{count}} Fortsetzungen',
  [tokens.tariffClassification.nextLevels_one]: '1 Fortsetzung',
  [tokens.tariffClassification.costAfterComplete]: 'Geschätzte Kosten und Maßnahmen erscheinen, sobald der Code vollständig ist.',
  [tokens.tariffClassification.openDirectoryFor]: 'Im Verzeichnis anzeigen',
  [tokens.tariffClassification.openDetail]: 'Artikelblatt',
  [tokens.tariffClassification.openTreeHere]: 'Baum hier öffnen',
  [tokens.tariffClassification.backToArticles]: 'Artikel',
  [tokens.tariffClassification.pathTitle]: 'Pfad in der Nomenklatur',
  [tokens.tariffClassification.costTitle]: 'Geschätzte Einfuhrkosten',
  [tokens.tariffClassification.costNormal]: 'Regelsatz',
  [tokens.tariffClassification.costPreference]: 'Präferenz {{origin}}',
  [tokens.tariffClassification.costSituation]: 'Zollsituation',
  [tokens.tariffClassification.costOrigin]: 'Ursprungsland',
  [tokens.tariffClassification.costTerritory]: 'Anwendungsgebiet',
  [tokens.tariffClassification.costTerritoryValue]: 'Französisches Festland (CONTI)',
  [tokens.tariffClassification.costPreferentialOrigin]: 'Präferenzursprung',
  [tokens.tariffClassification.costNomenclature]: 'Abfertigungsnomenklatur',
  [tokens.tariffClassification.costAdditionalCodes]: 'Zusatzcodes',
  [tokens.tariffClassification.costValueData]: 'Wertangaben',
  [tokens.tariffClassification.costInvoiced]: 'Rechnungswert',
  [tokens.tariffClassification.costCustomsValue]: 'Zollwert',
  [tokens.tariffClassification.costVatValue]: 'MwSt.-Wert',
  [tokens.tariffClassification.costCif]: 'CIF-Basis',
  [tokens.tariffClassification.costCifNo]: 'Nein, Fracht nicht aufgeteilt',
  [tokens.tariffClassification.costNetMass]: 'Eigenmasse',
  [tokens.tariffClassification.costColCode]: 'Code',
  [tokens.tariffClassification.costColTax]: 'Vorberechnete Abgaben',
  [tokens.tariffClassification.costColRate]: 'Satz',
  [tokens.tariffClassification.costColAmount]: 'Betrag',
  [tokens.tariffClassification.costDuty]: 'Zölle',
  [tokens.tariffClassification.costDutyThirdCountry]: 'TARIC · Drittland',
  [tokens.tariffClassification.costDutyPreference]: 'TARIC · Präferenz {{agreement}}',
  [tokens.tariffClassification.costVat]: 'Einfuhrumsatzsteuer',
  [tokens.tariffClassification.costVatBasis]: 'RITA · auf den MwSt.-Wert',
  [tokens.tariffClassification.costTotal]: 'Geschätzte Kosten',
  [tokens.tariffClassification.costNoValue]: 'Beträge nicht berechnet: Zollwert unbekannt (Währung ohne Wechselkurs oder fehlender Betrag).',
  [tokens.tariffClassification.costRatesAt]: 'Sätze gültig am {{date}}',
  [tokens.tariffClassification.costCompareRita]: 'Auf RITA vergleichen',
  [tokens.tariffClassification.measuresSectionTitle]: 'Maßnahmen und Unterlagen',
  [tokens.tariffClassification.measuresCount]: '{{count}} Maßnahmen',
  [tokens.tariffClassification.measuresCount_one]: '1 Maßnahme',
  [tokens.tariffClassification.documentsCount]: '{{count}} Unterlagen',
  [tokens.tariffClassification.documentsCount_one]: '1 Unterlage',
  [tokens.tariffClassification.measureSourceTaric]: 'TARIC',
  [tokens.tariffClassification.measureSourceRita]: 'Frankreich · RITA',
  [tokens.tariffClassification.measureNationalCode]: 'Nationaler Zusatzcode zu wählen',
  [tokens.tariffClassification.measureVat]: 'Einfuhrumsatzsteuer',
  [tokens.tariffClassification.documentToProvide]: 'Vorzulegende Unterlage:',
  [tokens.tariffClassification.documentRequired]: '{{document}}.',
  [tokens.tariffClassification.proofOptional]: '{{document}}, nur wenn die Präferenz beantragt wird.',
  [tokens.tariffClassification.proofRequired]: '{{document}}. Erforderlich: die Präferenz wird beantragt.',
  [tokens.tariffClassification.directoryFor]: 'Für',
  [tokens.tariffClassification.directoryScopeOurs]: 'Unsere Artikel · {{count}}',
  [tokens.tariffClassification.directoryOursPlaceholder]: 'Artikel, Code oder Bezeichnung im Vorgang',
  [tokens.tariffClassification.directoryOursEmpty]: 'Kein Artikel des Vorgangs entspricht.',
  [tokens.tariffClassification.directoryChooseArticle]: 'Artikel wählen…',
  [tokens.tariffClassification.inDossier]: 'Im Vorgang',
  [tokens.tariffClassification.dossierArticles]: 'Artikel des Vorgangs',
  [tokens.tariffClassification.viewInTree]: 'Im Baum anzeigen',
  [tokens.tariffClassification.completeInTree]: 'Im Baum vervollständigen',
  [tokens.tariffClassification.usedByArticles]: 'Von {{count}} Artikeln des Vorgangs verwendet',
  [tokens.tariffClassification.usedByArticles_one]: 'Von 1 Artikel des Vorgangs verwendet',
  [tokens.tariffClassification.chapterCode]: 'Kapitel {{chapter}}',
  [tokens.tariffClassification.treeSearched]: 'Gesuchte Nomenklatur:',
  [tokens.tariffClassification.treeNone]: 'keine',
  [tokens.tariffClassification.tourStepCardApplyTitle]: 'Anwenden',
  [tokens.tariffClassification.tourStepCardApplyBody]: 'Der gewählte Code kommt in das Feld des Artikels, als ein Schritt im Verlauf. „Rückgängig“ stellt den vorherigen Code wieder her.',
  [tokens.tariffClassification.tourStepCardCostTitle]: 'Kosten und Maßnahmen',
  [tokens.tariffClassification.tourStepCardCostBody]: 'Ein vollständiger Code zeigt die geschätzten Einfuhrkosten (Zölle und MwSt., mit oder ohne Präferenz) und die ausgelösten Maßnahmen und Unterlagen. Nie eine erfundene Zahl: Nicht Berechenbares bleibt x xxx,xx €.',
  [tokens.tariffClassification.tourStepCardOptionsTitle]: 'Die Fortsetzung wählen',
  [tokens.tariffClassification.tourStepCardOptionsBody]: 'Jede Fortsetzung mit ihrer amtlichen Bezeichnung. „Restposition“ markiert „andere“, in risikoarmen Kapiteln vorausgewählt. Die Flaggen öffnen den Code in TARIC (EU-Maßnahmen) oder RITA (französische Maßnahmen).',
  [tokens.tariffClassification.tourStepCardPathTitle]: 'Die erkannten Ebenen',
  [tokens.tariffClassification.tourStepCardPathBody]: 'Jede abgehakte Ebene existiert in der Nomenklatur; ein Klick öffnet das Verzeichnis auf dieser Ebene. Der orange Chip zählt die möglichen Fortsetzungen. Das Buch öffnet das Verzeichnis für den Artikel, das i sein Blatt.',
  [tokens.tariffClassification.tourStepDetailBrowseTitle]: 'Das Blatt eines Artikels',
  [tokens.tariffClassification.tourStepDetailBrowseBody]: 'Eine Seite pro Artikel. Die Pfeile ↑ ↓ oder die der Tastatur wechseln zum benachbarten Artikel, ohne zur Liste zurückzukehren; das Raster folgt. „Artikel“ führt zur Liste zurück.',
  [tokens.tariffClassification.tourStepDetailCodeTitle]: 'Der Code, groß',
  [tokens.tariffClassification.tourStepDetailCodeBody]: 'Der angemeldete Code, sein Status, seine Herkunft (abgeleitet, Stammdaten, Regel) und der erhaltene Code, falls er sich geändert hat.',
  [tokens.tariffClassification.tourStepDetailPathTitle]: 'Der vollständige Pfad',
  [tokens.tariffClassification.tourStepDetailPathBody]: 'Vom Kapitel bis zum Code, jede Ebene mit ihrer Bezeichnung. Ein Klick öffnet das Verzeichnis auf dieser Ebene.',
  [tokens.tariffClassification.tourStepDirectoryButtonTitle]: 'Das Verzeichnis',
  [tokens.tariffClassification.tourStepDirectoryButtonBody]: 'Diese Schaltfläche öffnet das Verzeichnis für den ganzen Vorgang; von einer Karte oder einem Blatt aus öffnet es sich für den Artikel.',
  [tokens.tariffClassification.tourStepSummaryTitle]: 'Stand des Vorgangs',
  [tokens.tariffClassification.tourStepSummaryBody]: 'Wie viele Artikel bereit sind, und ein Balken: ein Strich pro Artikel, grün wenn bereit, orange wenn zu vervollständigen, rot wenn nicht gefunden.',
  [tokens.declarationKeyboard.shortcutSourceDocument]: 'Quelldokument (Vollbild)',
  [tokens.declarationKeyboard.shortcutDauRecap]: 'Einheitspapier-Übersicht',
  [tokens.declarationKeyboard.shortcutShowHints]: 'Tastenkürzel öffnen / schließen',
  [tokens.declarationKeyboard.hintsDialogTitle]: 'Tastenkürzel',
  [tokens.declarationKeyboard.panelSubtitle]: 'Schließt beim nächsten Klick oder mit Esc',
  [tokens.declarationKeyboard.panelSearchPlaceholder]: 'Tastenkürzel suchen',
  [tokens.declarationKeyboard.panelSearchEmpty]: 'Kein Tastenkürzel für „{{query}}“',
  [tokens.declarationKeyboard.panelContextBadge]: 'Aktueller Kontext',
  [tokens.declarationKeyboard.panelClose]: 'Schließen (Esc)',
  [tokens.declarationKeyboard.panelFooterToggle]: '<key/> öffnen / schließen',
  [tokens.declarationKeyboard.shortcutStepNavigation]: 'Vorheriger / nächster Tab',
  [tokens.declarationKeyboard.shortcutFocusSearch]: 'Feld suchen',
  [tokens.declarationKeyboard.shortcutOpenSettings]: 'Einstellungen',
  [tokens.declarationKeyboard.shortcutCopyNabuNumber]: 'Nabu-Nummer kopieren',
  [tokens.declarationKeyboard.shortcutOpenHistory]: 'Verlauf der Erklärung',
  [tokens.declarationKeyboard.shortcutMoveCell]: 'Benachbarte Zelle',
  [tokens.declarationKeyboard.shortcutEditCell]: 'Zelle bearbeiten',
  [tokens.declarationKeyboard.shortcutLeaveCell]: 'Eingabe verlassen',
  [tokens.declarationKeyboard.keyEnter]: 'Eingabe',
  [tokens.declarationKeyboard.keyEscape]: 'Esc',
  [tokens.declarationKeyboard.keySpace]: 'Leertaste',
  [tokens.declarationKeyboard.shortcutToggleArticleGrid]:
    'Tabellennavigation ein- oder ausschalten',
  [tokens.declarationKeyboard.shortcutOpenTarifill]: 'Tarifill öffnen oder schließen',
  [tokens.declarationKeyboard.categoryNavigate]: 'Navigieren · {{command}} + Taste',
  [tokens.declarationKeyboard.categoryOpen]: 'Öffnen und handeln · {{commandShift}} + Anfangsbuchstabe',
  [tokens.declarationKeyboard.categoryEdit]: 'Bearbeiten',
  [tokens.declarationKeyboard.categoryAssistant]: 'Nabu-Assistent',
  [tokens.declarationKeyboard.categoryGrid]: 'In der Tabelle',
  [tokens.declarationKeyboard.categoryDocument]: 'Im Quelldokument',
  [tokens.declarationKeyboard.shortcutSourceDocumentSwitch]: 'Vorheriges oder nächstes Dokument',
  [tokens.declarationKeyboard.shortcutSourceDocumentPage]: 'Vorherige oder nächste Seite',
  [tokens.declarationKeyboard.shortcutSourceDocumentZoom]: 'Vergrößern oder verkleinern',
  [tokens.declarationKeyboard.shortcutSourceDocumentResetZoom]: 'Zurück auf 100 %',
  [tokens.declarationKeyboard.shortcutSourceDocumentRotate]: 'Seite nach rechts oder links drehen',
  [tokens.declarationKeyboard.shortcutSourceDocumentSearch]: 'Im Dokument suchen',
  [tokens.declarationKeyboard.shortcutSourceDocumentPan]: 'Gedrückt halten und ziehen zum Verschieben',
  [tokens.declarationKeyboard.copyNabuNumberTooltip]: 'Nabu-Nummer kopieren',

  [tokens.declarationUi.saving]: 'Speichern…',
  [tokens.declarationUi.stateGenerated]: 'Vorzubereiten',
  [tokens.declarationUi.stateInReview]: 'In Korrektur',
  [tokens.declarationUi.stateReady]: 'Validiert, Versand wartet auf die anderen Anmeldungen',
  [tokens.declarationUi.stateSent]: 'Übermittelt',
  [tokens.declarationUi.stateAccepted]: 'Angenommen',
  [tokens.declarationUi.stateRejected]: 'Abgelehnt',
  [tokens.declarationUi.stateSuperseded]: 'Ersetzt',
  [tokens.declarationUi.fieldRequiredError]: 'Pflichtfeld nicht ausgefüllt',
  [tokens.declarationUi.catalogLoading]: 'Wird geladen…',
  [tokens.declarationUi.fieldMaxLengthError]:
    'Höchstens {{max}} Zeichen, {{count}} eingegeben',
  [tokens.declarationUi.fieldRejected]: '„{{value}}“ nicht gespeichert: {{reason}}',
  [tokens.declarationUi.sourceManualTooltip]:
    'Manuell von einem Bediener auf diesem Bildschirm erfasst.',
  [tokens.declarationUi.sourceRoutineTooltip]:
    'Von der Routine „{{routine}}“ geschrieben, Anweisung „{{instruction}}“.',
  [tokens.declarationUi.sourceComputed]: 'Berechnet',
  [tokens.declarationUi.sourceDerived]: 'Abgeleitet',
  [tokens.declarationUi.sourceMasterData]: 'Kundenstammdaten',
  [tokens.declarationUi.sourceDefault]: 'Standardwert',
  [tokens.declarationUi.sourceManual]: 'Erfasst',
  [tokens.declarationUi.sourceConsolidated]: 'Konsolidiert',
  [tokens.declarationUi.sourceRemote]: 'Zollrückmeldung',
  [tokens.declarationUi.sourceSetting]: 'Einstellung',
  [tokens.declarationUi.sourceSettingFlux]: 'Einstellung des Modells „{{name}}“',
  [tokens.declarationUi.sourceSettingFluxUnnamed]: 'Einstellung des Modells',
  [tokens.declarationUi.sourceSettingGroup]: 'Agentureinstellung',
  [tokens.declarationUi.sourceSettingUser]: 'Benutzereinstellung',
  [tokens.declarationUi.sourcePieceSaid]: 'Das Dokument sagte „{{value}}“',
  [tokens.declarationUi.evidenceExtracted]: 'Gelesener Wert',

  [tokens.declarationUi.title]: 'Anmeldung',
  [tokens.declarationUi.loading]: 'Anmeldung wird geladen…',
  [tokens.declarationUi.notFound]: 'Dieser Vorgang hat keine agentische Anmeldung.',
  [tokens.declarationUi.error]: 'Die Anmeldung konnte nicht geladen werden.',
  [tokens.declarationUi.interfaceClassic]: 'Dokumente links',
  [tokens.declarationUi.interfaceSections]: 'Abschnitte',
  [tokens.declarationUi.showDocument]: 'Dokument anzeigen',
  [tokens.declarationUi.showOrigin]: 'Quelle anzeigen',
  [tokens.declarationUi.hideDocument]: 'Dokument ausblenden',
  [tokens.declarationUi.validate]: 'Anmeldung validieren',
  [tokens.declarationUi.validateAndSend]: 'Validieren und senden',
  [tokens.declarationUi.validated]: 'Anmeldung validiert',
  [tokens.declarationUi.blockedHint]:
    'Beheben Sie blockierende Auffälligkeiten, um zu validieren',
  [tokens.declarationUi.progressRequired]: 'Pflichtfelder',
  [tokens.declarationUi.sectionCountRequired]:
    '{{filled}} von {{total}} Pflichtfeldern in diesem Abschnitt',
  [tokens.declarationUi.sectionCountRequired_one]:
    '{{filled}} von {{total}} Pflichtfeld in diesem Abschnitt',
  [tokens.declarationUi.sectionCountOptional]:
    ' · {{optional}} optionale Felder leer, blockieren die Validierung nicht',
  [tokens.declarationUi.sectionCountOptional_one]:
    ' · {{optional}} optionales Feld leer, blockiert die Validierung nicht',
  [tokens.declarationUi.progressFilled]: 'ausgefüllt',
  [tokens.declarationUi.anomalies]: 'Hinweise',
  [tokens.declarationUi.severityBlocking]: 'Blockierend',
  [tokens.declarationUi.severityInfo]: 'Info',
  [tokens.declarationUi.seeDetail]: 'Details anzeigen',
  [tokens.declarationUi.hideDetail]: 'Ausblenden',
  [tokens.declarationUi.seeInfos]: 'Info-Hinweise anzeigen',
  [tokens.declarationUi.hideInfos]: 'Info-Hinweise ausblenden',
  [tokens.declarationUi.linesConcerned]: 'Betroffene Zeilen',
  [tokens.declarationUi.totalMismatchTitle]:
    'Die Dokumentsumme und die Summe der Zeilen stimmen nicht überein',
  [tokens.declarationUi.totalMismatchTitleReference]:
    'Die gewählte Summe und die Summe der Zeilen stimmen nicht überein',
  [tokens.declarationUi.totalMismatchValues]:
    'Dokument: {{reference}} · Summe der Zeilen ({{count}}): {{lines}} · Abweichung: {{gap}}',
  [tokens.declarationUi.totalMismatchValuesReference]:
    'Gewählte Summe: {{reference}} · Summe der Zeilen ({{count}}): {{lines}} · Abweichung: {{gap}}',
  [tokens.declarationUi.totalLinesMissingTitle]:
    'Das Dokument nennt eine Summe, aber keine Zeile hat einen Wert',
  [tokens.declarationUi.totalLinesMissingValues]:
    'Dokument: {{reference}} · Ausgefüllte Zeilen: 0 von {{count}}',
  [tokens.declarationUi.totalNoticeHint]:
    'Nur zur Information: Der Versand ist nicht blockiert. Prüfen Sie die Werte der Positionen oder die Dokumentsumme.',
  [tokens.declarationUi.lineCount]: 'Anzahl Zeilen',
  [tokens.declarationUi.goToLine]: 'Zur Zeile',
  [tokens.declarationUi.completion]: 'Fortschritt · Pflichtfelder',
  [tokens.declarationUi.searchField]: 'Feld suchen',
  [tokens.declarationUi.onlyBlocking]: 'Fehlende Pflichtfelder',
  [tokens.declarationUi.expandAll]: 'Auszufüllende Abschnitte aufklappen',
  [tokens.declarationUi.nothingToExpand]: 'Kein Abschnitt auszufüllen',
  [tokens.declarationUi.collapseAll]: 'Alle Abschnitte zuklappen',
  [tokens.declarationUi.expandRubrique]: 'Rubrik aufklappen',
  [tokens.declarationUi.collapseRubrique]: 'Rubrik zuklappen',
  [tokens.declarationUi.mailThread]: 'E-Mail-Verlauf',
  [tokens.declarationUi.emailSource]: 'Quell-E-Mail',
  [tokens.declarationUi.collapseRail]: 'Panel zuklappen',
  [tokens.declarationUi.expandRail]: 'Panel aufklappen',
  [tokens.declarationUi.noMatch]: 'Keine passenden Daten.',
  [tokens.declarationUi.noFieldsInStep]: 'Keine Felder in diesem Schritt.',
  [tokens.declarationUi.fieldSearchRecent]: 'Letzte Suchen',
  [tokens.declarationUi.fieldSearchToComplete]: 'Zu ergänzen',
  [tokens.declarationUi.fieldSearchToCompleteHint]: 'Nur leere Pflichtfelder und fehlerhafte Felder anzeigen',
  [tokens.declarationUi.fieldSearchMissing]: 'Fehlt',
  [tokens.declarationUi.fieldSearchInError]: 'Fehlerhaft',
  [tokens.declarationUi.fieldSearchSynonymsProcedure]: 'Verfahren Zollverfahren Verfahrenscode 4000 4200 1000 1040',
  [tokens.declarationUi.fieldSearchSynonymsIncoterm]: 'Incoterm Lieferbedingungen EXW FCA FAS FOB CFR CIF CPT CIP DAP DPU DDP',
  [tokens.declarationUi.fieldSearchSynonymsCustomsOffice]: 'Zollstelle Ausgangszollstelle Ausfuhrzollstelle',
  [tokens.declarationUi.fieldSearchSynonymsIdentification]: 'EORI Identifikationsnummer USt-IdNr',
  [tokens.declarationUi.fieldSearchSynonymsSupportingDocument]: 'Unterlage Begleitdokument Bescheinigung Lizenz Rechnung N380 N935 N325 EUR.1',
  [tokens.declarationUi.fieldSearchSynonymsPreviousDocument]: 'Vorpapier vorangegangenes Dokument',
  [tokens.declarationUi.fieldSearchSynonymsContainer]: 'Container Behälter',
  [tokens.declarationUi.fieldSearchSynonymsTransport]: 'Beförderungsmittel Verkehrszweig Schiff LKW Flugzeug Kennzeichen',
  [tokens.declarationUi.fieldSearchSynonymsLocationOfGoods]: 'Warenort Ort der Waren',
  [tokens.declarationUi.fieldSearchSynonymsConsignee]: 'Empfänger',
  [tokens.declarationUi.fieldSearchSynonymsExporter]: 'Ausführer Versender',
  [tokens.declarationUi.fieldSearchSynonymsImporter]: 'Einführer Importeur',
  [tokens.declarationUi.fieldSearchSynonymsRepresentative]: 'Vertreter Zollagent',
  [tokens.declarationUi.fieldSearchSynonymsDeclarant]: 'Anmelder',
  [tokens.declarationUi.fieldSearchSynonymsReference]: 'Bezugsnummer LRN UCR',
  [tokens.declarationUi.fieldSearchSynonymsDeclarationType]: 'Anmeldungsart Art der Anmeldung',
  [tokens.declarationUi.fieldSearchSynonymsOrigin]: 'Ursprung Ursprungsland',
  [tokens.declarationUi.keyboardNext]: 'nächstes Feld',
  [tokens.declarationUi.keyboardCommit]: 'bestätigen',
  [tokens.declarationUi.fields]: 'Felder',
  [tokens.declarationUi.add]: 'Hinzufügen',
  [tokens.declarationUi.remove]: 'Entfernen',
  [tokens.declarationUi.noOccurrence]: 'Kein Vorkommen',
  [tokens.declarationUi.sourceDocument]: 'Quelldokument',
  [tokens.declarationUi.control]: 'Prüfung & Validierung',
  [tokens.declarationUi.notOnDocument]:
    'kein gedruckter Gesamtbetrag · Vergleich nicht möglich',
  [tokens.declarationUi.notIdentified]: 'nicht identifiziert',
  [tokens.declarationUi.clear]: 'Löschen',
  [tokens.declarationUi.howObtained]: 'Wie dieser Wert ermittelt wurde',
  [tokens.declarationUi.noAnomaly]: 'Keine Auffälligkeit: die Anmeldung ist bereit.',
  [tokens.declarationUi.fix]: 'Diese Auffälligkeit beheben',
  [tokens.declarationUi.guidedReview]: 'Geführte Prüfung',
  [tokens.declarationUi.locate]: 'Lokalisieren',
  [tokens.declarationUi.previous]: 'Zurück',
  [tokens.declarationUi.next]: 'Weiter',
  [tokens.declarationUi.close]: 'Schließen',
  [tokens.declarationUi.totals]: 'Summen',
  [tokens.declarationUi.documentTotal]: 'Dokumentsumme',
  [tokens.declarationUi.linesTotal]: 'Summe der Zeilen',
  [tokens.declarationUi.verdictEqual]: 'Identisch',
  [tokens.declarationUi.verdictDiffers]: 'Abweichung',
  [tokens.declarationUi.verdictMissing]: 'Keine Summe auf den Dokumenten',
  [tokens.declarationUi.verdictLinesMissing]: 'Zeilen nicht ausgefüllt',
  [tokens.declarationUi.totalEmpty]: 'Keine Zeile trägt diese Größe, und kein Dokument druckt sie',
  [tokens.declarationUi.referenceManual]: 'Eingegeben',
  [tokens.declarationUi.referenceLines]: 'Summe der Zeilen übernommen',
  [tokens.declarationUi.referenceReading]: 'Übernommen',
  [tokens.declarationUi.alsoReadOn]: 'auch gelesen auf',
  [tokens.declarationUi.enterTotal]: 'Summe eingeben',
  [tokens.declarationUi.editTotal]: 'Summe ändern',
  [tokens.declarationUi.enterPlaceholder]: 'Eingeben',
  [tokens.declarationUi.readOn]: 'Gelesen auf',
  [tokens.declarationUi.computedSum]: 'Summe der Gesamtbeträge von {{count}} Belegen',
  [tokens.declarationUi.readShort]: 'gelesen',
  [tokens.declarationUi.pageShort]: 'S. {{page}}',
  [tokens.declarationUi.notDeclared]: 'nicht angemeldet',
  [tokens.declarationUi.verdictGap]: 'Abweichung von {{value}}',
  [tokens.declarationUi.offerKeepLines]: 'Summe der Zeilen übernehmen ({{value}})',
  [tokens.declarationUi.offerKeepReading]: '{{value}} übernehmen ({{piece}})',
  [tokens.declarationUi.offerClearReference]: 'Zur gelesenen Summe zurück',
  [tokens.declarationUi.distributeTotal]: 'Auf Positionen verteilen',
  [tokens.declarationUi.distributeTitle]: 'Summe auf Positionen verteilen',
  [tokens.declarationUi.distributeSummary]: '{{amount}} auf {{count}} Positionen verteilen.',
  [tokens.declarationUi.distributeSummary_one]: '{{amount}} auf {{count}} Position verteilen.',
  [tokens.declarationUi.distributeEvenly]: 'Zu gleichen Teilen',
  [tokens.declarationUi.distributeProrata]: 'Im Verhältnis zu',
  [tokens.declarationUi.distributePackages]: 'Die Packstücke kommen auf die erste Position jeder Rechnung, die übrigen Positionen auf 0 ({{amount}} insgesamt).',
  [tokens.declarationUi.distributeOverwrite]: 'Die {{count}} vorhandenen Werte werden ersetzt.',
  [tokens.declarationUi.distributeOverwrite_one]: 'Der vorhandene Wert wird ersetzt.',
  [tokens.declarationUi.distributeConfirm]: 'Verteilen',
  [tokens.declarationUi.distributeInvoice]: 'Auf diese Rechnung verteilen',
  [tokens.declarationUi.distributeInvoiceUndo]: 'Verteilung auf diese Rechnung rückgängig machen',
  [tokens.declarationUi.revertConfirmText]: '„{{title}}“ rückgängig zu machen, macht auch rückgängig:',
  [tokens.declarationUi.revertConfirmTextGeneric]: 'Diese Aktion rückgängig zu machen, macht auch rückgängig:',
  [tokens.declarationUi.revertDialogTitleGeneric]: 'Eine Aktion rückgängig machen',
  [tokens.declarationUi.revertKeep]: 'Behalten',
  [tokens.declarationUi.revertConfirm]: 'Die {{count}} Aktionen rückgängig machen',
  [tokens.declarationUi.undoLast]: 'Rückgängig',
  [tokens.declarationUi.redoLast]: 'Wiederherstellen',
  [tokens.declarationUi.sourceDistributed]: 'Verteilt',
  [tokens.declarationUi.articlesFilled]: '{{filled}}/{{total}} Artikel ausgefüllt',
  [tokens.declarationUi.articles]: 'Artikel',
  [tokens.declarationUi.columns]: 'Spalten',
  [tokens.declarationUi.allColumns]: 'Alle Spalten',
  [tokens.declarationUi.usefulColumns]: 'Ausgefüllte Spalten',
  [tokens.declarationUi.addLine]: 'Artikelzeile hinzufügen',
  [tokens.declarationUi.addColumn]: 'Spalte hinzufügen',
  [tokens.declarationUi.addColumnSpecific]: 'Eine bestimmte Spalte hinzufügen',
  [tokens.declarationUi.searchArticles]: 'Artikel suchen',
  [tokens.declarationUi.ocrPasteHint]: '{{count}} Werte kopiert. Klicken Sie eine Zelle der Tabelle an.',
  [tokens.declarationUi.ocrPasteSame]: 'Alles in diese Zelle',
  [tokens.declarationUi.ocrPasteDown]: 'Ein Wert pro Zelle, nach unten',
  [tokens.declarationUi.ocrPasteRight]: 'Ein Wert pro Zelle, nach rechts',
  [tokens.declarationUi.ocrPasteDismiss]: 'Schließen',
  [tokens.declarationUi.ocrPasteTruncated]: '{{count}} Werte hatten keine Zelle.',
  [tokens.declarationUi.noLineMatch]: 'Kein Artikel entspricht der Suche.',
  [tokens.declarationUi.linesGroupCount]: '{{count}} Positionen',
  [tokens.declarationUi.linesGroupCount_one]: '{{count}} Position',
  [tokens.declarationUi.linesGroupOther]: 'Weitere Positionen',
  [tokens.declarationUi.linesGroupUnknownPiece]: 'Unbekanntes Dokument',
  [tokens.declarationUi.invoiceTotalsTitle]: 'Aufschlüsselung nach Rechnung',
  [tokens.declarationUi.invoiceTotalsLines]: 'Summe der Artikelzeilen: {{value}}',
  [tokens.declarationUi.invoiceTotalsNotPrinted]: 'Summe der Artikelzeilen, nicht auf der Rechnung',
  [tokens.declarationUi.filterColumns]: '{{count}} Spalten filtern…',
  [tokens.declarationUi.columnTypeText]: 'Text',
  [tokens.declarationUi.columnTypeNumber]: 'Zahl',
  [tokens.declarationUi.columnTypeInteger]: 'Ganzzahl',
  [tokens.declarationUi.columnTypeDate]: 'Datum',
  [tokens.declarationUi.columnTypeDateTime]: 'Datum/Uhrzeit',
  [tokens.declarationUi.columnTypeBoolean]: 'Boolesch',
  [tokens.declarationUi.columnTypeCode]: 'Code',
  [tokens.declarationUi.noColumnMatch]: 'Keine passende Spalte',
  [tokens.declarationUi.removeColumn]: 'Spalte entfernen',
  [tokens.declarationUi.setColumn]: 'Einen Wert auf die ganze Spalte anwenden',
  [tokens.declarationUi.setColumnTitle]: '„{{label}}“ auf allen {{count}} Positionen',
  [tokens.declarationUi.setColumnTitle_one]: '„{{label}}“ auf der Position',
  [tokens.declarationUi.setColumnReplaces]: '{{count}} vorhandene Werte werden ersetzt',
  [tokens.declarationUi.setColumnReplaces_one]: '1 vorhandener Wert wird ersetzt',
  [tokens.declarationUi.setColumnApply]: 'Anwenden',
  [tokens.declarationUi.reorderColumn]: 'Spalte neu anordnen',
  [tokens.declarationUi.pinColumn]: 'Spalte fixieren',
  [tokens.declarationUi.unpinColumn]: 'Spalte lösen',
  [tokens.declarationUi.noLines]: 'Keine Artikelzeile.',
  [tokens.declarationUi.documents]: 'Dokumente',
  [tokens.declarationUi.piecePages]: 'S. {{range}}',
  [tokens.declarationUi.pieceSheet]: 'Blatt {{index}}',
  [tokens.declarationUi.pieceFilePages]: '{{count}} S.',
  [tokens.declarationUi.pieceFileSheets]: '{{count}} Blätter',
  [tokens.declarationUi.pieceDated]: 'vom {{date}}',
  [tokens.declarationUi.pieceNumberNotRead]: 'Nr. nicht gelesen',
  [tokens.declarationUi.pieceNotUsed]: 'Nicht in der Anmeldung verwendet',
  [tokens.declarationUi.pieceEmail]: 'E-Mail',
  [tokens.declarationUi.previousPiece]: 'Vorheriges Dokument',
  [tokens.declarationUi.nextPiece]: 'Nächstes Dokument',
  [tokens.declarationUi.pieceNavHint]: 'Vorheriges / nächstes Dokument, in dieser Reihenfolge',
  [tokens.declarationUi.previousPage]: 'Vorherige Seite',
  [tokens.declarationUi.nextPage]: 'Nächste Seite',
  [tokens.declarationUi.scrollToTop]: 'Anfang des Dokuments',
  [tokens.declarationUi.scrollToBottom]: 'Ende des Dokuments',
  [tokens.declarationUi.resizeForm]: 'Formulargröße ändern',
  [tokens.declarationUi.zoomIn]: 'Vergrößern',
  [tokens.declarationUi.zoomOut]: 'Verkleinern',
  [tokens.declarationUi.resetZoom]: 'Originalgröße',
  [tokens.declarationUi.rotateLeft]: 'Seite nach links drehen',
  [tokens.declarationUi.rotateRight]: 'Seite nach rechts drehen',
  [tokens.declarationUi.fitPage]: 'Ganze Seite anzeigen',
  [tokens.declarationUi.showThumbnails]: 'Miniaturansichten einblenden',
  [tokens.declarationUi.hideThumbnails]: 'Miniaturansichten ausblenden',
  [tokens.declarationUi.searchInDocument]: 'Im Dokument suchen',
  [tokens.declarationUi.searchPlaceholder]: 'In diesem Dokument suchen…',
  [tokens.declarationUi.searchLoading]: 'Text wird gelesen…',
  [tokens.declarationUi.searchNoResult]: 'Keine Treffer',
  [tokens.declarationUi.searchPrevious]: 'Vorheriger Treffer',
  [tokens.declarationUi.searchNext]: 'Nächster Treffer',
  [tokens.declarationUi.searchClose]: 'Suche schließen',
  [tokens.declarationUi.openOriginal]: 'Originaldatei öffnen',
  [tokens.declarationUi.noDocument]: 'Kein Dokument.',
  [tokens.declarationUi.previewUnavailable]: 'Vorschau nicht verfügbar',
  [tokens.declarationUi.loadingPreview]: 'Laden…',
  [tokens.declarationUi.citation]: 'Zitat',
  [tokens.declarationUi.origin]: 'Quelle',
  [tokens.declarationUi.openCalendar]: 'Kalender öffnen',
  [tokens.declarationUi.empty]: 'Nicht ausgefüllt',
  [tokens.declarationUi.required]: 'Pflichtfeld',
  [tokens.declarationUi.outOfForm]: 'Außerhalb des Formulars gelesen',
  [tokens.declarationUi.conflictReload]:
    'Die Anmeldung wurde während Ihrer Eingabe geändert. Der Bildschirm wurde neu geladen: setzen Sie Ihre Korrektur fort.',
  [tokens.declarationUi.rejected]: 'Korrektur abgelehnt',
  [tokens.declarationUi.operationSum]: 'Summe',
  [tokens.declarationUi.operationProduct]: 'Produkt',
  [tokens.declarationUi.operationProrata]: 'Prorata',
  [tokens.declarationUi.operationRequalification]: 'Requalifizierung',
  [tokens.declarationUi.computedFromReadings]:
    '{{operation}} aus {{count}} Lesung(en): {{terms}}',
  [tokens.declarationUi.pageNumber]: 'Seite {{page}}',
  [tokens.declarationUi.prepareDeclarationTitle]: 'Kontrollbereich',
  [tokens.declarationUi.reviewIntro]: 'Ergänzen Sie die fehlenden Felder und prüfen Sie dann die Abweichungen zu den Dokumenten. Jede Korrektur wird automatisch gespeichert.',
  [tokens.declarationUi.reviewUnblocked]: 'Die blockierenden Prüfungen sind behoben. Die Validierung bleibt ein ausdrücklicher Schritt.',
  [tokens.declarationUi.reviewGroupBlocking]: 'Zu ergänzen',
  [tokens.declarationUi.reviewGroupToCheck]: 'Zu prüfen',
  [tokens.declarationUi.reviewGroupInfo]: 'Hinweise',
  [tokens.declarationUi.reviewGroupDecided]: 'Gespeicherte Entscheidungen',
  [tokens.declarationUi.reviewIssueCount]: '{{count}} Punkte',
  [tokens.declarationUi.reviewIssueCount_one]: '{{count}} Punkt',
  [tokens.declarationUi.reviewLines]: 'Artikel: {{lines}}',
  [tokens.declarationUi.reviewComplete]: 'Ergänzen ({{count}})',
  [tokens.declarationUi.reviewCheckValues]: 'Werte prüfen',
  [tokens.declarationUi.reviewShowReadings]: 'Gelesene Werte anzeigen',
  [tokens.declarationUi.reviewHideReadings]: 'Einklappen',
  [tokens.declarationUi.reviewPieceFallback]: 'Dokument {{index}}',
  [tokens.declarationUi.reviewPageUnavailable]: 'Die genaue Seite der widersprüchlichen Werte ist nicht verfügbar. Prüfen Sie die Dokumente der Akte.',
  [tokens.declarationUi.reviewVerified]: 'Geprüft',
  [tokens.declarationUi.reviewReopen]: 'Diesen Punkt wieder öffnen',
  [tokens.declarationUi.reviewTabToProcess]: 'Zu bearbeiten',
  [tokens.declarationUi.labelValue]: '{{label}}: {{value}}',
  [tokens.declarationUi.quoted]: '„{{text}}“',
  [tokens.declarationUi.clearColumnTooltip]: 'Spalte „{{column}}“ in allen {{count}} Artikeln leeren',
  [tokens.declarationUi.clearColumnTooltip_one]: 'Spalte „{{column}}“ im Artikel leeren',
  [tokens.declarationUi.clearColumn]: 'Spalte leeren',
  [tokens.declarationUi.removeArticle]: 'Artikel löschen',
  [tokens.declarationUi.manualCorrectionNote]: 'Ursprünglich gelesen: {{value}} · Wert manuell korrigiert',
  [tokens.declarationUi.totalsFamilyBilling]: 'Abrechnung',
  [tokens.declarationUi.totalsFamilyPackaging]: 'Verpackung',
  [tokens.declarationUi.addTuple]: 'Hinzufügen',
  [tokens.declarationUi.removeTuple]: 'Entfernen',
  [tokens.declarationUi.prepareDeclarationButton]: 'Prüfungen',
  [tokens.declarationUi.prepareWindowPin]: 'An der Seite anheften',
  [tokens.declarationUi.prepareWindowPinLeft]: 'Links anheften',
  [tokens.declarationUi.prepareWindowPinRight]: 'Rechts anheften',
  [tokens.declarationUi.prepareWindowUnpin]: 'Lösen',
  [tokens.declarationUi.pinPreferencesHint]:
    'Heften Sie dieses Fenster an, um daneben zu arbeiten. Wo es sich jedes Mal öffnet, legen Sie in Ihren Einstellungen fest.',
  [tokens.declarationUi.pinPreferencesHintAction]: 'Einstellungen öffnen',
  [tokens.declarationUi.pinPreferencesHintClose]: 'Schließen',
  [tokens.declarationUi.pinPreferencesHintDocked]:
    'Fenster für diese Sitzung angeheftet. Damit es sich jedes Mal hier öffnet, legen Sie es in Ihren Einstellungen fest.',
  [tokens.declarationUi.pinPreferencesHintDockedFromPreferences]:
    'Dieses Fenster öffnet sich hier gemäß Ihren Einstellungen: Sie können sie jederzeit ändern.',
  [tokens.declarationUi.prepareWindowClose]: 'Schließen',
  [tokens.declarationUi.prepareWindowResize]: 'Bereich in der Größe ändern',
  [tokens.declarationUi.consolidate]: 'Konsolidieren',
  [tokens.declarationUi.consolidateArticles]: 'Artikel konsolidieren',
  [tokens.declarationUi.unconsolidate]: 'Konsolidierung aufheben',
  [tokens.declarationUi.consolidationTitle]: 'Artikel gruppieren nach',
  [tokens.declarationUi.confirm]: 'Bestätigen',
  [tokens.declarationUi.cancel]: 'Abbrechen',
  [tokens.declarationUi.linesTab]: 'Zeilen ({{count}})',
  [tokens.declarationUi.articlesTab]: 'Artikel ({{count}})',
  [tokens.declarationUi.showSourceLines]: '{{count}} Ursprungszeilen anzeigen',
  [tokens.declarationUi.showConsolidatedArticles]: '{{count}} konsolidierte Artikel anzeigen',
  [tokens.declarationUi.mergedLines]: '{{count}} Zeilen',
  [tokens.declarationUi.unkeyedLines]: '{{count}} Zeilen bleiben einzeln (Schlüssel fehlt)',
  [tokens.declarationUi.unkeyedLines_one]: '{{count}} Zeile bleibt einzeln (Schlüssel fehlt)',
  [tokens.declarationUi.sourceLinesTitle]: 'Zeilen {{numbers}}',
  [tokens.declarationUi.expandArticleLines]: 'Zeilen aufklappen',
  [tokens.declarationUi.collapseArticleLines]: 'Zeilen zuklappen',
  [tokens.declarationUi.expandAllArticles]: 'Alle aufklappen',
  [tokens.declarationUi.collapseAllArticles]: 'Alle zuklappen',
  [tokens.declarationUi.expandAllSourceLines]: 'Ursprungszeilen aufklappen',
  [tokens.declarationUi.collapseAllSourceLines]: 'Ursprungszeilen zuklappen',
  [tokens.declarationUi.validatedDeliveryPending]: 'Anmeldung validiert. Der Versand erfolgt, sobald alle Anmeldungen des Vorgangs validiert sind.',
  [tokens.declarationUi.deliveryRunning]: 'Wird gesendet…',
  [tokens.declarationUi.deliverySucceeded]: 'Gesendet am {{date}}',
  [tokens.declarationUi.updatedAgo]: 'Geändert {{relative}}',
  [tokens.declarationUi.updatedAtTooltip]: 'Zuletzt geändert: {{date}}',
  [tokens.declarationUi.deliveryFailed]: 'Versand fehlgeschlagen: {{reason}}',
  [tokens.declarationUi.deliveryEntry]: 'Sendung {{index}}',
  [tokens.declarationUi.declarationsValidatedCount]: '{{validated}} / {{total}} validiert',
  [tokens.declarationUi.sendRecapTitle]: 'Versand von {{total}} Anmeldungen:',
  [tokens.declarationUi.commentsTitle]: 'Kommentare',
  [tokens.declarationUi.commentsButtonUnread]: 'Kommentare: {{count}} ungelesen',
  [tokens.declarationUi.commentsEmptyTitle]: 'Starten Sie die Unterhaltung',
  [tokens.declarationUi.commentsEmptyHint]: 'Alle Beteiligten an diesem Vorgang sehen diese Nachrichten. Aktivieren Sie Dringend, um auch das Nabu-Team zu benachrichtigen.',
  [tokens.declarationUi.commentsPlaceholder]: 'An das Team schreiben…',
  [tokens.declarationUi.commentsSend]: 'Senden',
  [tokens.declarationUi.commentsSendUrgent]: 'Als dringend senden',
  [tokens.declarationUi.commentsUrgentLabel]: 'Dringend',
  [tokens.declarationUi.commentsUrgentHint]: 'Das Nabu-Team wird sofort benachrichtigt.',
  [tokens.declarationUi.commentsNewlineHint]: '⇧↵ neue Zeile',
  [tokens.declarationUi.commentsEditHint]: '↵ speichern · Esc abbrechen',
  [tokens.declarationUi.commentsUnknownAuthor]: 'Unbekannter Benutzer',
  [tokens.declarationUi.commentsEdited]: 'bearbeitet',
  [tokens.declarationUi.commentsEdit]: 'Bearbeiten',
  [tokens.declarationUi.commentsDelete]: 'Löschen',
  [tokens.declarationUi.commentsDeleteConfirm]: 'Für alle löschen?',
  [tokens.declarationUi.commentsSave]: 'Speichern',
  [tokens.declarationUi.commentsCancel]: 'Abbrechen',
  [tokens.declarationUi.commentsError]: 'Der Kommentar konnte nicht gespeichert werden. Bitte erneut versuchen.',
  [tokens.declarationUi.commentsSending]: 'Wird gesendet…',
  [tokens.declarationUi.commentsSendFailed]: 'Nicht gesendet.',
  [tokens.declarationUi.commentsRetry]: 'Erneut versuchen',
  [tokens.declarationUi.commentsDiscard]: 'Verwerfen',
  [tokens.declarationUi.commentsToday]: 'Heute',
  [tokens.declarationUi.commentsYesterday]: 'Gestern',
  [tokens.declarationUi.commentsNew]: 'Neu',
  [tokens.declarationUi.commentsClose]: 'Schließen',
  [tokens.declarationUi.dossierTabDetails]: 'Vorgang',
  [tokens.declarationUi.dossierProperties]: 'Eigenschaften',
  [tokens.declarationUi.dossierActions]: 'Aktionen',
  [tokens.declarationUi.dossierOwner]: 'Verantwortlich',
  [tokens.declarationUi.dossierOwnerError]: 'Der Verantwortliche konnte nicht geändert werden.',
  [tokens.declarationUi.dossierModel]: 'Modell',
  [tokens.declarationUi.dossierType]: 'Typ',
  [tokens.declarationUi.dossierClient]: 'Kunde',
  [tokens.declarationUi.dossierTags]: 'Tags',
  [tokens.declarationUi.dossierTagsError]: 'Die Tags konnten nicht gespeichert werden.',
  [tokens.declarationUi.dossierNoModel]: 'Kein Modell',
  [tokens.declarationUi.dossierModelChange]: 'Modell ändern',
  [tokens.declarationUi.dossierModelRemove]: 'Modell entfernen',
  [tokens.declarationUi.dossierModelApply]: 'Anwenden',
  [tokens.declarationUi.dossierModelKeepsCorrections]: 'Die vom Modell vorgegebenen Felder werden aktualisiert. Ihre Korrekturen bleiben erhalten; um zurückzukehren, wählen Sie das vorherige Modell erneut.',
  [tokens.declarationUi.dossierModelApplied]: 'Modell angewendet: {{changed}} Feld(er) aktualisiert, {{kept}} Korrektur(en) beibehalten.',
  [tokens.declarationUi.dossierModelError]: 'Das Modell konnte nicht angewendet werden.',
  [tokens.declarationUi.dossierTypeChange]: 'Anmeldungsart ändern',
  [tokens.declarationUi.dossierTypeFromTo]: 'Die Art wechselt von {{from}} zu {{to}}.',
  [tokens.declarationUi.dossierTypeWarning]: 'Die Anmeldung wird neu erstellt, ohne die Dokumente erneut zu lesen. Ihre Korrekturen werden nicht übernommen, und das Modell wird entfernt.',
  [tokens.declarationUi.dossierTypeApply]: 'Ändern und neu erstellen',
  [tokens.declarationUi.dossierTypeError]: 'Die Art konnte nicht geändert werden.',
  [tokens.declarationUi.dossierAddFile]: 'Datei hinzufügen',
  [tokens.declarationUi.dossierAddFileHint]: 'Eine PDF-Datei, ein Bild (PNG, JPEG) oder eine Tabelle (XLSX, XLS, XLSM, CSV). Nur diese Datei wird gelesen: bereits gelesene Dokumente werden nicht erneut gelesen.',
  [tokens.declarationUi.dossierAddFileChoose]: 'Datei auswählen',
  [tokens.declarationUi.dossierAddFileUnsupported]: 'Dieser Dateityp wird nicht akzeptiert. Archive und E-Mails laufen über das Anlegen eines Vorgangs.',
  [tokens.declarationUi.dossierAddFileWarning]: 'Die Anmeldung wird mit dieser Datei neu erstellt. Ihre Korrekturen werden nicht übernommen.',
  [tokens.declarationUi.dossierAddFileApply]: 'Hinzufügen und neu erstellen',
  [tokens.declarationUi.dossierAddFileError]: 'Die Datei konnte nicht hinzugefügt werden.',
  [tokens.declarationUi.relaunchStarted]: 'Neuerstellung gestartet.',
  [tokens.declarationUi.relaunchReading]: 'Lesen läuft: Die Anmeldung wird neu erstellt. Bis dahin ist sie schreibgeschützt.',
  [tokens.declarationUi.reviseAction]: 'Anmeldung überarbeiten',
  [tokens.declarationUi.reviseDialogTitle]: 'Übermittelte Anmeldung überarbeiten',
  [tokens.declarationUi.reviseDialogText]: 'Die Anmeldung wird wieder bearbeitbar. Nach der Korrektur wird beim Validieren der gesamte Vorgang erneut gesendet.',
  [tokens.declarationUi.reviseReasonLabel]: 'Grund (optional)',
  [tokens.declarationUi.reviseConfirm]: 'Anmeldung wieder öffnen',
  [tokens.declarationUi.reviseError]: 'Die Anmeldung konnte nicht wieder geöffnet werden.',
  [tokens.declarationUi.revisionOpenBanner]: 'Überarbeitung läuft: Diese übermittelte Anmeldung ist wieder bearbeitbar. Beim Validieren wird der gesamte Vorgang erneut gesendet.',
  [tokens.declarationUi.dossierApplyAutomation]: 'Automatisierung anwenden',
  [tokens.declarationUi.automationTitle]: 'Automatisierung anwenden',
  [tokens.declarationUi.automationChoose]: 'Kundenstammdaten',
  [tokens.declarationUi.automationPreview]: 'Vorschläge anzeigen',
  [tokens.declarationUi.automationArticle]: 'Artikel {{number}}',
  [tokens.declarationUi.automationOverwritesCorrection]: 'Korrektur überschrieben',
  [tokens.declarationUi.automationIgnored]: '{{count}} Vorschlag/Vorschläge außerhalb des Formulars ignoriert.',
  [tokens.declarationUi.automationRejected]: 'Abgelehnt: {{count}}',
  [tokens.declarationUi.automationNothing]: 'Diese Automatisierung ändert an dieser Anmeldung nichts.',
  [tokens.declarationUi.automationApply]: 'Anwenden ({{count}})',
  [tokens.declarationUi.automationApplied]: 'Automatisierung angewendet: {{count}} Feld(er) gesetzt.',
  [tokens.declarationUi.automationConflict]: 'Die Anmeldung hat sich inzwischen geändert: Vorschau erneut starten.',
  [tokens.declarationUi.automationRunError]: 'Die Automatisierung konnte nicht ausgeführt werden.',
  [tokens.declarationUi.automationApplyError]: 'Die Automatisierung konnte nicht angewendet werden.',
  [tokens.declarationUi.automationNone]: 'Keine aktive Automatisierung für dieses Dossier.',
  [tokens.declarationUi.commentsDetach]: 'Kommentare in einem Fenster neben dem Formular öffnen',

  [tokens.declarationEvents.eventValidate]: 'Validierung der Anmeldung',
  [tokens.declarationEvents.routineActor]:
    'Routine „{{routine}}“, Anweisung „{{instruction}}“',
  [tokens.declarationEvents.eventReviewIssue]: 'Prüfentscheidung',
  [tokens.declarationEvents.eventAddTuple]: 'Vorkommen hinzufügen',
  [tokens.declarationEvents.eventRemoveTuple]: 'Vorkommen entfernen',
  [tokens.declarationEvents.eventAddLine]: 'Artikelzeile hinzufügen',
  [tokens.declarationEvents.eventRemoveLine]: 'Artikelzeile entfernen',
  [tokens.declarationEvents.eventModifyOccurrence]: 'Vorkommen ändern',
  [tokens.declarationEvents.eventClearColumn]: '{{label}} · gesamte Spalte geleert',
  [tokens.declarationEvents.eventSetColumn]: '{{label}} · {{value}} in der gesamten Spalte',
  [tokens.declarationEvents.eventClear]: '{{label}} · geleert',
  [tokens.declarationEvents.eventSetValue]: '{{label}}: {{value}}',
  [tokens.declarationEvents.reasonInvalidFormat]:
    'dieser Wert entspricht nicht dem erwarteten Format (Typ, Länge oder Grenzen)',
  [tokens.declarationEvents.reasonNotInCatalog]:
    'dieser Wert gehört nicht zur offiziellen Liste des Feldes',
  [tokens.declarationEvents.reasonStaleIssue]:
    'dieser Punkt hat sich geändert: Entscheidung verwerfen, dann neue Werte prüfen',
  [tokens.declarationEvents.reasonReasonRequired]: 'eine Begründung ist erforderlich',
  [tokens.declarationEvents.reasonLocked]: 'dieses Feld ist gesperrt',
  [tokens.declarationEvents.reasonUnknownPath]:
    'dieses Feld gehört nicht mehr zum Formular',
  [tokens.declarationEvents.reasonMissingTuple]:
    'fügen Sie ein Vorkommen hinzu, bevor Sie dieses Feld ausfüllen',
  [tokens.declarationEvents.reasonFallback]:
    'diese Korrektur passt nicht mehr zum Formular; Werte neu laden, bevor Sie fortfahren',
  [tokens.declarationEvents.applyRejectedCorrections]:
    'Einige Korrekturen wurden abgelehnt; die übrigen sind gespeichert.',
  [tokens.declarationEvents.applyConflict]:
    'Die Anmeldung wurde anderswo geändert. Ihre Korrekturen bleiben erhalten. Prüfen Sie die neue Version, bevor Sie sie erneut anwenden.',
  [tokens.declarationEvents.applySaveRetryable]:
    'Speichern nicht möglich. Ihre Korrekturen bleiben auf diesem Bildschirm.',
  [tokens.declarationEvents.applySaveNotRetryable]:
    'Der Server hat diese Anfrage abgelehnt. Erneutes Senden hilft nicht. Melden Sie es; Ihre Werte bleiben sichtbar.',
  [tokens.declarationEvents.applyServerReason]:
    'Vom Server genannter Grund: {{detail}}',
  [tokens.declarationEvents.applyInsufficientCredits]:
    'Nicht genügend Credits, um diesen Vorgang freizugeben: {{required}} erforderlich, {{balance}} verfügbar. Ihre Korrekturen sind gespeichert; laden Sie Credits auf und versuchen Sie es erneut.',
  [tokens.declarationEvents.applySubscriptionRequired]:
    'Kein aktives Abonnement: Aktivieren Sie es, um diesen Vorgang freizugeben, und versuchen Sie es erneut. Ihre Korrekturen sind gespeichert.',
  [tokens.declarationEvents.applySessionExpired]:
    'Ihre Sitzung ist abgelaufen: melden Sie sich erneut an. Die unten aufgeführten Korrekturen wurden nicht gespeichert.',
  [tokens.declarationEvents.applyForbidden]:
    'Sie haben keinen Zugriff auf diesen Vorgang: der Server hat die Anfrage abgelehnt.',
  [tokens.declarationEvents.applyNotFound]:
    'Diese Anmeldung wurde nicht gefunden: sie wurde möglicherweise ersetzt. Laden Sie die Seite neu.',
  [tokens.declarationEvents.applyContactAdmin]:
    'Wenden Sie sich an einen Administrator Ihrer Organisation, um Abonnement und Credits zu verwalten.',
  [tokens.declarationEvents.rechargeCredits]:
    'Credits aufladen',
  [tokens.declarationEvents.openSubscription]:
    'Abonnement anzeigen',
  [tokens.declarationEvents.retryReapply]: 'Erneut anwenden',
  [tokens.declarationEvents.retry]: 'Erneut versuchen',
  [tokens.declarationEvents.discardCorrections]: 'Diese Korrekturen verwerfen',
  [tokens.declarationEvents.eventConsolidate]: 'Konsolidierung nach {{keys}}',
  [tokens.declarationEvents.eventUnconsolidate]: 'Konsolidierung aufgehoben',
  [tokens.declarationEvents.reasonUnknownKey]: 'diese Spalte kann nicht zur Gruppierung verwendet werden',
  [tokens.declarationEvents.reasonRequiredKeyMissing]: 'ein verpflichtender Gruppierungsschlüssel wurde abgewählt',
  [tokens.declarationEvents.reasonNoKeys]: 'wählen Sie mindestens eine Gruppierungsspalte',
  [tokens.declarationEvents.historyUnconsolidated]: 'Konsolidierung aufgehoben',
  [tokens.declarationEvents.reasonRejectedWithDetail]: 'Wert abgelehnt: {{detail}}',
  [tokens.declarationEvents.eventSetTotalReferenceManual]: '{{total}} · Referenz eingegeben: {{value}}',
  [tokens.declarationEvents.eventSetTotalReferenceLines]: '{{total}} · Referenz: Summe der Zeilen übernommen',
  [tokens.declarationEvents.eventSetTotalReferenceReading]: '{{total}} · Referenz: Lesung von {{documentId}} übernommen',
  [tokens.declarationEvents.eventClearTotalReference]: '{{total}} · Referenz entfernt',
  [tokens.declarationEvents.reasonUnknownTotal]: 'diese Summe existiert nicht im Abgleich',
  [tokens.declarationEvents.reasonInvalidValue]: 'dieser Wert ist keine gültige Zahl',
  [tokens.declarationEvents.reasonNoLines]: 'keine Zeile trägt diese Größe',
  [tokens.declarationEvents.reasonUnknownReading]: 'diese Lesung ist nicht mehr verfügbar',
  [tokens.declarationEvents.eventDistributeTotal]: '{{total}} · auf Positionen verteilt',
  [tokens.declarationEvents.reasonWrongTotal]: 'diese Summe lässt sich nicht auf Positionen verteilen',
  [tokens.declarationEvents.reasonNoReference]: 'keine Summe zu verteilen',
  [tokens.declarationEvents.reasonUnknownWeight]: 'der Verteilungsschlüssel existiert nicht',
  [tokens.declarationEvents.reasonIncompleteWeights]: 'der Verteilungsschlüssel fehlt bei den Positionen {{articles}}',
  [tokens.declarationEvents.gestureDistribute]: 'Verteilung · {{total}}',
  [tokens.declarationEvents.gestureClearColumn]: 'Spalte geleert · {{label}}',
  [tokens.declarationEvents.gestureSetColumn]: 'Spalte befüllt · {{label}}',
  [tokens.declarationEvents.gestureApplySettings]: 'Modell angewendet · {{count}} Feld(er)',
  [tokens.declarationEvents.gestureApplyAutomation]: 'Automatisierung angewendet · {{count}} Feld(er)',
  [tokens.declarationEvents.gestureAddLines]: '{{count}} Positionen hinzugefügt',
  [tokens.declarationEvents.gestureValue]: 'Wert korrigiert · {{label}}',
  [tokens.declarationEvents.gestureValueCleared]: 'Wert gelöscht · {{label}}',
  [tokens.declarationEvents.gestureValues]: '{{count}} Werte korrigiert',
  [tokens.declarationEvents.gestureTotalReference]: 'Referenz der Summe · {{total}}',
  [tokens.declarationEvents.gestureTotalReferenceCleared]: 'Zurück zur gelesenen Summe · {{total}}',
  [tokens.declarationEvents.gestureRevert]: 'Rückgängig · {{title}}',
  [tokens.declarationEvents.gestureRevertMore]: ' (+{{count}} Aktionen)',
  [tokens.declarationEvents.gestureRevertMore_one]: ' (+1 Aktion)',
  [tokens.declarationEvents.gestureLine]: '{{label}} (Zeile {{row}})',
  [tokens.declarationEvents.gestureGeneric]: 'Erklärung geändert',
  [tokens.declarationEvents.gestureUnvalidate]: 'Überarbeitung geöffnet',
  [tokens.declarationEvents.gestureAbandonRevision]: 'Überarbeitung verworfen: zurück zur übermittelten Version',
  [tokens.declarationEvents.eventRevert]: 'Rückgängigmachen einer Aktion',
  [tokens.declarationEvents.reasonStaleRevert]: 'der Verlauf hat sich inzwischen geändert: erneut öffnen und wiederholen',
  [tokens.declarationEvents.reasonBarrier]: 'eine spätere Aktion kann nicht rückgängig gemacht werden: davor ist kein Zurück mehr möglich',
  [tokens.declarationEvents.reasonAlreadyReverted]: 'diese Aktion wurde bereits rückgängig gemacht',
  [tokens.declarationEvents.reasonNotRevertible]: 'diese Aktion kann nicht rückgängig gemacht werden',
  [tokens.declarationEvents.reasonUnknownGesture]: 'diese Aktion existiert nicht mehr',
  [tokens.declarationEvents.reasonAmbiguousTuple]: 'mehrere Einträge bei den Positionen {{articles}}: welcher erhält den Wert?',
  [tokens.declarationEvents.reasonLockedArticles]: 'gesperrtes Feld bei den Positionen {{articles}}',
  [tokens.declarationEvents.reasonUnknownLine]: 'diese Zeile existiert nicht',
  [tokens.declarationEvents.reasonUnknownTuple]: 'dieses Vorkommen existiert nicht',
  [tokens.declarationEvents.reasonUnknownCategory]: 'diese Gruppe existiert nicht',
  [tokens.declarationEvents.reasonWrongLevel]: 'dieses Feld liegt nicht auf dieser Ebene',
  [tokens.declarationEvents.reasonEmptyValue]: 'der Wert ist leer',
  [tokens.declarationEvents.reasonUnknownEvent]: 'diese Korrektur wird nicht erkannt',
  [tokens.declarationEvents.assistantEventArticle]: '{{label}} (Position {{row}})',
  [tokens.declarationEvents.assistantEventClear]: '{{label}} leeren',
  [tokens.declarationEvents.assistantEventSetColumn]: '{{value}} in die gesamte Spalte {{label}} eintragen',
  [tokens.declarationEvents.assistantEventClearColumn]: 'Gesamte Spalte {{label}} leeren',
  [tokens.declarationEvents.assistantEventCopyColumn]: 'Spalte {{from}} in {{to}} übernehmen',
  [tokens.declarationEvents.assistantEventWhere]:
    '{{action}}, {{scope}}',
  [tokens.declarationEvents.assistantEventSetColumnWhere]:
    '{{value}} in die Spalte {{label}} eintragen, {{scope}}',
  [tokens.declarationEvents.assistantEventClearColumnWhere]:
    'Spalte {{label}} leeren, {{scope}}',
  [tokens.declarationEvents.assistantEventCopyColumnUnchanged]:
    'Ohne {{from}}, unverändert: Positionen {{rows}}',
  [tokens.declarationEvents.assistantEventCopyColumnUnchanged_one]:
    'Ohne {{from}}, unverändert: Position {{rows}}',
  [tokens.declarationEvents.assistantEventScopeEquals]:
    'bei Positionen mit {{label}} = {{value}}',
  [tokens.declarationEvents.assistantEventScopeIn]:
    'bei Positionen mit {{label}} gleich {{values}}',
  [tokens.declarationEvents.assistantEventScopeEmpty]:
    'bei Positionen mit leerem Feld {{label}}',
  [tokens.declarationEvents.assistantEventScopeFilled]:
    'bei Positionen mit ausgefülltem Feld {{label}}',
  [tokens.declarationEvents.assistantEventMapColumn]:
    'In der Spalte {{to}} ersetzen: {{pairs}}',
  [tokens.declarationEvents.assistantEventMapColumnFrom]:
    'Spalte {{to}} aus {{from}} füllen: {{pairs}}',
  [tokens.declarationEvents.assistantEventMapColumnUnchanged]:
    'Nicht in der Tabelle, unverändert: Positionen {{rows}}',
  [tokens.declarationEvents.assistantEventMapColumnUnchanged_one]:
    'Nicht in der Tabelle, unverändert: Position {{rows}}',
  [tokens.declarationEvents.assistantEventComputeColumn]:
    'Spalte {{to}} berechnen = {{formula}}',
  [tokens.declarationEvents.assistantEventComputeColumnUnchanged]:
    'Ohne Zahl für die Berechnung, unverändert: Positionen {{rows}}',
  [tokens.declarationEvents.assistantEventComputeColumnUnchanged_one]:
    'Ohne Zahl für die Berechnung, unverändert: Position {{rows}}',
  [tokens.declarationEvents.assistantEventFormatColumnPadEnd]:
    'Spalte {{label}} am Ende mit „{{padWith}}“ auf {{length}} Zeichen auffüllen',
  [tokens.declarationEvents.assistantEventFormatColumnPadStart]:
    'Spalte {{label}} am Anfang mit „{{padWith}}“ auf {{length}} Zeichen auffüllen',
  [tokens.declarationEvents.assistantEventFormatColumnTruncate]:
    'Die ersten {{length}} Zeichen der Spalte {{label}} behalten',
  [tokens.declarationEvents.assistantEventFormatColumnUnchanged]:
    'Leer oder bereits {{length}} Zeichen, unverändert: Positionen {{rows}}',
  [tokens.declarationEvents.assistantEventFormatColumnUnchanged_one]:
    'Leer oder bereits {{length}} Zeichen, unverändert: Position {{rows}}',
  [tokens.declarationEvents.assistantEventAddLine]: 'Eine Position hinzufügen',
  [tokens.declarationEvents.assistantEventAddLineValues]: 'Eine Position hinzufügen: {{values}}',
  [tokens.declarationEvents.assistantEventRemoveLine]: 'Position {{row}} entfernen',
  [tokens.declarationEvents.assistantEventDistributeEqual]:
    'Summe {{total}} zu gleichen Teilen auf alle Positionen verteilen',
  [tokens.declarationEvents.assistantEventDistributeBy]:
    'Summe {{total}} anteilig nach {{weight}} auf alle Positionen verteilen',
  [tokens.declarationEvents.assistantEventDistributePackages]:
    'Packstücke auf die erste Position jedes Dokuments, 0 auf die übrigen',
  [tokens.declarationEvents.assistantEventScopeDocument]:
    'bei den Positionen des Dokuments {{document}}',
  [tokens.declarationEvents.assistantEventDistributeAmount]:
    'eingegebener Betrag: {{value}}',
  [tokens.declarationEvents.assistantEventDistributeFirstLine]:
    'Gesamtwert {{total}} auf die erste Position, 0 auf die übrigen',
  [tokens.declarationEvents.assistantEventDistributeFirstLinePerDocument]:
    'Gesamtwert {{total}} jedes Dokuments auf seine erste Position, 0 auf die übrigen',
  [tokens.declarationEvents.assistantEventDistributeEqualScoped]:
    'Gesamtwert {{total}} zu gleichen Teilen verteilen',
  [tokens.declarationEvents.assistantEventDistributeByScoped]:
    'Gesamtwert {{total}} anteilig nach {{weight}} verteilen',
  [tokens.declarationEvents.assistantEventDistributeFromValue]:
    'Verteilter Wert: {{value}}, eingegeben',
  [tokens.declarationEvents.assistantEventDistributeFromDocument]:
    'Verteilter Wert: {{value}}, gelesen auf {{document}}',
  [tokens.declarationEvents.assistantEventDistributeFromReference]:
    'Verteilter Wert: {{value}}, der gewählte Gesamtwert',
  [tokens.declarationEvents.assistantEventConsolidate]: 'Positionen nach {{keys}} zusammenfassen',
  [tokens.declarationEvents.assistantEventUnconsolidate]: 'Zusammenfassung der Positionen aufheben',
  [tokens.declarationEvents.assistantEventTotalManual]: 'Für {{total}} übernehmen: {{value}} (eingegeben)',
  [tokens.declarationEvents.assistantEventTotalLines]: 'Für {{total}} übernehmen: die Summe der Zeilen',
  [tokens.declarationEvents.assistantEventTotalReading]: 'Für {{total}} übernehmen: den Wert aus {{document}}',
  [tokens.declarationEvents.assistantEventTotalRead]: 'Für {{total}} zur gelesenen Summe zurückkehren',
  [tokens.declarationEvents.assistantEventRevert]:
    'Rückgängig machen: Änderung vom {{date}} um {{time}} ({{count}} Änderungen)',
  [tokens.declarationEvents.assistantEventRevert_one]:
    'Rückgängig machen: Änderung vom {{date}} um {{time}} ({{count}} Änderung)',
  [tokens.declarationEvents.assistantEventRevertUnknown]:
    'Rückgängig machen: eine Änderung des Assistenten',
  [tokens.declarationEvents.assistantEventRevertDependents]:
    '{{action}} und {{count}} davon abhängige Änderungen',
  [tokens.declarationEvents.assistantEventRevertDependents_one]:
    '{{action}} und {{count}} davon abhängige Änderung',
  [tokens.declarationEvents.assistantValueTrue]: 'ja',
  [tokens.declarationEvents.assistantValueFalse]: 'nein',
  [tokens.declarationEvents.assistantSuggestionBlocked]:
    'Warum ist die Deklaration blockiert?',
  [tokens.declarationEvents.assistantSuggestionMissing]:
    'Fülle {{fields}} anhand der Dokumente aus',
  [tokens.declarationEvents.assistantSuggestionMissingUnnamed]:
    'Fülle die fehlenden Pflichtfelder anhand der Dokumente aus',
  [tokens.declarationEvents.assistantSuggestionLines]:
    'Ergänze die Spalte {{column}} bei den {{count}} Positionen, in denen sie leer ist',
  [tokens.declarationEvents.assistantSuggestionLines_one]:
    'Ergänze die Spalte {{column}} bei der Position, in der sie leer ist',
  [tokens.declarationEvents.assistantSuggestionLinesColumns]:
    'Ergänze die Spalten {{columns}} bei den Positionen, in denen sie leer sind',
  [tokens.declarationEvents.assistantSuggestionFormat]:
    'Korrigiere die Werte im falschen Format: {{fields}}',
  [tokens.declarationEvents.assistantSuggestionConflict]:
    'Die Dokumente widersprechen sich bei {{fields}}: Welche Werte sollen übernommen werden?',
  [tokens.declarationEvents.assistantSuggestionConflict_one]:
    'Die Dokumente widersprechen sich bei {{fields}}: Welcher Wert soll übernommen werden?',
  [tokens.declarationEvents.assistantSuggestionConflictUnnamed]:
    'Die Dokumente widersprechen sich: Welche Werte sollen übernommen werden?',
  [tokens.declarationEvents.assistantSuggestionGap]:
    'Erkläre die Abweichungen bei {{totals}}',
  [tokens.declarationEvents.assistantSuggestionGap_one]:
    'Erkläre die Abweichung bei {{totals}}',
  [tokens.declarationEvents.assistantSuggestionDistribute]:
    'Verteile {{totals}} auf die Positionen',
  [tokens.declarationEvents.assistantSuggestionWeights]:
    'Prüfe, ob die Gewichte in den Dokumenten übereinstimmen',
  [tokens.declarationEvents.assistantSuggestionTotals]:
    'Prüfe die Summen der Deklaration',
  [tokens.declarationEvents.assistantSuggestionHistory]:
    'Fasse die Historie des Vorgangs zusammen',
  [tokens.declarationEvents.assistantSuggestionSummary]:
    'Fasse diesen Vorgang zusammen',
  [tokens.declarationEvents.assistantSuggestionNamesTwo]:
    '{{first}} und {{second}}',
  [tokens.declarationEvents.assistantSuggestionNamesMore]:
    '{{first}}, {{second}} und {{count}} weitere Einträge',
  [tokens.declarationEvents.assistantSuggestionNamesMore_one]:
    '{{first}}, {{second}} und {{count}} weiterer Eintrag',
  [tokens.declarationEvents.assistantSuggestionNamesOneMore]:
    '{{first}} und {{count}} weitere Einträge',
  [tokens.declarationEvents.assistantSuggestionNamesOneMore_one]:
    '{{first}} und {{count}} weiterer Eintrag',

  [tokens.extraction.index]: 'Inhaltsverzeichnis',
  [tokens.extraction.selectAnErrorState]: 'Wählen Sie einen Fehlerzustand',
  [tokens.extraction.exportDeclaration]: 'Ausfuhranmeldung',
  [tokens.extraction.dauRecapButtonLabel]: 'Einheitspapier',
  [tokens.extraction.dauRecapButtonTooltip]:
    'Die Anmeldung als Einheitspapier aufbereiten.',
  [tokens.extraction.dauRecapNoArticlesTooltip]:
    'Keine Artikel zum Zusammenfassen',
  [tokens.extraction.dauRecapUnavailableSchemaTooltip]:
    'Zusammenfassung für diesen Anmeldetyp nicht verfügbar',
  [tokens.extraction.dauRecapPrintButton]: 'Drucken',
  [tokens.extraction.dauRecapCloseButton]: 'Schließen',
  [tokens.extraction.dauRecapModalSubtitle]:
    'Einheitspapier · {{articleCount}} Artikel · {{pageCount}} Seite(n)',
  [tokens.extraction.dauRecapCloseHint]: 'zum Schließen',
  [tokens.extraction.dauRecapPreviousPage]: 'Vorherige Seite',
  [tokens.extraction.dauRecapNextPage]: 'Nächste Seite',
  [tokens.extraction.dauRecapZoomOut]: 'Verkleinern',
  [tokens.extraction.dauRecapZoomIn]: 'Vergrößern',
  [tokens.extraction.validateThisDataset]:
    'Dieses Dataset validieren ({{current}}/{{total}})',
  [tokens.extraction.validateDatasetSuccess]:
    'Dataset validiert ({{current}}/{{total}})',
  [tokens.extraction.dataset]: 'Datensatz',
  [tokens.extraction.validateDatasetModalTitle]:
    'Datensatz {{current}}/{{total}} validieren?',
  [tokens.extraction.validateDatasetModalDescription]:
    'Die Daten dieses Datensatzes werden validiert. Anschließend können Sie zum nächsten Datensatz wechseln.',
  [tokens.extraction.datasetsValidatedProgress]:
    '{{validated}}/{{total}} Datensätze validiert',
  [tokens.extraction.datasetsRemainingProgress]:
    'Noch {{remaining}}',
  [tokens.extraction.datasetsAllValidatedReady]:
    'Alle validiert, bereit zum Senden',
  [tokens.extraction.goToNextDataset]:
    'Zum nächsten Datensatz wechseln',
  [tokens.extraction.datasetValidationGuidanceBanner]:
    'Datensatz {{validated}}/{{total}} validiert. Noch {{remaining}} Datensatz/Datensätze. Sie wurden zu Datensatz {{next}} weitergeleitet.',
  [tokens.extraction.multiDatasetSendRecapTitle]:
    'Senden von {{total}} Datensätzen:',
  [tokens.extraction.agentRationale]: 'Vom Agent generiert',
  [tokens.extraction.agentRationaleTooltip]:
    'Vom Agent hinterlassene Anweisungen',
  [tokens.extraction.showSidebar]: 'Zeige Sidebar',
  [tokens.extraction.hideSidebar]: 'Seitenleiste ausblenden',
  [tokens.extraction.enlargeViewer]:
    'Formular ausblenden und Viewer vergrößern',
  [tokens.extraction.shrinkViewer]: 'Formular wieder anzeigen',
  [tokens.extraction.enlargeTableOverlay]: 'Tabelle im Vollbild anzeigen',
  [tokens.extraction.shrinkTableOverlay]: 'Vollbild beenden',
  [tokens.extraction.enlargeTableWidth]: 'Tabellenbreite erweitern',
  [tokens.extraction.shrinkTableWidth]: 'Tabellenbreite reduzieren',
  [tokens.extraction.enlargeTable]: 'Viewer ausblenden und Tabelle vergrößern',
  [tokens.extraction.shrinkTable]: 'Viewer wieder anzeigen',
  [tokens.extraction.scrollToDocumentTop]: 'Zum Dokumentanfang',
  [tokens.extraction.scrollToDocumentBottom]: 'Zum Dokumentende',
  [tokens.extraction.suggestedColumnIsMissing]: 'Vorgeschlagene Spalte fehlt',
  [tokens.extraction.thereAreOverlappingFields]:
    'Es gibt {{count}} Felder, die denselben Bereich auf der Seite belegen.',
  [tokens.extraction.clickHereToSeeFurtherEditingOptions]:
    'Klicken Sie hier, um weitere Bearbeitungsoptionen anzuzeigen.',
  [tokens.extraction.default]: 'Standard',
  [tokens.extraction.anUnusedDocumentWasFound]:
    'Nicht verwendetes Dokument gefunden : {{code}}',
  [tokens.extraction.validateTheMerge]: 'Überprüfen Sie die Zusammenführung',
  [tokens.extraction.rowTotalAmountIsMissing]: 'Zeilengesamtbetrag fehlt',
  [tokens.extraction.additionalCodeNotValid]:
    'Ungültiger zusätzlicher Code gefunden : {{code}}',
  [tokens.extraction.noTaxComponentSelected]: 'Keine Steuermaßnahme ausgewählt',
  [tokens.extraction.rowsToValidate]: '{{count}} zu validierende Zeile',
  [tokens.extraction.rowsToValidate_other]: '{{count}} zu validierende Zeilen',
  [tokens.extraction.noDutyComponentSelected]: 'Keine Zollmaßnahme ausgewählt',
  [tokens.extraction.selectedLines]: '{{count}} Zeile ausgewählt',
  [tokens.extraction.selectedLines_other]: '{{count}} Zeilen ausgewählt',
  [tokens.extraction.selectedLines_zero]: '{{count}} Zeilen ausgewählt',
  [tokens.extraction.additionalCodeIsMissingACertificate]:
    'Für den zusätzlichen Code fehlt ein Zertifikat : {{code}}',
  [tokens.extraction.countryOfOriginUnknown]: 'Herkunftsland unbekannt',
  [tokens.extraction.countryOfDestinationUnknown]: 'Zielland unbekannt',
  [tokens.extraction.noErrorState]: 'Anmeldung nicht im Fehlerzustand',
  [tokens.extraction.valueRequiredToSpread]:
    'Erforderlicher Wert für die Streuung',
  [tokens.extraction.columnEmpty]: 'Spalte leer',
  [tokens.extraction.documentColumnIsEmpty]:
    'Alle Zellen in der Spalte "{{columnName}}" für Dokument "{{documentName}}" sind leer',
  [tokens.extraction.valuesMissing]: 'Keine Werte',
  [tokens.extraction.theDocumentTotalAndTheTableTotalAreDifferent]:
    'Die im Dokument angegebene Summe und die Summe der Tabellenzellen sind nicht gleich.',
  [tokens.extraction.theDocumentTotalAndTheTableTotalAreEqual]:
    'Die im Dokument angegebene Summe und die Summe der Tabellenzellen sind gleich.',
  [tokens.extraction.countryUnknown]: 'Idioma: [es]',
  [tokens.extraction.failedToRetrieveTaricCodeDataForCode]:
    'TARIC-Daten für Code {{code}} konnten nicht abgerufen werden',
  [tokens.extraction.findAColumn]: 'Eine Spalte finden',
  [tokens.extraction.changeColumnName]: 'Spalte ändern',
  [tokens.extraction.closeDebug]: 'Debug schließen',
  [tokens.extraction.legalInformationAboutCode]:
    'Rechtliche Informationen zum Code {{code}}',
  [tokens.extraction.legalInformationAboutMeasure]:
    'Rechtliche Hinweise zur Maßnahme {{measure}}',
  [tokens.extraction.legalInformation]: 'Rechtliche Hinweise',
  [tokens.extraction.datasourceOrigin]: 'Daten stammen von',
  [tokens.extraction.propertiesInheritedFromCode]:
    'Code-Informationen geerbt von',
  [tokens.extraction.fields]: 'Felder',
  [tokens.extraction.totaux]: 'Summen',
  [tokens.extraction.assistant]: 'Assistent',
  [tokens.extraction.articles]: 'Artikel',
  [tokens.extraction.rows]: 'Zeilen',
  [tokens.extraction.errors]: 'Fehler',
  [tokens.extraction.mergeValidationExplanation]:
    'Hier können Sie die Übereinstimmung zwischen den Packlistenzeilen (Quelle) und den Rechnungszeilen (Ziel) prüfen. Linien mit Abweichungen werden farblich hervorgehoben.<br>Klicken Sie auf eine Zeile, um die entsprechenden Quellen anzuzeigen und die Zuordnungen zu korrigieren, bevor Sie mit der Zusammenführung fortfahren.',
  [tokens.extraction.mergeValidationCaseOneExplanation]:
    '<b>Keine zugehörige Quelle</b>: Diese Rechnungszeile ist mit keinem Artikel in der Packliste verknüpft. Wählen Sie eine oder mehrere Zeilen aus der Quelltabelle aus, die zugeordnet werden sollen.<br><b>Empfohlene Aktion:</b> Wählen Sie eine Zeile aus der Packliste manuell aus.',
  [tokens.extraction.mergeValidationCaseTwoExplanation]:
    '<b>Mehrere zugehörige Quellen</b>: Mehrere Lieferscheinpositionen sind derzeit mit dieser Rechnungszeile verknüpft. Überprüfen Sie die Korrespondenz und behalten Sie nur eine gültige Quellzeile bei.<br><b>Empfohlene Aktion:</b> Deaktivieren Sie die zusätzlichen Quellen.',
  [tokens.extraction.mergeValidationCaseThreeExplanation]:
    '<b>Mehrfach verwendete Quelle</b>: Dieselbe Verpackungslinie ist mehreren Rechnungszeilen zugeordnet. Jede Quelle kann nur mit einem einzigen Ziel verknüpft werden.<br><b>Empfohlene Aktion:</b> Passen Sie die Zuordnungen so an, dass nur ein Link pro Quelle beibehalten wird.',
  [tokens.extraction.mergeValidationCaseFourExplanation]:
    '<b>Ungültige Mehrfachzuordnungen</b>: Mehrere Verpackungs- und Rechnungszeilen sind vernetzt. Diese Übereinstimmungen können nicht automatisch zusammengeführt werden.<br><b>Empfohlene Aktion:</b> Korrigieren Sie die Assoziationen manuell, um eine 1:1-Übereinstimmung sicherzustellen.',
  [tokens.extraction.mergeSourceDuplicateExplanation]:
    'Eine Zeile in der Quelltabelle wird mehreren Zeilen in der Zieltabelle zugeordnet, wodurch möglicherweise falsche Daten in der Zieltabelle erstellt werden. Zeile',
  [tokens.extraction.mergeSourceDuplicateExplanation2]:
    'in der Quelltabelle ordnet Zeilen zu',
  [tokens.extraction.mergeDestinationDuplicateExplanation]:
    'Mehrere Zeilen in der Quelltabelle werden derselben Zeile in der Zieltabelle zugeordnet, wodurch mehrdeutige Zusammenführungsdaten erstellt werden. Zeilen',
  [tokens.extraction.readyToMerge]: 'Bereit zum Zusammenführen',
  [tokens.extraction.mergeSuccess]:
    'Die Zeilen wurden erfolgreich zusammengeführt.',
  [tokens.extraction.mergeError]:
    'Die Zusammenführung konnte nicht abgeschlossen werden. Überprüfen Sie die angegebenen Leitungen und korrigieren Sie eventuelle Fehler, bevor Sie den Betrieb wieder aufnehmen.',
  [tokens.extraction.mapToRow]: 'zu Zeile zuordnen',
  [tokens.extraction.inTheDestinationTable]: 'in der Zieltabelle.',
  [tokens.extraction.mergeDestinationUnmapped]:
    'Eine oder mehrere Zeilen in der Zieltabelle - Zeilen',
  [tokens.extraction.and]: 'und',
  [tokens.extraction.mergeImpossible]: 'Zusammenführen unmöglich.',
  [tokens.extraction.willNotReceiveAnyDataFromTheMerge]:
    'erhält keine Daten aus der Zusammenführung.',
  [tokens.extraction.packages]: 'Pakete',
  [tokens.extraction.totalDeclaredValue]: 'Insgesamt deklarierter Wert',
  [tokens.extraction.productCodes]: 'Produktcodes',
  [tokens.extraction.chooseClassification]: 'Wählen Sie eine Klassifizierung',
  [tokens.extraction.exceptions]: 'Ausnahmen',
  [tokens.extraction.downloadRowsAsExcelWorksheet]:
    'Zeilen als Excel-Arbeitsblatt herunterladen',
  [tokens.extraction.convertRowsToFees]: 'Zeilen in Gebühren umwandeln',
  [tokens.extraction.convertRowsToRefunds]:
    'Zeilen in Rückerstattungen umwandeln',
  [tokens.extraction.createNewDeclarationFromRows]:
    'Neue Anmeldung aus Zeilen erstellen',
  [tokens.extraction.noExceptionsFound]: 'Gefundene Ausnahmen',
  [tokens.extraction.noDescriptionFound]: 'keine Beschreibung hinterlegt',
  [tokens.extraction.noConditionsFound]: 'Keine Bedingungen gefunden',
  [tokens.extraction.updateDeclarationExportType]:
    'Art des Exports der Anmeldung aktualisieren',
  [tokens.extraction.changeExportTypeForCurrentDeclaration]:
    'Aktualisieren Sie den Typ für diese Erklärung',
  [tokens.extraction.noColumnsFound]: 'Keine Spalten gefunden',
  [tokens.extraction.whyMergeKeysNeeded]:
    'Um zusammenzuführen, müssen wir Spalten haben, die zwischen der Quelltabelle und der Zieltabelle geteilt werden.',
  [tokens.extraction.noClassification]: 'Nicht klassifiziert',
  [tokens.extraction.legalContext]: 'Rechtliche Rahmenbedingungen',
  [tokens.extraction.informations]: 'Informationen',
  [tokens.extraction.products]: 'Produkte',
  [tokens.extraction.editCells]: 'Zellen bearbeiten',
  [tokens.extraction.editGrid]: 'Raster bearbeiten — Strg+Alt',
  [tokens.extraction.deleteTable]: 'Tisch löschen',
  [tokens.extraction.articlesTable]: 'Artikeltabelle',
  [tokens.extraction.showArticlesTable]: 'Artikeltabelle anzeigen',
  [tokens.extraction.hideArticlesTable]: 'Artikeltabelle ausblenden',
  [tokens.extraction.anyColumnsToMatchNotPresentWillBeCreated]:
    'Alle <b>Spalten, die nicht</b> in der Artikeltabelle vorhanden sind, werden erstellt.',
  [tokens.extraction.whenCopyingARowFromSourceOnlyCopyValuesWillBeCopied]:
    'Beim Kopieren einer Zeile aus der Packliste in die Rechnungstabelle werden nur die Werte für die <b>zu kopierenden Spalten</b> in der Zeile kopiert.',
  [tokens.extraction.chooseTheTableYouWantToMergeIntoTheMainArticlesTable]:
    'Wählen Sie die Tabelle aus, die Sie in der Tabelle Artikel zusammenführen möchten',
  [tokens.extraction.deleteTablePage]: 'Tabelle auf aktueller Seite löschen',
  [tokens.extraction.deleteAllTablePages]: 'Tabellen auf allen Seiten löschen',
  [tokens.extraction.missingProduct]: 'Fehlender Product Key',
  [tokens.extraction.certificateCode]: 'Zertifikatscode',
  [tokens.extraction.informationOnCodesAndDuties]:
    'Informationen zu Codes und Aufgaben',
  [tokens.extraction.mergeOptions]: 'Zusammenführungsoptionen',
  [tokens.extraction.addInformation]: 'Information hinzufügen',
  [tokens.extraction.convertRowsToAdditions]: 'Zeilen in Ergänzungen umwandeln',
  [tokens.extraction.deleteArticleRowTitle]: 'Diesen Artikel löschen?',
  [tokens.extraction.deleteArticleRowMessage]:
    'Zeile {{row}}: Die Löschung ist endgültig. Die Summen der Anmeldung werden neu berechnet.',
  [tokens.extraction.deleteArticleRowTooltip]: 'Diese Zeile löschen',
  [tokens.extraction.convertRowsToDeductions]: 'Zeilen in Abzüge umwandeln',
  [tokens.extraction.addElement]: 'Element hinzufügen',
  [tokens.extraction.customInformation]: 'Zollinformationen',
  [tokens.extraction.documentInformation]: 'Deklaration',
  [tokens.extraction.shippingInformation]: 'Versandinformationen',
  [tokens.extraction.transactionDetails]: 'Umsatzdetails',
  [tokens.extraction.findField]: 'Feld suchen',
  [tokens.extraction.cellTooSmall]: 'Zu klein',
  [tokens.extraction.cellNotValid]: 'Nicht gültig',
  [tokens.extraction.groupByHSCode]: 'Nach HS-Code gruppieren',
  [tokens.extraction.doYouWantToGroupTokensByHSCode]:
    'Möchten Sie nach HS-Code gruppieren?',
  [tokens.extraction.yes]: 'Ja',
  [tokens.extraction.no]: 'nein',
  [tokens.extraction.addData]: 'Daten hinzufügen',
  [tokens.extraction.addRow]: 'Zeile hinzufügen',
  [tokens.extraction.tableRows]: 'Tabellenzeilen',
  [tokens.extraction.deleteRow]: 'Zeile löschen',
  [tokens.extraction.invoices]: 'Rechnungen',
  [tokens.extraction['commercial-invoice']]: 'Rechnung',
  [tokens.extraction.packings]: 'UMSCHLIEßUNGEN',
  [tokens.extraction['packing-list']]: 'verpacken',
  [tokens.extraction['packing-list-description']]:
    'Kombinierte Daten aus allen Packlisten',
  [tokens.extraction['hscodes-list']]: 'HS-Codes',
  [tokens.extraction['hscodes-list-description']]:
    'Kombinierte Daten aus allen HS-Code-Listen',
  [tokens.extraction['bill-of-lading']]: '6 Konnossement',
  [tokens.extraction['bill-of-lading-description']]:
    'Kombinierte Daten aus allen Frachtbrieflisten',
  [tokens.extraction['delivery-note']]: 'Empfangsschein',
  [tokens.extraction['delivery-note-description']]:
    'Kombinierte Daten aus allen Lieferscheinlisten',
  [tokens.extraction['articles-table-description']]:
    'Artikel basierend auf Handelsrechnung exportieren',
  [tokens.extraction.createNewFieldHere]:
    'Ein neues Feld an diesem Standort erstellen',
  [tokens.extraction.showOtherFieldsHere]:
    'Andere Felder an diesem Standort anzeigen',
  [tokens.extraction.convertSelectionToTable]: 'Feld in eine Tabelle umwandeln',
  [tokens.extraction.drawingHintField]: 'Feld',
  [tokens.extraction.drawingHintArticleGrid]: 'Artikelraster',
  [tokens.extraction.drawingHintArticleColumn]: 'Artikelspalte',
  [tokens.extraction.drawingHintPageAlreadyHasArticleGrid]:
    'Raster bereits auf dieser Seite vorhanden',
  [tokens.extraction.drawingRejectedAgenticField]:
    'Bei einem Dokument ohne Positionierungszonen zeichnen Sie ein Artikelraster (breites Rechteck, über 70 % der Seitenbreite).',
  [tokens.extraction.drawingRejectedPageAlreadyHasArticleGrid]:
    'Auf dieser Dokumentseite existiert bereits ein Artikelraster.',
  [tokens.extraction.validateRequiresFieldSelection]:
    'Wählen Sie ein Feld aus, bevor Sie bestätigen.',
  [tokens.extraction.convertTableToSelection]: 'Tabelle in ein Feld umwandeln',
  [tokens.extraction.mergeTables]: 'Zusammenführung',
  [tokens.extraction.sourceTable]: 'Quell-Tabelle',
  [tokens.extraction.columnsToMatch]: 'Übereinstimmende Spalten',
  [tokens.extraction.columnsToCopy]: 'Zu kopierende Spalten',
  [tokens.extraction.validation]: 'Validierung',
  [tokens.extraction.columnToMatchExplanation]:
    'Eine Zeile in der Packlisten-Tabelle wird in eine Zeile in der Tabelle kopiert, wenn sie für jede <b>Spalte</b> die gleichen Werte aufweist.',
  [tokens.extraction.extraction]: 'Absaugung',
  [tokens.extraction.nothingToShow]: 'Nichts zu zeigen',
  [tokens.extraction.table]: 'Tabelle',
  [tokens.extraction.field]: 'Feld',
  [tokens.extraction.tables]: 'Tische',
  [tokens.extraction.grids]: 'Raster',
  [tokens.extraction.grid]: 'Raster',
  [tokens.extraction.excelGridModeTooltip]:
    'Tabelle auf dem Blatt zeichnen (mindestens 70 % der Breite in Spalten)',
  [tokens.extraction.excelGridModeInstructions]:
    'Rastermodus: Auf dem Excel-Blatt klicken und ziehen, um die Tabelle zu umrahmen. Die Auswahl muss mindestens 70 % der Blattbreite (in Spalten) abdecken. Anschließend können Sie das Rechteck mit den orangefarbenen Griffen anpassen.',
  [tokens.extraction.excelCellsModeTooltip]:
    'Zellen und Felder auf dem Excel-Blatt auswählen',
  [tokens.extraction.gridModeTooltip]:
    'Raster der Tabelle auf dem Dokument anpassen',
  [tokens.extraction.gridModeInstructions]:
    'Rastermodus: Rahmen vergrößern und Zeilentrenner auf dem Dokument verschieben.',
  [tokens.extraction.cellsModeTooltip]:
    'Zellen im Raster auf dem Dokument auswählen und bearbeiten',
  [tokens.extraction.cells]: 'Zellen',
  [tokens.extraction.displayTheTable]: 'Elektronen-AffinitÃ¤t',
  [tokens.extraction.save]: 'Speichern',
  [tokens.extraction.noOtherFormatsAvailable]:
    'Keine anderen Formate verfügbar',
  [tokens.extraction.downloadTestFile]: 'Test herunterladen',
  [tokens.extraction.exportTo]: 'Senden an',
  [tokens.extraction.newField]: 'Neues Feld',
  [tokens.extraction.convertIntoField]: 'In Feld umwandeln',
  [tokens.extraction.convertIntoTable]: 'In Tabelle umwandeln',
  [tokens.extraction.newTable]: 'Neue Tabelle',
  [tokens.extraction.on]: 'von',
  [tokens.extraction.duplicate]: 'Kopie erstellen',
  [tokens.extraction.completedFields]: 'Ausgefuellte Felder',
  [tokens.extraction.workComplete]: 'Arbeit abgeschlossen',
  [tokens.extraction.mustBeString]: 'Muss eine Zeichenkette sein',
  [tokens.extraction.mustBeNumber]: 'Muss eine Zahl sein',
  [tokens.extraction.areYouSureYouWantToCopyDeclaration]:
    'Moechten Sie diese Anmeldung wirklich kopieren?',
  [tokens.extraction.thereWasAnErrorCopyingTheDeclaration]:
    'Beim Kopieren dieser Anmeldung ist ein Fehler aufgetreten',
  [tokens.extraction.mustMatchFormatDateTime]:
    'Muss dem Datums-/Zeitformat entsprechen',
  [tokens.extraction.mustMatchFormatDate]: 'Muss dem Datumsformat entsprechen',
  [tokens.extraction.mustNotHaveMoreThanCharacters]:
    'Darf nicht mehr als {{ count }} Zeichen enthalten',
  [tokens.extraction.mustNotHaveFewerThanCharacters]:
    'Darf nicht weniger als {{ count }} Zeichen enthalten',
  [tokens.extraction.pleaseEnterBetweenXAndYCharacters]:
    'Bitte geben Sie zwischen {{min}} und {{max}} Zeichen ein.',
  [tokens.extraction.pleaseEnterExactlyXCharacters]:
    'Bitte geben Sie genau {{count}} Zeichen ein.',
  [tokens.extraction.pleaseEnterAWholeNumber]:
    'Bitte geben Sie eine ganze Zahl ein',
  [tokens.extraction.updatingData]: 'Daten werden aktualisiert',
  [tokens.extraction.mustBeInAlpha2]:
    'Muss im Alpha-2-Format sein. Beispiel: Frankreich -> FR.',
  [tokens.extraction.doitTreAuFormatAlpha2ExemplePourFranceFr]:
    'Muss im Alpha-2-Format sein. Beispiel: Frankreich -> FR.',
  [tokens.extraction.pleaseEnterExactly10CharactersInFormat]:
    'Bitte geben Sie genau 10 Zeichen im Format TT/MM/JJJJ ein',
  [tokens.extraction.pleaseEnterANumber]: 'Bitte geben Sie eine Zahl ein',
  [tokens.extraction.pleaseEnterAMaximumOf]:
    'Bitte geben Sie maximal {{count}} Zeichen ein',
  [tokens.extraction.pleaseSelectFromTheGivenValues]:
    'Bitte waehlen Sie einen der vorgegebenen Werte aus',
  [tokens.extraction.pleaseEnterAValueThatConsistsOfLetters]:
    'Bitte geben Sie einen Wert ein, der aus Buchstaben (gross/klein), Zahlen und Bindestrichen besteht und maximal 35 Zeichen lang ist',
  [tokens.extraction.pleaseEnterAValidSiretNumber]:
    'Bitte geben Sie eine gueltige SIRET-Nummer ein',
  [tokens.extraction['18LettersAndNumbersMaximum']]:
    '18 letters and numbers maximum',
  [tokens.extraction.mustBeInteger]: 'Muss eine Zahl sein',
  [tokens.extraction.loadingExtractionInformation]:
    'Nabu extrahiert Daten aus Ihren Dokumenten',
  [tokens.extraction.emailAttachments]: '{{count}} Anhang',
  [tokens.extraction.emailAttachments_other]: '{{count}} Anhänge',
  [tokens.extraction.loadingBackToDashboard]:
    'Sie koennen in der Zwischenzeit zum Dashboard zurueckkehren',
  [tokens.extraction.notAccessibleForOrganization]:
    'Dieses Dokument ist für diese Organisation nicht zugänglich. Bitte melden Sie sich mit dem entsprechenden Konto an.',
  [tokens.extraction.createTable]: 'Tabelle erstellen',
  [tokens.extraction.deleteColumn]: 'Spalte loeschen',
  [tokens.extraction.doYouWantToDeleteTable]:
    'Moechten Sie die Tabelle auf allen Seiten wirklich loeschen? Alle extrahierten und manuell hinzugefuegten Daten gehen verloren.',
  [tokens.extraction.doYouWantToDeleteTableOnCurrentPage]:
    'Moechten Sie die Tabelle auf dieser Seite wirklich loeschen? Alle extrahierten und manuell hinzugefuegten Daten der Tabelle gehen verloren.',
  [tokens.extraction.editTable]: 'Tabelle bearbeiten',
  [tokens.extraction.editCells]: 'Zellen bearbeiten',
  [tokens.extraction.editField]: 'Feld bearbeiten',
  [tokens.extraction.deleteTableOnlyInThePage]:
    'Tabelle auf dieser Seite loeschen',
  [tokens.extraction.deleteTableInAllPage]: 'Tabelle auf allen Seiten loeschen',
  [tokens.extraction.doYouWantToDeleteColumn]:
    'Moechten Sie diese Spalte wirklich loeschen? Alle extrahierten und manuell hinzugefuegten Daten in der Spalte gehen verloren.',
  [tokens.extraction.doYouWantToDeleteColumnAndDeconsolidate]:
    'Moechten Sie diese Spalte wirklich loeschen? Alle Daten in der Spalte (extrahiert und manuell hinzugefuegt) gehen verloren und Positionen werden nicht mehr konsolidiert.',
  [tokens.extraction.doYouWantToEditColumnAndDeconsolidate]:
    'Moechten Sie diese Zeile wirklich bearbeiten? Artikel werden nicht mehr konsolidiert',
  [tokens.extraction.doYouWantToDeleteRow]:
    'Moechten Sie diese Zeile wirklich loeschen? Alle extrahierten und manuell hinzugefuegten Daten der Zeile gehen verloren.',
  [tokens.extraction.doYouWantToDeleteGroupedColumns]:
    'Wichtig - diese Spalte gehoert zu einer Spaltengruppe. Alle weiteren Spalten dieser Gruppe werden ebenfalls geloescht und alle Daten der gruppierten Spalten gehen verloren. Moechten Sie diese Spalte wirklich loeschen?',
  [tokens.extraction.missingValuesInColumn]:
    '{{count}} fehlende(r) Wert(e) in der Spalte "{{column}}" fuer diese Berechnung',
  [tokens.extraction.columnMissing]:
    'Werte in der Spalte "{{column}}" fehlen fuer diese Berechnung',
  [tokens.extraction.addOriginOfArticles]: 'den Ursprung der Artikel',
  [tokens.extraction.addHSCodeOfArticles]: 'den HS-Code',
  [tokens.extraction.addCodePrefOfArticles]: 'den Praeferenztarifcode',
  [tokens.extraction.addOriginCountryCode]: 'den Ursprungslandcode',
  [tokens.extraction.codePreferenceModalTitle]: 'Codepraeferenzen',
  [tokens.extraction.preferenceCode]: 'Praeferenzcode',
  [tokens.extraction.currency]: 'Waehrung',
  [tokens.extraction.codePreferenceCopy]:
    'Der Feldcode wurde erfolgreich kopiert',
  [tokens.extraction.ofItems]: 'der Artikel',
  [tokens.extraction.add]: 'Hinzufügen',
  [tokens.extraction.emptyTable]: 'Die Tabelle ist leer',
  [tokens.extraction.emptyTableHintLine1]:
    'Klicken Sie auf die Spaltenbeschriftungen oben im Raster,',
  [tokens.extraction.emptyTableHintLine2]:
    'und wählen Sie für jede Spalte eine Klassifizierung, um die Tabelle zu füllen.',
  [tokens.extraction.addToTable]: 'Zur Tabelle hinzufuegen',
  [tokens.extraction.addColumn]: 'Spalte hinzufuegen',
  [tokens.extraction.declarationState]: 'Status der Anmeldung',
  [tokens.extraction.returnToDeclarations]: 'Zurueck zu aktiven Anmeldungen',
  [tokens.extraction.updateDeclaration]: 'Aktuelle Anmeldung aktualisieren',
  [tokens.extraction.declarationUploading]: 'Ihre Anmeldung wird geladen',
  [tokens.extraction.declarationUploaded]:
    'Ihre Anmeldung wurde erfolgreich geladen',
  [tokens.extraction.youWillBeRedirectedToModelCreation]:
    'Sie werden in 10 Sekunden zur Modellerstellung weitergeleitet',
  [tokens.extraction.youWillBeRedirectedToTheDashboard]:
    'Sie werden in 10 Sekunden zum Dashboard weitergeleitet',
  [tokens.extraction.declarationUploadFailed]:
    'Das Laden Ihrer Anmeldung ist fehlgeschlagen',
  [tokens.extraction.failedToLoadOptions]:
    'Optionen konnten nicht geladen werden',
  [tokens.extraction.checkDeclarationAndRetry]:
    'Bitte pruefen Sie Ihre Anmeldung und versuchen Sie es erneut',
  [tokens.extraction.checkDeclaration]: 'Bitte pruefen Sie Ihre Anmeldung',
  [tokens.extraction.retryExport]: 'Versand erneut starten',
  [tokens.extraction.exportRetryDialogMessage]:
    'Der Versand dieser Anmeldung ist fehlgeschlagen. Sie koennen den Versand jetzt erneut starten.',
  [tokens.extraction.exportFailedMessage]:
    'Der Versand dieser Anmeldung ist fehlgeschlagen.',
  [tokens.extraction.exportRetryInitiated]:
    'Der erneute Versand wurde erfolgreich gestartet.',
  [tokens.extraction.warningOriginX]:
    'Ursprung x wird in den Zellbereich verschoben',
  [tokens.extraction.warningOriginY]:
    'Ursprung y wird in den Zellbereich verschoben',
  [tokens.extraction.warningTouchingCellsOnX]:
    'Breite wird zu stark reduziert - vorhandene Zellen werden beruehrt',
  [tokens.extraction.warningTouchingCellsOnY]:
    'Hoehe wird zu stark reduziert - vorhandene Zellen werden beruehrt',
  [tokens.extraction.warningBottomRowTooSmall]: 'untere Zeile ist zu klein',
  [tokens.extraction.warningTopRowTooSmall]: 'obere Zeile ist zu klein',
  [tokens.extraction.warningTableLeavesPage]: 'Tabelle verlaesst die Seite',
  [tokens.extraction.consolidate]: 'Konsolidieren',
  [tokens.extraction.consolidated]: 'Konsolidiert',
  [tokens.extraction.deconsolidate]: 'Konsolidierung aufheben',
  [tokens.extraction.clickOnTheButtonToUndoConsolidation]:
    'Die Tabelle wurde konsolidiert - klicken Sie auf die Schaltflaeche unten, um die Konsolidierung rueckgaengig zu machen.',
  [tokens.extraction.selectTheColumnsToBeUsedForConsolidation]:
    'Waehlen Sie die Spalten fuer die Konsolidierung aus',
  [tokens.extraction.sendingConfirmation]: 'Sendebestaetigung',
  [tokens.extraction.createModelInfo]:
    'Damit können Sie Informationen aus dieser Anmeldung speichern und später wiederverwenden. Bei einer neuen Anmeldung wählen Sie einfach ein Modell aus der Liste aus.',
  [tokens.extraction.sendingFileQuestion]:
    'Moechten Sie diese Anmeldung wirklich senden?',
  [tokens.extraction.saveModelQuestion]:
    'Moechten Sie aus dieser Anmeldung ein neues Modell erstellen?',
  [tokens.extraction.consolidateAndVerify]: 'Konsolidieren und pruefen',
  [tokens.extraction.consolidateAndSend]: 'Konsolidieren und senden',
  [tokens.extraction.consolidateAndSendOptions]:
    'Weitere Optionen fuer Konsolidierung und Senden',
  [tokens.extraction.sendWithoutConsolidating]: 'Senden ohne Konsolidierung',
  [tokens.extraction.declarationQualityQuestion]: 'Wie war diese Deklaration?',
  [tokens.extraction.declarationQualityVeryDissatisfied]: 'Sehr unzufrieden',
  [tokens.extraction.declarationQualityVerySatisfied]: 'Sehr zufrieden',
  [tokens.extraction.declarationQualityAddRemark]:
    'Bemerkung hinzufuegen (optional)',
  [tokens.extraction.declarationQualityRemarkPlaceholder]:
    'Teilen Sie Ihre Anmerkungen zu dieser Extraktion…',
  [tokens.extraction.createNewModel]: 'Neues Modell erstellen',
  [tokens.extraction.redirectCreateModel]: 'Zur Modellerstellung weiterleiten',
  [tokens.extraction.modelFieldsAreFixed]:
    'Die folgenden Felder sind nicht bearbeitbar - Sie können bei einem Modell nur Felder hinzufügen oder entfernen',
  [tokens.extraction.selectAllFields]: 'Alle Felder auswaehlen',
  [tokens.extraction.modelDetail]: 'Modelldetails',
  [tokens.extraction.modelCreation]: 'Modellerstellung',
  [tokens.extraction.modelCreated]: 'Modell erstellt',
  [tokens.extraction.modelCreationFailed]: 'Modellerstellung fehlgeschlagen',
  [tokens.extraction.noModelApplied]: 'Kein Modell angewendet',
  [tokens.extraction.glideHeaderSum]: 'Summe',
  [tokens.extraction.glideHeaderArticleNumber]: 'Anzahl Artikel',
  [tokens.extraction.checkFieldModalFirstTextWarning]: 'Warnung!',
  [tokens.extraction.checkFieldModalFirstText]:
    'Durch das Aktualisieren dieses Felds werden alle Werte fuer "',
  [tokens.extraction.checkFieldModalFirstTextEnding]:
    '" in Ihrer Tabelle ersetzt.',
  [tokens.extraction.checkFieldModalSecondText]:
    'Alle aktuellen Werte gehen verloren!',
  [tokens.extraction.checkFieldModalFieldUpdated]: 'Feld aktualisiert',
  [tokens.extraction.unknownTaricCode]: 'Unbekannter TARIC-Code: {{code}}',
  [tokens.extraction.checkFieldModalConsolidatedTitle]:
    'Konsolidierung der Artikel',
  [tokens.extraction.checkFieldModalConsolidatedFirstText]:
    'Sie senden Ihre Anmeldung ohne konsolidierte Artikel.',
  [tokens.extraction.consolidationRequired]:
    'Vor der Validierung einer Anmeldung ist eine Konsolidierung erforderlich.',
  [tokens.extraction.checkFieldModalConsolidatedSecondText]:
    'Moechten Sie Ihre Anmeldung bearbeiten oder ohne Konsolidierung senden?',
  [tokens.extraction.checkFieldModalConsolidatedUpdatedButton]:
    'Zur Anmeldung zurueckkehren',
  [tokens.extraction.checkFieldModalConsolidatedSendButton]:
    'Ohne Konsolidierung senden',
  [tokens.extraction.checkFieldModalDependenciesWarning]: 'Warnung!',
  [tokens.extraction.resetLabelBox]: 'Zuruecksetzen',
  [tokens.extraction.productDescription]: 'Produktbeschreibung',
  [tokens.extraction.noAdditionalCodesAvailableForThisTaricCode]:
    'Fuer diesen TARIC-Code sind keine zusaetzlichen Codes verfuegbar',
  [tokens.extraction.addAnAdditionalCode]:
    'Einen zusaetzlichen Code hinzufuegen',
  [tokens.extraction.additionalCodes]: 'Zusaetzliche Codes',
  [tokens.extraction.noResult]: 'Kein Ergebnis',
  [tokens.extraction.previousResult]: 'Vorheriges Ergebnis',
  [tokens.extraction.nextResult]: 'Naechstes Ergebnis',
  [tokens.extraction.searchByKeywords]: 'Nach Stichwoertern suchen',
  [tokens.extraction.currentChoice]: 'Aktuelle Auswahl',
  [tokens.extraction.selectItem]: 'Auswaehlen',
  [tokens.extraction.itemDescription]: 'Artikelbeschreibung',
  [tokens.extraction.searchAnotherHsCode]: 'Nach einem anderen Code suchen',
  [tokens.extraction.moreDetails]: '+ Details',
  [tokens.extraction.seeLess]: '- Details',
  [tokens.extraction.previousRow]: 'Vorherige Zeile',
  [tokens.extraction.nextRow]: 'Naechste Zeile',
  [tokens.extraction.row]: 'Zeile',
  [tokens.extraction.mustBeEqualToOneOfTheAllowedValues]:
    'Muss einem der erlaubten Werte entsprechen',
  [tokens.extraction.editDescription]: 'Beschreibung bearbeiten',
  [tokens.extraction.replaceDescriptionByTaricCodeDescription]:
    'Beschreibung durch TARIC-Beschreibung ersetzen',
  [tokens.extraction.applyValueToAllRows]: 'Wert auf alle Zeilen anwenden',
  [tokens.extraction.revertToInitialCode]:
    'Auf den urspruenglichen Code zuruecksetzen',
  [tokens.extraction.noAdditionalCodesSelected]:
    'Keine zusaetzlichen Codes ausgewaehlt',
  [tokens.extraction.additionalCodesSelected]:
    '{{count}} zusaetzlicher Code ausgewaehlt',
  [tokens.extraction.additionalCodesSelected_other]:
    '{{count}} zusaetzliche Codes ausgewaehlt',
  [tokens.extraction.copyValueToEntireColumn]:
    'Wert dieser Zelle in die gesamte Spalte kopieren',
  [tokens.extraction.copyValueToEntireColumnShortcut]:
    'Auf aktuelle Rechnung duplizieren (Strg+Umschalt+C)',
  [tokens.extraction.copyToCurrentDocumentColumn]:
    'Auf aktuelle Rechnung duplizieren',
  [tokens.extraction.copyToAllDocumentsColumn]:
    'Auf alle Rechnungen duplizieren',
  [tokens.extraction.copyToCurrentDocumentColumnShortcut]:
    'Auf aktuelle Rechnung duplizieren (Strg+Umschalt+C)',
  [tokens.extraction.copyToColumnOptions]: 'Duplizierungsoptionen',
  [tokens.extraction.areYouSureYouWantToCopyThisCellValueToAllColumns]:
    'Moechten Sie den Wert dieser Zelle wirklich in alle Zeilen der Tabelle kopieren?',
  [tokens.extraction
    .areYouSureYouWantToCopyThisCellValueToCurrentDocumentColumn]:
    'Moechten Sie die Spaltenwerte wirklich auf der aktuellen Rechnung ersetzen?',
  [tokens.extraction.areYouSureYouWantToCopyThisCellValueToAllDocumentsColumns]:
    'Moechten Sie die Spaltenwerte wirklich auf allen Rechnungen in der Anmeldung ersetzen?',
  [tokens.extraction.taricCodeNotFound]: 'TARIC-Code nicht gefunden',
  [tokens.extraction.noArticleDescription]:
    'Keine Artikelbeschreibung verfuegbar',
  [tokens.extraction.updateDeclarationModel]:
    'Modell der Anmeldung aktualisieren',
  [tokens.extraction.removeModel]: 'Modell entfernen',
  [tokens.extraction.changeModel]: 'Modell wechseln',
  [tokens.extraction.changeModelForCurrentDeclaration]:
    'Modell der aktuellen Anmeldung ändern.',
  [tokens.extraction.applyItemToDeclaration]:
    'Diese Codes auf die Anmeldung anwenden',
  [tokens.extraction.redoClassificationStep]:
    'Klassifizierungsschritt erneut ausfuehren',
  [tokens.extraction.noDuty]: 'Kein Zollbetrag gefunden',
  [tokens.extraction.hoverOverAResultToSeeDetails]:
    'Fahren Sie mit der Maus ueber ein Ergebnis, um Details zu sehen',
  [tokens.extraction.searchAdditionalCodesByKeyword]:
    'Nach zusaetzlichen Codes per Stichwort suchen',
  [tokens.extraction.basicValidations]: 'Grundlegende Validierungen',
  [tokens.extraction.showAnomalies]: 'Fehler anzeigen',
  [tokens.extraction.clickToViewValidationErrors]:
    'Klicken, um zu behebende Fehler anzuzeigen',
  [tokens.extraction.validationErrorsToFix]: '{{count}} Fehler zu korrigieren',
  [tokens.extraction.validationErrorsToFix_other]:
    '{{count}} Fehler zu korrigieren',
  [tokens.extraction.goToValidationField]: 'Zum Feld « {{field}} » gehen',
  [tokens.extraction.validationFieldError]: 'Fehler im Feld « {{field}} »',
  [tokens.extraction.anomaliesBeforeSend]:
    '{{count}} Fehler vor dem Senden zu korrigieren',
  [tokens.extraction.anomaliesBeforeSend_other]:
    '{{count}} Fehler vor dem Senden zu korrigieren',
  [tokens.extraction.validationSummary]:
    '{{validated}} / {{total}} Felder validiert · {{remaining}} erforderliche Felder verbleibend:',
  [tokens.extraction.showErrorsOnlySections]: 'Fehler anzeigen',
  [tokens.extraction.clearErrorsOnlyFilter]: 'Alle Abschnitte anzeigen',
  [tokens.extraction.otherErrorFields]: 'Weitere Felder',
  [tokens.extraction.coherenceChecks]: 'Konsistenzpruefungen',
  [tokens.extraction.pressCtrlJToGoToNextCoherenceError]:
    'Druecken Sie Strg + J, um zum naechsten Kohaerenzfehler zu springen',
  [tokens.extraction.additionalCode]: 'Zusaetzlicher Code',
  [tokens.extraction.sendMessage]: 'Nachricht senden',
  [tokens.extraction.newMessage]: 'Neue Nachricht',
  [tokens.extraction.setBatchImportError]: 'Anmeldung in den Fehlerstatus versetzen',
  [tokens.extraction.internalErrorState]: 'Interner Fehlerstatus',
  [tokens.extraction
    .puttingThisDossierInErrorStateTellsExternalUsersNabuCannotProcessIt]:
    'Warnung - das Setzen dieser Anmeldung auf Fehlerstatus informiert externe Nutzer, dass Nabu sie nicht verarbeiten kann',
  [tokens.extraction.error]: 'Fehler',
  [tokens.extraction.tabHasNoData]:
    'Dieser Abschnitt des Anmeldeformulars enthaelt keine Daten, wahrscheinlich aufgrund eines technischen Problems. Bitte kontaktieren Sie den Support ueber das Symbol unten rechts.',
  [tokens.extraction.countries]: 'Laender',
  [tokens.extraction.includedCountries]: 'Enthaltene Laender',
  [tokens.extraction.excludedCountries]: 'Ausgeschlossene Laender',
  [tokens.extraction.renvois]: 'Rechtsgrundlagen',
  [tokens.extraction.referenceAbbrev_tax]: 'TAX',
  [tokens.extraction.referenceAbbrev_certificate]: 'CRT',
  [tokens.extraction.referenceAbbrev_preference]: 'PRF',
  [tokens.extraction.referenceAbbrev_location]: 'LOC',
  [tokens.extraction.referenceAbbrev_additionalcode]: 'ADD',
  [tokens.extraction.taxCode]: 'Steuercode',
  [tokens.extraction.duty]: 'Zoll',
  [tokens.extraction.tax]: 'Steuer',
  [tokens.extraction.prefTarif]: 'Praeferenztarif',
  [tokens.extraction.tariffProvision]: 'Tarifregelung',
  [tokens.extraction.tariffProvision_short]: 'Tarifreg.',
  [tokens.extraction.legalReferences]: 'Rechtsgrundlagen',
  [tokens.extraction.unknown]: 'Unbekannt',
  [tokens.extraction.consolidationOptions]: 'Konsolidierungsoptionen',
  [tokens.extraction.hscode]: 'HS-Code',
  [tokens.extraction.countryOfOrigin]: 'Ursprungsland',
  [tokens.extraction.description]: 'Beschreibung',
  [tokens.extraction.numberOfUnits]: 'Anzahl Einheiten',
  [tokens.extraction.numberOfPackages]: 'Anzahl Packstuecke',
  [tokens.extraction.netWeight]: 'Nettogewicht',
  [tokens.extraction.grossWeight]: 'Bruttogewicht',
  [tokens.extraction.containerCode]: 'Containernummer',
  [tokens.extraction.codeDescriptionNotFound]:
    'Codebeschreibung nicht gefunden',
  [tokens.extraction.noTablesWithMergeableColumns]:
    'Keine Tabellen mit zusammenfuehrbaren Spalten',
  [tokens.extraction.noCertificateRequired]: 'Kein Zertifikat erforderlich',
  [tokens.extraction.informationAbout]:
    'Informationen zu {{ itemName }} : {{ code }}',
  [tokens.extraction.thisCodeHasMissingInformation]:
    'Dieser Code enthaelt fehlende Informationen',
  [tokens.extraction.thisDeclarationIsNotInAnErrorState]:
    'Diese Anmeldung befindet sich nicht im Fehlerstatus',
  [tokens.extraction.is]: 'ist',
  [tokens.extraction.if]: 'wenn',
  [tokens.extraction.then]: 'dann',
  [tokens.extraction.shouldBe]: 'sollte sein',
  [tokens.extraction.equalTo]: 'gleich',
  [tokens.extraction.lessThan]: 'kleiner als',
  [tokens.extraction.lessThanOrEqualTo]: 'kleiner oder gleich',
  [tokens.extraction.notIn]: 'nicht in',
  [tokens.extraction.filled]: 'ausgefuellt',
  [tokens.extraction.greaterThan]: 'groesser als',
  [tokens.extraction.greaterThanOrEqualTo]: 'groesser oder gleich',
  [tokens.extraction.in]: 'in',
  [tokens.extraction.notEqualTo]: 'ungleich',
  [tokens.extraction.totalDocument]: 'Dokumentsumme',
  [tokens.extraction.calculatedDocument]: 'Berechnete Summe',
  [tokens.extraction.documentTotals]: 'Dokumentsummen',
  [tokens.extraction.amountTotal]: 'Gesamtbetrag',
  [tokens.extraction.grossWeightTotal]: 'Gesamtbruttogewicht',
  [tokens.extraction.netWeightTotal]: 'Gesamtnettogewicht',
  [tokens.extraction.numberOfPosition]: 'Anzahl Positionen',
  [tokens.extraction.spread]: 'Verteilen',
  [tokens.extraction.spreadOverAllLines]: 'Auf alle Zeilen verteilen',
  [tokens.extraction.spreadDialogTitle]: 'Werte verteilen fuer {{name}}',
  [tokens.extraction.spreadDialogContent]:
    'Verteilen Sie den Wert {{value}} auf alle Artikelzeilen der Spalte {{name}}.',
  [tokens.extraction.spreadSuccess]: 'Verteilung erfolgreich abgeschlossen.',
  [tokens.extraction.documentTotalNotFound]:
    'Kein extrahierter Wert fuer "{{columnName}}" in "{{documentName}}" gefunden. Fuellen Sie den Wert manuell aus oder klassifizieren Sie ihn im Dokument als "{{columnName}}".',
  [tokens.extraction.documentTotalNotFoundSingle]:
    'Kein extrahierter Wert fuer "{{columnName}}" im Dokument gefunden. Fuellen Sie den Wert manuell aus oder klassifizieren Sie ihn im Dokument als "{{columnName}}".',
  [tokens.extraction.notFound]: 'Nicht gefunden',
  [tokens.extraction.clearColumnValuesForDocument]:
    'Werte der Spalte "{{columnName}}" in allen Zeilen von "{{documentTitle}}" leeren.',
  [tokens.extraction.documentCellsClearedSuccessfully]:
    'Dokumentzellen erfolgreich geleert.',
  [tokens.extraction.errorClearingDocumentCells]:
    'Fehler beim Leeren der Dokumentzellen',
  [tokens.extraction.spreadOverDocumentLinesSelect]:
    'Verteilen Sie den Wert "{{value}}" ueber die Zeilen von "{{documentTitle}}" fuer die Spalte "{{columnName}}". Waehlen Sie eine Verteilungsstrategie.',
  [tokens.extraction.spreadOverDocumentLinesSelectSingle]:
    'Verteilen Sie den Wert "{{value}}" ueber alle Dokumentzeilen fuer die Spalte "{{columnName}}". Waehlen Sie eine Verteilungsstrategie.',
  [tokens.extraction.spreadOverDocumentLinesAutoSingle]:
    'Verteilen Sie den Wert "{{value}}" automatisch ueber alle Dokumentzeilen fuer die Spalte "{{columnName}}" mit der Strategie "{{strategyName}}".',
  [tokens.extraction.spreadOverDocumentLinesAuto]:
    'Verteilen Sie den Wert "{{value}}" ueber die Zeilen von "{{documentTitle}}" fuer die Spalte "{{columnName}}" mit der Strategie "{{strategyName}}".',
  [tokens.extraction.spreadOverAllLinesSelect]:
    'Verteilen Sie den Wert "{{value}}" ueber alle Zeilen der Anmeldung. Waehlen Sie eine Verteilungsstrategie.',
  [tokens.extraction.spreadOverAllLinesAuto]:
    'Verteilen Sie den Wert "{{value}}" automatisch ueber alle Zeilen der Anmeldung mit der Strategie "{{strategyName}}".',
  [tokens.extraction.noPostProcessFound]: 'Keine Verteilungsstrategie gefunden',
  [tokens.extraction.source]: 'Quelle',
  [tokens.extraction.sourceTooltip]:
    'Wert, der aus dem Quelldokument extrahiert wurde.',
  [tokens.extraction.packageTypeNotSourced]: 'Packungsart nicht ermittelt',
  [tokens.extraction.weightUnitNotSourced]: 'Gewichtseinheit nicht ermittelt',
  [tokens.extraction.packageTypeNotSourced]: 'Packungsart nicht ermittelt',
  [tokens.extraction.currencyNotSourced]: 'Waehrung nicht ermittelt',
  [tokens.extraction.thisActionWillClearAllCellsInTheDocumentColumn]:
    'Diese Aktion leert alle Zellen in der Spalte "{{columnName}}" fuer das Dokument "{{documentTitle}}". Diese Aktion kann nicht rueckgaengig gemacht werden. Moechten Sie fortfahren?',
  [tokens.extraction.declaration]: 'Deklaration',
  [tokens.extraction.declarationTooltip]: 'Wert aus der Artikeltabelle.',
  [tokens.extraction.notSourced]: 'Stammdatenwert',
  [tokens.extraction.spreadError]:
    'Die Verteilung der Summen konnte nicht angewendet werden.',
  [tokens.extraction.document]: 'Dokument',
  [tokens.extraction.totalNotFound]:
    'Die Summe <strong>{{label}}</strong> wurde in den Dokumenten nicht erkannt. Moeglicherweise muessen Sie die Spalte "{{label}}" zur Artikeltabelle hinzufuegen.',
  [tokens.extraction.errorCells]:
    'Informationen in den Zellen der Artikeltabelle fehlen fuer die Summenberechnung. Bitte fuellen Sie diese Zellen aus.',
  [tokens.extraction.errorMissingDocumentTitle]: 'Fehlende Dokumente',
  [tokens.extraction.errorMissingDocumentContent]:
    'Die Datei kann in ihrem aktuellen Zustand nicht verarbeitet werden: verpflichtende Dokumente fehlen (z. B. Handelsrechnung, Packliste, Ursprungszeugnis). Bitte reichen Sie alle erforderlichen Dokumente ein.',
  [tokens.extraction.errorDocumentaryInconsistenciesTitle]:
    'Dokumenteninkonsistenzen',
  [tokens.extraction.errorDocumentaryInconsistenciesContent]:
    'Zwischen den bereitgestellten Dokumenten wurden Inkonsistenzen festgestellt (z. B. Mengen, Werte oder Warenbeschreibungen). Bitte pruefen Sie die Dokumente und reichen Sie konsistente Unterlagen ein.',
  [tokens.extraction.errorNonCompliantDocumentTitle]:
    'Unleserliche oder nicht konforme Dokumente',
  [tokens.extraction.errorGenericTitle]: 'Dateifehler',
  [tokens.extraction.errorGenericContent]:
    'Ein Fehler verhindert die Verarbeitung dieser Datei. Bitte pruefen Sie die uebermittelten Dateien.<br>Wenn das Problem weiter besteht, kontaktieren Sie unser Support-Team ueber <intercom>Intercom</intercom>.',
  [tokens.extraction.downloadOriginalFilesForThisDossier]:
    'Originaldateien fuer diese Anmeldung herunterladen',
  [tokens.extraction.noClientOrganization]: 'Keine Kundenorganisation',
  [tokens.extraction.errorNonCompliantDocumentContent]:
    'Einige eingereichte Dokumente sind unleserlich, unvollstaendig oder nicht konform. Bitte reichen Sie lesbare, vollstaendige und offizielle Versionen ein.',
  [tokens.extraction.searchForAField]: 'Nach einem Feld suchen',
  [tokens.extraction.keyboardShortcutTab]: 'Tab',
  [tokens.extraction.keyboardShortcutEnter]: 'Eingabe',
  [tokens.extraction.keyboardShortcutNextField]: 'naechstes Feld',
  [tokens.extraction.keyboardShortcutValidate]: 'validieren',
  [tokens.extraction.selectedField]: 'Feld ausgewaehlt',
  [tokens.extraction.stepKeyboardShortcutTab]: 'Tab',
  [tokens.extraction.stepKeyboardShortcutEnter]: 'Eingabe',
  [tokens.extraction.stepKeyboardShortcutNextField]: 'validieren und naechstes Feld',
  [tokens.extraction.stepKeyboardShortcutValidate]: 'validieren',
  [tokens.extraction.stepKeyboardShortcutEscape]: 'Esc',
  [tokens.extraction.stepKeyboardShortcutCancel]: 'abbrechen',
  [tokens.extraction.stepKeyboardShortcutSearch]: 'suchen',
  [tokens.extraction.stepKeyboardShortcutQuickActions]: 'Schnellaktionen',
  [tokens.extraction.summaryTableArticles]: 'Artikeltabelle',
  [tokens.extraction.additionSummaryTitle]: 'Aufschlaege',
  [tokens.extraction.deductionSummaryTitle]: 'Abzuege',
  [tokens.extraction.statisticalValueSummaryTitle]: 'Statistischer Wert',
  [tokens.extraction.totauxSummaryTitle]: 'Summen',
  [tokens.extraction.totauxSummaryInfo]:
    'Aggregierte Anmeldungsbeträge: Warenwert, Gebuehren, Massen und statistischer Wert.',
  [tokens.extraction.totalsRubriqueFacturation]: 'Abrechnung',
  [tokens.extraction.totalsRubriqueColisage]: 'Verpackung',
  [tokens.extraction.totalsArticlesBadge]: 'Artikel',
  [tokens.extraction.totalsArticlesBadge_other]: 'Artikel',
  [tokens.extraction.statisticalValueSummaryInfo]:
    'Wert der Waren am Ausgangspunkt aus dem französischen Staatsgebiet, berechnet gemäß Incoterm.',
  [tokens.extraction.statisticalValueAutoBadge]: 'Auto',
  [tokens.extraction.statisticalValueManualBadge]: 'Manuell',
  [tokens.extraction.statisticalValueIncotermLabel]:
    'Incoterm der Anmeldung: {{code}}',
  [tokens.extraction.statisticalValueIncotermFolderLabel]:
    'Incoterm der Anmeldung:',
  [tokens.extraction.statisticalValueIncotermNotSet]:
    'Kein Incoterm angegeben',
  [tokens.extraction.statisticalValueIncotermNotSetHelp]:
    'Geben Sie den Incoterm der Anmeldung an, um automatische Berechnungsregeln anzuwenden.',
  [tokens.extraction.statisticalValueIncotermFcaDescription]:
    '{{code}}: Warenwert + Transport bis zur franzoesischen Grenze (Zuschlag).',
  [tokens.extraction.statisticalValueIncotermFobDescription]:
    '{{code}}: Warenwert ohne internationalen Transport.',
  [tokens.extraction.statisticalValueIncotermCifDescription]:
    '{{code}}: Warenwert einschliesslich Transport bis zur Grenze.',
  [tokens.extraction.statisticalValueManualEntry]: 'Manuelle Eingabe',
  [tokens.extraction.statisticalValueManualEntryHelpOff]:
    'Wert wird automatisch gemaess Incoterm berechnet.',
  [tokens.extraction.statisticalValueManualEntryHelpOn]:
    'Freier Wert. Zurück auf Auto schalten, um neu zu berechnen.',
  [tokens.extraction.statisticalValueManualInputPlaceholder]:
    '{{value}} (berechneter Wert)',
  [tokens.extraction.statisticalValueManualCalculatedHint]:
    'Berechneter Wert ({{description}}): {{value}} {{currency}}. Klicken Sie, um ihn zu uebernehmen, oder geben Sie einen anderen ein.',
  [tokens.extraction.statisticalValueManualReuseCalculatedValue]:
    'Berechneten Wert uebernehmen',
  [tokens.extraction.statisticalValueTransportAbroad]: 'Transport im Ausland',
  [tokens.extraction.statisticalValueTransportAbroadHelp]:
    'Anteil jenseits der Grenze, vom Zuschlag ausgeschlossen.',
  [tokens.extraction.statisticalValueBreakdownArticles]: 'Artikelbetrag',
  [tokens.extraction.statisticalValueBreakdownTransport]:
    'Transport bis zur franzoesischen Grenze',
  [tokens.extraction.statisticalValueBreakdownMiscFees]: 'Diverse Gebuehren',
  [tokens.extraction.noStatisticalValueDocumentsFound]:
    'Keine Dokumente mit statistischem Wert gefunden',
  [tokens.extraction.conversionSourcedFrom]:
    'Umrechnung aus {{source}} am {{date}}',
  [tokens.extraction.fieldsList]: 'Feldliste',
  [tokens.extraction.runTableAutomations]:
    'Tabellenautomatisierungen ausfuehren',
  [tokens.extraction.runReferentialAutomations]:
    'Referenzautomatisierung starten',
  [tokens.extraction.referentialAutomationDrawerTitle]:
    'Referenzautomatisierung',
  [tokens.extraction.referentialAutomationDrawerSubtitle]:
    'Automatisierung anzeigen und anwenden',
  [tokens.extraction.referentialAutomationPreviewHint]:
    'Es werden keine Werte geschrieben, bis Sie die Vorschau bestätigen',
  [tokens.extraction.referentialAutomationSelectLabel]:
    'Auszufuehrende Automatisierung',
  [tokens.extraction.referentialAutomationSourceLabel]: 'Referenz: {{name}}',
  [tokens.extraction.referentialAutomationReadyTitle]: 'Bereit zum Vergleich',
  [tokens.extraction.referentialAutomationReadyDescription]:
    'Starten Sie die Automatisierung, um zeilenweise die Werte zu sehen, die aus "{{name}}" ergänzt oder ersetzt werden.',
  [tokens.extraction.referentialAutomationLaunch]: 'Automatisierung starten',
  [tokens.extraction.referentialAutomationApply]: 'Anwenden',
  [tokens.extraction.referentialAutomationApplySummary]:
    '{{count}} Zeile(n) werden geändert',
  [tokens.extraction.referentialAutomationApplySuccess]:
    'Automatisierung erfolgreich angewendet',
  [tokens.extraction.referentialAutomationApplyError]:
    'Fehler beim Anwenden der Automatisierung',
  [tokens.extraction.referentialAutomationRunError]:
    'Fehler beim Ausfuehren der Automatisierung',
  [tokens.extraction.referentialAutomationNoReferentials]:
    'Keine Referenzautomatisierung fuer diese Deklaration verfuegbar',
  [tokens.extraction.referentialAutomationRowUpdateBadge]: 'Aktualisieren',
  [tokens.extraction.referentialAutomationWillChangeLabel]: 'werden geändert',
  [tokens.extraction.referentialAutomationWillChangeLabel_one]: 'wird geändert',
  [tokens.extraction.referentialAutomationEmptyCell]: 'leer',
  [tokens.extraction.runMergeAutomations]: 'Merge-Automatisierungen ausfuehren',
  [tokens.extraction.duplicateThisDossier]: 'Diese Anmeldung duplizieren',
  [tokens.extraction.renameThisDossier]: 'Diese Anmeldung umbenennen',
  [tokens.extraction.renameDossierTitle]: 'Anmeldung umbenennen',
  [tokens.extraction.manageTags]: 'Tags verwalten',
  [tokens.extraction.bugTagDuplicateTitle]: 'Als BUG markieren',
  [tokens.extraction.bugTagDuplicateMessage]:
    'Möchten Sie diese Anmeldung duplizieren, um die Deklaration auf einer Kopie fortzusetzen ? Der aktuelle Anmeldung behält das BUG-Tag.',
  [tokens.extraction.bugTagDuplicateYes]: 'Ja, duplizieren',
  [tokens.extraction.bugTagDuplicateNo]: 'Nein, nur taggen',
  [tokens.extraction.duplicatingFolder]: 'Anmeldung wird dupliziert…',
  [tokens.extraction.folderDuplicatedSuccessfully]:
    'Die Anmeldung wurde erfolgreich dupliziert.',
  [tokens.extraction.openDuplicatedFolder]: 'Duplizierte Anmeldung öffnen',
  [tokens.extraction.viewingDuplicatedFolder]:
    'Sie befinden sich nun im duplizierte Anmeldung.',
  [tokens.extraction.editLockConflictTitle]: 'Anmeldung wird bereits bearbeitet',
  [tokens.extraction.editLockConflictMessage]:
    '<bold>{{lockedBy}}</bold> bearbeitet diese Anmeldung seit {{lockedSince}}. Sie können sie nur lesen oder die Bearbeitung übernehmen.',
  [tokens.extraction.editLockSinceToday]: '{{time}} heute',
  [tokens.extraction.editLockSinceYesterday]: '{{time}} gestern',
  [tokens.extraction.editLockSinceOnDate]: '{{time}} am {{date}}',
  [tokens.extraction.editLockReadOnlyBadgeHint]:
    'Klicken Sie, um die Bearbeitung zu übernehmen',
  [tokens.extraction.editLockLostTitle]: 'Bearbeitungssperre verloren',
  [tokens.extraction.editLockLostMessage]:
    '<bold>{{takenOverBy}}</bold> hat die Bearbeitung dieser Anmeldung übernommen. Ihre Änderungen können nicht mehr gespeichert werden.',
  [tokens.extraction.editLockLockRequiredTitle]:
    'Bearbeitungssperre erforderlich',
  [tokens.extraction.editLockLockRequiredMessage]:
    'Zum Bearbeiten dieser Anmeldung ist eine Sperre erforderlich. Erneut versuchen oder Bearbeitung übernehmen.',
  [tokens.extraction.editLockLockedBy]: 'Gesperrt von {{lockedBy}}',
  [tokens.extraction.editLockTakeOver]: 'Bearbeitung übernehmen',
  [tokens.extraction.editLockBackToList]: 'Zurück zur Liste',
  [tokens.extraction.editLockUnknownUser]: 'ein anderer Benutzer',
  [tokens.extraction.editLockBadgeEditing]: 'Bearbeitung',
  [tokens.extraction.editLockBadgeReadOnly]: 'Lesen',
  [tokens.extraction.editLockBannerEditing]: 'Sie bearbeiten diese Anmeldung',
  [tokens.extraction.editLockBannerReadOnlyConflict]:
    'Nur Lesen: {{lockedBy}} bearbeitet diese Anmeldung',
  [tokens.extraction.editLockBannerReadOnlyLost]:
    'Nur Lesen: {{takenOverBy}} hat die Bearbeitung übernommen',
  [tokens.extraction.editLockEditorTooltip]:
    '{{name}} bearbeitet diese Anmeldung',
  [tokens.extraction.createAModelFromThisDossier]:
    'Modell aus dieser Anmeldung erstellen',
  [tokens.extraction.createANewClientOrganizationFromThisDossier]:
    'Neue Kundenorganisation aus dieser Anmeldung erstellen',
  [tokens.extraction.tableAutomations]: 'Tabellenautomatisierungen',
  [tokens.extraction.tableAutomationMatchesFound]:
    'Treffer bei Tabellenautomatisierungen gefunden',
  [tokens.extraction.payloads]: 'Nutzdaten',
  [tokens.extraction.noTableAutomationsFound]:
    'Keine Tabellenautomatisierungen gefunden',
  [tokens.extraction.noAutomationGroupsFound]:
    'Keine Automatisierungsgruppen gefunden',
  [tokens.extraction.noTableInDocument]:
    'In diesem Dokument konnte keine Artikeltabelle erkannt werden. Bitte definieren Sie die Tabelle manuell.',
  [tokens.extraction.allFieldsValidated]:
    'Alle Felder in diesem Abschnitt wurden validiert.',
  [tokens.extraction.fieldsInError]:
    '{{errorsCount}} Felder mit Fehler in diesem Abschnitt.',
  [tokens.extraction.fieldsValidationProgress]:
    '{{validatedFields}} Felder von insgesamt {{totalFields}} in diesem Abschnitt wurden validiert.',
  [tokens.extraction.totalFieldsToValidate]:
    'Insgesamt {{totalFields}} Felder in diesem Abschnitt zu validieren.',
  [tokens.extraction.sectionCompleted]:
    'Alle Pflichtfelder in diesem Abschnitt sind ausgefüllt.',
  [tokens.extraction.sectionCompletionProgress]:
    '{{filledFields}}/{{totalFields}} Pflichtfelder in diesem Abschnitt ausgefüllt.',
  [tokens.extraction.dossierReferenceCopiedToClipboard]:
    'Anmeldungsreferenz in die Zwischenablage kopiert',
  [tokens.extraction.comments]: 'Kommentare',
  [tokens.extraction.addAComment]: 'Schreibe einen Kommentar...',
  [tokens.extraction.commentsForThisDeclaration]:
    'Kommentare zu dieser Anmeldung',
  [tokens.extraction.downloadDeclarationOutputFile]:
    'Ausgabedatei herunterladen',
  [tokens.extraction.settingsDrawerTreatment]: 'Verarbeitung',
  [tokens.extraction.settingsDrawerFolder]: 'Anmeldung',
  [tokens.extraction.settingsDrawerComments]: 'Kommentare',
  [tokens.extraction.settingsDrawerTags]: 'Tags',
  [tokens.extraction.settingsDrawerLayout]: 'Anordnung',
  [tokens.extraction.settingsDrawerOpenComments]: 'Kommentare öffnen',
  [tokens.extraction.settingsDrawerInvertDocumentPanel]:
    'Dokument / Panel invertieren',
  [tokens.extraction.settingsDrawerLayoutBalanced]: 'Ausgewogen',
  [tokens.extraction.settingsDrawerLayoutDocument]: 'Dokument',
  [tokens.extraction.settingsDrawerLayoutPanel]: 'Panel',
  [tokens.extraction.settingsDrawerLayoutDocumentTable]: 'Dokument + Tabelle',
  [tokens.extraction.rossumExtraction]: 'Rossum-Extraktion',
  [tokens.extraction.legacyExtractionModel]: 'Altes Extraktionsmodell',
  [tokens.extraction.newExtractionModel]: 'Neues Extraktionsmodell',
  [tokens.extraction.rossumExtractionNoCompatibleLayer]:
    'Das angeforderte Extraktionsmodell ist für die Handelsrechnung nicht verfügbar.',
  [tokens.extraction.updateExtractionModelTitle]: 'Extraktionsmodell',
  [tokens.extraction.selectExtractionModel]: 'Extraktionsmodell',
  [tokens.extraction.extractionModelRegenerateAlertToNew]:
    'Achtung: Sie sind dabei, die Extraktion mit <bold>dem neuen Modell</bold> neu zu erzeugen. Möchten Sie bestätigen?',
  [tokens.extraction.extractionModelRegenerateAlertToLegacy]:
    'Achtung: Sie sind dabei, die Extraktion mit <bold>dem älteren Modell</bold> neu zu erzeugen. Möchten Sie bestätigen?',
  [tokens.extraction.newInterfaceToggleLabel]: 'Neue Oberfläche',
  [tokens.extraction.newInterfaceBetaBadge]: 'BETA',
  [tokens.extraction.newInterfacePlaceholder]:
    'Die neue Oberfläche wird hier in Kürze verfügbar sein.',
  [tokens.extraction.betaStepHeadersTitle]: 'Köpfe',
  [tokens.extraction.betaStepHeadersSubtitle]: 'Identifikation & Parteien',
  [tokens.extraction.betaStepArticlesTitle]: 'Artikel',
  [tokens.extraction.betaStepArticlesSubtitle]: 'Positionszeilen',
  [tokens.extraction.betaStepDeliveryTitle]: 'Lieferung & Transport',
  [tokens.extraction.betaStepDeliverySubtitle]: 'Verpackung & Gewichte',
  [tokens.extraction.betaStepRegulationTitle]: 'Regulierung & Zoll',
  [tokens.extraction.betaStepRegulationSubtitle]: 'Regime & Verfahren',
  [tokens.extraction.betaStepControlTitle]: 'Kontrolle & Versand',
  [tokens.extraction.betaStepTotalsTitle]: 'Summen',
  [tokens.extraction.betaStepControlSubtitle]: 'Fakturierung & statistischer Wert',
  [tokens.extraction.betaActionAssistant]: 'Assistent',
  [tokens.extraction.betaActionAssistantTooltip]:
    'Stellen Sie eine Frage zu dieser Anmeldung oder fordern Sie eine Feldkorrektur, einen Kommentar oder Tags an, angewendet nach Ihrer Bestätigung.',
  [tokens.extraction.betaActionSourceDocument]: 'Quelldokument',
  [tokens.extraction.betaActionSourceDocumentTooltip]:
    'Quelldokument öffnen und mit der Anmeldung vergleichen.',
  [tokens.extraction.betaActionArticlesTable]: 'Artikeltabelle',
  [tokens.extraction.betaActionStartReview]: 'Überprüfung starten',
  [tokens.extraction.betaActionStartReviewTooltip]:
    'Anomalien und Vorschläge nacheinander prüfen, mit automatischer Fokussierung auf das betreffende Feld.',
  [tokens.extraction.betaStatusCritical]: 'Kritisch',
  [tokens.extraction.betaStatusWarning]: 'Abweichungen',
  [tokens.extraction.betaStatusSuggestion]: 'Vorschläge',
  [tokens.extraction.betaReviewProgress]: '{{current}}/{{total}} {{anomalyLabel}}',
  [tokens.extraction.betaReviewCounter]: '{{current}} / {{total}}',
  [tokens.extraction.betaReviewPrevious]: 'Vorherige Anomalie',
  [tokens.extraction.betaReviewNext]: 'Nächste Anomalie',
  [tokens.extraction.betaReviewOpenTable]: 'Tabelle öffnen',
  [tokens.extraction.betaReviewVerified]: 'Verifiziert',
  [tokens.extraction.betaReviewClose]: 'Überprüfung schließen',
  [tokens.extraction.betaReviewNavigate]: 'Zum Feld',
  [tokens.extraction.betaReviewPanelTitle]: 'Deklarationsprüfung',
  [tokens.extraction.betaReviewPanelSubtitle]:
    'Beheben Sie Anomalien und prüfen Sie Vorschläge.',
  [tokens.extraction.betaReviewPanelStartReviewHint]:
    '{{count}} Anomalie nacheinander bearbeiten',
  [tokens.extraction.betaReviewPanelStartReviewHint_other]:
    'Alle {{count}} Anomalien nacheinander bearbeiten',
  [tokens.extraction.betaReviewPanelSectionBlocking]: 'EXPORT BLOCKIERT',
  [tokens.extraction.betaReviewPanelSectionToVerify]: 'ZU PRÜFEN',
  [tokens.extraction.betaReviewPanelExportBlockedFooter]:
    'Der Export ist blockiert, solange eine kritische Anomalie besteht.',
  [tokens.extraction.betaReviewPanelTabAnomalies]: 'Anomalien ({{count}})',
  [tokens.extraction.betaReviewPanelTabSuggestions]: 'Vorschläge ({{count}})',
  [tokens.extraction.betaReviewPanelNoAnomalies]: 'Keine verbleibenden Anomalien.',
  [tokens.extraction.betaReviewPanelNoSuggestions]: 'Noch keine KI-Vorschläge.',
  [tokens.extraction.betaStatusSummary]: '{{critical}} kritisch · {{warning}} Abweichungen',
  [tokens.extraction.betaStatusSuggestionCount]: '{{count}} Vorschläge',
  [tokens.extraction.betaExportBlockedTitle]: 'Kritische Anomalien zu korrigieren',
  [tokens.extraction.betaExportBlockedDescription]:
    '{{count}} kritische Inkonsistenz verhindert den Versand der Anmeldung.',
  [tokens.extraction.betaExportBlockedDescription_other]:
    '{{count}} kritische Inkonsistenzen verhindern den Versand der Anmeldung.',
  [tokens.extraction.betaExportBlockedReview]: 'Anomalien anzeigen',
  [tokens.extraction.betaExportBlockedClose]: 'Hinweis ausblenden',
  [tokens.extraction.betaSuggestionsBannerTitle]: 'KI-Vorschläge',
  [tokens.extraction.betaSuggestionsBannerSubtitle]: 'akzeptieren oder ignorieren',
  [tokens.extraction.betaSuggestionsBannerHide]: 'Ausblenden',
  [tokens.extraction.betaSuggestionAccept]: 'Akzeptieren',
  [tokens.extraction.betaSuggestionIgnore]: 'Ignorieren',
  [tokens.extraction.betaSuggestionConfidence_high]: 'Hohe Konfidenz',
  [tokens.extraction.betaSuggestionConfidence_medium]: 'Mittlere Konfidenz',
  [tokens.extraction.betaSuggestionConfidence_low]: 'Niedrige Konfidenz',
  [tokens.extraction.betaStepArticlesPlaceholder]:
    'Die Artikeltabelle wird in einem eigenen Fenster geöffnet.',
  [tokens.extraction.betaStepControlPlaceholder]:
    'Summen und Kontrollen werden hier angezeigt.',
  [tokens.extraction.betaStepEmptyContent]:
    'Für diesen Schritt ist kein Inhalt verfügbar.',
  [tokens.extraction.macroCheckAmount]: 'Betrag',
  [tokens.extraction.macroCheckPackages]: 'Anzahl Packstücke',
  [tokens.extraction.macroCheckGrossMass]: 'Rohmasse',
  [tokens.extraction.macroCheckNetMass]: 'Eigenmasse',
  [tokens.extraction.macroCheckOk]: 'OK',
  [tokens.extraction.macroCheckLineSum]: 'Summe der Artikelzeilen:',
  [tokens.extraction.macroCheckSourceUnavailable]: 'Nicht extrahiert',
  [tokens.extraction.macroCheckTooltipAmount]:
    'Vergleicht die Summe der Spalte Betrag (alle Zeilen, einschließlich Gebühren und Rabatte) mit dem in Rechnung gestellten Betrag der Rechnungen, deren Zeilen in der Tabelle stehen.',
  [tokens.extraction.macroCheckTooltipPackages]:
    'Vergleicht die auf die Zeilen verteilten Packstücke mit der auf den Dokumenten desselben Umfangs angegebenen Packstückzahl. Gebühren- und Rabattzeilen haben keine Packstücke.',
  [tokens.extraction.macroCheckTooltipGrossMass]:
    'Vergleicht die verteilte Rohmasse mit der auf den Dokumenten desselben Umfangs angegebenen Rohmasse. Gebühren- und Rabattzeilen haben keine Masse.',
  [tokens.extraction.macroCheckTooltipNetMass]:
    'Vergleicht die verteilte Eigenmasse mit der auf den Dokumenten desselben Umfangs angegebenen Eigenmasse. Gebühren- und Rabattzeilen haben keine Masse.',
  [tokens.extraction.macroCheckFilterAmount]: 'Zeilen mit Betragsabweichung',
  [tokens.extraction.macroCheckFilterPackages]: 'Zeilen ohne Packstücke',
  [tokens.extraction.macroCheckFilterNetMass]: 'Zeilen ohne Eigenmasse',
  [tokens.extraction.macroCheckFilterGrossMass]: 'Zeilen ohne Rohmasse',
  [tokens.extraction.stepDocumentWindowTitle]: 'Quelldokument',
  [tokens.extraction.stepArticlesWindowTitle]: 'Artikeltabelle',
  [tokens.extraction.stepArticlesWindowOpenHint]:
    'Die Artikeltabelle ist in einem schwebenden Fenster geöffnet.',
  [tokens.extraction.stepSourceDocumentPin]: 'Dokument an Seite anheften',
  [tokens.extraction.stepSourceDocumentUnpin]: 'Dokument lösen',
  [tokens.extraction.stepSourceDocumentFullscreen]: 'Vollbild anzeigen',
  [tokens.extraction.stepSourceDocumentOpenInOtherWindow]:
    'Quelldokument in einem anderen Fenster öffnen',
  [tokens.extraction.stepSourceDocumentOpenedInOtherWindow]:
    'Quelldokument bereits in einem anderen Fenster geöffnet',
  [tokens.extraction.stepSourceDocumentSecondScreenTitle]: 'Dokument auf Ihrem zweiten Bildschirm anzeigen',
  [tokens.extraction.stepSourceDocumentSecondScreenBody]:
    'Nabu kann das Quelldokument direkt auf Ihrem anderen Bildschirm öffnen. Ihr Browser fragt nach der Berechtigung, „Fenster auf allen Bildschirmen zu verwalten“: Stimmen Sie zu, danach werden Sie nicht mehr gefragt.',
  [tokens.extraction.stepSourceDocumentSecondScreenContinue]: 'Weiter',
  [tokens.extraction.stepSourceDocumentSecondScreenTab]: 'In einem Tab öffnen',
  [tokens.extraction.stepSourceDocumentExitFullscreen]: 'Vollbild beenden',
  [tokens.extraction.stepSourceDocumentClose]: 'Dokument schließen',
  [tokens.extraction.stepSourceDocumentResizeHandle]:
    'Quelldokument-Panel in der Breite anpassen',
  [tokens.extraction.stepSourceDocumentTextCopied]: 'Text kopiert',
  [tokens.extraction.stepSourceDocumentTextCopyFailed]: 'Text konnte nicht kopiert werden',
  [tokens.extraction.stepArticlesValuesPasted]: 'Werte eingefügt',
  [tokens.extraction.stepArticlesValuesPasteFailed]:
    'Werte konnten nicht eingefügt werden',
  [tokens.extraction.stepSourceDocumentPdfCopyHint]:
    'Bereich zum Kopieren auswählen, und fügen Sie ihn ein ({{command}}).',
  [tokens.extraction.stepSourceDocumentExcelCopyHint]:
    'Wählen Sie eine oder mehrere Zellen aus und kopieren Sie sie ({{command}}).',
  [tokens.extraction.stepAssistantWindowTitle]: 'Nabu-Assistent',
  [tokens.extraction.stepAssistantHeading]: 'Was ist bei dieser Anmeldung zu tun?',
  [tokens.extraction.stepAssistantDescription]:
    'Fragen Sie zum Vorgang: Blockaden, Summen, fehlende Felder, Herkunft eines Werts. Ich kann auch Felder korrigieren, einen Kommentar oder Tags hinzufügen, immer nach Ihrer Bestätigung.',
  [tokens.extraction.stepAssistantSuggestedActionsLabel]: 'VORSCHLÄGE',
  [tokens.extraction.stepAssistantPlaceholder]:
    'Hallo, ich bin Ihr Deklarationsassistent. Stellen Sie mir eine Frage oder wählen Sie einen Vorschlag, um mit der Erfassung fortzufahren.',
  [tokens.extraction.stepAssistantInputPlaceholder]:
    'Stellen Sie eine Frage oder fordern Sie eine Korrektur an…',
  [tokens.extraction.stepAssistantSend]: 'Senden',
  [tokens.extraction.stepAssistantAddAttachment]: 'Anhang hinzufügen',
  [tokens.extraction.stepAssistantVoiceInput]: 'Spracheingabe',
  [tokens.extraction.stepAssistantVoiceStop]: 'Diktat beenden',
  [tokens.extraction.stepAssistantVoiceTranscribing]:
    'Wird transkribiert…',
  [tokens.extraction.stepAssistantVoiceMicrophoneDenied]:
    'Das Mikrofon ist nicht verfügbar. Erlauben Sie es in Ihrem Browser.',
  [tokens.extraction.stepAssistantVoiceTooLong]:
    'Diktat zu lang: Es wurde beendet und bis dahin transkribiert.',
  [tokens.extraction.stepAssistantVoiceFailed]:
    'Das Diktat konnte nicht transkribiert werden. Bitte versuchen Sie es erneut.',
  [tokens.extraction.stepAssistantRefresh]: 'Konversation zurücksetzen',
  [tokens.extraction.stepAssistantPin]: 'Assistent an Seite anheften',
  [tokens.extraction.stepAssistantUnpin]: 'Assistent ablösen',
  [tokens.extraction.stepAssistantClose]: 'Assistent schließen',
  [tokens.extraction.stepAssistantResizeHandle]:
    'Assistenten-Panel in der Breite anpassen',
  [tokens.extraction.stepAssistantSuggestedActionBlocked]:
    'Warum ist die Deklaration blockiert?',
  [tokens.extraction.stepAssistantSuggestedActionTotals]:
    'Prüfe die Summen der Deklaration',
  [tokens.extraction.stepAssistantSuggestedActionMissing]:
    'Welche Pflichtfelder fehlen?',
  [tokens.extraction.stepAssistantSuggestedActionHistory]:
    'Fasse die Historie des Vorgangs zusammen',
  [tokens.extraction.stepAssistantSkillsLabel]: 'ANWEISUNGEN',
  [tokens.extraction.stepAssistantNoSkillsPrefix]: 'Noch keine Anweisungen.',
  [tokens.extraction.stepAssistantCreateSkill]: 'Anweisung erstellen',
  [tokens.extraction.stepAssistantAddSkill]: 'Anweisung aktivieren',
  [tokens.extraction.stepAssistantSendTooltip]: 'Senden · Enter',
  [tokens.extraction.stepAssistantRemoveSkill]: '{{name}} entfernen',
  [tokens.extraction.stepAssistantSkillsHint]: 'Aktive Anweisungen leiten den Nabu-Assistenten in Ihren nächsten Nachrichten.',
  [tokens.extraction.stepAssistantApprove]: 'Bestätigen',
  [tokens.extraction.stepAssistantDeny]: 'Ablehnen',
  [tokens.extraction.stepAssistantToolDone]: '{{action}}: ausgeführt',
  [tokens.extraction.stepAssistantToolDenied]: '{{action}}: abgelehnt',
  [tokens.extraction.stepAssistantToolFailed]: '{{action}}: fehlgeschlagen',
  [tokens.extraction.stepAssistantToolPartial]:
    '{{action}}: teilweise ausgeführt',
  [tokens.extraction.stepAssistantToolNotApplied]:
    '{{action}}: nichts geändert',
  [tokens.extraction.stepAssistantToolInProgress]: '{{action}}: läuft',
  [tokens.extraction.stepAssistantToolAddComment]:
    'Kommentar zum Dossier hinzufügen',
  [tokens.extraction.stepAssistantToolSetTags]: 'Tags des Dossiers ersetzen',
  [tokens.extraction.stepAssistantToolUpdateFields]:
    'Felder der Deklaration ändern',
  [tokens.extraction.stepAssistantToolAddLines]:
    'Positionen zur Deklaration hinzufügen',
  [tokens.extraction.stepAssistantToolGetDossier]: 'Dossier abrufen',
  [tokens.extraction.stepAssistantToolGetDossierDocuments]:
    'Dokumente des Dossiers abrufen',
  [tokens.extraction.stepAssistantToolGetDossierProgress]:
    'Fortschritt des Dossiers abrufen',
  [tokens.extraction.stepAssistantToolGetDossierHistory]:
    'Verlauf des Dossiers abrufen',
  [tokens.extraction.stepAssistantToolGetDossierErrorStatus]:
    'Fehler des Dossiers abrufen',
  [tokens.extraction.stepAssistantToolGetDeclaration]: 'Deklaration abrufen',
  [tokens.extraction.stepAssistantToolGetDeclarationValidation]:
    'Validierung der Deklaration abrufen',
  [tokens.extraction.stepAssistantToolGetDeclarationContent]:
    'Inhalt der Deklaration abrufen',
  [tokens.extraction.stepAssistantToolUnknown]: 'Assistenten-Werkzeug',
  [tokens.extraction.stepAssistantToolGetTags]: 'Tags abrufen',
  [tokens.extraction.stepAssistantToolGetDocumentFacts]:
    'Daten eines Dokuments abrufen',
  [tokens.extraction.stepAssistantToolGetPageText]: 'Text einer Seite abrufen',
  [tokens.extraction.stepAssistantToolGetSpreadsheet]:
    'Das Excel-Tabellenblatt abrufen',
  [tokens.extraction.stepAssistantToolCompareDocuments]:
    'Dokumente mit der Deklaration vergleichen',
  [tokens.extraction.stepAssistantToolGetDeclarationGestures]:
    'Verlauf der Deklaration abrufen',
  [tokens.extraction.stepAssistantToolGetExchangeRates]: 'Wechselkurse abrufen',
  [tokens.extraction.stepAssistantToolLookupCatalog]:
    'Katalogwerte abrufen',
  [tokens.extraction.stepAssistantToolGetDeclarationFields]:
    'Formularfelder abrufen',
  [tokens.extraction.stepAssistantToolExplainFieldValue]:
    'Herkunft eines Werts ermitteln',
  [tokens.extraction.stepAssistantToolFindClientHistory]:
    'Verlauf des Kunden abrufen',
  [tokens.extraction.stepAssistantToolCalculate]: 'Berechnen',
  [tokens.extraction.stepAssistantToolListInstructions]: 'Anweisungen ansehen',
  [tokens.extraction.stepAssistantToolUpdateInstructionText]: 'Text einer Anweisung ändern',
  [tokens.extraction.stepAssistantToolSetInstructionAutomatic]: 'Modus einer Anweisung ändern',
  [tokens.extraction.stepAssistantInstructionName]: 'Anweisung „{{name}}“',
  [tokens.extraction.stepAssistantInstructionTextBefore]: 'Vorher: {{text}}',
  [tokens.extraction.stepAssistantInstructionTextAfter]: 'Nachher: {{text}}',
  [tokens.extraction.stepAssistantInstructionBecomesAutomatic]: 'Wird automatisch: Sie kann in eine Routine aufgenommen werden.',
  [tokens.extraction.stepAssistantInstructionBecomesOnDemand]: 'Wird auf Abruf: Sie wird nur über den Assistenten verwendet.',
  [tokens.extraction.stepAssistantApprovalShowAll]: 'Alle anzeigen ({{count}})',
  [tokens.extraction.stepAssistantApprovalShowLess]: 'Weniger anzeigen',
  [tokens.extraction.stepAssistantWaitingForReply]:
    'Warten auf die Antwort des Assistenten',
  [tokens.extraction.stepAssistantHistoryLoadError]:
    'Der Gesprächsverlauf konnte nicht geladen werden.',
  [tokens.extraction.stepAssistantHistoryRetry]: 'Erneut versuchen',
  [tokens.extraction.stepAssistantMessageTimeYesterday]: 'Gestern, {{time}}',
  [tokens.extraction.stepAssistantMessageTimeOnDate]: '{{date}}, {{time}}',
  [tokens.extraction.stepAssistantReplyError]: 'Der Assistent konnte nicht antworten.',
  [tokens.extraction.stepAssistantQuotaReached]:
    'Ihr Kontingent für diesen Monat ist erreicht. Bitte wenden Sie sich an einen Administrator.',
  [tokens.extraction.stepAssistantDisabled]:
    'Der Nabu-Assistent ist für Ihre Organisation deaktiviert. Bitte wenden Sie sich an einen Administrator.',
  [tokens.extraction.stepAssistantThinking]: 'Der Nabu-Assistent denkt nach…',
  [tokens.extraction.stepAssistantStepsOne]: '1 Schritt',
  [tokens.extraction.stepAssistantStepsOther]: '{{count}} Schritte',
  [tokens.extraction.stepAssistantStepWrite]: 'Änderung',
  [tokens.extraction.stepFieldNotIdentified]: 'Nicht identifiziert',
  [tokens.extraction.stepControlEnter]: 'Eingeben',
  [tokens.extraction.stepControlEmptyValue]: 'Einzutragen',
  [tokens.extraction.stepControlPanelValidation]: 'Kontrolle',
  [tokens.extraction.stepControlNoIssues]: 'Keine Anomalien erkannt.',
  [tokens.extraction.stepControlSeverityCritical]: 'KRITISCH',
  [tokens.extraction.stepControlSeverityGap]: 'ABWEICHUNG',
  [tokens.extraction.stepControlAddTransportFees]: '+ Transportkosten',
  [tokens.extraction.stepControlAdditionsDeductions]: '+ Zuschlaege & Abzuege',
  [tokens.extraction.stepControlTotalsPanelInfoTooltip]:
    'Die auf den Dokumenten erfasste Summe ist massgeblich. Die Summe der Artikelzeilen muss ihr entsprechen.',
  [tokens.extraction.stepControlTotalsCardTotalOfDocument]: 'Dokumentsumme',
  [tokens.extraction.stepControlTotalsCardLineSum]: 'Summe der Artikelzeilen:',
  [tokens.extraction.stepControlTotalsCardIdentical]: 'Identisch',
  [tokens.extraction.stepControlTotalsCardToFill]: '{{count}} einzutragen',
  [tokens.extraction.stepControlTotalsCardSourceCountInvoices_one]:
    'Σ {{count}} Rechnung',
  [tokens.extraction.stepControlTotalsCardSourceCountInvoices_other]:
    'Σ {{count}} Rechnungen',
  [tokens.extraction.stepControlTotalsCardSourceCountPackingLists_one]:
    'Σ {{count}} Packliste',
  [tokens.extraction.stepControlTotalsCardSourceCountPackingLists_other]:
    'Σ {{count}} Packlisten',
  [tokens.extraction.stepControlTotalsCardSumHint]:
    'Der obige Wert addiert diese Dokumente.',
  [tokens.extraction.stepControlTotalsCardDocTypeInvoice]: 'Rechnung',
  [tokens.extraction.stepControlTotalsCardDocTypePackingList]: 'Packliste',
  [tokens.extraction.stepControlTotalsCardTooltipOk]:
    'Aus dem Quelldokument extrahiert: {{value}} {{unit}}, identisch mit der Summe der Artikelzeilen.',
  [tokens.extraction.stepControlTotalsCardTooltipGap]:
    'Aus dem Quelldokument extrahiert: {{value}} {{unit}}. Die Summe der Artikelzeilen betraegt {{lineValue}} {{unit}}.',
  [tokens.extraction.stepControlTotalsCardTooltipMissing]:
    'Kein Wert aus diesem Dokument extrahiert. Klicken, um ihn einzutragen.',

  [tokens.extractionSteps['run-export']]: 'Run export',
  [tokens.extractionSteps['start-work']]: 'Start work',
  [tokens.extractionSteps['apply-specific-data']]: 'Apply specific data',
  [tokens.extractionSteps['publishing-page-messages']]:
    'Publishing page messages',
  [tokens.extractionSteps['start-extraction']]: 'Start extraction',
  [tokens.extractionSteps['apply-post-process']]: 'Apply post-process',
  [tokens.extractionSteps['batch-import-status-to-done']]:
    'Batch import status to done',
  [tokens.extractionSteps['parsing-ocr']]: 'Parsing OCR',
  [tokens.extractionSteps['get-fast-track-option']]: 'Get fast track option',
  [tokens.extractionSteps['handle-ocr']]: 'Handle OCR',
  [tokens.extractionSteps['collecting-configurations']]:
    'Collecting configurations',
  [tokens.extractionSteps['starting-work']]: 'Starting work',
  [tokens.extractionSteps['save-export-data']]: 'Save export data',
  [tokens.extractionSteps['update-batch-import-status']]:
    'Update batch import status',
  [tokens.extractionSteps['canceled-iteration']]: 'Canceled iteration',
  [tokens.extractionSteps['classification-done']]: 'Classification done',
  [tokens.extractionSteps['saving-pages']]: 'Saving pages',
  [tokens.extractionSteps['end-validation-work']]: 'End validation work',
  [tokens.extractionSteps['end-mapping-work']]: 'End mapping work',
  [tokens.extractionSteps['start-ocr-work']]: 'Start OCR work',
  [tokens.extractionSteps['create-files-in-database']]: 'Create files ',
  [tokens.extractionSteps['generate-export']]: 'Generate export',
  [tokens.extractionSteps['start-mapping-work']]: 'Start mapping work',
  [tokens.extractionSteps['segmentation-done']]: 'Segmentation',
  [tokens.extractionSteps['apply-segmentations']]: 'Apply segmentations',
  [tokens.extractionSteps['fetching-file']]: 'Fetching file',
  [tokens.extractionSteps['deskew']]: 'Deskew',
  [tokens.flows.sender]: 'Sender',
  [tokens.flows.receiver]: 'Receiver',
  [tokens.flows.modelType]: 'Modelltyp',
  [tokens.flows.exportContext]: 'Export context',
  [tokens.segmentation.finishSegmentationStep]: 'Finish segmentation step',
  [tokens.segmentation.merge]: 'Zusammenführung',
  [tokens.segmentation.cut]: 'Cut',
  [tokens.segmentation.deletePage]: 'Delete page',
  [tokens.segmentation.keep]: 'Keep',
  [tokens.settings.noDocumentsFound]: 'No declaration found',
  [tokens.settings.docTitleProfile]: 'Profil',
  [tokens.settings.docTitleNotifications]: 'Benachrichtigungen',
  [tokens.settings.docTitleSecurity]: 'Sicherheit',
  [tokens.settings.docTitleOrg]: 'Organisation',
  [tokens.settings.docTitleFormCustomization]: 'Formulare',
  [tokens.settings.formCustomizationPageTitle]: 'Formulare',
  [tokens.settings.formCustomizationPageSubtitle]:
    'Reduzieren Sie das Import-Formular auf die Felder, die Ihre Deklaranten tatsächlich nutzen, im Wortschatz Ihrer Zollsoftware.',
  [tokens.settings.formCustomizationLoadError]:
    'Formularanpassung konnte nicht geladen werden.',
  [tokens.settings.formCustomizationMissingSchema]:
    'Für diese Organisation ist kein Import-Schema verfügbar.',
  [tokens.settings.formCustomizationConexTitle]: 'Conex',
  [tokens.settings.formCustomizationConexSubtitle]: 'Transfer In v4.0',
  [tokens.settings.formCustomizationConexDescription]:
    'Bezeichnungen im Conex-Wortschatz, Abschnitte wie in der Transfer-In-Datei, nicht übertragene Felder ausgeblendet.',
  [tokens.settings.formCustomizationAkaneaTitle]: 'Akanéa',
  [tokens.settings.formCustomizationAkaneaSubtitle]: 'Douane .NET',
  [tokens.settings.formCustomizationAkaneaDescription]:
    'Bezeichnungen im Akanéa-Wortschatz, Parteien oben, Zollblöcke am Ende der Eingabe eingeklappt.',
  [tokens.settings.formCustomizationLayoutName]: 'Disposition {{name}}',
  [tokens.settings.formCustomizationApplyLayout]: 'Dieses Modell anwenden',
  [tokens.settings.formCustomizationAppliedBadge]: 'Angewendet',
  [tokens.settings.formCustomizationStartingModel]: 'Startvorlage',
  [tokens.settings.formCustomizationStartingModelSubtitle]:
    'Richten Sie die Eingabe an Ihrer Zollsoftware aus. Sie können danach alles nach Belieben neu organisieren.',
  [tokens.settings.formCustomizationNabuModelTitle]: 'Nabu-Standardvorlage',
  [tokens.settings.formCustomizationNabuModelSubtitle]:
    'Alle Import-Schemafelder, in Nabu-Reihenfolge und -Wortschatz.',
  [tokens.settings.formCustomizationResetNabu]: 'Auf Standard zurücksetzen',
  [tokens.settings.formCustomizationTabsContent]: 'Inhalt der Registerkarten',
  [tokens.settings.formCustomizationCollapseAll]: 'Alle zuklappen',
  [tokens.settings.formCustomizationExpandAll]: 'Alle aufklappen',
  [tokens.settings.formCustomizationEdit]: 'Bearbeiten',
  [tokens.settings.formCustomizationTabTitleLabel]: 'Registerkartentitel',
  [tokens.settings.formCustomizationAddFieldAction]: 'Hinzufügen',
  [tokens.settings.formCustomizationApplyConfirm]:
    'Dieses Layout ersetzt die aktuelle Anpassung (Bezeichnungen, Reihenfolge, Sichtbarkeit, Pflichtfelder). Fortfahren?',
  [tokens.settings.formCustomizationApplyModalTitle]:
    'Layout {{name}} (alle drei Registerkarten)',
  [tokens.settings.formCustomizationApplyModalConfirm]: 'Layout anwenden',
  [tokens.settings.formCustomizationResetConfirm]:
    'Das ursprüngliche Nabu-Formular wird wiederhergestellt. Fortfahren?',
  [tokens.settings.formCustomizationTabHeaders]: 'Köpfe',
  [tokens.settings.formCustomizationTabDelivery]: 'Lieferung & Transport',
  [tokens.settings.formCustomizationTabRegulation]: 'Regulierung & Zoll',
  [tokens.settings.formCustomizationVisibleSections]:
    '{{count}} sichtbare(r) Abschnitt(e)',
  [tokens.settings.formCustomizationRenameTab]: 'Tab umbenennen',
  [tokens.settings.formCustomizationSearchPlaceholder]: 'Feld suchen...',
  [tokens.settings.formCustomizationFilterVisibility]: 'Sichtbarkeit',
  [tokens.settings.formCustomizationFilterRequired]: 'Pflicht',
  [tokens.settings.formCustomizationFilterAll]: 'Alle',
  [tokens.settings.formCustomizationFilterVisible]: 'Sichtbar',
  [tokens.settings.formCustomizationFilterHidden]: 'Ausgeblendet',
  [tokens.settings.formCustomizationFilterRequiredOnly]: 'Pflicht',
  [tokens.settings.formCustomizationFilterOptional]: 'Optional',
  [tokens.settings.formCustomizationShowRequiredBadge]: 'Hinweis REQUIS',
  [tokens.settings.formCustomizationPreview]: 'Vorschau',
  [tokens.settings.formCustomizationFieldsCount]: '{{visible}}/{{total}} Felder',
  [tokens.settings.formCustomizationMoveSection]: 'Verschieben nach',
  [tokens.settings.formCustomizationSection]: 'Abschnitt',
  [tokens.settings.formCustomizationMoveField]: 'Verschieben nach',
  [tokens.settings.formCustomizationAddField]:
    '+ Feld aus dem Datenmodell hinzufügen...',
  [tokens.settings.formCustomizationRequired]: 'Pflicht',
  [tokens.settings.formCustomizationDefaultValue]: 'Standardwert',
  [tokens.settings.formCustomizationBehavior]: 'Verhalten',
  [tokens.settings.formCustomizationBehaviorPrefilled]:
    'Vorausgefüllt, bearbeitbar',
  [tokens.settings.formCustomizationBehaviorLocked]: 'Gesperrt',
  [tokens.settings.formCustomizationBehaviorSuggested]: 'Vorgeschlagen',
  [tokens.settings.formCustomizationDuplicate]: 'Duplizieren',
  [tokens.settings.formCustomizationRemove]: 'Entfernen',
  [tokens.settings.formCustomizationHide]: 'Ausblenden',
  [tokens.settings.formCustomizationShow]: 'Anzeigen',
  [tokens.settings.formCustomizationRequiredBadge]: 'PFLICHT',
  [tokens.settings.formCustomizationPreviewSelectPlaceholder]: 'Auswählen…',
  [tokens.settings.formCustomizationLockedBadge]: 'Gesperrt',
  [tokens.settings.formCustomizationSuggestedHint]: 'Vorschlag: {{value}}',
  [tokens.settings.settingsUnsavedChanges]: 'Nicht gespeicherte Änderungen',
  [tokens.settings.settingsLeaveUnsavedTitle]: 'Ohne Speichern verlassen?',
  [tokens.settings.settingsLeaveUnsavedMessage]:
    'Ihre Änderungen wurden nicht gespeichert. Wenn Sie diese Seite verlassen, gehen sie verloren.',
  [tokens.settings.settingsLeaveUnsavedConfirm]: 'Ohne Speichern verlassen',
  [tokens.settings.formCustomizationSaved]: 'Anpassung gespeichert',
  [tokens.settings.formCustomizationSaveError]:
    'Anpassung konnte nicht gespeichert werden.',
  [tokens.settings.formCustomizationAnomalyHiddenRequired]:
    '{{count}} Pflichtfeld(er) ausgeblendet: Der Versand wird ohne Wert blockiert',
  [tokens.settings.formCustomizationAnomalyEmptySection]:
    'Sichtbarer Abschnitt ohne angezeigtes Feld',
  [tokens.settings.formCustomizationAnomalyLockedNoDefault]:
    'Gesperrtes Feld ohne Standardwert',
  [tokens.settings.formCustomizationNoSections]:
    'Kein Abschnitt entspricht den Filtern.',
  [tokens.settings.docTitleAgencies]: 'Agenturen',
  [tokens.settings.docTitleAgencyDetail]: 'Agentur',
  [tokens.settings.docTitleMembers]: 'Benutzer',
  [tokens.settings.docTitleMemberDetail]: 'Benutzer',
  [tokens.settings.docTitleRoles]: 'Rollen und Berechtigungen',
  [tokens.settings.docTitleEmailTemplates]: 'E-Mail-Vorlagen',
  [tokens.settings.docTitleHelp]: 'Hilfe-Center',
  [tokens.settings.docTitleAiAgents]: 'Nabu-Assistent',
  [tokens.settings.sidebarKicker]: 'Einstellungen',
  [tokens.settings.back]: 'Zurück',
  [tokens.settings.groupYourAccount]: 'Ihr Konto',
  [tokens.settings.groupOrganization]: 'Organisation',
  [tokens.settings.groupModules]: 'Module',
  [tokens.settings.groupSupport]: 'Support',
  [tokens.settings.navProfile]: 'Profil',
  [tokens.settings.navNotifications]: 'Benachrichtigungen',
  [tokens.settings.navSecurity]: 'Sicherheit',
  [tokens.settings.navOrganization]: 'Organisation',
  [tokens.settings.navAgencies]: 'Agenturen',
  [tokens.settings.navMembers]: 'Benutzer',
  [tokens.settings.navFormCustomization]: 'Formulare',
  [tokens.settings.navRoles]: 'Rollen und Berechtigungen',
  [tokens.settings.navEmailTemplates]: 'E-Mail-Vorlagen',
  [tokens.settings.navAiAgents]: 'Nabu-Assistent',
  [tokens.settings.navHelpCenter]: 'Hilfe-Center',
  [tokens.settings.helpBoxTitle]: 'Brauchen Sie Hilfe?',
  [tokens.settings.helpBoxBody]:
    'Lesen Sie die Nabu-Dokumentation oder kontaktieren Sie den Support.',
  [tokens.settings.helpDocumentationLink]: 'Dokumentation',
  [tokens.settings.aiAgentsPageTitle]: 'Nabu-Assistent',
  [tokens.settings.aiAgentsPageSubtitle]:
    'Die Anweisungen, die der Nabu-Assistent für Ihre Organisation anwendet.',
  [tokens.settings.aiAgentsLoadError]:
    'KI-Einstellungen konnten derzeit nicht geladen werden.',
  [tokens.settings.aiAgentsSkillsSectionTitle]: 'Anweisungen',
  [tokens.settings.aiAgentsSkillsSectionDescription]:
    'Definieren Sie Arbeitsmethoden. Der Nabu-Assistent nutzt sie für Antworten und Aktionen.',
  [tokens.settings.aiAgentsNewSkillButton]: 'Neue Anweisung',
  [tokens.settings.aiAgentsCreateFirstSkillButton]: 'Meine erste Anweisung erstellen',
  [tokens.settings.aiAgentsSkillsEmptyTitle]: 'Keine Anweisung definiert',
  [tokens.settings.aiAgentsSkillsEmptyDescription]:
    'Fügen Sie Ihre ersten Arbeitsmethoden hinzu, damit der Nabu-Assistent sie nutzen kann.',
  [tokens.settings.aiAgentsCreateSkillTitle]: 'Neue Anweisung',
  [tokens.settings.aiAgentsCreateSkillSubtitle]: 'Der Nabu-Assistent wendet diese Methode an, wenn Sie sie in einer Unterhaltung aktivieren.',
  [tokens.settings.aiAgentsEditSkillTitle]: 'Anweisung bearbeiten',
  [tokens.settings.aiAgentsSkillNameLabel]: 'Name der Anweisung',
  [tokens.settings.aiAgentsSkillNameRequired]: 'Der Name der Anweisung ist erforderlich',
  [tokens.settings.aiAgentsSkillDescriptionLabel]: 'Beschreibung',
  [tokens.settings.aiAgentsSkillDescriptionPlaceholder]: 'Wofür ist diese Anweisung?',
  [tokens.settings.aiAgentsSkillIconLabel]: 'Symbol',
  [tokens.settings.aiAgentsSkillWorkMethodLabel]: 'Arbeitsmethode',
  [tokens.settings.aiAgentsSkillWorkMethodPlaceholder]:
    'Beschreiben Sie Schritt für Schritt, wie der Nabu-Assistent vorgehen soll…',
  [tokens.settings.aiAgentsSkillWorkMethodTooltip]:
    'Beschreiben Sie das Vorgehen Schritt für Schritt: je genauer, desto zuverlässiger ist der Nabu-Assistent. Z. B. Zolltarifnummer prüfen, Gewichte und statistischen Wert abgleichen.',
  [tokens.settings.aiAgentsCreateSkillSubmit]: 'Anweisung erstellen',
  [tokens.settings.aiAgentsDeleteSkillTitle]: 'Anweisung löschen',
  [tokens.settings.aiAgentsDeleteSkillDescription]:
    'Möchten Sie die Anweisung „{{name}}“ wirklich löschen?',
  [tokens.settings.aiAgentsSkillNabuBadge]: 'Nabu',
  [tokens.settings.aiAgentsSkillNabuTooltip]:
    'Von Nabu bereitgestellt: im Chat nutzbar, nicht bearbeitbar.',
  [tokens.settings.aiAgentsSkillDecTypesLabel]: 'Deklarationstypen',
  [tokens.settings.aiAgentsSkillDecTypesHelper]:
    'Keiner ausgewählt: Die Anweisung gilt für alle Deklarationstypen.',
  [tokens.settings.aiAgentsSkillDecTypesAll]: 'Alle Deklarationstypen',
  [tokens.settings.aiAgentsSkillAutomaticLabel]: 'Automatisch',
  [tokens.settings.aiAgentsSkillAutomaticHelper]:
    'Eine automatische Anweisung kann Teil einer Routine werden. Sonst wird sie nur über den Assistenten genutzt.',
  [tokens.settings.aiAgentsSkillAutomaticBadge]: 'Auto',
  [tokens.settings.aiAgentsRoutinesSectionTitle]: 'Routinen',
  [tokens.settings.aiAgentsRoutinesSectionDescription]: 'Eine Routine wendet automatische Anweisungen der Reihe nach auf die Anmeldungen eines Kunden und eines Typs an, direkt nach der intelligenten Vorbereitung.',
  [tokens.settings.aiAgentsNewRoutineButton]: 'Neue Routine',
  [tokens.settings.aiAgentsRoutinesEmptyTitle]: 'Noch keine Routine',
  [tokens.settings.aiAgentsRoutinesEmptyDescription]: 'Erstellen Sie eine Routine, um Ihre automatischen Anweisungen auf jede Anmeldung eines Kunden anzuwenden.',
  [tokens.settings.aiAgentsRoutinesLoadError]: 'Routinen können gerade nicht geladen werden.',
  [tokens.settings.aiAgentsCreateRoutineTitle]: 'Neue Routine',
  [tokens.settings.aiAgentsEditRoutineTitle]: 'Routine bearbeiten',
  [tokens.settings.aiAgentsRoutineSubtitle]: 'Ihre Anweisungen werden der Reihe nach angewendet, nach der intelligenten Vorbereitung und bevor die Anmeldung angezeigt wird.',
  [tokens.settings.aiAgentsRoutineNameLabel]: 'Name der Routine',
  [tokens.settings.aiAgentsRoutineClientLabel]: 'Kunde',
  [tokens.settings.aiAgentsRoutineClientHelper]: 'Leer: Die Routine gilt für alle Kunden.',
  [tokens.settings.aiAgentsRoutineAllClients]: 'Alle Kunden',
  [tokens.settings.aiAgentsRoutineDecTypeLabel]: 'Deklarationstyp',
  [tokens.settings.aiAgentsRoutineInstructionsLabel]: 'Anweisungen',
  [tokens.settings.aiAgentsRoutineInstructionsHelper]: 'Nur automatische Anweisungen können in eine Routine aufgenommen werden. Ziehen Sie sie, um die Reihenfolge zu ändern.',
  [tokens.settings.aiAgentsRoutineAddInstruction]: 'Anweisung hinzufügen',
  [tokens.settings.aiAgentsRoutineNoInstructionLeft]: 'Keine weitere automatische Anweisung gilt für diesen Typ.',
  [tokens.settings.aiAgentsRoutineInstructionOtherType]: 'Gilt nicht für diesen Deklarationstyp: bitte entfernen.',
  [tokens.settings.aiAgentsRoutineInstructionUnavailable]: 'Nicht mehr verfügbar: bitte entfernen.',
  [tokens.settings.aiAgentsRoutineDragInstruction]: '„{{name}}“ verschieben',
  [tokens.settings.aiAgentsRoutineRemoveInstruction]: 'Aus der Routine entfernen',
  [tokens.settings.aiAgentsRoutineInstructionsCount]: '{{count}} Anweisung',
  [tokens.settings.aiAgentsRoutineInstructionsCount_other]: '{{count}} Anweisungen',
  [tokens.settings.aiAgentsRoutineActive]: 'Aktiv',
  [tokens.settings.aiAgentsRoutineInactive]: 'Inaktiv',
  [tokens.settings.aiAgentsCreateRoutineSubmit]: 'Routine erstellen',
  [tokens.settings.aiAgentsDeleteRoutineTitle]: 'Routine löschen',
  [tokens.settings.aiAgentsDeleteRoutineDescription]: 'Möchten Sie die Routine „{{name}}“ wirklich löschen? Ihre Anweisungen bleiben erhalten.',
  [tokens.settings.aiAgentsToastRoutineCreated]: 'Routine erstellt',
  [tokens.settings.aiAgentsToastRoutineUpdated]: 'Routine aktualisiert',
  [tokens.settings.aiAgentsToastRoutineDeleted]: 'Routine gelöscht',
  [tokens.settings.aiAgentsRoutineConditionsTaken]: 'Die Routine „{{names}}“ gilt bereits für diesen Kunden und diesen Typ: Deaktivieren Sie sie oder wählen Sie einen anderen Kunden oder Typ.',
  [tokens.settings.aiAgentsToastSkillInRoutine]: 'Entfernen Sie diese Anweisung zuerst aus ihren Routinen: {{names}}.',
  [tokens.settings.aiAgentsBlockedByNabu]: 'Von Nabu gesperrt',
  [tokens.settings.aiAgentsBlockedByNabuTooltip]: 'Von Nabu gesperrt: wird nicht mehr angewendet. Wenden Sie sich an den Support, um die Sperre aufzuheben.',
  [tokens.settings.aiAgentsToastBlockedByNabu]: 'Von Nabu gesperrt: Wenden Sie sich an den Support, um sie zu ändern.',
  [tokens.settings.aiAgentsSkillScopeLabel]: 'Geltungsbereich',
  [tokens.settings.aiAgentsSkillScopeHelper]:
    'Eine Agentur-Anweisung gilt für die Agentur und, wenn Sie sie einschließen, für ihre Unteragenturen; andere Agenturen sehen sie nicht.',
  [tokens.settings.aiAgentsSkillAgencySubAgencies]: 'und ihre Unteragenturen',
  [tokens.settings.aiAgentsSkillIconBook]: 'Buch',
  [tokens.settings.aiAgentsSkillIconLightning]: 'Blitz',
  [tokens.settings.aiAgentsSkillIconGrid]: 'Raster',
  [tokens.settings.aiAgentsSkillIconDocument]: 'Dokument',
  [tokens.settings.aiAgentsSkillIconSearch]: 'Suche',
  [tokens.settings.aiAgentsSkillIconLayers]: 'Ebenen',
  [tokens.settings.aiAgentsSkillIconShield]: 'Schild',
  [tokens.settings.aiAgentsSkillIconShuffle]: 'Mischen',
  [tokens.settings.aiAgentsToastSkillCreated]: 'Anweisung erstellt',
  [tokens.settings.aiAgentsToastSkillUpdated]: 'Anweisung aktualisiert',
  [tokens.settings.aiAgentsToastSkillDeleted]: 'Anweisung gelöscht',
  [tokens.settings.aiAgentsToastSaveError]: 'Speichern fehlgeschlagen',
  [tokens.settings.previewNoticeLocalOnly]:
    'Diese Schalter werden nur in dieser Sitzung gespeichert. Die serverseitige Speicherung folgt in einer späteren Version.',
  [tokens.settings.previewNoticeInviteSoon]:
    'Das Einladen von Benutzern über diesen Bildschirm ist noch nicht möglich.',
  [tokens.settings.previewNoticeAgencyCreateSoon]:
    'Das Anlegen einer Agentur über diesen Bildschirm ist noch nicht möglich.',
  [tokens.settings.previewNoticeRolesReadOnly]:
    'Die Berechtigungsmatrix ist nur informativ; die Bearbeitung folgt mit einer eigenen API.',
  [tokens.settings.previewNoticeEmailTemplatesSoon]:
    'Das Bearbeiten von E-Mail-Vorlagen ist noch nicht möglich.',
  [tokens.settings.previewNoticeHelpLinksSoon]:
    'Hilfe- und Kontaktlinks werden bald bereitgestellt.',
  [tokens.settings.previewNoticeOrgConfigDemo]:
    'Dieses Tab zeigt die Feldstruktur; Speichern ändert noch keine Organisationsparameter auf dem Server.',
  [tokens.settings.orgConfigDemoSaved]:
    'Lokal gespeichert (Vorschau, nicht mit dem Server synchronisiert).',
  [tokens.settings.profilePageTitle]: 'Mein Konto',
  [tokens.settings.profilePageSubtitle]:
    'Verwalten Sie persönliche Daten, Einstellungen und Deklarationskonfiguration.',
  [tokens.settings.profileSectionPersonal]: 'Persönliche Informationen',
  [tokens.settings.profileSectionPersonalSubtitle]:
    'Diese Informationen sind für andere Nutzer Ihrer Organisation sichtbar.',
  [tokens.settings.profileSectionPrefs]: 'Sprache & Design',
  [tokens.settings.profileSectionPrefsSubtitle]:
    'Sprache und Erscheinungsbild.',
  [tokens.settings.profileSectionDeclaration]: 'Deklarationskonfiguration',
  [tokens.settings.profileTabGeneral]: 'Allgemein',
  [tokens.settings.profileTabPreferences]: 'Einstellungen',
  [tokens.settings.profileTabConfiguration]: 'Konfiguration',
  [tokens.settings.profilePreferencesInterface]: 'Oberfläche',
  [tokens.settings.profilePreferencesPreparation]: 'Anmeldungsvorbereitung',
  [tokens.settings.profilePreferencesPreparationClassic]: 'Klassische Vorbereitung',
  [tokens.settings.profilePreferencesPreparationIntelligent]: 'Intelligente Vorbereitung',
  [tokens.settings.profilePreferencesBetaViews]:
    'Layout der Beta-Oberfläche - Intelligente Vorbereitung',
  [tokens.settings.profilePreferencesBetaViewsSubtitle]:
    'Diese Layout-Einstellungen gelten nur für die Beta-Oberfläche, beim Öffnen jeder Anmeldung in der intelligenten Vorbereitung.',
  [tokens.settings.profilePreferencesSmartView]: 'Bevorzugte Ansicht - Intelligente Vorbereitung',
  [tokens.settings.profilePreferencesSmartViewSubtitle]:
    'Version der Oberfläche und Layout beim Öffnen jeder Anmeldung in der intelligenten Vorbereitung.',
  [tokens.settings.profilePreferencesSourceDocument]: 'Quelldokument',
  [tokens.settings.profilePreferencesSourceDocumentDesc]:
    'Fenster zum Lesen der Dokumente der Anmeldung.',
  [tokens.settings.profilePreferencesControlPanel]: 'Prüfungen',
  [tokens.settings.profilePreferencesControlPanelDesc]:
    'Abweichungen, Anomalien und Informationen vor dem Versand.',
  [tokens.settings.profilePreferencesAssistant]: 'Nabu-Assistent',
  [tokens.settings.profilePreferencesAssistantDesc]:
    'Chat mit dem Nabu-Assistenten im Editor.',
  [tokens.settings.profilePreferencesHomeTab]: 'Startregister',
  [tokens.settings.profilePreferencesHomeTabDesc]:
    'Register, das beim Öffnen einer Anmeldung angezeigt wird.',
  [tokens.settings.profilePreferencesLoadState]: 'Zustand beim Laden',
  [tokens.settings.profilePreferencesPlacementHidden]: 'Geschlossen (Standard)',
  [tokens.settings.profilePreferencesPlacementFloating]: 'Schwebendes Fenster',
  [tokens.settings.profilePreferencesPlacementLeft]: 'Links angeheftet',
  [tokens.settings.profilePreferencesPlacementRight]: 'Rechts angeheftet',
  [tokens.settings.profileSectionWorkMode]: 'Arbeitsmodus',
  [tokens.settings.profileSectionWorkModeSubtitle]: 'Methode der Anmeldungsvorbereitung.',
  [tokens.settings.profilePreferencesPreparationClassicDesc]:
    'Manuelle Erfassung und Prüfung der Felder der Zollanmeldung.',
  [tokens.settings.profilePreferencesPreparationIntelligentDesc]:
    'Nabu AI füllt die Zollanmeldung anhand der beigefügten Dokumente vor.',
  [tokens.settings.profilePreferencesInterfaceStandard]: 'Standardoberfläche',
  [tokens.settings.profilePreferencesInterfaceBeta]: 'Oberfläche',
  [tokens.settings.profilePreferencesInterfaceStandardDesc]: 'Aktuelle Oberfläche.',
  [tokens.settings.profilePreferencesInterfaceBetaDesc]:
    'Früher Zugang zu neuen Funktionen. Wählen Sie das Layout unten.',
  [tokens.settings.profilePreferencesBetaBadge]: 'BETA',
  [tokens.settings.profilePreferencesPlacementClosed]: 'Geschlossen',
  [tokens.settings.profilePreferencesDefaultTab]: 'Standardregister',
  [tokens.settings.profilePreferencesSaved]: 'Einstellungen gespeichert',
  [tokens.settings.profileUserConfigCardTitle]: 'Meine Konfiguration',
  [tokens.settings.profileUserConfigCardSubtitle]:
    'Von der Organisationskonfiguration übernommene Werte. Deaktivieren Sie den Schalter oben, um sie zu überschreiben.',
  [tokens.settings.profileUserConfigInheritanceTitle]:
    'Organisationskonfiguration beibehalten',
  [tokens.settings.profileUserConfigInheritanceDescription]:
    'Ihre Deklarationen verwenden die auf Organisationsebene festgelegten Werte. Deaktivieren Sie die Option, um einzelne Felder für Ihr Konto zu überschreiben.',
  [tokens.settings.profileEmailLabel]: 'E-Mail-Adresse',
  [tokens.settings.themeLabel]: 'Design',
  [tokens.settings.themeLight]: 'Hell',
  [tokens.settings.themeLightDesc]: 'Weißer Hintergrund, helle Oberfläche',
  [tokens.settings.themeDark]: 'Dunkel',
  [tokens.settings.themeDarkDesc]:
    'Dunkler Hintergrund, augenschonender abends',
  [tokens.settings.themeSystem]: 'System',
  [tokens.settings.themeSystemDesc]:
    'Orientiert sich an den Geräteeinstellungen',
  [tokens.settings.toastProfileUpdated]: 'Profil aktualisiert',
  [tokens.settings.toastProfileError]: 'Ein Fehler ist aufgetreten',
  [tokens.settings.validationRequired]: 'Erforderlich',
  [tokens.settings.notificationsPageTitle]: 'Benachrichtigungen',
  [tokens.settings.notificationsPageSubtitle]:
    'Legen Sie fest, wann und wie Nabu Sie kontaktiert.',
  [tokens.settings.notificationsSectionEmail]: 'E-Mail',
  [tokens.settings.notificationsMasterTitle]: 'Alle E-Mail-Benachrichtigungen',
  [tokens.settings.notificationsMasterDesc]:
    'Alle unten aufgeführten Hinweise auf einmal aktivieren oder deaktivieren.',
  [tokens.settings.notifAck]: 'Eingangsbestätigung',
  [tokens.settings.notifAckDesc]:
    'Sobald eine Deklaration von der Zollbehörde übernommen wird.',
  [tokens.settings.notifFinalized]: 'Abschluss',
  [tokens.settings.notifFinalizedDesc]:
    'Wenn eine Deklaration abgeschlossen ist.',
  [tokens.settings.notifDeclErr]: 'Deklarationsfehler',
  [tokens.settings.notifDeclErrDesc]: 'Ablehnung oder administrative Anomalie.',
  [tokens.settings.notifPipelineErr]: 'Pipeline-Fehler',
  [tokens.settings.notifPipelineErrDesc]:
    'Fehler bei der Übernahme oder Verarbeitung.',
  [tokens.settings.notifMasterStateAllOn]:
    'Alle unten aufgeführten Benachrichtigungen sind aktiv.',
  [tokens.settings.notifMasterStatePartial]:
    'Einige Benachrichtigungen sind deaktiviert. Aktivieren Sie alle mit einem Klick.',
  [tokens.settings.notifMasterStateAllOff]:
    'Alle Benachrichtigungen sind deaktiviert.',
  [tokens.settings.notifPipelineRowTitle]:
    'Fehleralarm (pipeline_file_error, manual_file_error)',
  [tokens.settings.notifPipelineRowDesc]:
    'Benachrichtigung bei fehlgeschlagener automatischer Übernahme oder manueller Dateiverarbeitung.',
  [tokens.settings.securityPageTitle]: 'Sicherheit',
  [tokens.settings.securityPageSubtitle]:
    'Schützen Sie Ihr Konto und steuern Sie den Zugriff.',
  [tokens.settings.securitySectionPasswordSubtitle]:
    'Ändern Sie Ihr Passwort. Verwenden Sie 8 bis 16 Zeichen mit Groß- und Kleinbuchstaben, Ziffern und Sonderzeichen.',
  [tokens.settings.securityPasswordAside]:
    'Wählen Sie aus Sicherheitsgründen ein langes, einzigartiges Passwort aus Buchstaben, Zahlen und Sonderzeichen. Nabu speichert Ihr Passwort niemals im Klartext.',
  [tokens.settings.securityUpdatePasswordButton]: 'Passwort aktualisieren',
  [tokens.settings.orgPageTitle]: 'Organisation',
  [tokens.settings.orgPageSubtitle]:
    'Allgemeine Einstellungen, Konfiguration und Automatisierungen Ihrer Organisation.',
  [tokens.settings.orgTabGeneral]: 'Allgemein',
  [tokens.settings.orgTabConfiguration]: 'Konfiguration',
  [tokens.settings.orgTabPreferences]: 'Präferenzen',
  [tokens.settings.orgGeneralTitle]: 'Allgemeine Informationen',
  [tokens.settings.orgGeneralSubtitle]:
    'Informationen zu Ihrer Organisation auf Nabu.',
  [tokens.settings.orgFieldOrgName]: 'Name der Organisation',
  [tokens.settings.orgFieldIdentifier]: 'Kennung',
  [tokens.settings.orgLoading]: 'Wird geladen…',
  [tokens.settings.orgSaveDisabledHint]:
    'Die Umbenennung der Organisation erfolgt über den Nabu-Support.',
  [tokens.settings.orgConfigChooseAgency]: 'Agentur wählen',
  [tokens.settings.orgConfigChooseConfig]: 'Konfiguration wählen',
  [tokens.settings.orgConfigPlaceholder]:
    'Bitte Agentur und Konfiguration wählen',
  [tokens.settings.orgConfigSectionTitle]: 'Organisationskonfiguration',
  [tokens.settings.orgConfigSectionSubtitle]:
    'Tragen Sie hier die Standardwerte für diese Konfiguration ein. Sie können fallweise in jeder Anmeldung angepasst werden.',
  [tokens.settings.orgPreferencesCardTitle]: 'Präferenzen',
  [tokens.settings.orgPreferencesCardSubtitle]:
    'Regeln, die für die gesamte Organisation gelten.',
  [tokens.settings.orgPreferencesLimitAgencyLabel]:
    'Nutzer auf die Kundenakten ihrer Agentur beschränken',
  [tokens.settings.orgPreferencesLimitAgencyDescription]:
    'Ist diese Option aktiviert, kann ein Nutzer nur auf die Akten der seiner Agentur zugeordneten Kunden zugreifen. Ohne diese Einschränkung hat er je nach Rolle Zugriff auf alle Akten der Organisation.',
  [tokens.settings.agenciesPageTitle]: 'Agenturen',
  [tokens.settings.agenciesPageSubtitle]:
    'Einheiten Ihrer Organisation. Jede Agentur bündelt Nutzer, Konfigurationen und Automatisierungen.',
  [tokens.settings.agenciesChipAllLabel]: 'Alle Agenturen',
  [tokens.settings.agenciesNewButton]: 'Neue Agentur',
  [tokens.settings.agenciesSearchPlaceholder]: 'Agentur suchen…',
  [tokens.settings.agenciesLoading]: 'Wird geladen…',
  [tokens.settings.agenciesEmpty]: 'Keine Agenturen gefunden.',
  [tokens.settings.agenciesEmptySearch]:
    'Keine Agenturen entsprechen der Suche.',
  [tokens.settings.agenciesEmptyOrgOnlyHint]:
    'Ihre Organisation hat noch keine untergeordneten Agenturen. Deklarationskonfigurationen und E-Mail-Adressen für die Eingabe verwalten Sie auf Organisationsebene.',
  [tokens.settings.agenciesEmptyOrgConfigurationLink]:
    'Organisationskonfiguration öffnen',
  [tokens.settings.agenciesEmptyOrgEmailLink]: 'Eingabe-E-Mails öffnen',
  [tokens.settings.agenciesMembersLabel]: 'Benutzer',
  [tokens.settings.agenciesColType]: 'Typ',
  [tokens.settings.agenciesColAgency]: 'Agentur',
  [tokens.settings.agenciesColMembers]: 'Benutzer',
  [tokens.settings.agenciesColAdministrator]: 'Administrator',
  [tokens.settings.agenciesAdministratorLabel]: 'Administrator',
  [tokens.settings.agenciesAdministratorUnassigned]: 'Nicht zugewiesen',
  [tokens.settings.agenciesInfoPopoverTitle]:
    'Warum in Agenturen strukturieren?',
  [tokens.settings.agenciesInfoPopoverBody]:
    'Eine Agentur trennt Zollkonfigurationen, Nutzer und Vorgänge eines Standorts oder einer Rechtseinheit. Sinnvoll bei mehreren Büros oder Marken unter einem Nabu-Konto.',
  [tokens.settings.agenciesInfoHelpLink]: 'Mehr im Hilfe-Center',
  [tokens.settings.agenciesViewGrid]: 'Rasteransicht',
  [tokens.settings.agenciesViewList]: 'Listenansicht',
  [tokens.settings.agenciesAttachedTo]: 'Zugeordnet zu {{name}}',
  [tokens.settings.agenciesAttachedToUnknown]:
    'Zugeordnet zu einer übergeordneten Agentur',
  [tokens.settings.agenciesChildBadge]: 'Unteragentur',
  [tokens.settings.agenciesChildTooltip]: 'Mutteragentur: {{name}}',
  [tokens.settings.agenciesTypeService]: 'Service',
  [tokens.settings.agenciesTypeTeam]: 'Team',
  [tokens.settings.agenciesTypeOffice]: 'Büro',
  [tokens.settings.agenciesTypeOrganization]: 'Organisation',
  [tokens.settings.agenciesTypeUndefined]: 'Nicht definiert',
  [tokens.settings.agencyDetailBackToList]: 'Zurück zu den Agenturen',
  [tokens.settings.agencyDetailSubtitleLead]: 'Agentur von',
  [tokens.settings.agencyDetailTabGeneral]: 'Allgemein',
  [tokens.settings.agencyDetailTabMembers]: 'Benutzer',
  [tokens.settings.agencyDetailTabClients]: 'Kunden',
  [tokens.settings.agencyDetailTabConfiguration]: 'Konfiguration',
  [tokens.settings.agencyDetailTabEmail]: 'Posteingänge',
  [tokens.settings.agencyDetailTabTableAutomations]:
    'Tabellen-Automatisierungen',
  [tokens.settings.agencyDetailTabApi]: 'API-Verwaltung',
  [tokens.settings.agencyDetailTabMetrics]: 'Kennzahlen',
  [tokens.settings.agencyDetailGeneralIntro]:
    'Grundlegende Agenturinformationen. Sie erscheinen in Anmeldungen und administrativen Vorgängen.',
  [tokens.settings.agencyDetailLegalNameLabel]: 'Firmenname',
  [tokens.settings.agencyDetailLegalNameRequired]:
    'Firmenname ist erforderlich',
  [tokens.settings.agencyDetailSaveSuccess]: 'Agentur aktualisiert',
  [tokens.settings.agencyDetailSettingsKeysInfo]:
    'Die hier gewählten Integrationseinstellungen gelten für diese Agentur.',
  [tokens.settings.agencyDetailConfigSectionTitle]: 'Konfiguration',
  [tokens.settings.agencyDetailConfigSectionSubtitle]:
    'Konfigurationseinstellungen zu Anmeldungen für diese Agentur.',
  [tokens.settings.agencyDetailMembersCountLine]:
    '{{count}} Benutzer sind dieser Agentur zugeordnet.',
  [tokens.settings.agencyDetailRoleOwnerBadge]: 'Inhaber',
  [tokens.settings.membersPageTitle]: 'Benutzer',
  [tokens.settings.membersPageSubtitle]:
    'Alle Benutzer der Organisation, ihre Rollen und Agenturzuordnungen.',
  [tokens.settings.membersInvite]: 'Einladen',
  [tokens.settings.membersSearchPlaceholder]: 'Benutzer suchen…',
  [tokens.settings.membersLoading]: 'Wird geladen…',
  [tokens.settings.membersEmpty]: 'Keine Benutzer gefunden',
  [tokens.settings.membersColUser]: 'Benutzer',
  [tokens.settings.membersColEmail]: 'E-Mail',
  [tokens.settings.membersColRole]: 'Rolle',
  [tokens.settings.membersYouBadge]: 'Sie',
  [tokens.settings.membersInfoPopoverTitle]: 'Hinweise zu Benutzern',
  [tokens.settings.membersInfoPopoverBody]:
    'Verwalten Sie Benutzer Ihrer Organisation. Laden Sie Kollegen ein, weisen Sie Rollen zu und verknüpfen Sie sie mit einer oder mehreren Agenturen. Benutzer sehen nur Vorgänge ihrer Agenturen.',
  [tokens.settings.membersSeatSummary]:
    '{{used}} / {{max}} Plätze genutzt · {{plan}}',
  [tokens.settings.membersSeatLimitHint]:
    'Limit erreicht: Deaktivieren Sie einen Benutzer oder erweitern Sie Ihren Plan.',
  [tokens.settings.membersSeatPlanScale]: 'Scale-Tarif',
  [tokens.settings.membersRequestSeats]: 'Mehr Plätze anfragen',
  [tokens.settings.membersBillingMailSubject]: 'Platzerweiterung — Nabu',
  [tokens.settings.membersBillingMailBody]:
    'Guten Tag,\n\nwir möchten unserem Nabu-Tarif weitere Plätze hinzufügen (aktuell: {{used}}/{{max}}).\n\nVielen Dank.',
  [tokens.settings.membersFilterAllRoles]: 'Alle Rollen',
  [tokens.settings.membersFilterAllStatuses]: 'Alle Status',
  [tokens.settings.membersFilterStatusActive]: 'Aktiv',
  [tokens.settings.membersFilterStatusInactive]: 'Inaktiv',
  [tokens.settings.membersColAgencies]: 'Agenturen',
  [tokens.settings.membersColAffiliation]: 'Zugehörigkeit',
  [tokens.settings.membersAffiliationOrganization]: 'Organisation',
  [tokens.settings.membersColStatus]: 'Status',
  [tokens.settings.membersColEnabled]: 'Aktiviert',
  [tokens.settings.membersStatusActive]: 'Aktiv',
  [tokens.settings.membersStatusInactive]: 'Inaktiv',
  [tokens.settings.membersAddUser]: 'Benutzer hinzufügen',
  [tokens.settings.membersViewList]: 'Listenansicht',
  [tokens.settings.membersViewGrid]: 'Rasteransicht',
  [tokens.settings.membersAgencyNone]: '—',
  [tokens.settings.organizationMembersGroup]: 'Organisation · {{name}}',
  [tokens.settings.membersMenuViewProfile]: 'Profil anzeigen',
  [tokens.settings.membersMenuEdit]: 'Bearbeiten',
  [tokens.settings.membersMenuDeactivate]: 'Deaktivieren',
  [tokens.settings.membersMenuReactivate]: 'Reaktivieren',
  [tokens.settings.membersDeactivateTitle]: '{{name}} deaktivieren',
  [tokens.settings.membersDeactivateBody]:
    '{{name}} kann sich nicht mehr anmelden. Die Zugriffe bleiben bestehen und gelten wieder, sobald das Mitglied reaktiviert wird.',
  [tokens.settings.membersReactivateTitle]: '{{name}} reaktivieren',
  [tokens.settings.membersReactivateBody]:
    '{{name}} kann sich wieder anmelden, mit den bisherigen Zugriffen.',
  [tokens.settings.membersDeactivateSuccess]: 'Mitglied deaktiviert.',
  [tokens.settings.membersReactivateSuccess]: 'Mitglied reaktiviert.',
  [tokens.settings.membersSetActiveForbidden]:
    'Ihre Zugriffe erlauben es nicht, die Aktivierung dieses Mitglieds zu ändern.',
  [tokens.settings.membersSetActiveError]: 'Die Aktivierung dieses Mitglieds konnte nicht geändert werden.',
  [tokens.settings.membersMenuTransferAgency]: 'Agentur wechseln',
  [tokens.settings.membersMenuManageAgencies]: 'Agentur verwalten',
  [tokens.settings.manageAgenciesDialogTitle]: 'Agentur verwalten',
  [tokens.settings.manageAgenciesDialogDescription]:
    'Wählen Sie die Agentur aus, der {{name}} zugeordnet werden soll.',
  [tokens.settings.manageAgenciesSearchPlaceholder]: 'Agentur suchen…',
  [tokens.settings.manageAgenciesSave]: 'Speichern',
  [tokens.settings.manageAgenciesMinOneAgency]:
    'Es muss eine Agentur ausgewählt werden.',
  [tokens.settings.manageAgenciesSuccess]: 'Agenturzuordnung aktualisiert.',
  [tokens.settings.manageAgenciesAlreadyMember]:
    'Dieser Benutzer ist bereits Mitglied dieser Agentur.',
  [tokens.settings.manageAgenciesNoAgencies]:
    'Keine Agenturen in dieser Organisation verfügbar.',
  [tokens.settings.manageAgenciesNoSearchResults]: 'Keine Agenturen gefunden.',
  [tokens.settings.manageAgenciesErrorForbidden]:
    'Sie haben keine Berechtigung, diese Zuordnung zu ändern.',
  [tokens.settings.manageAgenciesErrorInvalid]:
    'Die ausgewählten Agenturen sind für diese Organisation ungültig.',
  [tokens.settings.manageAgenciesErrorGeneric]:
    'Agenturzuordnung konnte nicht aktualisiert werden.',
  [tokens.settings.memberDetailAgencyFilterAll]: 'Alle Agenturen',
  [tokens.settings.memberDetailAgencyFilterLabel]: 'Nach Agentur filtern',
  [tokens.settings.membersMenuDelete]: 'Löschen',
  [tokens.settings.memberDetailBackToList]: 'Zurück zu Benutzern',
  [tokens.settings.memberDetailStatLastConnection]: 'Letzte Anmeldung',
  [tokens.settings.memberDetailStatMemberSince]: 'Mitglied seit',
  [tokens.settings.memberDetailStatDeclarations]: 'Anzahl Anmeldungen',
  [tokens.settings.memberDetailNotAvailable]: 'Nicht verfügbar',
  [tokens.settings.memberDetailTabInfo]: 'Informationen',
  [tokens.settings.memberDetailTabReports]: 'Berichte',
  [tokens.settings.memberDetailReportsTitle]: 'Deklarationsverlauf',
  [tokens.settings.memberDetailReportsSubtitle]:
    '{{count}} Deklarationen von {{user}}',
  [tokens.settings.memberDetailReportsSeeDocuments]: 'Deklarationen anzeigen',
  [tokens.settings.memberDetailOverviewTitle]: 'Übersicht',
  [tokens.settings.memberDetailOverviewSubtitle]:
    'Zusammenfassung der von diesem Benutzer erstellten Deklarationen.',
  [tokens.settings.memberDetailOverviewDeclarationsLabel]: 'Deklarationen',
  [tokens.settings.memberDetailPeriodLast7Days]: 'Letzte 7 Tage',
  [tokens.settings.memberDetailPeriodLast30Days]: 'Letzte 30 Tage',
  [tokens.settings.memberDetailPeriodLast90Days]: 'Letzte 90 Tage',
  [tokens.settings.memberDetailPeriodLast12Months]: 'Letzte 12 Monate',
  [tokens.settings.memberDetailPeriodAll]: 'Gesamter Verlauf',
  [tokens.settings.memberDetailPeriodCustom]: 'Benutzerdefinierter Zeitraum',
  [tokens.settings.memberDetailStatusValidated]: 'Validiert',
  [tokens.settings.memberDetailStatusPending]: 'Ausstehend',
  [tokens.settings.memberDetailStatusError]: 'Fehlerhaft',
  [tokens.settings.memberDetailStatusAbandoned]: 'Verfallen',
  [tokens.settings.memberDetailStatusUnknown]: 'Unbekannt',
  [tokens.settings.memberDetailColReference]: 'Referenz',
  [tokens.settings.memberDetailSectionIdentity]: 'Identität',
  [tokens.settings.memberDetailSectionIdentitySubtitle]:
    'Persönliche Angaben und Kontakte.',
  [tokens.settings.memberDetailSectionAttachment]: 'Zuordnung & Rolle',
  [tokens.settings.memberDetailSectionAttachmentSubtitle]:
    'Agenturen und Berechtigungen dieses Benutzers.',
  [tokens.settings.memberDetailLabelFullName]: 'Vollständiger Name',
  [tokens.settings.memberDetailLabelEmail]: 'E-Mail',
  [tokens.settings.memberDetailLabelPhone]: 'Telefon',
  [tokens.settings.memberDetailLabelPosition]: 'Funktion',
  [tokens.settings.memberDetailLabelRole]: 'Rolle',
  [tokens.settings.memberDetailLabelAgencies]: 'Zugeordnete Agenturen',
  [tokens.settings.memberDetailToolbarEdit]: 'Bearbeiten',
  [tokens.settings.memberDetailToolbarMail]: 'E-Mail senden',
  [tokens.settings.rolesPageTitle]: 'Rollen und Berechtigungen',
  [tokens.settings.rolesPageSubtitle]:
    'Zugriffsrechte pro Rolle in Ihrer Organisation.',
  [tokens.settings.rolesColPermission]: 'Berechtigung',
  [tokens.settings.roleLabelAdmin]: 'Admin',
  [tokens.settings.roleLabelManager]: 'Manager',
  [tokens.settings.roleLabelOperator]: 'Operator',
  [tokens.settings.roleLabelReader]: 'Leser',
  [tokens.settings.roleLabelGuest]: 'Gast',
  [tokens.settings.roleLabelSuperadmin]: 'Super-Admin',
  [tokens.settings.roleLabelAgent]: 'Agent',
  [tokens.settings.roleLabelDeclarative]: 'Anmelder',
  [tokens.settings.emailTemplatesPageTitle]: 'E-Mail-Vorlagen',
  [tokens.settings.emailTemplatesPageSubtitle]:
    'Automatische E-Mails von Nabu an Ihr Team und Ihre Kunden anpassen.',
  [tokens.settings.emailTemplatesModify]: 'Bearbeiten',
  [tokens.settings.emailTemplatesFootnote]:
    'Vorlagen sorgen für einheitliche Kommunikation; erweiterter Editor folgt.',
  [tokens.settings.emailTplAckTitle]: 'Eingangsbestätigung',
  [tokens.settings.emailTplAckDesc]:
    'Automatisch gesendet, sobald eine Deklaration von der Zollbehörde übernommen wird.',
  [tokens.settings.emailTplFinalizedTitle]: 'Abschlussbestätigung',
  [tokens.settings.emailTplFinalizedDesc]:
    'Informiert das Team, wenn eine Deklaration akzeptiert und abgeschlossen ist.',
  [tokens.settings.emailTplDeclErrTitle]: 'Deklarationsfehler-Alarm',
  [tokens.settings.emailTplDeclErrDesc]:
    'Sofortige Warnung bei Ablehnung oder administrativer Anomalie.',
  [tokens.settings.emailTplPipelineErrTitle]: 'Pipeline-Fehler-Alarm',
  [tokens.settings.emailTplPipelineErrDesc]:
    'Benachrichtigung bei fehlgeschlagener Übernahme oder manueller Verarbeitung.',
  [tokens.settings.emailTplInviteTitle]: 'Benutzereinladung',
  [tokens.settings.emailTplInviteDesc]:
    'E-Mail bei Einladung eines neuen Nutzers in die Organisation.',
  [tokens.settings.helpPageTitle]: 'Hilfe-Center',
  [tokens.settings.helpPageSubtitle]:
    'Ressourcen für die effektive Nutzung von Nabu.',
  [tokens.settings.helpCardDocTitle]: 'Dokumentation',
  [tokens.settings.helpCardDocDesc]: 'Anleitungen zu allen Nabu-Funktionen.',
  [tokens.settings.helpCardDocAction]: 'Öffnen',
  [tokens.settings.helpCardVideoTitle]: 'Video-Tutorials',
  [tokens.settings.helpCardVideoDesc]:
    'Nabu Schritt für Schritt mit Videos lernen.',
  [tokens.settings.helpCardVideoAction]: 'Videos ansehen',
  [tokens.settings.helpCardChatTitle]: 'Support-Chat',
  [tokens.settings.helpCardChatDesc]: 'Fragen Sie unser Support-Team direkt.',
  [tokens.settings.helpCardChatAction]: 'Starten',
  [tokens.settings.helpCardMailTitle]: 'E-Mail-Support',
  [tokens.settings.helpCardMailDesc]:
    'Schreiben Sie uns; Antwort innerhalb von 24h.',
  [tokens.settings.helpCardMailAction]: 'Kontakt',
  [tokens.settings.helpSearchPlaceholder]: 'Artikel suchen…',
  [tokens.settings.helpHeroTitle]: 'Wie können wir helfen?',
  [tokens.settings.helpHeroSubtitle]:
    'Finden Sie Antworten, folgen Sie Tutorials oder kontaktieren Sie unser Support-Team.',
  [tokens.settings.helpFrequentSearches]: 'Häufige Suchen',
  [tokens.settings.helpPopularTitle]: 'Beliebte Artikel',
  [tokens.settings.helpBrowseByTheme]: 'Nach Thema durchsuchen',
  [tokens.settings.helpSearchResultsTitle]: 'Suchergebnisse',
  [tokens.settings.helpArticlesCountLink]: '{{count}} Artikel >',
  [tokens.settings.helpArticlesCountLink_other]: '{{count}} Artikel >',
  [tokens.settings.helpSupportCta]:
    'Keine Antwort gefunden? Unser Team antwortet an Werktagen innerhalb von 2 Stunden.',
  [tokens.settings.helpSupportEmail]: 'E-Mail senden',
  [tokens.settings.helpSupportChat]: 'Chat starten',
  [tokens.settings.helpCategoryAll]: 'Alle',
  [tokens.settings.helpCategoryDeclarationDouaniere]: 'Zollerklärung',
  [tokens.settings.helpCategoryDeclarationDouaniereDesc]:
    'Zolldokumente erstellen, prüfen und übermitteln.',
  [tokens.settings.helpCategoryExtractionDonnee]: 'Datenextraktion',
  [tokens.settings.helpCategoryExtractionDonneeDesc]:
    'Wie Nabu Daten aus Ihren Dokumenten extrahiert.',
  [tokens.settings.helpCategoryDocumentsDossiers]: 'Dokumente & Anmeldungen',
  [tokens.settings.helpCategoryDocumentsDossiersDesc]:
    'Dokumente und Anmeldungen in Nabu verwalten.',
  [tokens.settings.helpCategoryClassificationDocumentaire]:
    'Dokumentenklassifizierung',
  [tokens.settings.helpCategoryClassificationDocumentaireDesc]:
    'Dokumente automatisch klassifizieren.',
  [tokens.settings.helpCategoryAutomatisationMetier]:
    'Geschäftsautomatisierung',
  [tokens.settings.helpCategoryAutomatisationMetierDesc]:
    'Geschäftsprozesse mit Nabu automatisieren.',
  [tokens.settings.helpCategoryIntegrations]: 'Integrationen',
  [tokens.settings.helpCategoryIntegrationsDesc]:
    'Nabu mit Ihren Tools und externen Systemen verbinden.',
  [tokens.settings.helpArticlesCount]: '{{count}} Artikel',
  [tokens.settings.helpArticlesCount_other]: '{{count}} Artikel',
  [tokens.settings.helpArticlesEmpty]: 'Keine Artikel gefunden.',
  [tokens.settings.helpArticlesLoadError]:
    'Hilfeartikel konnten nicht geladen werden.',
  [tokens.settings.helpArticleLoadError]:
    'Dieser Artikel konnte nicht geladen werden.',
  [tokens.settings.helpBackToList]: 'Zurück',
  [tokens.settings.helpBackToCategories]: 'Zurück zu den Kategorien',
  [tokens.settings.helpPopularBadge]: 'Beliebt',
  [tokens.settings.helpFrequentSearchBadge]: 'Häufige Suche',
  [tokens.settings.helpFrequentSearchBadgeAria]: 'Nach « {{term}} » suchen',
  [tokens.settings.helpReadingTime]: '{{minutes}} Min. Lesezeit',
  [tokens.settings.helpReadingMinutesShort]: '{{minutes}} Min.',
  [tokens.settings.helpArticleViews]: '{{count}} Aufrufe',
  [tokens.settings.helpArticleFeedbackQuestion]: 'War dieser Artikel hilfreich?',
  [tokens.settings.helpArticleFeedbackYes]: 'Ja',
  [tokens.settings.helpArticleFeedbackNo]: 'Nein',
  [tokens.settings.helpArticleFeedbackContactSupport]: 'Support kontaktieren',
  [tokens.settings.helpExpandArticle]: 'Vergrößern',
  [tokens.settings.helpCollapseArticle]: 'Verkleinern',
  [tokens.settings.helpBugTitle]: 'Einen Fehler gefunden?',
  [tokens.settings.helpBugDesc]:
    'Melden Sie unerwartetes Verhalten und helfen Sie uns, Nabu zu verbessern.',
  [tokens.settings.helpBugAction]: 'Problem melden',
  [tokens.settings.permViewFolders]: 'Anmeldungen anzeigen',
  [tokens.settings.permCreateFolders]: 'Anmeldungen erstellen',
  [tokens.settings.permSendDeclarations]: 'Deklarationen senden',
  [tokens.settings.permManageUsers]: 'Benutzer verwalten',
  [tokens.settings.permManageOrg]: 'Organisation verwalten',
  [tokens.settings.permManageIntegrations]: 'Integrationen verwalten',
  [tokens.settings.docTitleSubscription]: 'Abonnement',
  [tokens.settings.docTitleBilling]: 'Abrechnung',
  [tokens.settings.navSubscription]: 'Abonnement',
  [tokens.settings.navBilling]: 'Abrechnung',
  [tokens.settings.subscriptionPageTitle]: 'Abonnement',
  [tokens.settings.subscriptionPageSubtitle]:
    'Plan, Abrechnungszyklus und Credits.',
  [tokens.settings.subscriptionLoadError]:
    'Abonnementinformationen konnten nicht geladen werden.',
  [tokens.settings.subscriptionPendingTitle]:
    'Wählen Sie Ihr Abonnement, um Ihr Credit-Kontingent zu aktivieren',
  [tokens.settings.subscriptionPendingBody]:
    'Ihre Organisation ist bereit. Wählen Sie einen Plan und Abrechnungszyklus, und aktivieren Sie dann Ihr Abonnement, um Credits freizuschalten.',
  [tokens.settings.subscriptionPendingCta]: 'Mein Abonnement aktivieren',
  [tokens.settings.subscriptionPendingPaymentTitle]:
    'Fügen Sie eine Zahlungsmethode hinzu, um Ihr Abonnement zu aktivieren',
  [tokens.settings.subscriptionPendingPaymentBody]:
    'Eine Karte ist vor der Aktivierung erforderlich. Anschließend können Sie Ihr Abonnement abschließen und Credits erhalten.',
  [tokens.settings.subscriptionPendingPaymentCta]:
    'Zahlungsmethode hinzufügen',
  [tokens.settings.subscriptionEmptyManualTitle]: 'Manuelle Abrechnung',
  [tokens.settings.subscriptionEmptyManualBody]:
    'Ihre Organisation wird manuell abgerechnet. Self-Serve-Abonnementverwaltung ist nicht verfügbar. Kontaktieren Sie Ihren Nabu-Ansprechpartner für Änderungen.',
  [tokens.settings.subscriptionEmptyNotConfiguredTitle]:
    'Abonnement nicht konfiguriert',
  [tokens.settings.subscriptionEmptyNotConfiguredBody]:
    'Für Ihre Organisation ist noch kein Abonnement konfiguriert. Kontaktieren Sie Nabu, um Ihren Plan zu aktivieren.',
  [tokens.settings.subscriptionCreditsBannerLowTitle]:
    'Credits bald aufgebraucht',
  [tokens.settings.subscriptionCreditsBannerLowBody]:
    'Sie haben nur noch <strong>{{remaining}} Credits</strong>. Laden Sie Ihr Konto auf, um die Verarbeitung Ihrer Deklarationen nicht zu unterbrechen.',
  [tokens.settings.subscriptionCreditsBannerExhaustedTitle]:
    'Credits aufgebraucht',
  [tokens.settings.subscriptionCreditsBannerExhaustedBody]:
    'Sie haben nur noch <strong>{{remaining}} Credits</strong>. Laden Sie Ihr Konto auf, um die Verarbeitung Ihrer Deklarationen nicht zu unterbrechen.',
  [tokens.settings.subscriptionCreditsBannerRecharge]: 'Credits aufladen',
  [tokens.settings.subscriptionCreditsBannerLater]: 'Später',
  [tokens.settings.subscriptionRecapTitle]: 'Übersicht',
  [tokens.settings.subscriptionRecapSubtitle]:
    'Was zur nächsten Fälligkeit abgebucht wird.',
  [tokens.settings.subscriptionRecapSubtitlePending]:
    'Vorschau basierend auf dem gewählten Plan, aktiv nach Aktivierung.',
  [tokens.settings.subscriptionRecapAmountMonthly]: 'Monatlicher Betrag',
  [tokens.settings.subscriptionRecapAmountAnnual]: 'Jährlicher Betrag',
  [tokens.settings.subscriptionRecapPlanName]: 'Plan {{plan}}',
  [tokens.settings.subscriptionRecapAnnualSavingsBadge]: '− {{percent}} %',
  [tokens.settings.subscriptionRecapAnnualSavingsAmount]:
    '{{amount}} Ersparnis / Jahr',
  [tokens.settings.subscriptionCustomPricingBadge]: 'Individueller Tarif',
  [tokens.settings.subscriptionRecapCredits]: 'Credits',
  [tokens.settings.subscriptionRecapCreditsUsed]: '{{percent}} % verbraucht',
  [tokens.settings.subscriptionRecapCreditsAvailable]: '{{remaining}} verfügbar',
  [tokens.settings.subscriptionRecapCreditsExtraPurchased]:
    'davon {{count}} gekauft',
  [tokens.settings.subscriptionRecapCreditsExtraGifted]:
    'davon {{count}} geschenkt',
  [tokens.settings.subscriptionRecapCreditsEnvelopeUsed]:
    '{{percent}} % Kontingent verbraucht',
  [tokens.settings.subscriptionRecapCreditsPending]: 'Nicht aktiviert',
  [tokens.settings.subscriptionRecapCreditsPendingHint]:
    'Das Kontingent wird bei Aktivierung des Abonnements gutgeschrieben.',
  [tokens.settings.subscriptionRecapNextBilling]: 'Nächste Fälligkeit',
  [tokens.settings.subscriptionRecapNextBillingPending]: 'Nach Aktivierung',
  [tokens.settings.subscriptionRecapNextBillingPendingHint]:
    'Das Abbuchungsdatum wird nach Aktivierung des Abonnements festgelegt.',
  [tokens.settings.subscriptionRecapAutoCharge]: 'Automatische Abbuchung',
  [tokens.settings.subscriptionCreditsTitle]: 'Credits',
  [tokens.settings.subscriptionCreditsSubtitle]:
    'Ihr Kontingent wird bei jeder Fälligkeit aufgeladen. Darüber hinaus werden zusätzliche Credits nach Verbrauch berechnet.',
  [tokens.settings.subscriptionCreditsPendingTitle]:
    'Kontingent noch nicht aktiviert',
  [tokens.settings.subscriptionCreditsPendingBody]:
    'Aktivieren Sie Ihr Abonnement, um Ihr Credit-Kontingent zu erhalten und Deklarationen zu verarbeiten.',
  [tokens.settings.subscriptionCreditsBuy]: '+ Credits kaufen',
  [tokens.settings.subscriptionCreditsConsumedLabel]: 'Credits verbraucht',
  [tokens.settings.subscriptionCreditsAvailable]:
    '{{remaining}} Credits verfügbar',
  [tokens.settings.subscriptionCreditsDeclarationsHint]:
    '≈ {{declarations}} Deklarationen diesen Monat',
  [tokens.settings.subscriptionCreditsSourceSubscription]:
    'Abonnement · {{count}}',
  [tokens.settings.subscriptionCreditsSourcePurchased]: 'Kauf · {{count}}',
  [tokens.settings.subscriptionCreditsSourceGifted]: 'Geschenk · {{count}}',
  [tokens.settings.subscriptionCreditsEnvelopeLabel]: 'Monatskontingent',
  [tokens.settings.subscriptionCreditsEnvelopeConsumed]:
    '{{consumed}} / {{envelope}} verbraucht',
  [tokens.settings.subscriptionCreditsThresholdLow]: 'Bald aufgebraucht',
  [tokens.settings.subscriptionCreditsThresholdExhausted]: 'Aufgebraucht',
  [tokens.settings.subscriptionCreditsRemainingHint]:
    '{{remaining}} Credits übrig, etwa {{declarations}} Deklarationen diesen Monat.',
  [tokens.settings.subscriptionCreditsRateDeclaration]: '1 Deklaration',
  [tokens.settings.subscriptionCreditsRateArticle]: '1 Position',
  [tokens.settings.subscriptionCreditsRateRollover]: 'Übertrag',
  [tokens.settings.subscriptionCreditsRateCredits]: '{{count}} Credits',
  [tokens.settings.subscriptionCreditsRolloverNone]: 'Keiner',
  [tokens.settings.subscriptionCreditsRolloverMonths]:
    'Übertrag {{count}} Monat(e)',
  [tokens.settings.subscriptionCycleTitle]: 'Abrechnungszyklus',
  [tokens.settings.subscriptionCycleSubtitle]:
    'Wählen Sie, ob monatlich oder jährlich abgebucht wird.',
  [tokens.settings.subscriptionCycleMonthly]: 'Monatlich',
  [tokens.settings.subscriptionCycleMonthlyLine1]:
    'Abbuchung am 1. jedes Monats.',
  [tokens.settings.subscriptionCycleMonthlyLine2]:
    'Ohne Bindung, jederzeit kündbar.',
  [tokens.settings.subscriptionCycleAnnual]: 'Jährlich',
  [tokens.settings.subscriptionCycleAnnualBadge]: '− {{percent}} %',
  [tokens.settings.subscriptionCycleAnnualLine1]:
    'Einmal jährlich abgebucht.',
  [tokens.settings.subscriptionCycleAnnualLine2]:
    'Zwei Monate gratis, {{percent}} % Ersparnis.',
  [tokens.settings.subscriptionCycleEffectiveHint]:
    'Zyklusänderungen gelten ab der nächsten Verlängerung (keine anteilige Berechnung).',
  [tokens.settings.subscriptionPlansTitle]: 'Plan',
  [tokens.settings.subscriptionPlansSubtitle]:
    'Jeder Plan enthält ein monatliches Credit-Kontingent. Eine Deklaration verbraucht Credits je nach Plan.',
  [tokens.settings.subscriptionPlansSubtitlePending]:
    'Wählen Sie den zu aktivierenden Plan. Enterprise erfordert Kontakt zum Vertrieb.',
  [tokens.settings.subscriptionPlansCompare]: 'Pläne vergleichen',
  [tokens.settings.subscriptionPlanPerMonth]: '/ Monat',
  [tokens.settings.subscriptionPlanPerYear]: '/ Jahr',
  [tokens.settings.subscriptionPlanAnnualEquivalent]:
    'oder {{amount}} / Monat bei jährlicher Abrechnung',
  [tokens.settings.subscriptionPlanAnnualSavings]:
    '{{amount}} Ersparnis / Jahr',
  [tokens.settings.subscriptionPlanEnvelopeBadge]:
    '{{credits}} Credits inkl. / Monat',
  [tokens.settings.subscriptionPlanCoverage]:
    '{{declarations}} Deklarationen oder {{articles}} Positionen',
  [tokens.settings.subscriptionPlanImportExport]: 'IMPORT / EXPORT',
  [tokens.settings.subscriptionPlanCoverageDeclarations]:
    '{{count}} Deklarationen',
  [tokens.settings.subscriptionPlanCoverageOr]: 'oder',
  [tokens.settings.subscriptionPlanCoverageArticles]: '{{count}} Positionen',
  [tokens.settings.subscriptionPlanRateDeclaration]:
    '1 Deklaration = {{count}} Credits',
  [tokens.settings.subscriptionPlanRateArticle]:
    '1 Position = {{count}} Credits',
  [tokens.settings.subscriptionPlanRateLine]:
    '1 Deklaration = {{declaration}} Credits · 1 Position = {{article}} Credits',
  [tokens.settings.subscriptionPlanExtraCredit]:
    'Zusätzliche Credits: {{price}}/Credit',
  [tokens.settings.subscriptionPlanMinGrowth]:
    'Ab 500 Deklarationen / Monat',
  [tokens.settings.subscriptionPlanMinEnterprise]:
    'Ab 5K Deklarationen / Monat',
  [tokens.settings.subscriptionPlanSetupFee]:
    'Einmalige Einrichtung: {{amount}}',
  [tokens.settings.subscriptionPlanCurrentBadge]: 'Aktueller Plan',
  [tokens.settings.subscriptionPlanRecommendedBadge]: 'Empfohlen',
  [tokens.settings.subscriptionPlanSelectedBadge]: 'Ausgewählt',
  [tokens.settings.subscriptionPlanCurrentCta]: 'Aktueller Plan',
  [tokens.settings.subscriptionPlanChooseCta]: 'Diesen Plan wählen',
  [tokens.settings.subscriptionPlanActivateCta]: 'Diesen Plan aktivieren',
  [tokens.settings.subscriptionPlanContactCta]: 'Kontakt aufnehmen',
  [tokens.settings.subscriptionPlanFeatureStarterUsers]:
    'Bis zu 3 Benutzer',
  [tokens.settings.subscriptionPlanFeatureStarterEmail]: 'E-Mail-Support',
  [tokens.settings.subscriptionPlanFeatureStarterOnboarding]:
    'Selbstständiges Onboarding',
  [tokens.settings.subscriptionPlanFeatureStarterArchive]: '1 Jahr Archivierung',
  [tokens.settings.subscriptionPlanFeatureStarterCsv]: 'CSV-Export',
  [tokens.settings.subscriptionPlanFeatureStarterNoDashboard]:
    'Kein Steuerungs-Dashboard',
  [tokens.settings.subscriptionPlanFeatureStarterNoSla]:
    'Kein vertragliches SLA',
  [tokens.settings.subscriptionPlanFeatureStarterNoRollover]:
    'Credit-Übertrag: keiner',
  [tokens.settings.subscriptionPlanFeatureGrowthIntro]:
    'Alles aus Starter, plus:',
  [tokens.settings.subscriptionPlanFeatureGrowthUsers]:
    'Unbegrenzte Benutzer',
  [tokens.settings.subscriptionPlanFeatureGrowthDashboard]:
    'Steuerungs-Dashboard',
  [tokens.settings.subscriptionPlanFeatureGrowthSla]: 'SLA 99,0 %',
  [tokens.settings.subscriptionPlanFeatureGrowthSupport]:
    'Prioritäts-Support E-Mail + Chat',
  [tokens.settings.subscriptionPlanFeatureGrowthOnboarding]:
    'Begleitetes Onboarding',
  [tokens.settings.subscriptionPlanFeatureGrowthArchive]:
    '5 Jahre Archivierung',
  [tokens.settings.subscriptionPlanFeatureGrowthConnectors]:
    'ERP- / TMS-Konnektoren',
  [tokens.settings.subscriptionPlanFeatureGrowthApi]: 'API-Zugang',
  [tokens.settings.subscriptionPlanFeatureGrowthEdi]:
    'EDI-Prüfung in Echtzeit',
  [tokens.settings.subscriptionPlanFeatureGrowthRollover]:
    'Credit-Übertrag: 1 Monat',
  [tokens.settings.subscriptionPlanFeatureEnterpriseIntro]:
    'Alles aus Growth, plus:',
  [tokens.settings.subscriptionPlanFeatureEnterpriseDashboard]:
    'Erweitertes Dashboard',
  [tokens.settings.subscriptionPlanFeatureEnterpriseSla]:
    'Dediziertes SLA 99,9 %',
  [tokens.settings.subscriptionPlanFeatureEnterpriseAm]:
    'Dedizierter Account Manager',
  [tokens.settings.subscriptionPlanFeatureEnterpriseOnboarding]:
    'Individuelles Onboarding',
  [tokens.settings.subscriptionPlanFeatureEnterpriseSso]: 'SSO / SAML',
  [tokens.settings.subscriptionPlanFeatureEnterpriseCompliance]:
    'Erweiterte Compliance (DGDDUI, DSGVO+)',
  [tokens.settings.subscriptionPlanFeatureEnterpriseRouting]:
    'Multi-Büro-Zollrouting',
  [tokens.settings.subscriptionPlanFeatureEnterpriseWorkflows]:
    'Individuelle Workflows',
  [tokens.settings.subscriptionPlanFeatureEnterpriseRollover]:
    'Credit-Übertrag: 3 Monate',
  [tokens.settings.subscriptionBuyCreditsTitle]: 'Credits kaufen',
  [tokens.settings.subscriptionBuyCreditsSubtitle]:
    'Wählen Sie ein Paket oder geben Sie eine freie Menge ein. Credits werden sofort Ihrem Kontingent gutgeschrieben.',
  [tokens.settings.subscriptionBuyCreditsPackLabel]: '{{credits}} Credits',
  [tokens.settings.subscriptionBuyCreditsPackDecls]:
    '≈ {{count}} Deklarationen',
  [tokens.settings.subscriptionBuyCreditsCustomLabel]: 'Freie Menge',
  [tokens.settings.subscriptionBuyCreditsCustomPlaceholder]:
    'Anzahl Credits',
  [tokens.settings.subscriptionBuyCreditsPreview]:
    '{{quantity}} Credits · {{amount}}',
  [tokens.settings.subscriptionBuyCreditsCancel]: 'Abbrechen',
  [tokens.settings.subscriptionBuyCreditsConfirm]: 'Kauf bestätigen',
  [tokens.settings.subscriptionToastCycleUpdated]:
    'Abrechnungszyklus aktualisiert.',
  [tokens.settings.subscriptionToastPlanUpdated]:
    'Plan aktualisiert.',
  [tokens.settings.subscriptionToastCreditsPurchased]:
    'Credits erfolgreich gekauft.',
  [tokens.settings.subscriptionToastActivated]:
    'Abonnement aktiviert. Ihr Credit-Kontingent ist verfügbar.',
  [tokens.settings.subscriptionErrorGeneric]:
    'Ein Fehler ist aufgetreten. Bitte erneut versuchen.',
  [tokens.settings.subscriptionErrorContactRequired]:
    'Kontaktieren Sie den Vertrieb, um den Enterprise-Plan zu aktivieren.',
  [tokens.settings.subscriptionErrorActivationRequired]:
    'Aktivieren Sie zuerst Ihr Abonnement, um diese Aktion auszuführen.',
  [tokens.settings.subscriptionErrorPaymentMethodRequired]:
    'Fügen Sie eine Zahlungsmethode hinzu, bevor Sie Ihr Abonnement aktivieren.',
  [tokens.settings.subscriptionContactMailSubject]:
    'Anfrage zu meinem Nabu-Abonnement',
  [tokens.settings.billingPageTitle]: 'Abrechnung',
  [tokens.settings.billingPageSubtitle]:
    'Zahlungsmethoden und Rechnungshistorie.',
  [tokens.settings.billingPageSubtitleAddPayment]:
    'Fügen Sie eine Karte hinzu, um Ihr Abonnement zu aktivieren.',
  [tokens.settings.billingPageComingSoon]:
    'Diese Seite kommt in Kürze.',
  [tokens.settings.billingLoadError]:
    'Abrechnungsinformationen konnten nicht geladen werden.',
  [tokens.settings.billingAddPaymentTitle]: 'Zahlungsmethode',
  [tokens.settings.billingAddPaymentBody]:
    'Speichern Sie eine Karte. Kehren Sie danach zum Abonnement zurück, um es zu aktivieren.',
  [tokens.settings.billingAddPaymentPlaceholder]:
    'Das Hyperline-Kartenformular wird hier integriert.',
  [tokens.settings.billingAddPaymentCancel]: 'Zurück',
  [tokens.settings.billingAddPaymentDone]:
    'Karte hinzugefügt — zurück zum Abonnement',
  [tokens.settings.billingAddPaymentBannerTitle]:
    'Fügen Sie eine Karte hinzu, um Ihr Abonnement zu aktivieren',
  [tokens.settings.billingAddPaymentBannerBody]:
    'Nach dem Speichern Ihrer Zahlungsmethode werden Sie zur Abonnementseite weitergeleitet, um die Aktivierung abzuschließen.',
  [tokens.settings.billingPaymentMethodsTitle]: 'Zahlungsmethoden',
  [tokens.settings.billingPaymentMethodsSubtitle]:
    'Die Hauptkarte wird bei jeder Fälligkeit belastet.',
  [tokens.settings.billingInvoicesTitle]: 'Rechnungen',
  [tokens.settings.billingInvoicesSubtitle]: 'Rechnungshistorie.',
  [tokens.settings.billingEmptyManualTitle]: 'Manuelle Abrechnung',
  [tokens.settings.billingEmptyManualBody]:
    'Ihre Organisation wird manuell abgerechnet. Self-Serve-Zahlungsmethoden und Rechnungen sind nicht verfügbar.',
  [tokens.settings.billingEmptyNotConfiguredTitle]:
    'Abrechnung nicht konfiguriert',
  [tokens.settings.billingEmptyNotConfiguredBody]:
    'Für Ihre Organisation ist kein Abrechnungskonto konfiguriert. Prüfen Sie die Abonnementseite oder kontaktieren Sie Nabu.',
  [tokens.settings.billingEmptyGoSubscription]: 'Abonnement ansehen',
  [tokens.settings.billingTokenDisabledTitle]: 'Abrechnung nicht verfügbar',
  [tokens.settings.billingTokenErrorTitle]:
    'Abrechnung konnte nicht geladen werden',
  [tokens.settings.billingTokenErrorBody]:
    'Bitte versuchen Sie es gleich erneut. Wenn das Problem weiterhin besteht, kontaktieren Sie den Support.',
  [tokens.settings.billingTokenRetry]: 'Erneut versuchen',
  [tokens.settings.billingToastPaymentCreated]:
    'Zahlungsmethode hinzugefügt.',
  [tokens.settings.billingToastPaymentDeleted]:
    'Zahlungsmethode gelöscht.',
  [tokens.settings.billingToastPaymentDefault]:
    'Hauptkarte aktualisiert.',
  [tokens.settings.billingToastEmbedError]:
    'Das Kartenformular ist fehlgeschlagen. Bitte erneut versuchen.',
  [tokens.settings.billingAddCardCta]: '+ Karte hinzufügen',
  [tokens.settings.billingAddCardTitle]: 'Karte hinzufügen',
  [tokens.settings.billingAddCardBody]:
    'Geben Sie Ihre Kartendaten ein. Die Daten werden sicher verarbeitet.',
  [tokens.settings.billingAddCardError]:
    'Das Formular konnte nicht geöffnet werden. Bitte erneut versuchen.',
  [tokens.settings.billingAddCardSubmit]: 'Karte speichern',
  [tokens.settings.billingAddCardConfirmError]:
    'Die Karte konnte nicht gespeichert werden. Angaben prüfen und erneut versuchen.',
  [tokens.settings.billingCardPrimaryBadge]: 'Hauptkarte',
  [tokens.settings.billingCardExpiry]: 'Gültig bis {{exp}}',
  [tokens.settings.billingCardExpiryWithHolder]:
    '{{holder}} · gültig bis {{exp}}',
  [tokens.settings.billingCardSetDefault]: 'Als Hauptkarte festlegen',
  [tokens.settings.billingCardDelete]: 'Karte löschen',
  [tokens.settings.billingDeleteCardTitle]: 'Diese Karte löschen?',
  [tokens.settings.billingDeleteCardBody]:
    'Die Karte •••• {{last4}} wird aus Ihren Zahlungsmethoden entfernt.',
  [tokens.settings.billingDeleteCardConfirm]: 'Löschen',
  [tokens.settings.billingPaymentMethodsLoadError]:
    'Zahlungsmethoden konnten nicht geladen werden.',
  [tokens.settings.billingPaymentMethodsEmptyTitle]:
    'Keine Zahlungsmethode',
  [tokens.settings.billingPaymentMethodsEmptyBody]:
    'Fügen Sie eine Karte für Abonnementabbuchungen hinzu.',
  [tokens.settings.billingInvoicesLoadError]:
    'Rechnungen konnten nicht geladen werden.',
  [tokens.settings.billingInvoicesEmpty]: 'Noch keine Rechnungen.',
  [tokens.settings.billingInvoiceColNumber]: 'Nr.',
  [tokens.settings.billingInvoiceColDate]: 'Datum',
  [tokens.settings.billingInvoiceColPeriod]: 'Zeitraum',
  [tokens.settings.billingInvoiceColAmount]: 'Betrag',
  [tokens.settings.billingInvoiceColStatus]: 'Status',
  [tokens.settings.billingInvoiceColAction]: 'Aktion',
  [tokens.settings.billingInvoiceStatusPaid]: 'Bezahlt',
  [tokens.settings.billingInvoiceStatusPending]: 'Ausstehend',
  [tokens.settings.billingInvoiceStatusFailed]: 'Fehlgeschlagen',
  [tokens.settings.billingInvoiceDownload]: 'Rechnung herunterladen',
  [tokens.settings.billingInvoiceDownloadSuccess]:
    'Rechnung in einem neuen Tab geöffnet.',
  [tokens.settings.billingInvoiceDownloadError]:
    'Rechnung konnte nicht heruntergeladen werden.',
  [tokens.settings.billingErrorGeneric]:
    'Ein Fehler ist aufgetreten. Bitte erneut versuchen.',
  [tokens.settings.billingErrorLastCardActive]:
    'Die letzte Karte eines aktiven Abonnements kann nicht gelöscht werden.',
  [tokens.settings.authzRolesSubtitle]: 'Vier ineinander verschachtelte Nabu-Rollen, von der engsten zur weitesten. Erstellen Sie eigene auf dieser Basis und weisen Sie sie Agentur für Agentur zu.',
  [tokens.settings.authzNabuRolesTitle]: 'Nabu-Rollen',
  [tokens.settings.authzCustomRolesTitle]: 'Ihre Rollen',
  [tokens.settings.authzCreateRole]: 'Rolle erstellen',
  [tokens.settings.authzCreateRoleTitle]: 'Rolle erstellen',
  [tokens.settings.authzCreateRoleHint]: 'Eine Rolle basiert immer auf einer Nabu-Rolle. Anschließend passen Sie ihre Fähigkeiten einzeln an.',
  [tokens.settings.authzCreateRoleName]: 'Rollenname',
  [tokens.settings.authzCreateRoleBase]: 'Basierend auf',
  [tokens.settings.authzRoleOriginNabu]: 'Nabu-Rolle',
  [tokens.settings.authzMembersCount]: '{{count}} Personen',
  [tokens.settings.authzMembersCountOne]: '1 Person',
  [tokens.settings.authzRoleNotFound]: 'Diese Rolle existiert nicht oder wurde gelöscht.',
  [tokens.settings.authzRoleName]: 'Rollenname',
  [tokens.settings.authzRoleReadOnlyNotice]: 'Nabu-Rollen lassen sich nicht bearbeiten: Nabu pflegt sie für alle. Duplizieren Sie sie, um sie an Ihre Organisation anzupassen.',
  [tokens.settings.authzImpactNone]: 'Kein Recht ändert sich.',
  [tokens.settings.authzSaveRole]: 'Speichern',
  [tokens.settings.authzDiscardChanges]: 'Änderungen verwerfen',
  [tokens.settings.authzDeleteRole]: 'Rolle löschen',
  [tokens.settings.authzDeleteRoleBlocked]: 'Entziehen Sie diese Rolle zuerst den {{count}} Person(en), die sie haben.',
  [tokens.settings.authzDeleteRoleConfirm]: 'Die Rolle „{{role}}“ wird endgültig gelöscht.',
  [tokens.settings.authzRightMissing]: '„{{action}}“: Ihre Zugriffsrechte erlauben das hier nicht.',
  [tokens.settings.authzRightAskPeople]: 'Fragen Sie {{names}}.',
  [tokens.settings.authzRightAskAdmin]: 'Fragen Sie einen Administrator Ihrer Organisation.',
  [tokens.settings.authzWhyMissing]: 'Es fehlt: {{actions}}.',
  [tokens.settings.authzWhyNotGranted]: 'Keiner ihrer Zugriffe hier gewährt sie.',
  [tokens.settings.authzWhyAccessesHere]: 'Ihre Zugriffe hier: {{accesses}}.',
  [tokens.settings.authzWhyAccessInherited]: '{{role}}, geerbt von {{agency}}',
  [tokens.settings.authzWhyNoAccessHere]: 'Kein Zugriff auf diese Agentur.',
  [tokens.settings.authzWhySmallestRole]: 'Kleinste Nabu-Rolle, die sie gewährt: {{role}}.',
  [tokens.settings.authzChangesPeople]: 'Wer gewinnt und wer verliert:',
  [tokens.settings.authzEffectGains]: '{{name}} erhält: {{actions}}.',
  [tokens.settings.authzEffectLoses]: '{{name}} verliert: {{actions}}.',
  [tokens.settings.authzEffectNone]: 'Ihre Rechte ändern sich nicht: Ihre anderen Zugriffe gewähren sie bereits.',
  [tokens.settings.authzChangeRoleTitle]: 'Rolle ändern',
  [tokens.settings.authzChangeRoleConfirm]: '{{name}} erhält die Rolle {{role}} auf allen Zugriffen.',
  [tokens.settings.memberDetailTabAccess]: 'Zugriff',
  [tokens.settings.authzAccessTitle]: 'Zugriff',
  [tokens.settings.authzAccessSubtitle]: 'Jede Zeile gewährt eine Rolle für eine Agentur – und ihre Unteragenturen, wenn gewünscht. Rechte addieren sich; nichts wird anderswo entzogen.',
  [tokens.settings.authzAddAccess]: 'Zugriff hinzufügen',
  [tokens.settings.authzNoAccess]: '{{name}} hat keinen Zugriff und sieht nichts in dieser Organisation.',
  [tokens.settings.authzScopeWholeOrg]: 'Gesamte Organisation',
  [tokens.settings.authzScopeWithDescendants]: '{{name}} und ihre Unteragenturen',
  [tokens.settings.authzScopeOnly]: 'Nur {{name}}',
  [tokens.settings.authzValidFrom]: 'ab {{date}}',
  [tokens.settings.authzValidUntil]: 'bis {{date}}',
  [tokens.settings.authzValidBetween]: 'vom {{from}} bis {{until}}',
  [tokens.settings.authzExpired]: 'Abgelaufen',
  [tokens.settings.authzScheduled]: 'Bevorstehend',
  [tokens.settings.authzOriginMigration]: 'Aus der alten Rolle übernommen',
  [tokens.settings.authzOriginMigrationHint]: 'Bei der Umstellung automatisch aus der alten Rolle und den Agenturen dieses Mitglieds erstellt.',
  [tokens.settings.authzRemoveAccess]: 'Diesen Zugriff entfernen',
  [tokens.settings.authzRemoveAccessConfirm]: '{{name}} verliert die Rolle „{{role}}“ für {{scope}}.',
  [tokens.settings.authzRightsPreviewTitle]: 'Was {{name}} tun kann',
  [tokens.settings.authzRightsPreviewOn]: 'Für',
  [tokens.settings.authzStateEnabled]: 'Gewährt',
  [tokens.settings.authzStatePartial]: 'Teilweise',
  [tokens.settings.authzStateDisabled]: 'Sichtbar, ausgegraut',
  [tokens.settings.authzStateHidden]: 'Ausgeblendet',
  [tokens.settings.authzStateLegend]: 'Ausgegraut zum Handeln, ausgeblendet zum Zerstören: Eine nicht gewährte Aktionsschaltfläche bleibt sichtbar, aber inaktiv, mit Erklärung; Löschen und Rechteverwaltung erscheinen gar nicht.',
  [tokens.settings.authzNoRightsHere]: 'Keine Rechte für diese Agentur.',
  [tokens.settings.authzAddAccessTitle]: 'Zugriff für {{name}} hinzufügen',
  [tokens.settings.authzAddAccessRole]: 'Rolle',
  [tokens.settings.authzRolesGroupNabu]: 'Nabu-Rollen',
  [tokens.settings.authzRolesGroupCustom]: 'Ihre Rollen',
  [tokens.settings.authzAddAccessScope]: 'Geltungsbereich',
  [tokens.settings.authzAddAccessScopeOrg]: 'Gesamte Organisation',
  [tokens.settings.authzAddAccessScopeAgencies]: 'Eine oder mehrere Agenturen',
  [tokens.settings.authzAddAccessIncludeDescendants]: 'Unteragenturen einschließen',
  [tokens.settings.authzAddAccessTemporary]: 'Befristeter Zugriff',
  [tokens.settings.authzAddAccessFrom]: 'Ab',
  [tokens.settings.authzAddAccessUntil]: 'Bis',
  [tokens.settings.authzAddAccessDatesInvalid]: 'Das Enddatum liegt vor dem Startdatum.',
  [tokens.settings.authzAddAccessPreview]: '{{name}} erhält die Rolle „{{role}}“ für {{scope}}{{validity}}.',
  [tokens.settings.authzAddAccessPreviewAgencies]: '{{count}} Agenturen',
  [tokens.settings.authzAddAccessPreviewAgenciesWithDescendants]: '{{count}} Agenturen und ihre Unteragenturen',
  [tokens.settings.authzAddAccessSelectAtLeastOne]: 'Wählen Sie eine Rolle und mindestens eine Agentur.',
  [tokens.settings.authzAddAccessSave]: 'Zugriff hinzufügen',
  [tokens.settings.authzLegacyRoleLine]: 'Heute angewandte Rolle: {{role}} – die höchste ihrer Zugriffe, solange die alte Zugriffskontrolle gilt.',
  [tokens.settings.authzTabCompare]: 'Rollen vergleichen',
  [tokens.settings.authzTabConfigure]: 'Rolle konfigurieren',
  [tokens.settings.authzTabAttribution]: 'Zuweisung nach Agentur',
  [tokens.settings.authzCopyName]: 'Kopie von {{role}}',
  [tokens.settings.authzCompareHint]: 'Jede Nabu-Rolle kann alles, was die vorherige kann, plus das Hervorgehobene. Öffnen Sie eine Zeile, um die einzelnen Aktionen zu sehen.',
  [tokens.settings.authzCompareCapacity]: 'Fähigkeit',
  [tokens.settings.authzCompareLegendNew]: 'Durch diese Rolle hinzugefügt',
  [tokens.settings.authzCompareLegendIncluded]: 'Enthalten',
  [tokens.settings.authzCompareLegendPartial]: 'Teilweise, in Ihrer Rolle',
  [tokens.settings.authzCompareLegendNone]: 'Nicht enthalten',
  [tokens.settings.authzCompareRemoved]: 'entfernt',
  [tokens.settings.authzCompareExpand]: 'Aktionen von {{capacity}} anzeigen',
  [tokens.settings.authzCompareTotals]: 'Gewährte Fähigkeiten',
  [tokens.settings.authzCompareTotalFull]: '{{count}} von {{total}}',
  [tokens.settings.authzCompareTotalPartial]: '{{count}} + {{partial}} teilweise',
  [tokens.settings.authzRoleKindCustom]: 'Ihre Rolle · aus {{preset}}',
  [tokens.settings.authzDuplicate]: 'Duplizieren',
  [tokens.settings.authzEdit]: 'Bearbeiten',
  [tokens.settings.authzCreateFromNabu]: 'Rolle aus einer Nabu-Rolle erstellen',
  [tokens.settings.authzCustomRolesUsage]: 'Ihre Rollen: {{count}} von {{max}}',
  [tokens.settings.authzCustomRolesLimitReached]: 'Höchstzahl eigener Rollen erreicht ({{max}}): Löschen Sie eine, um eine neue zu erstellen.',
  [tokens.settings.authzLoadError]: 'Die Rollen und Zugriffe der Organisation konnten nicht geladen werden. Laden Sie die Seite neu.',
  [tokens.settings.authzToastRoleCreated]: 'Rolle erstellt.',
  [tokens.settings.authzToastRoleSaved]: 'Rolle gespeichert.',
  [tokens.settings.authzToastRoleDeleted]: 'Rolle gelöscht.',
  [tokens.settings.authzToastAccessGiven]: 'Zugriff erteilt.',
  [tokens.settings.authzToastAccessRemoved]: 'Zugriff entfernt.',
  [tokens.settings.authzToastMemberRoleChanged]: 'Rolle des Mitglieds geändert.',
  [tokens.settings.authzErrorRoleLimit]: 'Ihre Organisation hat die Höchstzahl eigener Rollen erreicht: Löschen Sie eine, um eine neue zu erstellen.',
  [tokens.settings.authzErrorRoleInUse]: 'Mitglieder haben diese Rolle noch: Ändern Sie deren Rolle, bevor Sie sie löschen.',
  [tokens.settings.authzErrorAccessAlreadyGranted]: 'Dieses Mitglied hat diese Rolle bereits in dieser Agentur.',
  [tokens.settings.authzErrorLastAdministrator]: 'Ihre Organisation muss mindestens eine Person behalten, die Rollen verwaltet.',
  [tokens.settings.authzErrorRoleInvalid]: 'Diese Rolle konnte so nicht gespeichert werden. Laden Sie die Seite neu und versuchen Sie es erneut.',
  [tokens.settings.authzErrorForbidden]: 'Ihre Zugriffe erlauben diese Änderung nicht.',
  [tokens.settings.authzErrorGeneric]: 'Die Änderung konnte nicht gespeichert werden. Versuchen Sie es erneut.',
  [tokens.settings.authzConfigureChipsHint]: 'Nabu-Rollen sind schreibgeschützt und bleiben von selbst aktuell. Ihre Rollen ({{count}} von {{max}}) werden Feld für Feld eingestellt.',
  [tokens.settings.authzNewRoleChip]: 'Neue Rolle',
  [tokens.settings.authzNewRoleBadge]: 'Neu · aus {{preset}}',
  [tokens.settings.authzMatrixGranted]: '{{granted}} / {{total}} Aktionen gewährt',
  [tokens.settings.authzMatrixGaps]: '{{count}} Abweichung(en) von {{preset}}',
  [tokens.settings.authzMatrixRevert]: 'Zurück zu {{preset}}',
  [tokens.settings.authzMatrixModule]: 'Modul',
  [tokens.settings.authzMatrixRead]: 'Lesen',
  [tokens.settings.authzMatrixCreate]: 'Erstellen',
  [tokens.settings.authzMatrixUpdate]: 'Bearbeiten',
  [tokens.settings.authzMatrixDelete]: 'Löschen',
  [tokens.settings.authzMatrixAccess]: 'Zugriff',
  [tokens.settings.authzMatrixNotApplicable]: 'Entfällt',
  [tokens.settings.authzMatrixDiffers]: 'Weicht von {{preset}} ab',
  [tokens.settings.authzMatrixCellHint]: '{{action}} · gehört zu „{{capacity}}“',
  [tokens.settings.authzMatrixCellOwnVersion]: '{{action}} · „{{capacity}}“: Diese Rolle hat eine eigene Version, die den Aktualisierungen von Nabu nicht mehr folgt',
  [tokens.settings.authzMatrixOwnVersions]: 'Diese Rolle hat eine eigene Version von {{capacities}}. Diese Felder folgen den Aktualisierungen von Nabu nicht mehr; aktivieren Sie alle wieder, um zur Nabu-Version zurückzukehren.',
  [tokens.settings.authzCreateRoleSave]: 'Rolle erstellen',
  [tokens.settings.authzGiveCopyTitle]: '„{{role}}“ den Personen mit {{preset}} geben?',
  [tokens.settings.authzGiveCopyBody]: 'Die markierten Personen wechseln von {{preset}} zu dieser Rolle, in denselben Agenturen und mit denselben Daten. Sonst nutzt niemand die neue Rolle.',
  [tokens.settings.authzAttributionHint]: 'Wer in welcher Agentur eine Rolle hat: direkt oder über eine übergeordnete Agentur mit ihren Unteragenturen.',
  [tokens.settings.authzAttributionAgencies]: 'Agenturen',
  [tokens.settings.authzAttributionTitle]: 'Zugriff auf {{agency}}',
  [tokens.settings.authzAttributionGive]: 'Zugriff geben',
  [tokens.settings.authzAttributionEmpty]: 'Noch niemand hat eine Rolle in {{agency}}.',
  [tokens.settings.authzAttributionDirect]: 'Nur für diese Agentur vergeben',
  [tokens.settings.authzAttributionDirectWithDescendants]: 'Für diese Agentur und ihre Unteragenturen vergeben',
  [tokens.settings.authzAttributionInherited]: 'Über {{agency}} und ihre Unteragenturen',
  [tokens.settings.authzAttributionInheritedHint]: 'Für {{agency}} vergeben: wird dort verwaltet',
  [tokens.settings.authzAttributionDialogTitle]: 'Zugriff auf {{agency}} geben',
  [tokens.settings.authzAttributionMember]: 'Mitglied',
  [tokens.settings.authzAttributionNoMember]: 'Kein Mitglied, das Sie verwalten können',
  [tokens.settings.authzAttributionPickMember]: 'Wählen Sie ein Mitglied und eine Rolle.',
  [tokens.settings.authzGiveCopyCheckAll]: 'Alle auswählen',
  [tokens.settings.authzGiveCopyUncheckAll]: 'Alle abwählen',
  [tokens.settings.authzGiveCopyCount]: '{{count}} von {{total}}',
  [tokens.settings.authzChangesCount]: 'Aktion geändert',
  [tokens.settings.authzChangesCount_other]: 'Aktionen geändert',
  [tokens.settings.authzChangesTouches]: 'Betrifft {{count}} Person',
  [tokens.settings.authzChangesTouches_other]: 'Betrifft {{count}} Personen',
  [tokens.settings.authzChangesNewRole]: 'Neue Rolle aus {{preset}}',
  [tokens.settings.authzChangesDetail]: 'Was sich ändert',
  [tokens.settings.inboxesIntro]: 'Eine E-Mail an einen dieser Posteingänge erstellt ein Dossier mit ihren Anhängen. Nur zugelassene Absender werden angenommen.',
  [tokens.settings.inboxNew]: 'Neuer Posteingang',
  [tokens.settings.inboxesListTitle]: 'Empfangsadressen',
  [tokens.settings.inboxesActiveCount]: '{{count}} aktiv von {{total}}',
  [tokens.settings.inboxesActiveCount_other]: '{{count}} aktiv von {{total}}',
  [tokens.settings.inboxesSearch]: 'Suchen',
  [tokens.settings.inboxesColAddress]: 'Adresse',
  [tokens.settings.inboxesColCreates]: 'Erstelltes Dossier',
  [tokens.settings.inboxesColAssignee]: 'Zugewiesen an',
  [tokens.settings.inboxesEmptyTitle]: 'Noch kein Posteingang',
  [tokens.settings.inboxesNoMatch]: 'Kein Posteingang entspricht der Suche',
  [tokens.settings.inboxesEmptyHint]: 'Erstellen Sie einen Posteingang und geben Sie seine Adresse an Ihre Kunden weiter.',
  [tokens.settings.inboxCopyAddress]: 'Adresse kopieren',
  [tokens.settings.inboxCopy]: 'Kopieren',
  [tokens.settings.inboxActive]: 'Aktiv',
  [tokens.settings.inboxPaused]: 'Pausiert',
  [tokens.settings.inboxToggle]: 'Aktivieren oder pausieren',
  [tokens.settings.inboxUnassigned]: 'Nicht zugewiesen',
  [tokens.settings.inboxClientFromDocuments]: 'den Kunden aus den Dokumenten',
  [tokens.settings.allowedSendersTitle]: 'Zugelassene Absender',
  [tokens.settings.allowedSendersHint]: 'Gilt für alle Posteingänge der Agentur.',
  [tokens.settings.allowedSendersPlaceholder]: 'name@kunde.de',
  [tokens.settings.allowedSendersAdd]: 'Hinzufügen',
  [tokens.settings.allowedSendersInvalid]: 'Geben Sie eine vollständige Adresse (name@domain.de) ein.',
  [tokens.settings.allowedSendersDuplicate]: 'Bereits in der Liste.',
  [tokens.settings.allowedSendersAddresses]: 'Adressen',
  [tokens.settings.allowedSendersRemove]: 'Entfernen',
  [tokens.settings.allowedSendersDefault]: 'Standard',
  [tokens.settings.allowedSendersAgencyMembers]: 'Mitglieder der Agentur ({{count}})',
  [tokens.settings.allowedSendersDefaultHint]: 'Mitglieder der Agentur sind standardmäßig zugelassen.',
  [tokens.settings.allowedSendersOnlyMembers]: 'Nur Mitglieder der Agentur können an ihre Posteingänge schreiben.',
  [tokens.settings.allowedSendersAdded]: '{{email}} ist zugelassen',
  [tokens.settings.allowedSendersRemoved]: '{{email}} ist nicht mehr zugelassen',
  [tokens.settings.allowedSendersError]: 'Die Absenderliste konnte nicht geändert werden.',
  [tokens.settings.inboxRejectedTitle]: 'Kürzlich abgelehnt',
  [tokens.settings.inboxRejectedTo]: '{{date}} · an {{inbox}}',
  [tokens.settings.inboxRejectedAllow]: 'Zulassen',
  [tokens.settings.inboxRejectedDismiss]: 'Ignorieren',
  [tokens.settings.inboxRejectedCount]: '{{count}} E-Mail',
  [tokens.settings.inboxRejectedCount_other]: '{{count}} E-Mails',
  [tokens.settings.inboxRejectedPaused]: 'Posteingang pausiert',
  [tokens.settings.inboxEditorNewTitle]: 'Neuer Posteingang',
  [tokens.settings.inboxEditorEditTitle]: 'Posteingang bearbeiten',
  [tokens.settings.inboxEditorAddress]: 'Empfangsadresse',
  [tokens.settings.inboxEditorPrefixHint]: 'Kleinbuchstaben, Ziffern und Bindestriche. Nur zugelassene Absender der Agentur können daran schreiben.',
  [tokens.settings.inboxEditorWhatItDoes]: 'Was diese Adresse tut',
  [tokens.settings.inboxEditorNotify]: 'Benachrichtigen',
  [tokens.settings.inboxEditorNotifyHint]: 'Diese Personen erhalten bei jedem erstellten Dossier eine E-Mail.',
  [tokens.settings.inboxEditorFieldType]: 'Dossiertyp',
  [tokens.settings.inboxEditorFieldClient]: 'Kunde',
  [tokens.settings.inboxEditorFieldClientPlaceholder]: 'Aus den Dokumenten gelesen',
  [tokens.settings.inboxEditorFieldAssignee]: 'Zugewiesen an',
  [tokens.settings.inboxEditorPreparation]: 'Vorbereitung',
  [tokens.settings.inboxEditorPrepSmart]: 'Intelligente Vorbereitung',
  [tokens.settings.inboxEditorPrepClassic]: 'Klassische Vorbereitung',
  [tokens.settings.inboxEditorDelete]: 'Löschen',
  [tokens.settings.inboxEditorCancel]: 'Abbrechen',
  [tokens.settings.inboxEditorCreate]: 'Posteingang erstellen',
  [tokens.settings.inboxEditorSave]: 'Speichern',
  [tokens.settings.inboxEditorClose]: 'Schließen',
  [tokens.settings.inboxStepMailTitle]: 'Eine E-Mail kommt an',
  [tokens.settings.inboxStepMailBody]: 'mit ihren Anhängen, von einem zugelassenen Absender der Agentur',
  [tokens.settings.inboxStepFolderTitle]: 'Nabu erstellt ein Dossier',
  [tokens.settings.inboxStepFolderBody]: 'Vom Typ <type>{{type}}</type>, mit dem Ablauf <flow>{{flow}}</flow>, für <client>{{client}}</client>',
  [tokens.settings.inboxStepPrepTitle]: 'Vorbereitung',
  [tokens.settings.inboxStepPrepBody]: 'Dieses Dossier wird mit <prep>{{prep}}</prep> vorbereitet',
  [tokens.settings.inboxPrepSmartPhrase]: 'der intelligenten Vorbereitung',
  [tokens.settings.inboxPrepClassicPhrase]: 'der klassischen Vorbereitung',
  [tokens.settings.inboxStepAssignTitle]: 'Es wird zugewiesen',
  [tokens.settings.inboxStepAssignBody]: 'an <user>{{user}}</user>',
  [tokens.settings.inboxStepAssignNotified]: ', und {{count}} Person wird benachrichtigt',
  [tokens.settings.inboxStepAssignNotified_other]: ', und {{count}} Personen werden benachrichtigt',
  [tokens.settings.inboxMissingType]: 'Typ auswählen',
  [tokens.settings.inboxMissingFlow]: 'Ablauf auswählen',
  [tokens.settings.inboxMissingAssignee]: 'Person auswählen',
  [tokens.settings.inboxCreated]: 'Posteingang erstellt',
  [tokens.settings.inboxSaved]: 'Posteingang gespeichert',
  [tokens.settings.inboxDeleted]: 'Posteingang gelöscht',
  [tokens.settings.inboxSaveError]: 'Der Posteingang konnte nicht gespeichert werden.',
  [tokens.settings.inboxDeleteError]: 'Der Posteingang konnte nicht gelöscht werden.',
  [tokens.settings.inboxPrefixTaken]: 'Dieses Präfix wird bereits von einem anderen Posteingang verwendet.',
  [tokens.settings.inboxDeleteConfirm]: 'Posteingang {{address}} löschen? E-Mails an diese Adresse erstellen dann keine Dossiers mehr.',
  [tokens.floatinglabelform.save]: 'Speichern',
  [tokens.floatinglabelform.apply]: 'Anwenden',
  [tokens.floatinglabelform.text]: 'Text',
  [tokens.viewer.doYouWantToDeleteTheTable]: 'Do you want to delete the table',
  [tokens.viewer.apply]: 'Anwenden',
  [tokens.viewer.adjustTheDocument]: 'Adjust the document',
  [tokens.viewer.selectedLabel]: 'Selected label',
  [tokens.viewer.selectADocument]: 'Select a document',
  [tokens.viewer.applyAModel]: 'Modell anwenden',
  [tokens.viewer.newColumn]: 'New column',
  [tokens.viewer.selectColumnTooltip]:
    'Klicken, um die gesamte Spalte zum Verschieben auszuwählen. Umschalt+Klick auf eine Zelle: gleiche Aktion.',
  [tokens.viewer.selectColumnTooltipExcel]:
    'Klicken, um die gesamte Spalte zum Verschieben auszuwählen.',
  [tokens.viewer.invoice]: 'Rechnung',
  [tokens.classification.layers]: 'Layers',
  [tokens.classification.manualLayer]: 'Manual',
  [tokens.classification.searchClassificationType]:
    'Nach einem Klassifizierungstyp suchen',
  [tokens.classification.outOf]: 'in',
  [tokens.classification.validate]: 'Bestätigen',
  [tokens.classification.unknownDocument]: 'unbekanntes Dokument',
  [tokens.classification.unknownDocuments]: 'unbekannte Dokumente',
  [tokens.classification.addExtractionMode]: 'Add extraction mode',
  [tokens.classification.ignoreDocument]: 'Dokument ignorieren',
  [tokens.classification.includeDocument]: 'Dokument einschliessen',
  [tokens.classification.fieldRequired]: 'Field is required',
  [tokens.classification.selectExtractionMode]: 'Extraction mode',
  [tokens.classification.onlyInvoicesAllowed]:
    'Only invoices or EAD are accepted',
  [tokens.classification.noLeadDocument]:
    'Mindestens ein Export-Leitdokument ist erforderlich',
  [tokens.classification.someDocumentsWithoutClassification]:
    'Einige Dokumente sind nicht klassifiziert',
  [tokens.classification.hasNoExportConfiguration]: 'Der Anmeldetyp fehlt',
  [tokens.classification.document]: '{{count}} Dokument',
  [tokens.classification.document_other]: '{{count}} Dokumente',
  [tokens.classification.page]: '{{count}} Seite',
  [tokens.classification.page_other]: '{{count}} Seiten',
  [tokens.classification.MT700]: 'MT 700',
  [tokens.classification.weight_note]: 'Weight note',
  [tokens.classification.exchange_bill]: 'Bill of exchange',
  [tokens.classification.origin_certif]: 'Certificate of origin',
  [tokens.classification.multimodal_doc]: 'Multimodal transport document',
  [tokens.classification.flight_letter]: 'Air waybill',
  [tokens.classification.sea_waybill]: 'Sea waybill',
  [tokens.classification.road_document]: 'Road Transport Document',
  [tokens.classification.delivery_note]: 'Empfangsschein',
  [tokens.classification.insurance_policy]: 'Insurance policy',
  [tokens.classification.bill_of_lading]: '6 Konnossement',
  [tokens.classification.single_administrative_document]: 'SAD',
  [tokens.classification.commercial_invoice]: 'Commercial invoice',
  [tokens.classification.customs_instructions]: 'Customs instructions',
  [tokens.classification.packing_list]: 'Packing list',
  [tokens.classification.hscodes_list]: 'HS Codes list',
  [tokens.classification.t1]: 'T1-Versand',
  [tokens.classification.t2]: 'T2-Versand',
  [tokens.classification.t2l]: 'T2L / T2LF',
  [tokens.classification.ata]: 'ATA-Carnet',
  [tokens.classification.bae]: 'Freigabevermerk',
  [tokens.classification.invoice_summary]: 'Rechnungszusammenfassung',
  [tokens.classification.electronic_accompanying_document]: 'EAD',
  [tokens.classification.EAD]: 'Ausfuhrbegleitdokument',
  [tokens.classification.conversation]: 'Konversation',
  [tokens.classification.terms_and_conditions]: 'Allgemeine Geschäftsbedingungen',
  [tokens.classification.model]: 'Angewendetes Modell',
  [tokens.classification.setting_keys]: 'Applied setting keys',
  [tokens.classification.MT700_short]: 'MT 700',
  [tokens.classification.weight_note_short]: 'Weight note',
  [tokens.classification.exchange_bill_short]: 'BE',
  [tokens.classification.origin_certif_short]: 'Certificate of origin',
  [tokens.classification.multimodal_doc_short]: 'MTD',
  [tokens.classification.flight_letter_short]: 'Air waybill',
  [tokens.classification.sea_waybill_short]: 'Sea waybill',
  [tokens.classification.road_document_short]: 'RTD',
  [tokens.classification.delivery_note_short]: 'Empfangsschein',
  [tokens.classification.insurance_policy_short]: 'Insurance policy',
  [tokens.classification.bill_of_lading_short]: 'BL',
  [tokens.classification.single_administrative_document_short]: 'SAD',
  [tokens.classification.commercial_invoice_short]: 'Rechnung',
  [tokens.classification.customs_instructions_short]: 'Customs instr.',
  [tokens.classification.packing_list_short]: 'PL',
  [tokens.classification.hscodes_list_short]: 'HS-Codes',
  [tokens.classification.t1_short]: 'T1',
  [tokens.classification.t2_short]: 'T2',
  [tokens.classification.t2l_short]: 'T2L',
  [tokens.classification.ata_short]: 'ATA',
  [tokens.classification.bae_short]: 'BAE',
  [tokens.classification.invoice_summary_short]: 'Rechnungszusammenfassung',
  [tokens.classification.electronic_accompanying_document_short]: 'EAD',
  [tokens.classification.EAD_short]: 'EAD',
  [tokens.classification.conversation_short]: 'Konversation',
  [tokens.classification.email_short]: 'Mail',
  [tokens.connector.addConnector]: 'Add connector',
  [tokens.filter.sortBy]: 'Sort By',
  [tokens.filter.searchOrganization]: 'Search an organization',
  [tokens.filter.searchUser]: 'Search an user',
  [tokens.filter.searchLayer]: 'Search a layer',
  [tokens.filter.lastUpdateNewest]: 'Last update (newest)',
  [tokens.filter.lastUpdateOldest]: 'Last update (oldest)',
  [tokens.customerFlow.customer]: 'Auftraggeber:Innen',
  [tokens.customerFlow.model]: 'Modell',
  [tokens.customerFlow.areYouSureYouWantToDeleteThisModel]:
    'Moechten Sie diesen Workflow wirklich loeschen?',
  [tokens.customerFlow.documentType]: 'Dokumenttyp',
  [tokens.customerFlow.removeCustomerTitle]: 'Delete a customer',
  [tokens.customerFlow.removeCustomerText]:
    'Do you really want to delete this customer?',
  [tokens.customerFlow.customerHasBeenDeleted]: 'The customer has been deleted',
  [tokens.customerFlow.customerHasNotBeenDeleted]: 'Cannot delete the customer',
  [tokens.customerFlow.removeModelTitle]: 'Modell löschen',
  [tokens.customerFlow.removeModelText]:
    'Möchten Sie dieses Modell wirklich löschen?',
  [tokens.customerFlow.modelHasBeenDeleted]: 'Das Modell wurde gelöscht',
  [tokens.customerFlow.modelHasNotBeenDeleted]:
    'Modell konnte nicht gelöscht werden',
  [tokens.common.modelShareToOtherGroup]:
    'Dieses Modell mit einer anderen Agentur teilen',
  [tokens.common.modelShareToOtherGroupText]:
    'Dieses Modell zu den für andere Agenturen in Ihrer Organisation sichtbaren Modellen hinzufügen.',
  [tokens.customerFlow.settingKeyDeleted]: 'The setting key has been deleted',
  [tokens.customerFlow.actionFailed]: 'Action failed',
  [tokens.customerFlow.settingKeyCreated]: 'The setting key has been created',
  [tokens.customerFlow.settingKeyUpdated]: 'The setting key has been updated',
  [tokens.customerFlow.sender]: 'Sender',
  [tokens.customerFlow.modelType]: 'Modelltyp',
  [tokens.customerFlow.informations]: 'Informationen',
  [tokens.customerFlow.documentModels]: 'Document models',
  [tokens.customerFlow.nameOfModel]: 'Name of the model',
  [tokens.customerFlow.issuesSettingsOptions]: 'Error loading keys',
  [tokens.customerFlow.noModelAvailable]: 'Kein Modell verfügbar',
  [tokens.customerFlow.unknownUser]: 'Unbekannt',
  [tokens.customerFlow.deleteThisModel]: 'Dieses Modell löschen',
  [tokens.customerFlow.deleteModelSuccess]: 'Modell erfolgreich gelöscht',
  [tokens.customerFlow.deleteModelFailed]: 'Löschen des Modells fehlgeschlagen',
  [tokens.customerFlow.duplicateThisModel]: 'Dieses Modell duplizieren',
  [tokens.customerFlow.duplicateModelTitle]: 'Modell duplizieren',
  [tokens.customerFlow.duplicateModelText]:
    'Eine Kopie von „{{name}}“ wird in Ihrer Agentur erstellt. Freigaben werden nicht kopiert.',
  [tokens.customerFlow.duplicateModelNamePlaceholder]:
    'Leer lassen für automatischen Namen (z. B. „{{name}} - (1)“)',
  [tokens.customerFlow.duplicateModelNameTooShort]:
    'Der Name muss mindestens 3 Zeichen lang sein',
  [tokens.customerFlow.duplicateModelConfirm]: 'Duplizieren',
  [tokens.customerFlow.duplicateModelSuccess]: 'Modell erfolgreich dupliziert',
  [tokens.customerFlow.duplicateModelFailed]:
    'Fehler beim Duplizieren des Modells',
  [tokens.customerFlow.bulkSelectedCount]: 'Modell ausgewählt',
  [tokens.customerFlow.bulkSelectedCount_other]: 'Modelle ausgewählt',
  [tokens.customerFlow.bulkDuplicate]: 'Duplizieren',
  [tokens.customerFlow.bulkDelete]: 'Löschen',
  [tokens.customerFlow.modelsDuplicated]: '{{count}} Modell dupliziert',
  [tokens.customerFlow.modelsDuplicated_other]: '{{count}} Modelle dupliziert',
  [tokens.customerFlow.modelsNotDuplicated]:
    'Fehler beim Duplizieren des Modells',
  [tokens.customerFlow.modelsNotDuplicated_other]:
    'Fehler beim Duplizieren der Modelle',

  [tokens.customerFlow.customersPageTitle]: 'Kundenorganisationen',
  [tokens.customerFlow.customersPageSubtitle]:
    'Zentralisierte Liste der Kunden aller Agenturen. Filtern Sie, um Kunden einer bestimmten Agentur anzuzeigen.',
  [tokens.customerFlow.customersInfoPopoverTitle]: 'Was sind Kunden?',
  [tokens.customerFlow.customersInfoPopoverBody]:
    'Ihre Kunden sind die Organisationen, für die Sie Zollanmeldungen erstellen. Sie können sie einer Agentur zuordnen, um den Zugriff zu trennen und Workflows zu automatisieren.',
  [tokens.customerFlow.customersInfoHelpLink]: 'Mehr im Hilfe-Center',
  [tokens.customerFlow.customersSearchPlaceholder]: 'Kunden suchen…',
  [tokens.customerFlow.allAgencies]: 'Alle Agenturen',
  [tokens.customerFlow.customersCount]: '{{count}} Kunden',
  [tokens.customerFlow.addCustomer]: 'Kunden hinzufügen',
  [tokens.customerFlow.addModel]: 'Modell erstellen',
  [tokens.customerFlow.addModelAgency]: 'Agentur',
  [tokens.customerFlow.addModelDeclarationType]: 'Art der Anmeldung',
  [tokens.customerFlow.addModelSubtitle]: 'Ein Modell füllt die gewählten Felder aus, sobald es auf ein Dossier angewendet wird.',
  [tokens.customerFlow.addModelIdentification]: 'Identifikation',
  [tokens.customerFlow.addModelName]: 'Name des Modells',
  [tokens.customerFlow.addModelNamePlaceholder]: 'Z. B. Export Delta E — Le Havre Straße',
  [tokens.customerFlow.addModelDeclarationTypeHint]: 'Legt fest, welche Felder das Modell ausfüllen kann.',
  [tokens.customerFlow.addModelDeclarationTypePlaceholder]: 'Art wählen',
  [tokens.customerFlow.addModelNoDeclarationType]: 'Für diese Agentur ist keine Art der Anmeldung eingerichtet: Wählen Sie eine andere.',
  [tokens.customerFlow.addModelNoDeclarationTypePlaceholder]: 'Keine Art verfügbar',
  [tokens.customerFlow.addModelFields]: 'Felder des Modells',
  [tokens.customerFlow.addModelFieldsCount]: 'Felder des Modells · {{count}}',
  [tokens.customerFlow.addModelChooseTypeFirst]: 'Wählen Sie eine Art der Anmeldung, um Felder hinzuzufügen.',
  [tokens.customerFlow.addModelSchemaError]: 'Die Felder dieser Art der Anmeldung konnten nicht geladen werden.',
  [tokens.customerFlow.addModelAddField]: 'Feld hinzufügen: Incoterm, Zollstelle, Beförderung…',
  [tokens.customerFlow.addModelNoFieldFound]: 'Kein Feld gefunden',
  [tokens.customerFlow.addModelEmptyTitle]: 'Noch kein Feld',
  [tokens.customerFlow.addModelEmptyBody]: 'Fügen Sie die Felder hinzu, die dieses Modell ausfüllen soll. Die übrigen bleiben im Dossier auszufüllen.',
  [tokens.customerFlow.addModelRemoveField]: 'Feld {{name}} entfernen',
  [tokens.customerFlow.addModelRemoveRow]: 'Zeile {{index}} entfernen',
  [tokens.customerFlow.addModelAddRow]: 'Zeile hinzufügen',
  [tokens.customerFlow.addModelFieldRequired]: 'Geben Sie einen Wert ein oder entfernen Sie das Feld.',
  [tokens.customerFlow.addModelMissingName]: 'Geben Sie dem Modell einen Namen.',
  [tokens.customerFlow.addModelMissingDeclarationType]: 'Wählen Sie eine Art der Anmeldung.',
  [tokens.customerFlow.addModelMissingField]: 'Fügen Sie mindestens ein Feld hinzu.',
  [tokens.customerFlow.addModelEmptyFields]: '{{count}} Feld ohne Wert: ausfüllen oder entfernen.',
  [tokens.customerFlow.addModelEmptyFields_other]: '{{count}} Felder ohne Wert: ausfüllen oder entfernen.',
  [tokens.customerFlow.addModelSubmit]: 'Modell erstellen',
  [tokens.customerFlow.columnName]: 'Name',
  [tokens.customerFlow.columnAddress]: 'Adresse',
  [tokens.customerFlow.columnContact]: 'Kontakt',
  [tokens.customerFlow.columnAgency]: 'Agentur',
  [tokens.customerFlow.columnCreatedAt]: 'Erstellungsdatum',
  [tokens.customerFlow.viewCustomerDetail]: 'Details anzeigen',
  [tokens.customerFlow.agencyRequired]: 'Agentur ist erforderlich',
  [tokens.customerFlow.customerNameRequired]: 'Name ist erforderlich',
  [tokens.customerFlow.backToCustomers]: 'Zurück zu den Kunden',
  [tokens.customerFlow.backToModels]: 'Zurück zu den Modellen',
  [tokens.customerFlow.flowDetailDeclarationLabel]: 'Anmeldungstyp: {{type}}',
  [tokens.customerFlow.flowDetailConfigSectionTitle]: 'Modellkonfiguration',
  [tokens.customerFlow.flowDetailConfigSectionSubtitle]:
    'Legen Sie die Standardwerte fest, die bei der Verwendung dieses Modells gelten.',
  [tokens.customerFlow.tabGeneral]: 'Allgemein',
  [tokens.customerFlow.tabConfiguration]: 'Konfiguration',
  [tokens.customerFlow.tabReferentials]: 'Referenzdaten',
  [tokens.customerFlow.noReferentialsForClient]:
    'Diesem Kunden sind keine Referenzdaten zugeordnet',
  [tokens.customerFlow.customerDetailAgencyLabel]: 'Agentur: {{name}}',
  [tokens.customerFlow.customerDetailNoAgency]:
    'Diesem Kunden ist keine Agentur zugeordnet.',
  [tokens.customerFlow.customerDetailConfigInfoAlert]:
    'Alle Konfigurationen für diese Kundenorganisation gelten für jede Anmeldung dieser Kundenorganisation.',
  [tokens.customerFlow.customerDetailConfigSectionTitle]: 'Kundenkonfiguration',
  [tokens.customerFlow.customerDetailConfigSectionSubtitle]:
    'Von Agentur- oder Organisationskonfiguration geerbte Werte. Schalter deaktivieren zum Überschreiben; kundenspezifische Felder können hinzugefügt werden.',
  [tokens.customerFlow.customerDetailConfigInheritanceTitle]:
    'Agenturkonfiguration beibehalten',
  [tokens.customerFlow.customerDetailConfigInheritanceDescription]:
    'Dieser Kunde nutzt Werte auf Agentur- oder Organisationsebene. Deaktivieren für kundenspezifische Werte.',
  [tokens.customerFlow.configSourceClient]: 'Kunde',
  [tokens.customerFlow.configSourceAgency]: 'Agentur',
  [tokens.customerFlow.configSourceOrganization]: 'Organisation',

  [tokens.referentials.pageTitle]: 'Referenzdaten',
  [tokens.referentials.pageSubtitle]:
    'Eine persistente Geschäftsdatenbank für Abfrage, Aktualisierung und Automatisierung Ihrer Erklärungen.',
  [tokens.referentials.detailPageTitle]: 'Referenzdatenbank',
  [tokens.referentials.searchPlaceholder]: 'Referenzdaten suchen…',
  [tokens.referentials.allClients]: 'Alle Kunden',
  [tokens.referentials.independentOnly]: 'Unabhängig',
  [tokens.referentials.allStatuses]: 'Alle Status',
  [tokens.referentials.activeOnly]: 'Aktiv',
  [tokens.referentials.inactiveOnly]: 'Inaktiv',
  [tokens.referentials.resultsCount]: '{{count}} Referenzdatenbank',
  [tokens.referentials.resultsCount_other]: '{{count}} Referenzdatenbanken',
  [tokens.referentials.newReferential]: 'Neue Referenzdatenbank',
  [tokens.referentials.createModalTitle]: 'Neue Referenzdatenbank',
  [tokens.referentials.createModalDescription]:
    'Importieren Sie eine Datei oder erstellen Sie eine leere Basis zum späteren Ausfüllen.',
  [tokens.referentials.fieldNameLabel]: 'Name der Referenzdatenbank',
  [tokens.referentials.fieldNamePlaceholder]: 'z. B. Holdtrans, Textilartikel',
  [tokens.referentials.fieldDescriptionPlaceholder]:
    'Wofür dient diese Referenzdatenbank? (optional)',
  [tokens.referentials.fieldDataFileLabel]: 'Datendatei',
  [tokens.referentials.uploadZoneTitle]:
    'Datei hierher ziehen oder zum Durchsuchen klicken',
  [tokens.referentials.uploadZoneFormats]: '.xlsx · .xls · .csv · max. 20 MB',
  [tokens.referentials.fieldClientLabel]: 'Mit Kunde verknüpfen',
  [tokens.referentials.clientIndependentOption]: 'Unabhängig (kein Kunde)',
  [tokens.referentials.fieldAgencyLabel]: 'Agentur',
  [tokens.referentials.fieldAgencyTooltip]:
    'Verknüpfen Sie eine Agentur, um die Automatisierungen dieses Referenzdatensatzes der gewählten Agentur zuzuordnen.',
  [tokens.referentials.fieldConfigurationLabel]: 'Konfiguration',
  [tokens.referentials.fieldConfigurationTooltip]:
    'Dient als Matching-Bedingung für Automatisierungen.',
  [tokens.referentials.fieldDataFileTooltip]:
    'Importieren Sie Ihre Referenzdatenbank im Format .xlsx, .xls oder .csv. Die erste Zeile Ihrer Tabelle entspricht den Spaltenüberschriften, die folgenden Zeilen sind Ihre Daten. Alle Zeilen werden berücksichtigt. Sie können sie dennoch manuell bearbeiten oder die gesamte Referenzdatenbank aktualisieren.',
  [tokens.referentials.fieldClientTooltip]:
    'Verknüpfen Sie Ihre Referenzdatenbank mit einem Kunden.',
  [tokens.referentials.createReferentialButton]: 'Referenzdatenbank erstellen',
  [tokens.referentials.createEmptyBaseLink]: 'Leere Basis ohne Datei erstellen',
  [tokens.referentials.emptyBaseSelected]: 'Leere Basis ausgewählt',
  [tokens.referentials.fileTooLarge]:
    'Die Datei überschreitet die maximale Größe von 20 MB',
  [tokens.referentials.invalidFileType]:
    'Nicht unterstütztes Format. Verwenden Sie .xlsx, .xls oder .csv',
  [tokens.referentials.columnReferential]: 'Referenz',
  [tokens.referentials.columnDescription]: 'Beschreibung',
  [tokens.referentials.columnClient]: 'Kunde',
  [tokens.referentials.columnRows]: 'Zeilen',
  [tokens.referentials.columnAutomations]: 'Autos',
  [tokens.referentials.columnUpdatedAt]: 'Aktualisiert',
  [tokens.referentials.attachedToClient]: 'Kundenbezogen',
  [tokens.referentials.independent]: 'Unabhängig',
  [tokens.referentials.noReferentialsFound]: 'Keine Referenzdaten gefunden',
  [tokens.referentials.referentialCreated]:
    'Referenzdatenbank erfolgreich erstellt',
  [tokens.referentials.errorCreatingReferential]:
    'Fehler beim Erstellen der Referenzdatenbank',
  [tokens.referentials.importFile]: 'Datei importieren',
  [tokens.referentials.emptyBase]: 'Leere Basis',
  [tokens.referentials.nameRequired]: 'Name ist erforderlich',
  [tokens.referentials.configurationRequired]: 'Konfiguration ist erforderlich',
  [tokens.referentials.agencyRequired]: 'Agentur ist erforderlich',
  [tokens.referentials.importOrEmptyRequired]:
    'Datei importieren oder leere Basis wählen',
  [tokens.referentials.automationsTooltip]:
    '{{conditions}} Bedingung(en) · {{actions}} Aktion(en)',
  [tokens.referentials.automationsTooltipCondition]:
    'Bedingung · Spalte {{column}}',
  [tokens.referentials.automationsTooltipAction]: 'Aktion · Spalte {{column}}',
  [tokens.referentials.columnsTooltipTitle]: '{{count}} Referenzspalten',
  [tokens.referentials.automationsTooltipTitle]:
    '{{count}} Automatisierung(en)',
  [tokens.referentials.automationReplacesLabel]: 'Ersetzt: {{fields}}',
  [tokens.referentials.backToList]: 'Zurück zur Liste',
  [tokens.referentials.detailComingSoon]:
    'Die bearbeitbare Detailansicht folgt im nächsten Schritt.',
  [tokens.referentials.conditionsCount]: 'Bedingungen',
  [tokens.referentials.actionsCount]: 'Aktionen',
  [tokens.referentials.rowsUnknown]: '—',
  [tokens.referentials.rowsLoaded]: '{{count}} Zeilen geladen',
  [tokens.referentials.openReferential]: 'Öffnen',
  [tokens.referentials.deleteReferential]: 'Löschen',
  [tokens.referentials.deleteReferentialConfirm]:
    'Referenzdatenbank « {{name}} » löschen?',
  [tokens.referentials.referentialDeleted]: 'Referenzdatenbank gelöscht',
  [tokens.referentials.backToAllReferentials]: 'Alle Referenzdaten',
  [tokens.referentials.refresh]: 'Aktualisieren',
  [tokens.referentials.exportXlsx]: 'Exportieren (.xlsx)',
  [tokens.referentials.rowsCount]: '{{count}} Zeilen',
  [tokens.referentials.columnsCount]: '{{count}} Spalten',
  [tokens.referentials.lastUpdatedLabel]: 'Aktualisiert am {{date}}',
  [tokens.referentials.editName]: 'Name bearbeiten',
  [tokens.referentials.editDescription]: 'Beschreibung bearbeiten',
  [tokens.referentials.addDescription]: 'Beschreibung hinzufügen',
  [tokens.referentials.searchRowsPlaceholder]: 'Artikel suchen…',
  [tokens.referentials.cellsFilledPercent]:
    '{{percent}} % der Zellen ausgefüllt',
  [tokens.referentials.emptyCell]: 'leer',
  [tokens.referentials.emptyGridMessage]:
    'Diese Referenzdatenbank enthält noch keine Daten.',
  [tokens.referentials.noAutomationYet]: 'Keine Automatisierung konfiguriert',
  [tokens.referentials.toggleActive]:
    'Referenzdatenbank aktivieren oder deaktivieren',
  [tokens.referentials.referentialUpdated]: 'Referenzdatenbank aktualisiert',
  [tokens.referentials.errorUpdatingReferential]:
    'Fehler beim Aktualisieren der Referenzdatenbank',
  [tokens.referentials.errorExportingReferential]:
    'Fehler beim Export der Referenzdatenbank',
  [tokens.referentials.columnUpdatedAt]: 'Aktualisiert',
  [tokens.referentials.addRow]: 'Zeile hinzufügen',
  [tokens.referentials.gridFooterHint]:
    'Klicken Sie auf eine Zelle zum Bearbeiten • Zeile ankreuzen zum Duplizieren, Einfügen oder Löschen • « + » rechts zum Hinzufügen einer Spalte',
  [tokens.referentials.rowActions]: 'Aktionen',
  [tokens.referentials.selectedRowsCount]: '{{count}} Zeile(n) ausgewählt',
  [tokens.referentials.duplicateRow]: 'Zeile duplizieren',
  [tokens.referentials.insertRowBelow]: 'Zeile darunter einfügen',
  [tokens.referentials.insertRowAbove]: 'Zeile darüber einfügen',
  [tokens.referentials.deleteRow]: 'Zeile löschen',
  [tokens.referentials.clearRowSelection]: 'Zeilenauswahl aufheben',
  [tokens.referentials.gridSaving]: 'Speichern…',
  [tokens.referentials.gridSaved]: 'Änderungen gespeichert',
  [tokens.referentials.gridSaveError]: 'Fehler beim Speichern',
  [tokens.referentials.gridMissingTitle]:
    'Der Inhalt der Referenzdatenbank « {{name}} » wurde nicht gefunden',
  [tokens.referentials.gridMissingDescription]:
    'Die Datendatei fehlt, daher lässt sich diese Referenzdatenbank nicht öffnen. Löschen Sie sie in der Liste und legen Sie sie anschließend aus Ihrer Datei neu an.',
  [tokens.referentials.columnLinkSaved]: 'Spaltenverknüpfung gespeichert',
  [tokens.referentials.columnLinkSaveError]:
    'Fehler beim Speichern der Spaltenverknüpfung',
  [tokens.referentials.columnNameLabel]: 'Spaltenname',
  [tokens.referentials.columnLinkLabel]: 'Mit Datenfeld verknüpfen',
  [tokens.referentials.columnLinkPlaceholder]: 'Feld auswählen…',
  [tokens.referentials.columnLinkNoResults]: 'Keine Felder gefunden',
  [tokens.referentials.columnLinkHelper]:
    'Die Werte dieser Spalte speisen das gewählte Feld bei Automatisierungen.',
  [tokens.referentials.removeColumn]: 'Spalte entfernen',
  [tokens.referentials.addColumn]: 'Spalte hinzufügen',
  [tokens.referentials.addCardinalColumn]: 'Kardinale Spalten',
  [tokens.referentials.addCustomColumn]: 'Benutzerdefinierte Spalte',
  [tokens.referentials.customColumnOption]: 'Neue freie Spalte',
  [tokens.referentials.allCardinalColumnsUsed]:
    'Alle Kardinalspalten sind vergeben',
  [tokens.referentials.cardinalColumnBadge]: 'Kardinale Spalte',
  [tokens.referentials.untitledColumn]: 'Ohne Titel',
  [tokens.referentials.automationConditionsTitle]: 'Abgleichbedingungen',
  [tokens.referentials.automationActionsTitle]: 'Aktionen auf der Erklärung',
  [tokens.referentials.automationAddCondition]: '+ Bedingung hinzufügen',
  [tokens.referentials.automationAddAction]: '+ Aktion hinzufügen',
  [tokens.referentials.automationConditionsHelper]:
    'Die Bedingungen werden der Reihe nach ausgewertet. Die Anreicherung wird nur angewendet, wenn alle Bedingungen erfüllt sind.',
  [tokens.referentials.automationDeclarationColumnPlaceholder]:
    'Erklärungsspalte',
  [tokens.referentials.automationReferentialColumnPlaceholder]:
    'Referenzspalte',
  [tokens.referentials.automationRelationPlaceholder]: 'Relation',
  [tokens.referentials.automationRelationEq]: 'gleich',
  [tokens.referentials.automationRelationLt]: 'kleiner als',
  [tokens.referentials.automationRelationGt]: 'größer als',
  [tokens.referentials.automationRelationIncludes]: 'Enthält',
  [tokens.referentials.automationActionReplace]: 'Ersetzen',
  [tokens.referentials.automationActionFillIfEmpty]: 'Nur wenn leer',
  [tokens.referentials.automationRemoveCondition]: 'Bedingung entfernen',
  [tokens.referentials.automationRemoveAction]: 'Aktion entfernen',
  [tokens.referentials.automationSave]: 'Speichern',
  [tokens.referentials.automationSaved]: 'Automatisierung gespeichert',
  [tokens.referentials.automationSaveError]:
    'Fehler beim Speichern der Automatisierung',
  [tokens.referentials.deleteAutomation]: 'Löschen',
  [tokens.referentials.deleteAutomationConfirm]:
    'Automatisierung für diese Referenzdatenbank löschen? Bedingungen und Aktionen werden entfernt.',
  [tokens.referentials.automationDeleted]: 'Automatisierung gelöscht',
  [tokens.referentials.automationDeleteError]:
    'Fehler beim Löschen der Automatisierung',
  [tokens.referentials.automationCreateSimplified]:
    '+ Vereinfachte Automatisierung erstellen',
  [tokens.referentials.automationAutoRunLabel]: 'Automatisch aktivieren',
  [tokens.referentials.automationAutoRunTooltip]:
    'Automatisierung bei Erstellung einer Erklärung ausführen',
  [tokens.referentials.automationActiveLabel]: 'Verfügbar',
  [tokens.referentials.automationInactiveLabel]: 'Nicht verfügbar',
  [tokens.referentials.toggleAutomationAvailable]:
    'Automatisierung für Erklärungen verfügbar oder nicht verfügbar machen',
  [tokens.referentials.importModalTitle]: 'Per Import aktualisieren',
  [tokens.referentials.importModalSubtitle]:
    'Importieren Sie eine Excel- oder CSV-Datei, um diese Referenzdatenbank zu aktualisieren.',
  [tokens.referentials.importClickOrDrag]: 'Klicken oder Datei ziehen',
  [tokens.referentials.importModeComplete]: 'Bestehendes ergänzen',
  [tokens.referentials.importModeCompleteDesc]:
    'Fügt neue Zeilen zur Referenzdatenbank hinzu, ohne Bestehendes zu ändern.',
  [tokens.referentials.importModeReplace]: 'Alles ersetzen',
  [tokens.referentials.importModeReplaceDesc]:
    'Leert die Referenzdatenbank und importiert die Datei.',
  [tokens.referentials.importNext]: 'Weiter',
  [tokens.referentials.importBack]: 'Zurück',
  [tokens.referentials.importConfirm]: 'Importieren',
  [tokens.referentials.importDuplicateTitle]:
    'Wie sollen Duplikate behandelt werden?',
  [tokens.referentials.importDuplicateHelper]:
    'Wenn eine importierte Zeile einer vorhandenen Zeile entspricht (gleiche {{column}}).',
  [tokens.referentials.importDuplicateOverwrite]: 'Duplikate überschreiben',
  [tokens.referentials.importDuplicateOverwriteDesc]:
    'Die vorhandene Zeile wird durch die aus der Datei ersetzt.',
  [tokens.referentials.importDuplicateIgnore]: 'Duplikate ignorieren',
  [tokens.referentials.importDuplicateIgnoreDesc]:
    'Die vorhandene Zeile bleibt erhalten, die importierte wird ignoriert.',
  [tokens.referentials.importDuplicateKeepBoth]: 'Beide behalten',
  [tokens.referentials.importDuplicateKeepBothDesc]:
    'Die importierte Zeile wird als neuer Eintrag hinzugefügt.',
  [tokens.referentials.importColumnMappingTitle]: 'Spaltenzuordnung',
  [tokens.referentials.importDuplicateKeyLabel]:
    'Duplikate identifizieren über Spalte:',
  [tokens.referentials.importFileSummary]:
    '{{rows}} Zeilen · {{columns}} Spalten erkannt',
  [tokens.referentials.importEmptyFile]: 'Die Datei enthält keine Datenzeilen.',
  [tokens.referentials.importInvalidFile]:
    'Diese Datei konnte nicht gelesen werden.',
  [tokens.referentials.importSuccessTitle]: 'Import erfolgreich',
  [tokens.referentials.importSuccessSummary]:
    '{{count}} Zeilen wurden erfolgreich verarbeitet.',
  [tokens.referentials.importStatsCreated]: '{{count}} Zeilen erstellt',
  [tokens.referentials.importStatsUpdated]: '{{count}} Zeilen aktualisiert',
  [tokens.referentials.importStatsIgnored]: '{{count}} Duplikate ignoriert',
  [tokens.referentials.importStatsKeptBoth]: '{{count}} Duplikate behalten',
  [tokens.referentials.importError]: 'Fehler beim Import',
  [tokens.referentials.updateByImport]: 'Per Import aktualisieren',
  [tokens.referentials.importSkipColumn]: 'Ignorieren',
  [tokens.referentials.errorDeletingReferential]:
    'Fehler beim Löschen der Referenzdatenbank',

  [tokens.customer.addNew]: 'Add new customer',
  [tokens.customer.address]: 'Address',
  [tokens.customer.addressRequired]: 'Address is required',
  [tokens.customer.basicInformation]: 'Basic informations',
  [tokens.customer.corporateName]: 'Corporate name',
  [tokens.customer.corporateNameRequired]: 'Corporate name is required',
  [tokens.customer.city]: 'City',
  [tokens.customer.cityRequired]: 'City is required',
  [tokens.customer.country]: 'Land',
  [tokens.customer.countryRequired]: 'Land ist erforderlich',
  [tokens.customer.eoriNumber]: 'EOIR number',
  [tokens.customer.eoriNumberRequired]: 'EOIR number is required',
  [tokens.customer.identifiers]: 'Identifiers',
  [tokens.customer.postalCode]: 'Postal code',
  [tokens.customer.postalCodeRequired]: 'Postal code is required',
  [tokens.customer.rexNumber]: 'REX number',
  [tokens.customer.rexNumberRequired]: 'REX number is required',
  [tokens.customer.siretNumber]: 'SIRET number',
  [tokens.customer.siretNumberRequired]: 'SIRET number is required',
  [tokens.customer.societyType]: 'Society type',
  [tokens.customer.societyTypeRequired]: 'Society type is required',
  [tokens.customer.vatNumber]: 'VAT number',
  [tokens.customer.vatNumberRequired]: 'VAT number is required',
  [tokens.customer.otherSettings]: 'Other settings',
  [tokens.customer.settingValueRequired]: 'A value is required',
  [tokens.managementConsole.managementConsole]: 'Verwaltungskonsole',
  [tokens.managementConsole.userRequired]: 'Benutzer erforderlich',
  [tokens.managementConsole.targetUser]: 'Zielbenutzer',
  [tokens.managementConsole.settings]: 'Einstellungen',
  [tokens.managementConsole.emailAutomation]: 'E-Mail-Automatisierung',
  [tokens.managementConsole.emailAutomations]: 'E-Mail-Automatisierungen',
  [tokens.managementConsole.declarationType]: 'Art der Anmeldung',
  [tokens.managementConsole.allowedsenders]: 'Erlaubte Absender',
  [tokens.managementConsole.clientOrganizationsIntro]:
    'Mit Kundenorganisationen koennen Sie Automatisierungen fuer Anmeldungen eines bestimmten Kunden hinzufuegen. Zum Beispiel koennen Sie einen Workflow anwenden oder Werte vorausfuellen.',
  [tokens.managementConsole.emailAutomationDestinationAddress]:
    'Zieladresse der E-Mail-Automatisierung',
  [tokens.managementConsole.createEmailAutomation]:
    'E-Mail-Automatisierung erstellen',
  [tokens.managementConsole
    .theFollowingConfigurationWillBeAutomaticallyAppliedToAnyDeclarationRequestReceivedAt]:
    'Die folgende Konfiguration wird automatisch auf jede Anmeldeanfrage angewendet, die gesendet wird an',
  [tokens.managementConsole
    .whitelistingAnEmailAddressAuthorizedThatEmailAccountToRequestDeclarationsOnBehalfOfYourGroup]:
    'Wenn Sie eine E-Mail-Adresse zu den erlaubten Absendern hinzufuegen, darf dieses Konto Anmeldeanfragen im Namen Ihrer Agentur senden.',
  [tokens.managementConsole.emailPrefixRequired]: 'E-Mail-Praefix erforderlich',
  [tokens.managementConsole.areYouSureYouWantToDeleteThisClientOrganization]:
    'Moechten Sie diese Kundenorganisation wirklich loeschen?',
  [tokens.managementConsole.areYouSureYouWantToDeleteThisAuthorizedSender]:
    'Moechten Sie diesen erlaubten Absender wirklich loeschen?',
  [tokens.managementConsole.allowedSenderEmailRemoveSuccess]:
    'Erlaubter Absender wurde erfolgreich entfernt',
  [tokens.managementConsole.allowedSenderEmailRemoveFailed]:
    'Erlaubter Absender konnte nicht entfernt werden',
  [tokens.managementConsole.areYouSureYouWantToDeleteThisEmailAutomation]:
    'Moechten Sie diese E-Mail-Automatisierung wirklich loeschen?',
  [tokens.managementConsole.errorUpdatingEmailAutomation]:
    'Fehler beim Aktualisieren der E-Mail-Automatisierung',
  [tokens.managementConsole.emailAutomationRemoveSuccess]:
    'E-Mail-Automatisierung wurde erfolgreich entfernt',
  [tokens.managementConsole.emailAutomationRemoveFailed]:
    'E-Mail-Automatisierung konnte nicht entfernt werden',
  [tokens.managementConsole.clientOrganizationRemoveSuccess]:
    'Kundenorganisation wurde erfolgreich entfernt',
  [tokens.managementConsole.clientOrganizationRemoveFailed]:
    'Kundenorganisation konnte nicht entfernt werden',
  [tokens.managementConsole.emailAutomationUpdatedSuccessfully]:
    'E-Mail-Automatisierung erfolgreich aktualisiert',
  [tokens.managementConsole.createEmailAutomationFor]:
    'E-Mail-Automatisierung erstellen fuer',
  [tokens.managementConsole.allowedSenderEmailAddress]:
    'E-Mail-Adresse des erlaubten Absenders',
  [tokens.managementConsole.createAllowedSender]:
    'Erlaubten Absender erstellen',
  [tokens.managementConsole.createAllowedSenderFor]:
    'Erlaubten Absender erstellen fuer',
  [tokens.managementConsole.noEmailAutomationsFound]:
    'Keine E-Mail-Automatisierungen gefunden',
  [tokens.managementConsole.noAllowedSenderEmailAddressesFound]:
    'Keine erlaubten Absender gefunden',
  [tokens.managementConsole.emailAutomationAddress]:
    'Adresse der E-Mail-Automatisierung',
  [tokens.managementConsole.emailAutomationsIntro]:
    'Mit E-Mail-Automatisierungen koennen Sie Datenzuordnungen anhand der Empfaengeradresse steuern. Eine Anfrage an "my-automation@email-api.nabu.io" kann automatisch einen Workflow anwenden, einen Kunden zuordnen oder den Anmeldetyp setzen. Nur Konten aus der Liste erlaubter Absender duerfen solche Anfragen senden.',
  [tokens.managementConsole.anyClientOrganizationSettingKeysWillBeApplied]:
    'Jede fuer diese Kundenorganisation gesetzte Konfiguration wird auf alle verknuepften Anmeldeanfragen angewendet.',
  [tokens.managementConsole.anyGroupSettingKeysWillBeApplied]:
    'Jede fuer diese Agentur gesetzte Konfiguration wird auf alle verknuepften Anmeldeanfragen angewendet.',
  [tokens.managementConsole.establishmentsAndGroups]:
    'Niederlassungen und Agenturen',
  [tokens.managementConsole.metrics]: 'Wirtschaftlichkeitskontrolle',
  [tokens.managementConsole.member_one]: 'Mitglied',
  [tokens.managementConsole.member_other]: 'Mitglieder',
  [tokens.managementConsole.emailAutomationTargetUser]:
    'Zielbenutzer der E-Mail-Automatisierung',
  [tokens.managementConsole.emailAutomationIntelligentPreparation]:
    'Intelligente Vorbereitung',
  [tokens.managementConsole.emailAutomationIntelligentPreparationDescription]:
    'An diese Adresse gesendete Anmeldungen werden von Nabu AI vorbereitet.',
  [tokens.managementConsole.members]: 'Mitglieder',
  [tokens.managementConsole.general]: 'Allgemeines',
  [tokens.managementConsole.organizationSettings]: 'Einstellungen',
  [tokens.managementConsole.clientOrganizations]: 'Kundenorganisationen',
  [tokens.managementConsole.clientOrganizationName]:
    'Name der Kundenorganisation',
  [tokens.managementConsole.clientOrganizationNotes]:
    'Notizen zur Kundenorganisation',
  [tokens.managementConsole.clientOrganization]: 'Organisation des Kunden',
  [tokens.managementConsole.clientOrganizationCreated]:
    'Kundenorganisation erstellt',
  [tokens.managementConsole.errorCreatingClientOrganization]:
    'Fehler beim Erstellen der Kundenorganisation',
  [tokens.managementConsole.createClientOrganization]:
    'Kundenorganisation erstellen',
  [tokens.managementConsole.createClientOrganizationFor]:
    'Kundenorganisation erstellen fuer',
  [tokens.managementConsole.noClientOrganizationsFound]:
    'Keine Kundenorganisationen gefunden',
  [tokens.managementConsole
    .creatingAClientOrganizationAllowsYouToAutomateActionsWhenRequestsForTheClientOrganizationAreReceived]:
    'Das Erstellen einer Kundenorganisation ermoeglicht die Automatisierung von Aktionen bei eingehenden Anfragen fuer diese Organisation.',
  [tokens.managementConsole.clientOrganizationsAssociatedToTheGroup]:
    'Mit der Agentur verknuepfte Kundenorganisationen',
  [tokens.managementConsole.companyInformation]: 'Impressum',
  [tokens.managementConsole.companyNameRequired]: 'Firmenname erforderlich',
  [tokens.managementConsole.registrationNumberRequired]:
    'Registrierungsnummer erforderlich',
  [tokens.managementConsole.registrationCountryRequired]:
    'Registrierungsland erforderlich',
  [tokens.managementConsole.registrationNumberWarning]:
    'Die Registrierungsnummer muss mindestens 6 Ziffern enthalten',
  [tokens.managementConsole.registrationCountryWarning]:
    'Der Ländercode muss genau 3 Buchstaben enthalten',
  [tokens.managementConsole.darkMode]: 'Dunkelmodus',
  [tokens.managementConsole.organizationUpdated]: 'Unternehmen aktualisiert',
  [tokens.managementConsole.warningToSaveTitle]:
    'Moechten Sie die Aenderungen speichern?',
  [tokens.managementConsole.warningToSaveConfirmButtonText]: 'Speichern',
  [tokens.managementConsole.warningToSaveCancelButtonText]:
    'Tab ohne Speichern schliessen',
  [tokens.managementConsole.organizationSettingsUpdated]:
    'Unternehmenseinstellungen aktualisiert',
  [tokens.managementConsole.issuesSettingsOptions]:
    'Fehler beim Laden der Schluessel',
  [tokens.managementConsole.generalSettings]: 'Allgemeine Einstellungen',
  [tokens.managementConsole.customsPreFilling]:
    'Pre-filling customs declarations',
  [tokens.managementConsole.lockedFieldTooltip]:
    'Information not editable by your teams',
  [tokens.managementConsole.unlockedFieldTooltip]:
    'Information editable by your teams',
  [tokens.managementConsole.inheritedFieldTooltip]:
    'Von der Agentur geerbte Information',
  [tokens.managementConsole
    .tableAutomationsSelectHelperText]: `In the "Row" column to the right, select the lines from the worksheet that you want to use - by clicking and dragging. You can select multiple ranges, as long as they don't overlap. When you're done, click the "Validate" button to go onto the next step.`,
  [tokens.managementConsole.establishmentAndGroup]: 'Niederlassung und Agentur',
  [tokens.managementConsole.administrator]: 'Administator',
  [tokens.managementConsole.tableAutomationGroupParameters]:
    'Automation Group parameters',
  [tokens.managementConsole.establishment]: 'I.12.',
  [tokens.managementConsole.errorUpdatingSettings]:
    'Fehler beim Speichern der Einstellungen',
  [tokens.managementConsole.resetSettings]:
    'Die Einstellungen wurden zurueckgesetzt',
  [tokens.managementConsole.settingsHasBeenUpdated]:
    'Einstellungen wurden aktualisiert',
  [tokens.managementConsole.impossibleToLockEmptyField]:
    'Impossible to lock an empty field',
  [tokens.managementConsole.settingOfGroup]: 'Agentureinstellung',
  [tokens.managementConsole.invalidEmailPrefix]: 'Invalid email prefix',
  [tokens.managementConsole.mailhookCreated]: 'Mailhook created',
  [tokens.managementConsole.mailhookDeleted]: 'Mailhook deleted',
  [tokens.managementConsole
    .declarationsCreatedUsingThisEmailAutomationWillBeOwnedByTheTargetUser]:
    'Declarations created using this Email automation will be owned by the Target user',
  [tokens.managementConsole.errorCreatingMailhook]: 'Error creating mailhook',
  [tokens.managementConsole.errorDeletingMailhook]: 'Error deleting mailhook',
  [tokens.managementConsole.addMailhook]: 'Add mailhook',
  [tokens.managementConsole.emailPrefix]: 'Email prefix',
  [tokens.managementConsole.noTargetPrefixesFound]: 'No target prefixes found',
  [tokens.managementConsole.targetPrefixes]: 'Target prefixes',
  [tokens.managementConsole.mailhookWhitelist]: 'Whitelisted emails',
  [tokens.managementConsole.invalidEmail]: 'Invalid email',
  [tokens.managementConsole.emailWhitelisted]: 'Email whitelisted',
  [tokens.managementConsole.apiManagement]: 'API Management',
  [tokens.managementConsole.apiKeyId]: 'Key Id',
  [tokens.managementConsole.apiKeyNameRequired]: 'API Key name required',
  [tokens.managementConsole.unrecognizedFormat]: 'Unrecognized format',
  [tokens.managementConsole.invalidKey]: 'Invalid key',
  [tokens.managementConsole.keyDetected]: 'Key detected',
  [tokens.managementConsole.apiManagementIntro]:
    'API-Schluessel ermoeglichen sichere Anfragen an unsere API. Ueber diese API koennen Sie Anmeldungen und andere Dokumente erstellen, Konfigurationsdaten Ihrer Agentur abrufen und weitere Aufgaben ohne Benutzerinteraktion ausfuehren. Weitere Informationen finden Sie in der <docsLink>API-Dokumentation</docsLink>.',
  [tokens.managementConsole.publicKeyRequired]: 'Public key required',
  [tokens.managementConsole.apiKeyCreated]: 'API key created',
  [tokens.managementConsole.apiKeyName]: 'Key name',
  [tokens.managementConsole.apiKeyFingerprint]: 'Key fingerprint',
  [tokens.managementConsole.emailRemoved]: 'Email removed',
  [tokens.managementConsole.noApiKeysFound]: 'No API Keys found',
  [tokens.managementConsole.createApiKey]: 'Create API Key',
  [tokens.managementConsole.errorCreatingApiKey]: 'Error creating API Key',
  [tokens.managementConsole.creatingAnApiKey]:
    "Creating an API Key allows your infrastructure to access Nabu's API directly",
  [tokens.managementConsole.createApiKeyFor]: 'Create API Key for',
  [tokens.managementConsole.apiKeyPublicKey]: 'Public key',
  [tokens.managementConsole.errorWhitelistingEmail]: 'Error whitelisting email',
  [tokens.managementConsole.errorRemovingEmail]: 'Error removing email',
  [tokens.managementConsole.addEmail]: 'Add email',
  [tokens.managementConsole.noClient]: 'Did not find your client',
  [tokens.managementConsole.createClient]: 'Create client',
  [tokens.managementConsole.tableAutomation]: 'Table automation',
  [tokens.managementConsole.tableAutomations]: 'Table automations',
  [tokens.managementConsole.tableAutomationsIntro]:
    'Table automations allow you to set up line-level data attribution based on data provided in advance. For example, you could update Excel tables mapping incomplete HS Codes to completed HS Codes, indicating instructions for filling in dual-use information, or indicating measure components for given HS Codes.',
  [tokens.managementConsole.tableAutomationsRequiresNewSchema]:
    'Nur für Konfigurationen mit dem neuen Deklarationsschema verfügbar.',
  [tokens.managementConsole.tableAutomationsNewSchemaOnlyAlert]:
    'Tabellenautomatisierungen sind nicht mit älteren Konfigurationen kompatibel. Es können nur Konfigurationen mit dem neuen Deklarationsschema verwendet werden.',
  [tokens.managementConsole.tableAutomationsEligibleConfigsOnly]:
    'Es werden nur Konfigurationen aufgeführt, die mit dem neuen Deklarationsschema kompatibel sind.',
  [tokens.managementConsole.createTableAutomationGroup]:
    'Create Table automation group',
  [tokens.managementConsole.sourceName]: 'Source name',
  [tokens.managementConsole.sourceType]: 'Source type',
  [tokens.managementConsole
    .creatingATableAutomationGroupAllowsYouToAutomateComplexLineLevelTableDataEntry]:
    'Creating a Table Automation group allows you to automate complex line-level table data entry',
  [tokens.managementConsole.onlyExcelFilesAreAccepted]:
    'Only Excel files with extension .xlsx are accepted',
  [tokens.managementConsole.dropText]: 'Drop your Excel file here',
  [tokens.managementConsole.dropSubtext]:
    'Drop an Excel file to view its cells',
  [tokens.managementConsole.noTableAutomationGroupsFound]:
    'No Table Automation groups found',
  [tokens.managementConsole.tableAutomationGroupName]:
    'Table Automation group name',
  [tokens.managementConsole.tableAutomationGroupNameRequired]:
    'Table Automation group name required',
  [tokens.managementConsole.enterAName]: 'Enter a name',
  [tokens.managementConsole.selectedConfiguration]: 'Selected configuration',
  [tokens.managementConsole.templateRequired]: 'Template required',
  [tokens.managementConsole.selectATemplate]: 'Select a template',
  [tokens.managementConsole.configuration]: 'Konfiguration',
  [tokens.managementConsole.fileToUpload]: 'File to upload',
  [tokens.managementConsole.ruleBuilder]: 'Rule builder',
  [tokens.managementConsole.rule]: 'Rule',
  [tokens.managementConsole.lineProperty]: 'Property',
  [tokens.managementConsole.column]: 'Column',
  [tokens.managementConsole.IS]: 'IS',
  [tokens.managementConsole.IF]: 'IF',
  [tokens.managementConsole.THEN]: 'THEN',
  [tokens.managementConsole.addCondition]: 'Add a new condition',
  [tokens.managementConsole.setReferenceRows]: 'Set reference rows',
  [tokens.managementConsole.removeAllRows]: 'Remove all rows',
  [tokens.managementConsole.removeSelectedRows]: 'Remove selected rows',
  [tokens.managementConsole.addToPayload]: 'Add to payload',
  [tokens.managementConsole.payload]: 'Payload',
  [tokens.managementConsole.relations]: 'Relations',
  [tokens.managementConsole.ifTheFollowingConditionsAreTrue]:
    'If the following conditions are true',
  [tokens.managementConsole.thenTheFollowingValuesWillBeApplied]:
    'then the following values will be applied',
  [tokens.managementConsole.validateRules]: 'Validate rules',
  [tokens.managementConsole.createTheAutomationGroup]:
    'Create the Automation Group',
  [tokens.managementConsole.automationGroupRules]: 'Automation Group rules',
  [tokens.managementConsole.areYouSureYouWantToDeleteTheTableAutomationGroup]:
    'Moechten Sie die Automatisierungsgruppe "{{ name }}" wirklich loeschen?',
  [tokens.managementConsole.tableAutomationGroupRemoveSuccess]:
    'Automation group removed successfully',
  [tokens.managementConsole.referenceRows]: 'Reference rows',
  [tokens.managementConsole.tableAutomationGroupCreated]:
    'Automation group created successfully',
  [tokens.managementConsole.tableAutomationGroupUpdatedSuccessfully]:
    'Automation group updated successfully',
  [tokens.managementConsole.errorCreatingTableAutomationGroup]:
    'Error creating Table Automation group',
  [tokens.account.generalSettings]: 'Allgemeine Einstellungen',
  [tokens.account.customsPreFilling]: 'Pre-filling customs declarations',
  [tokens.account.settingsHasBeenUpdated]: 'Einstellungen wurden aktualisiert',
  [tokens.account.errorUpdatingSettings]:
    'Fehler beim Speichern der Einstellungen',
  [tokens.account.resetSettings]: 'Die Einstellungen wurden zurueckgesetzt',
  [tokens.store.anErrorOccurred]: 'Ein Fehler ist aufgetreten',
  [tokens.store.unableToUpdateBoundingRectangle]:
    'Unable to update bounding rectangle',
  [tokens.store.targetExportFieldIsNotEmpty]: 'Target field is not empty',
  [tokens.store.targetExportFieldNotFound]: 'Target export field not found',
  [tokens.store.unableToCreateColumnSomeCellsAreInvalid]:
    'Unable to create column - some cells are invalid',
  [tokens.store.unableToCreateColumnTableAndColumnRowsMustBeIdentical]:
    'Unable to create column - table and column rows must be identical',
  [tokens.store.thereIsAlreadyATableOnThisPage]:
    'Auf dieser Dokumentseite existiert bereits ein Artikelraster.',
  [tokens.store.unableToProjectCellsOntoNewTable]:
    'Unable to project cells onto new table',
  [tokens.store.unableToProjectEmptyRowOntoNewPage]:
    'Unable to project empty row onto new page',
  [tokens.store.newTableIsTooSmallToProjectCellsFromExistingTable]:
    'New table is too small to project cells from existing table',
  [tokens.store.referenceRowCellsTouchSourceGridEdge]:
    'Einige Zellen berühren den Rand des vorhandenen Rasters. Verschieben Sie sie leicht oder vergrößern Sie das Raster, bevor Sie eine Seite hinzufügen',
  [tokens.store.tableHasNoRows]: 'Table has no rows',
  [tokens.store.unableToIdentifyTheCurrentRow]:
    'Unable to identify the table row where the mouse is currently placed',
  [tokens.store.cannotDragTableCellIntoADifferentRow]:
    'Cannot move table cell into a different row',
  [tokens.store.tableCellTooSmallOrInverted]:
    'Table cell is too small or has been inverted',
  [tokens.store.tableCellCannotGoOutOfItsRowVertically]:
    "Table cell cannot go out of it's row vertically",
  [tokens.store.tableCellGoesOutOfTableOnTheLeft]:
    'Table cell goes out of table on the left',
  [tokens.store.tableCellGoesOutOfTableOnTheRight]:
    'Table cell goes out of table on the right',
  [tokens.store.tableCellGoesOutOfTableOnTheTop]:
    'Table cell goes out of table on the top',
  [tokens.store.tableCellGoesOutOfTableOnTheBottom]:
    'Table cell goes out of table on the bottom',
  [tokens.store.missingMergeColumnsInSourceTable]:
    'Source table does not have all of the selected merge columns',
  [tokens.store.mergeKeysNotSpecificEnough]:
    'Multiple merge rows match the same target row',
  [tokens.richText.bold]: 'Bold',
  [tokens.richText.italic]: 'Italic',
  [tokens.richText.underline]: 'Underline',
  [tokens.richText.strikethrough]: 'Strikethrough',
  [tokens.richText.subscript]: 'Subscript',
  [tokens.richText.superscript]: 'Superscript',
  [tokens.richText.textColor]: 'Text color',
  [tokens.richText.highlightColor]: 'Highlight color',
  [tokens.richText.removeFormatting]: 'Remove formatting',
  [tokens.richText.orderedList]: 'Numbered list',
  [tokens.richText.bulletedList]: 'Bulleted list',
  [tokens.richText.taskList]: 'Task list',
  [tokens.richText.undo]: 'Undo',
  [tokens.richText.redo]: 'Redo',
  [tokens.richText.heading]: 'Heading',
  [tokens.richText.blockquote]: 'Blockquote',
  [tokens.richText.code]: 'Inline code',
  [tokens.richText.codeBlock]: 'Code block',
  [tokens.richText.horizontalRule]: 'Horizontal rule',
  [tokens.richText.addTable]: 'Insert table',
  [tokens.richText.editLink]: 'Edit link',
  [tokens.richText.textAlign]: 'Text alignment',
  [tokens.richText.indent]: 'Increase indent',
  [tokens.richText.unindent]: 'Decrease indent',
  [tokens.richText.fontFamily]: 'Font family',
  [tokens.richText.fontSize]: 'Font size',
  [tokens.richText.imageUpload]: 'Insert image',
  [tokens.richText.cancelButton]: 'Abbrechen',
  [tokens.richText.removeColorButton]: 'Reset',
  [tokens.richText.removeColorButtonTooltipTitle]: 'Remove the color',
  [tokens.richText.empty]: 'Change to…',
  [tokens.richText.paragraph]: 'Normal text',
  [tokens.richText.left]: 'Left',
  [tokens.richText.right]: 'Right',
  [tokens.richText.center]: 'Center',
  [tokens.richText.justify]: 'Justify',

  [tokens.whatsNew.menuTitle]: 'Neuigkeiten',
  [tokens.whatsNew.newBadge]: 'NEU',
  [tokens.whatsNew.dialogSubtitle]: 'Die neuesten \u00c4nderungen in Nabu',
  [tokens.whatsNew.footerQuestion]: 'Fragen?',
  [tokens.whatsNew.footerContact]: 'Support kontaktieren',
  [tokens.whatsNew.understood]: 'Verstanden',
  [tokens.whatsNew.carouselNewer]: 'Neuere Version',
  [tokens.whatsNew.carouselOlder]: '\u00c4ltere Version',
  [tokens.whatsNew.latest]: 'Aktuell',
  [tokens.whatsNew.releasePager]: '<bold>{{current}}</bold> / {{total}}',
  [tokens.whatsNew.goToVersion]: 'Zu Version {{version}} wechseln',
  [tokens.whatsNew.versionPill]: 'Version',
  [tokens.whatsNew.sectionFeatures]: 'Neuerungen',
  [tokens.whatsNew.sectionFixes]: 'Korrekturen',
  [tokens.whatsNew.featureCount]: '{{count}} Neuerung',
  [tokens.whatsNew.featureCount_other]: '{{count}} Neuerungen',
  [tokens.whatsNew.fixCount]: '{{count}} Korrektur',
  [tokens.whatsNew.fixCount_other]: '{{count}} Korrekturen',
  [tokens.whatsNew.environmentPrefix]: 'Umgebung\u00a0:',
  [tokens.whatsNew.emptyState]: 'Derzeit keine Neuigkeiten.',

  [tokens.productTour.next]: 'Weiter',
  [tokens.productTour.previous]: 'Zurück',
  [tokens.productTour.finish]: 'Loslegen',
  [tokens.productTour.stepCounter]: '{{current}} / {{total}}',
  [tokens.productTour.launcher]: 'Geführte Tour',
  [tokens.productTour.eyebrow]: 'Geführte Tour',
  [tokens.productTour.skip]: 'Tour überspringen',
  [tokens.productTour.coachLabel]: 'Nabu führt Sie',
  [tokens.productTour.close]: 'Schließen',
  [tokens.productTour.start]: 'Los geht’s',
  [tokens.productTour.introStepsCount]: '{{total}} Schritte',
  [tokens.productTour.goToStep]: 'Zu Schritt {{current}} von {{total}}',

  [tokens.notifications.title]: 'Benachrichtigungen',
  [tokens.notifications.menuTitle]: 'Benachrichtigungen',
  [tokens.notifications.markAllRead]: 'Alle als gelesen markieren',
  [tokens.notifications.clearAll]: 'Alle löschen',
  [tokens.notifications.moreActions]: 'Weitere Aktionen',
  [tokens.notifications.preferences]: 'Benachrichtigungseinstellungen',
  [tokens.notifications.group_today]: 'Heute',
  [tokens.notifications.group_yesterday]: 'Gestern',
  [tokens.notifications.group_earlier]: 'Früher',
  [tokens.notifications.unreadCount]: '{{count}} ungelesen',
  [tokens.notifications.empty]: 'Keine Benachrichtigungen',
  [tokens.notifications.loadMore]: 'Mehr laden',
  [tokens.notifications.dossier]: 'Anmeldung',
  [tokens.notifications.dossierUnnamed]: 'Anmeldung ohne Namen',
  [tokens.notifications.dossierNotFound]: 'Anmeldung nicht gefunden',
  [tokens.notifications.types_declaration_status_changed]:
    'Deklarationsstatus aktualisiert',
  [tokens.notifications.types_declaration_comment_added]:
    '{{actor}} hat die Anmeldung kommentiert',
  [tokens.notifications.types_declaration_sent_by_collaborator]:
    '{{actor}} hat die Deklaration gesendet',
  [tokens.notifications.types_declaration_returned_for_correction]:
    'Deklaration zur Korrektur zurückgesendet',
  [tokens.notifications.types_app_update]:
    'Neue Version {{version}} verfügbar',
  [tokens.notifications.types_app_update_generic]: 'Neue Version verfügbar',
  [tokens.notifications.types_unknown]: 'Benachrichtigung',
  [tokens.notifications.trackingMessage_toTreat]: 'Die Anmeldung ist bereit zur Bearbeitung.',
  [tokens.notifications.trackingMessage_exportFailed]:
    'Der Versand der Anmeldung ist fehlgeschlagen.',
  [tokens.notifications.trackingMessage_error]:
    'Die Verarbeitung der Anmeldung ist fehlgeschlagen.',
  [tokens.notifications.statusChanged_mareva]:
    'Mareva-Status von {{from}} auf {{to}} geändert',
  [tokens.notifications.status_unknown]: 'Unbekannter Status',
  [tokens.notifications.status_mareva_accepted]: 'Akzeptiert',
  [tokens.notifications.status_mareva_processing]: 'In Bearbeitung',
  [tokens.notifications.status_mareva_rejected]: 'Abgelehnt',
  [tokens.notifications.systemActorCustoms]: 'Zoll',
  [tokens.notifications.commentMessage]: 'hat kommentiert: „{{preview}}“',
  [tokens.notifications.commentMessage_fallback]: 'hat die Anmeldung kommentiert',
  [tokens.notifications.sentMessage]: 'hat die Deklaration an den Zoll gesendet.',
  [tokens.notifications.invalidationRequestedMessage]:
    'hat beim Zoll die Ungültigerklärung der Deklaration beantragt.',
  [tokens.notifications.invalidationRequestedMessage_fallback]:
    'Ungültigerklärung der Deklaration beim Zoll beantragt.',
  [tokens.notifications.statusMessage_mareva_accepted]:
    'Deklaration vom Zoll angenommen.',
  [tokens.notifications.statusMessage_mareva_processing]:
    'Deklaration wird vom Zoll bearbeitet.',
  [tokens.notifications.statusMessage_mareva_rejected]:
    'Deklaration vom Zoll abgelehnt.',
  [tokens.commandBar.actionDuplicateFolder]: 'Anmeldung duplizieren',
  [tokens.commandBar.triggerPlaceholder]: 'Suchen',
  [tokens.commandBar.triggerTooltip]: 'Suchen ({{shortcut}})',
  [tokens.mcpOAuth.title]: 'MCP-Server autorisieren',
  [tokens.mcpOAuth.asksAccess]: 'fordert Zugriff auf Ihren Nabu-Bereich an.',
  [tokens.mcpOAuth.afterConfirm]:
    'Nach der Bestätigung werden Sie zum MCP-Client weitergeleitet. Sie können dieses Fenster dann schließen.',
  [tokens.mcpOAuth.allow]: 'Zulassen',
  [tokens.mcpOAuth.deny]: 'Ablehnen',
  [tokens.mcpOAuth.invalidRequest]: 'Die Autorisierungsanfrage ist ungültig.',
  [tokens.mcpOAuth.expired]: 'Die OAuth-Anfrage ist abgelaufen oder ungültig.',
  [tokens.mcpOAuth.sessionExpired]:
    'Ihre Nabu-Sitzung ist abgelaufen. Melden Sie sich erneut an.',
  [tokens.mcpOAuth.cannotComplete]:
    'Die Autorisierung konnte nicht abgeschlossen werden.',
  [tokens.mcpOAuth.invalidRedirect]:
    'Die OAuth-Antwort enthält keine gültige Weiterleitung.',
  [tokens.dauSheet.europeanCommunity]: 'EUROPÄISCHE UNION',
  [tokens.dauSheet.numberMark]: 'Nr.',
  [tokens.dauSheet.box1]: 'ANMELDUNG',
  [tokens.dauSheet.boxA]: 'A VERSENDUNGS-/AUSFUHR-/ BESTIMMUNGSSTELLE',
  [tokens.dauSheet.clearanceOffice]: 'Abfertigungszollstelle:',
  [tokens.dauSheet.declarationOffice]: 'Anmeldezollstelle:',
  [tokens.dauSheet.exportDeclaration]: 'AUSFUHRANMELDUNG',
  [tokens.dauSheet.box2]: 'Versender/Ausführer',
  [tokens.dauSheet.box3]: 'Vordrucke',
  [tokens.dauSheet.box4]: 'Ladelisten',
  [tokens.dauSheet.box5]: 'Positionen',
  [tokens.dauSheet.box6]: 'Packstücke insgesamt',
  [tokens.dauSheet.box7]: 'Bezugsnummer',
  [tokens.dauSheet.box8]: 'Empfänger',
  [tokens.dauSheet.foreignConsignee]: 'AUSLAND',
  [tokens.dauSheet.box9]: 'Verantwortlicher für den Zahlungsverkehr',
  [tokens.dauSheet.box10]: 'Erst. Best.',
  [tokens.dauSheet.box10Sub]: '/letzt. Herk.',
  [tokens.dauSheet.box11]: 'Handels-/Erz.-',
  [tokens.dauSheet.box11Sub]: 'land',
  [tokens.dauSheet.box12]: 'Angaben zum Wert',
  [tokens.dauSheet.box13]: 'G.L.P.',
  [tokens.dauSheet.box14]: 'Anmelder/Vertreter',
  [tokens.dauSheet.representationMode]: 'Art der Vertretung',
  [tokens.dauSheet.approvalNumber]: 'Bewilligungs-Nr.',
  [tokens.dauSheet.box15]: 'Versendungs-/Ausfuhrland',
  [tokens.dauSheet.box15Code]: 'Vers./Ausf.L.Code',
  [tokens.dauSheet.box17Code]: 'Best.L.Code',
  [tokens.dauSheet.box16]: 'Ursprungsland',
  [tokens.dauSheet.box17]: 'Bestimmungsland',
  [tokens.dauSheet.box20]: 'Lieferbedingung',
  [tokens.dauSheet.box18]: 'Kennzeichen und Staatszugehörigkeit des Beförderungsmittels beim Abgang/bei der Ankunft',
  [tokens.dauSheet.box19]: 'Ctr.',
  [tokens.dauSheet.box21]: 'Kennzeichen und Staatszugehörigkeit des grenzüberschreitenden aktiven Beförderungsmittels',
  [tokens.dauSheet.box22]: 'Währung u. in Rechnung gestellter Gesamtbetrag',
  [tokens.dauSheet.box23]: 'Umrechnungskurs',
  [tokens.dauSheet.box24]: 'Art des Geschäfts',
  [tokens.dauSheet.box25]: 'Verkehrszweig',
  [tokens.dauSheet.box25Sub]: 'an der Grenze',
  [tokens.dauSheet.box26]: 'Inländischer',
  [tokens.dauSheet.box26Sub]: 'Verkehrszweig',
  [tokens.dauSheet.box27]: 'Ladeort/Entladeort',
  [tokens.dauSheet.box28]: 'Finanz- und Bankangaben',
  [tokens.dauSheet.box29]: 'Ausgangs-/Eingangszollstelle',
  [tokens.dauSheet.box30]: 'Warenort',
  [tokens.dauSheet.box31]: 'Packstücke und',
  [tokens.dauSheet.box31Sub]: 'Warenbezeichnung',
  [tokens.dauSheet.box31Header]: 'Zeichen und Nummern - Container-Nr. - Anzahl und Art',
  [tokens.dauSheet.numberAndKind]: 'Anzahl und Art:',
  [tokens.dauSheet.marksAndNumbers]: 'Zeichen und Nummern:',
  [tokens.dauSheet.containerNumber]: 'Container-Nr.:',
  [tokens.dauSheet.box32]: 'Pos.-Nr.',
  [tokens.dauSheet.box33]: 'Warennummer',
  [tokens.dauSheet.firstAdditionalCode]: '1. Zusatzcode',
  [tokens.dauSheet.secondAdditionalCode]: '2. Zusatzcode',
  [tokens.dauSheet.box34]: 'Urspr.land Code',
  [tokens.dauSheet.box35]: 'Rohmasse (kg)',
  [tokens.dauSheet.box36]: 'Präferenz',
  [tokens.dauSheet.box37]: 'Verfahren',
  [tokens.dauSheet.box38]: 'Eigenmasse (kg)',
  [tokens.dauSheet.box39]: 'Kontingent',
  [tokens.dauSheet.box40]: 'Summarische Anmeldung/Vorpapier',
  [tokens.dauSheet.box41]: 'Besondere Maßeinheit',
  [tokens.dauSheet.box42]: 'Artikelpreis',
  [tokens.dauSheet.box43]: 'B.M.-Code',
  [tokens.dauSheet.additionalInformationCode]: 'Code bes. Vermerke',
  [tokens.dauSheet.box44]: 'Besondere',
  [tokens.dauSheet.box44Sub]: 'Vermerke/Vorgelegte\nUnterlagen/Bescheinigungen\nu. Genehmigungen',
  [tokens.dauSheet.nationalAdditionalCodes]: 'Nationale Zusatzcodes:',
  [tokens.dauSheet.attachedDocuments]: 'Vorgelegte Unterlagen:',
  [tokens.dauSheet.box45]: 'Berichtigung',
  [tokens.dauSheet.box46]: 'Statistischer Wert',
  [tokens.dauSheet.box47]: 'Abgaben-',
  [tokens.dauSheet.box47Sub]: 'berechnung',
  [tokens.dauSheet.box47Full]: 'Abgabenberechnung',
  [tokens.dauSheet.totalFirstItem]: 'Summe erste Position:',
  [tokens.dauSheet.totalSecondItem]: 'Summe zweite Position:',
  [tokens.dauSheet.totalThirdItem]: 'Summe dritte Position:',
  [tokens.dauSheet.box48]: 'Zahlungsaufschub',
  [tokens.dauSheet.box49]: 'Bezeichnung des Lagers',
  [tokens.dauSheet.boxB]: 'B ANGABEN ZUR VERBUCHUNG',
  [tokens.dauSheet.guaranteedRisk]: 'Gesichertes Risiko',
  [tokens.dauSheet.totalAmountPayable]: 'Zu zahlender Gesamtbetrag (in der EG gesichertes Risiko)',
  [tokens.dauSheet.amountUsedEc]: 'In der EG verwendeter Betrag:',
  [tokens.dauSheet.guaranteed]: 'gesichert (C):',
  [tokens.dauSheet.notGuaranteed]: 'nicht gesichert (NC):',
  [tokens.dauSheet.controlByOffice]: 'PRÜFUNG DURCH DIE ABGANGS-/ BESTIMMUNGSSTELLE',
  [tokens.dauSheet.stamp]: 'Stempel:',
  [tokens.dauSheet.controlResult]: 'Ergebnis:',
  [tokens.dauSheet.sealsAffixed]: 'Angebrachte Verschlüsse:',
  [tokens.dauSheet.sealMarks]: 'Zeichen:',
  [tokens.dauSheet.timeLimit]: 'Frist (Datum):',
  [tokens.dauSheet.signature]: 'Unterschrift:',
  [tokens.dauSheet.box54]: 'Ort und Datum:',
  [tokens.dauSheet.editionDate]: 'Druckdatum:',
  [tokens.dauSheet.validationDate]: 'Validierungsdatum:',
  [tokens.dauSheet.declarationStatus]: 'Status der Anmeldung:',
  [tokens.dauSheet.procedureType]: 'Verfahrensart:',
  [tokens.dauSheet.declarantSignature]: 'Unterschrift und Name des Anmelders/Vertreters',
  [tokens.dauSheet.statusShort]: 'Status:',
  [tokens.dauSheet.printedOn]: 'Gedruckt am {{date}} · C ABGANGSSTELLE',
}
